export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Local Date type */
  LocalDate: { input: any; output: any; }
  /** Local Date Time type */
  LocalDateTime: { input: string; output: string; }
  /** A 64-bit signed integer */
  Long: { input: any; output: any; }
  /** A file in a GraphQL multipart request */
  Upload: { input: any; output: any; }
};

export enum ActivityMetric {
  Arpu = 'ARPU',
  CostCount = 'COST_COUNT',
  CostSum = 'COST_SUM',
  Events = 'EVENTS',
  Installs = 'INSTALLS',
  RevenueCount = 'REVENUE_COUNT',
  RevenueSum = 'REVENUE_SUM',
  Roas = 'ROAS',
  Sessions = 'SESSIONS',
  SessionsPerUser = 'SESSIONS_PER_USER',
  Users = 'USERS'
}

export type ActivityQuery = {
  appIds?: InputMaybe<Array<Scalars['String']['input']>>;
  end: Scalars['LocalDateTime']['input'];
  filters?: InputMaybe<Array<AppReportFilter>>;
  first: Scalars['Int']['input'];
  granularity: AppReportGranularity;
  groupBy?: InputMaybe<Array<AppReportDimension>>;
  metrics: Array<ActivityMetric>;
  offset: Scalars['Int']['input'];
  sort?: InputMaybe<Array<ActivitySort>>;
  start: Scalars['LocalDateTime']['input'];
  storeAppIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ActivityReportConnection = {
  csvDownloadUrl: Scalars['String']['output'];
  edges: Array<ActivityReportEdge>;
  totalCount: Scalars['Int']['output'];
};

export type ActivityReportEdge = {
  node: ActivityReportRow;
};

export type ActivityReportMetricRecord = {
  field: ActivityMetric;
  value: Scalars['Float']['output'];
};

export type ActivityReportRow = {
  date: Scalars['LocalDateTime']['output'];
  dimensions: Array<AppReportDimensionRecord>;
  metrics: Array<ActivityReportMetricRecord>;
};

export type ActivitySort = {
  byDate?: InputMaybe<Scalars['Boolean']['input']>;
  dimension?: InputMaybe<AppReportDimension>;
  direction?: InputMaybe<SortOrder>;
  metric?: InputMaybe<ActivityMetric>;
};

export enum AdKeyWordImportSpecSchedule {
  Daily = 'DAILY',
  Once = 'ONCE'
}

export type AdKeywordImportSpec = {
  filler: Filler;
  filters?: Maybe<Array<AdKeywordImportSpecFilter>>;
  id: Scalars['String']['output'];
  importMaxNumberOfKeywords: Scalars['Int']['output'];
  lastRunAt?: Maybe<Scalars['LocalDateTime']['output']>;
  schedule: AdKeyWordImportSpecSchedule;
};

export type AdKeywordImportSpecConnection = {
  edges?: Maybe<Array<AdKeywordImportSpecEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type AdKeywordImportSpecEdge = {
  node: AdKeywordImportSpec;
};

export type AdKeywordImportSpecFilter = {
  field: AdKeywordImportSpecFilterName;
  values: Array<Scalars['String']['output']>;
};

export type AdKeywordImportSpecFilterField = {
  name: AdKeywordImportSpecFilterName;
  type: AdKeywordImportSpecFilterType;
};

export type AdKeywordImportSpecFilterInput = {
  field: AdKeywordImportSpecFilterName;
  values: Array<Scalars['String']['input']>;
};

export enum AdKeywordImportSpecFilterName {
  BingMonetized = 'BING_MONETIZED',
  Categories = 'CATEGORIES',
  GoogleMonetized = 'GOOGLE_MONETIZED',
  Keywords = 'KEYWORDS'
}

export enum AdKeywordImportSpecFilterType {
  Boolean = 'BOOLEAN',
  Numeric = 'NUMERIC',
  Text = 'TEXT'
}

export type AdKeywordImportSpecInput = {
  fillerId: Scalars['String']['input'];
  filters?: InputMaybe<Array<AdKeywordImportSpecFilterInput>>;
  importMaxNumberOfKeywords: Scalars['Int']['input'];
  schedule: AdKeyWordImportSpecSchedule;
};

export type AdKeywordPreview = {
  amount: Scalars['Int']['output'];
  keywords?: Maybe<Array<Scalars['String']['output']>>;
};

export type AdapterApiParam = {
  defaultValue?: Maybe<UserProvidedValue>;
  description?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  type: AdapterParamType;
};

export type AdapterDescriptor = {
  apiConfigParams: Array<AdapterApiParam>;
  name: Scalars['String']['output'];
  supportedFields: Array<SupportedField>;
  trackingUrlParams: Array<AdapterUrlParam>;
};

export enum AdapterParamType {
  Boolean = 'BOOLEAN',
  Float = 'FLOAT',
  Int = 'INT',
  String = 'STRING',
  StringArray = 'STRING_ARRAY'
}

export type AdapterUrlParam = {
  defaultValue?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
};

/** An ad spend email sent to Adjust */
export type AdjustCostEmail = {
  /** The attached CSV (header included); null when it was too large to keep */
  csv?: Maybe<Scalars['String']['output']>;
  /** First and last day covered by the CSV */
  dateFrom: Scalars['LocalDate']['output'];
  dateTo: Scalars['LocalDate']['output'];
  /** Name of the attached CSV */
  fileName?: Maybe<Scalars['String']['output']>;
  /** True when sent from cockpit instead of by the daily schedule */
  manual: Scalars['Boolean']['output'];
  /** Every offer in the email: offers sharing a recipient are sent together */
  offerIds: Array<Scalars['String']['output']>;
  recipient: Scalars['String']['output'];
  rowCount: Scalars['Int']['output'];
  /** Platform timezone */
  sentAt: Scalars['LocalDateTime']['output'];
  subject?: Maybe<Scalars['String']['output']>;
};

export type AdjustPostbackInfo = {
  url: Scalars['String']['output'];
};

export type AdjustPostbackInfoInput = {
  url: Scalars['String']['input'];
};

/** The store_type column of the Adjust ad spend CSV */
export enum AdjustStoreType {
  AppStore = 'APP_STORE',
  GooglePlay = 'GOOGLE_PLAY',
  Web = 'WEB'
}

export type AdjustUploadConfig = {
  /** EMAIL method: falls back to the offer id when blank */
  campaignId?: Maybe<Scalars['String']['output']>;
  /** EMAIL method: falls back to the offer name when blank */
  campaignName?: Maybe<Scalars['String']['output']>;
  /** API method */
  costType?: Maybe<Scalars['String']['output']>;
  /** EMAIL method: the automate.import.sa+<identifier>@adjust.com address agreed with the Adjust TAM */
  emailRecipient?: Maybe<Scalars['String']['output']>;
  /** EMAIL method: the last email (scheduled or manual) that included this offer */
  lastEmail?: Maybe<AdjustCostEmail>;
  /** EMAIL method: when the daily schedule last sent the CSV (platform timezone); manual sends don't change it */
  lastEmailSentAt?: Maybe<Scalars['LocalDateTime']['output']>;
  offerId: Scalars['String']['output'];
  /** EMAIL method: break rows down by publisher and send the publisher id as adgroup_id */
  sendPublisherAsAdgroup?: Maybe<Scalars['Boolean']['output']>;
  /** EMAIL method: overrides Offer.appStoreId in the store_id column; falls back to the offer value when blank */
  storeId?: Maybe<Scalars['String']['output']>;
  /** EMAIL method: falls back to the offer's targeted platform when null */
  storeType?: Maybe<AdjustStoreType>;
  tag?: Maybe<Scalars['String']['output']>;
  uploadMethod: AdjustUploadMethod;
};

export type AdjustUploadConfigInput = {
  campaignId?: InputMaybe<Scalars['String']['input']>;
  campaignName?: InputMaybe<Scalars['String']['input']>;
  costType?: InputMaybe<Scalars['String']['input']>;
  emailRecipient?: InputMaybe<Scalars['String']['input']>;
  offerId: Scalars['String']['input'];
  sendPublisherAsAdgroup?: InputMaybe<Scalars['Boolean']['input']>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  storeType?: InputMaybe<AdjustStoreType>;
  tag?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to API */
  uploadMethod?: InputMaybe<AdjustUploadMethod>;
};

/** How the cost data reaches Adjust */
export enum AdjustUploadMethod {
  /** One POST to https://app.adjust.com/cost per evaluated postback (realtime) */
  Api = 'API',
  /** A daily CSV attached to an email sent to the customer's automate.import.sa+<id>@adjust.com address */
  Email = 'EMAIL'
}

export type AdvancedTargeting = {
  group?: Maybe<AdvancedTargetingGroup>;
  offerId?: Maybe<Scalars['String']['output']>;
  rule?: Maybe<Scalars['String']['output']>;
};

export type AdvancedTargetingField = {
  bundleIds?: Maybe<Array<Scalars['String']['output']>>;
  field: AdvancedTargetingFieldType;
  operation: AdvancedTargetingOperator;
  value?: Maybe<Array<Scalars['String']['output']>>;
};

export type AdvancedTargetingFieldInput = {
  bundleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  field: AdvancedTargetingFieldType;
  operation: AdvancedTargetingOperator;
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum AdvancedTargetingFieldType {
  AdvertiserId = 'ADVERTISER_ID',
  AdvertiserTags = 'ADVERTISER_TAGS',
  ClicksOffer_1D = 'CLICKS_OFFER_1D',
  ClicksOffer_7D = 'CLICKS_OFFER_7D',
  ConversionsOffer_1D = 'CONVERSIONS_OFFER_1D',
  ConversionsOffer_7D = 'CONVERSIONS_OFFER_7D',
  DayOfWeek = 'DAY_OF_WEEK',
  Domain = 'DOMAIN',
  HourOfDay = 'HOUR_OF_DAY',
  HttpAcceptHeader = 'HTTP_ACCEPT_HEADER',
  HttpRefererHeader = 'HTTP_REFERER_HEADER',
  LandingPageId = 'LANDING_PAGE_ID',
  LeadAdvertiserId = 'LEAD_ADVERTISER_ID',
  LeadConnectionIsp = 'LEAD_CONNECTION_ISP',
  LeadDayOfWeek = 'LEAD_DAY_OF_WEEK',
  LeadEmail = 'LEAD_EMAIL',
  LeadFreeParameter1 = 'LEAD_FREE_PARAMETER1',
  LeadFreeParameter2 = 'LEAD_FREE_PARAMETER2',
  LeadFreeParameter3 = 'LEAD_FREE_PARAMETER3',
  LeadFreeParameter4 = 'LEAD_FREE_PARAMETER4',
  LeadFreeParameter5 = 'LEAD_FREE_PARAMETER5',
  LeadFreeParameter6 = 'LEAD_FREE_PARAMETER6',
  LeadFreeParameter7 = 'LEAD_FREE_PARAMETER7',
  LeadFreeParameter8 = 'LEAD_FREE_PARAMETER8',
  LeadFreeParameter9 = 'LEAD_FREE_PARAMETER9',
  LeadFreeParameter10 = 'LEAD_FREE_PARAMETER10',
  LeadFreeParameter11 = 'LEAD_FREE_PARAMETER11',
  LeadFreeParameter12 = 'LEAD_FREE_PARAMETER12',
  LeadFreeParameter13 = 'LEAD_FREE_PARAMETER13',
  LeadFreeParameter14 = 'LEAD_FREE_PARAMETER14',
  LeadFreeParameter15 = 'LEAD_FREE_PARAMETER15',
  LeadFreeParameter16 = 'LEAD_FREE_PARAMETER16',
  LeadFreeParameter17 = 'LEAD_FREE_PARAMETER17',
  LeadFreeParameter18 = 'LEAD_FREE_PARAMETER18',
  LeadFreeParameter19 = 'LEAD_FREE_PARAMETER19',
  LeadGeoCity = 'LEAD_GEO_CITY',
  LeadGeoCountry = 'LEAD_GEO_COUNTRY',
  LeadGeoRegion = 'LEAD_GEO_REGION',
  LeadHourOfDay = 'LEAD_HOUR_OF_DAY',
  LeadOfferId = 'LEAD_OFFER_ID',
  LeadPhoneNumber = 'LEAD_PHONE_NUMBER',
  LeadPublisherApp = 'LEAD_PUBLISHER_APP',
  LeadPublisherId = 'LEAD_PUBLISHER_ID',
  LeadPublisherSite = 'LEAD_PUBLISHER_SITE',
  LeadPublisherSubid = 'LEAD_PUBLISHER_SUBID',
  LeadPublisherSubsubid = 'LEAD_PUBLISHER_SUBSUBID',
  OfferId = 'OFFER_ID',
  OfferTags = 'OFFER_TAGS',
  Path = 'PATH',
  PublisherApp = 'PUBLISHER_APP',
  PublisherAppId = 'PUBLISHER_APP_ID',
  PublisherCreative = 'PUBLISHER_CREATIVE',
  PublisherId = 'PUBLISHER_ID',
  PublisherOriginalSubid = 'PUBLISHER_ORIGINAL_SUBID',
  PublisherSite = 'PUBLISHER_SITE',
  PublisherSubid = 'PUBLISHER_SUBID',
  PublisherSubsubid = 'PUBLISHER_SUBSUBID',
  PublisherTags = 'PUBLISHER_TAGS',
  PublisherTerm = 'PUBLISHER_TERM',
  PublisherUnique1 = 'PUBLISHER_UNIQUE1',
  PublisherUnique2 = 'PUBLISHER_UNIQUE2',
  PublisherUnique3 = 'PUBLISHER_UNIQUE3',
  PublisherUnique4 = 'PUBLISHER_UNIQUE4',
  PublisherUnique5 = 'PUBLISHER_UNIQUE5',
  PublisherUnique6 = 'PUBLISHER_UNIQUE6',
  PublisherUnique7 = 'PUBLISHER_UNIQUE7',
  PublisherUnique8 = 'PUBLISHER_UNIQUE8',
  PublisherUnique9 = 'PUBLISHER_UNIQUE9',
  PublisherUnique10 = 'PUBLISHER_UNIQUE10',
  RecommendedTraffic = 'RECOMMENDED_TRAFFIC',
  UserBrowser = 'USER_BROWSER',
  UserBrowserVersion = 'USER_BROWSER_VERSION',
  UserConnectionCarrierCode = 'USER_CONNECTION_CARRIER_CODE',
  UserConnectionIsp = 'USER_CONNECTION_ISP',
  UserConnectionMcc = 'USER_CONNECTION_MCC',
  UserConnectionMnc = 'USER_CONNECTION_MNC',
  UserConnectionType = 'USER_CONNECTION_TYPE',
  UserDeviceIp = 'USER_DEVICE_IP',
  UserDeviceLanguage = 'USER_DEVICE_LANGUAGE',
  UserDeviceMake = 'USER_DEVICE_MAKE',
  UserDeviceModel = 'USER_DEVICE_MODEL',
  UserDeviceOs = 'USER_DEVICE_OS',
  UserDeviceOsv = 'USER_DEVICE_OSV',
  UserDevicePreferredLanguage = 'USER_DEVICE_PREFERRED_LANGUAGE',
  UserDeviceType = 'USER_DEVICE_TYPE',
  UserDeviceUserAgent = 'USER_DEVICE_USER_AGENT',
  UserGeoCity = 'USER_GEO_CITY',
  UserGeoCountry = 'USER_GEO_COUNTRY',
  UserGeoLat = 'USER_GEO_LAT',
  UserGeoLon = 'USER_GEO_LON',
  UserGeoRegion = 'USER_GEO_REGION',
  UserId = 'USER_ID',
  UserIdsGaid = 'USER_IDS_GAID',
  UserIdsIdfa = 'USER_IDS_IDFA',
  UserInApp = 'USER_IN_APP'
}

export type AdvancedTargetingGroup = {
  fields?: Maybe<Array<AdvancedTargetingField>>;
  groups?: Maybe<Array<AdvancedTargetingGroup>>;
  operation: AdvancedTargetingGroupOperator;
};

export type AdvancedTargetingGroupInput = {
  fields?: InputMaybe<Array<AdvancedTargetingFieldInput>>;
  groups?: InputMaybe<Array<AdvancedTargetingGroupInput>>;
  operation: AdvancedTargetingGroupOperator;
};

export enum AdvancedTargetingGroupOperator {
  And = 'AND',
  Or = 'OR'
}

export type AdvancedTargetingInput = {
  group?: InputMaybe<AdvancedTargetingGroupInput>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
};

export enum AdvancedTargetingOperator {
  Contains = 'CONTAINS',
  DoesNotContain = 'DOES_NOT_CONTAIN',
  DoesNotMatchRegex = 'DOES_NOT_MATCH_REGEX',
  Equals = 'EQUALS',
  Gte = 'GTE',
  In = 'IN',
  IpMatch = 'IP_MATCH',
  IpNotMatch = 'IP_NOT_MATCH',
  IsEmpty = 'IS_EMPTY',
  IsNotEmpty = 'IS_NOT_EMPTY',
  LatLongMatch = 'LAT_LONG_MATCH',
  LatLongNotMatch = 'LAT_LONG_NOT_MATCH',
  Lte = 'LTE',
  MatchesRegex = 'MATCHES_REGEX',
  NotEquals = 'NOT_EQUALS',
  NotIn = 'NOT_IN',
  VersionGte = 'VERSION_GTE',
  VersionLte = 'VERSION_LTE'
}

export type AdvancedTargetingValueBundle = {
  fieldType: AdvancedTargetingFieldType;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type AdvancedTargetingValueBundleConnection = {
  edges?: Maybe<Array<AdvancedTargetingValueBundleEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type AdvancedTargetingValueBundleEdge = {
  node: AdvancedTargetingValueBundle;
};

export type AdvancedTargetingValueBundleFilter = {
  fieldType?: InputMaybe<AdvancedTargetingFieldType>;
};

export type AdvancedTargetingValueBundleInput = {
  fieldType: AdvancedTargetingFieldType;
  name: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

/** Describes a partner of the network that advertises their offers in our platform. */
export type Advertiser = {
  accountManager?: Maybe<User>;
  accountType: AdvertiserType;
  address?: Maybe<Scalars['String']['output']>;
  /** Ther advertiser blocked publisher, if this publisher is blocked */
  advertiserBlockedPublishers: Array<AdvertiserBlockedPublisher>;
  advertiserConfig?: Maybe<AdvertiserConfig>;
  audits: Array<Audit>;
  blacklistedSubIds: Array<BlacklistedSubId>;
  /**
   * Blocked advertiser publishers - Deprecated use advertiserBlockedPublishers instead
   * @deprecated Use offersV2 instead
   */
  blockedPublishers: Array<Publisher>;
  budgets: Array<Budget>;
  contacts: Array<AdvertiserContact>;
  country?: Maybe<Scalars['String']['output']>;
  counts: AdvertiserCounts;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  offerTotalBudgets: Array<Budget>;
  offers: Array<Offer>;
  offersCount: Scalars['Int']['output'];
  /** Advertiser offers */
  offersV2: OfferConnection;
  payoutMargins: Array<PayoutMargin>;
  pdId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postbackUrl?: Maybe<Scalars['String']['output']>;
  /** all the pub groups associated to this advertiser */
  pubGroups: PubGroupConnection;
  publisherGroups: Array<PublisherGroup>;
  /** Statistics about the performance of the advertiser based on the given fields */
  report: Array<Report>;
  salesManager?: Maybe<User>;
  searchIntegrations?: Maybe<SearchIntegration>;
  securityToken?: Maybe<Scalars['String']['output']>;
  singularKey: Scalars['String']['output'];
  sourceId?: Maybe<Scalars['String']['output']>;
  status: AdvertiserStatus;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  trackingDomain?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Describes a partner of the network that advertises their offers in our platform. */
export type AdvertiserBlacklistedSubIdsArgs = {
  filter?: InputMaybe<BlacklistedSubIdsFilter>;
  pagination?: InputMaybe<Pagination>;
};


/** Describes a partner of the network that advertises their offers in our platform. */
export type AdvertiserBudgetsArgs = {
  budgetSpecificity?: InputMaybe<Array<OfferPublisherBudgetType>>;
  status?: InputMaybe<Array<Status>>;
  thresholds?: InputMaybe<Array<BudgetThreshold>>;
  validities?: InputMaybe<Array<BudgetValidity>>;
};


/** Describes a partner of the network that advertises their offers in our platform. */
export type AdvertiserContactsArgs = {
  filter?: InputMaybe<AdvertiserContactFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<AdvertiserContactSort>;
};


/** Describes a partner of the network that advertises their offers in our platform. */
export type AdvertiserOfferTotalBudgetsArgs = {
  budgetSpecificity?: InputMaybe<Array<OfferPublisherBudgetType>>;
  status?: InputMaybe<Array<InputMaybe<Status>>>;
  thresholds?: InputMaybe<Array<InputMaybe<BudgetThreshold>>>;
  validities?: InputMaybe<Array<BudgetValidity>>;
};


/** Describes a partner of the network that advertises their offers in our platform. */
export type AdvertiserOffersArgs = {
  filter?: InputMaybe<AdvertiserOfferFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<AdvertiserOfferSort>;
};


/** Describes a partner of the network that advertises their offers in our platform. */
export type AdvertiserOffersCountArgs = {
  filter?: InputMaybe<AdvertiserOfferFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<AdvertiserOfferSort>;
};


/** Describes a partner of the network that advertises their offers in our platform. */
export type AdvertiserOffersV2Args = {
  filter?: InputMaybe<AdvertiserOfferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AdvertiserOfferSort>;
};


/** Describes a partner of the network that advertises their offers in our platform. */
export type AdvertiserPubGroupsArgs = {
  filter?: InputMaybe<PubGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes a partner of the network that advertises their offers in our platform. */
export type AdvertiserPublisherGroupsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
};


/** Describes a partner of the network that advertises their offers in our platform. */
export type AdvertiserReportArgs = {
  queries?: InputMaybe<Array<InputMaybe<ReportQuery>>>;
};

export type AdvertiserBatchOperation = {
  active: Scalars['Boolean']['output'];
  changeStatusAction?: Maybe<AdvertiserBatchOperationChangeStatusAction>;
  changeTagsAction?: Maybe<AdvertiserBatchOperationChangeTagsAction>;
  description?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<AdvertiserBatchOperationFilter>>;
  fireWebhookAction?: Maybe<AdvertiserBatchOperationFireWebhook>;
  id: Scalars['String']['output'];
  lastExecutionAt?: Maybe<Scalars['LocalDateTime']['output']>;
  name: Scalars['String']['output'];
  schedule: BatchOperationSchedule;
};

export type AdvertiserBatchOperationChangeStatusAction = {
  status: AdvertiserStatus;
};

export type AdvertiserBatchOperationChangeStatusActionInput = {
  status: AdvertiserStatus;
};

export type AdvertiserBatchOperationChangeTagsAction = {
  tagsToAdd?: Maybe<Array<Scalars['String']['output']>>;
  tagsToRemove?: Maybe<Array<Scalars['String']['output']>>;
};

export type AdvertiserBatchOperationChangeTagsActionInput = {
  tagsToAdd?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsToRemove?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdvertiserBatchOperationConnection = {
  edges?: Maybe<Array<AdvertiserBatchOperationEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type AdvertiserBatchOperationEdge = {
  node: AdvertiserBatchOperation;
};

export type AdvertiserBatchOperationFilter = {
  field: AdvertiserBatchOperationFilterField;
  operator: BatchOperationFilterOperator;
  values: Array<Scalars['String']['output']>;
};

export enum AdvertiserBatchOperationFilterField {
  AccountManagerId = 'ACCOUNT_MANAGER_ID',
  Clicks = 'CLICKS',
  Cr = 'CR',
  CreatedAt = 'CREATED_AT',
  DefaultConversions = 'DEFAULT_CONVERSIONS',
  Events = 'EVENTS',
  Id = 'ID',
  Impressions = 'IMPRESSIONS',
  InternalNote = 'INTERNAL_NOTE',
  IsNew = 'IS_NEW',
  Name = 'NAME',
  NonRejectedConversions = 'NON_REJECTED_CONVERSIONS',
  PaidConversions = 'PAID_CONVERSIONS',
  PaidCr = 'PAID_CR',
  RejectedConversions = 'REJECTED_CONVERSIONS',
  SalesManagerId = 'SALES_MANAGER_ID',
  Status = 'STATUS',
  Tags = 'TAGS',
  TheyGet = 'THEY_GET',
  TotalConversions = 'TOTAL_CONVERSIONS',
  UpdatedAt = 'UPDATED_AT',
  WeGet = 'WE_GET'
}

export type AdvertiserBatchOperationFilterInput = {
  field: AdvertiserBatchOperationFilterField;
  operator: BatchOperationFilterOperator;
  values: Array<Scalars['String']['input']>;
};

export type AdvertiserBatchOperationFireWebhook = {
  body?: Maybe<Scalars['String']['output']>;
  headers?: Maybe<Scalars['String']['output']>;
  method: BatchOperationWebhookMethod;
  url: Scalars['String']['output'];
};

export type AdvertiserBatchOperationFireWebhookInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  headers?: InputMaybe<Scalars['String']['input']>;
  method: BatchOperationWebhookMethod;
  url: Scalars['String']['input'];
};

export type AdvertiserBatchOperationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  changeStatusAction?: InputMaybe<AdvertiserBatchOperationChangeStatusActionInput>;
  changeTagsAction?: InputMaybe<AdvertiserBatchOperationChangeTagsActionInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<AdvertiserBatchOperationFilterInput>>;
  fireWebhookAction?: InputMaybe<AdvertiserBatchOperationFireWebhookInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedule: BatchOperationScheduleInput;
};

export type AdvertiserBatchOperationLogConnection = {
  edges?: Maybe<Array<AdvertiserBatchOperationLogEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type AdvertiserBatchOperationLogEdge = {
  node: AdvertiserBatchOperationLogEntry;
};

export type AdvertiserBatchOperationLogEntry = {
  actions?: Maybe<Array<BatchOperationLogActionEntry>>;
  advertiser: Advertiser;
};

export type AdvertiserBatchOperationReadFilter = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type AdvertiserBillingProfile = {
  address?: Maybe<Scalars['String']['output']>;
  advertiserId: Scalars['String']['output'];
  ccEmails: Array<Scalars['String']['output']>;
  emails: Array<Scalars['String']['output']>;
  /** null = settings default */
  lineGrouping?: Maybe<AdvertiserInvoiceLineGrouping>;
  name?: Maybe<Scalars['String']['output']>;
  /** Default notes printed on this advertiser's invoices */
  notes?: Maybe<Scalars['String']['output']>;
  /** null = settings default */
  paymentTermDays?: Maybe<Scalars['Int']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  /** Fraction; null = settings default */
  taxRate?: Maybe<Scalars['Float']['output']>;
};

export type AdvertiserBillingProfileInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  ccEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  lineGrouping?: InputMaybe<AdvertiserInvoiceLineGrouping>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentTermDays?: InputMaybe<Scalars['Int']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
};

export type AdvertiserBlockedPublisher = {
  advertiser?: Maybe<Advertiser>;
  advertiserId?: Maybe<Scalars['String']['output']>;
  blockingReason?: Maybe<Scalars['String']['output']>;
  publisher?: Maybe<Publisher>;
  publisherId?: Maybe<Scalars['String']['output']>;
};

export type AdvertiserBlockedPublisherInput = {
  advertiserId: Scalars['String']['input'];
  blockingReason?: InputMaybe<Scalars['String']['input']>;
  publisherId: Scalars['String']['input'];
};

/** Describes Config of a partner of Swaarm that advertises their offers in our platform. */
export type AdvertiserConfig = {
  adapter: Scalars['String']['output'];
  advertiser: Advertiser;
  advertiserId: Scalars['String']['output'];
  apiConfig: AdvertiserConfigApiConfig;
  audits: Array<Audit>;
  autoApprovalConfigs: Array<AutoApprovalConfig>;
  fieldSettings: Array<ImportedOfferFieldSetting>;
  id: Scalars['String']['output'];
  margin?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  syncingActive: Scalars['Boolean']['output'];
  trackingUrlParams: Array<UserProvidedParam>;
};

/** Describes ApiConfig of a partner of Swaarm that advertises their offers in our platform. */
export type AdvertiserConfigApiConfig = {
  parameters?: Maybe<Array<UserProvidedParam>>;
};

export type AdvertiserConfigApiConfigInput = {
  parameters?: InputMaybe<Array<UserProvidedParamInput>>;
};

/**
 * One HTTP request farmer made against the network API (paginated APIs produce several).
 * Credential-like values in url and params are masked.
 */
export type AdvertiserConfigApiRequest = {
  method: Scalars['String']['output'];
  /** JSON-encoded request params, if any */
  params?: Maybe<Scalars['String']['output']>;
  /**
   * JSON-encoded raw API response body. Only cut off for pathologically large bodies (see truncated);
   * the cockpit opens large responses in a new tab rather than truncating them.
   */
  response?: Maybe<Scalars['String']['output']>;
  truncated: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** Raw responses of the network API behind an AdvertiserConfig, for debugging syncing problems. */
export type AdvertiserConfigApiResponse = {
  error?: Maybe<Scalars['String']['output']>;
  requests: Array<AdvertiserConfigApiRequest>;
  status: AdvertiserConfigApiResponseStatus;
};

export enum AdvertiserConfigApiResponseStatus {
  NotFound = 'NOT_FOUND',
  Ok = 'OK',
  /** The advertiser API failed; requests contains the pages captured before the failure. */
  UpstreamError = 'UPSTREAM_ERROR'
}

export type AdvertiserConfigFilter = {
  accountManagerId?: InputMaybe<Scalars['String']['input']>;
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  salesManagerId?: InputMaybe<Scalars['String']['input']>;
  syncingActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdvertiserConfigInput = {
  adapter: Scalars['String']['input'];
  advertiserId: Scalars['String']['input'];
  apiConfig: AdvertiserConfigApiConfigInput;
  fieldSettings: Array<InputMaybe<ImportedOfferFieldSettingInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  margin?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  syncingActive: Scalars['Boolean']['input'];
  trackingUrlParams: Array<InputMaybe<UserProvidedParamInput>>;
};

/** Specific sort type for AdvertisersConfig */
export type AdvertiserConfigSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<AdvertiserConfigSortBy>;
  sortQuery?: InputMaybe<SortQuery>;
};

/** Describes the fields on which the Advertiser can be sorted on */
export enum AdvertiserConfigSortBy {
  AdvertiserConfigId = 'ADVERTISER_CONFIG_ID',
  AdvertiserId = 'ADVERTISER_ID',
  Name = 'NAME'
}

export type AdvertiserConfigSyncChange = {
  counts: Scalars['String']['output'];
  entity: Scalars['String']['output'];
};

export enum AdvertiserConfigSyncState {
  Failed = 'FAILED',
  /** No on-demand trigger pending; lastRun/lastSuccess still describe scheduled runs. */
  Idle = 'IDLE',
  Pending = 'PENDING',
  Success = 'SUCCESS',
  /** The triggered run did not report a result in time; check again later. */
  TimedOut = 'TIMED_OUT'
}

export type AdvertiserConfigSyncStatus = {
  /** Per-entity created/updated/deleted counts of the last completed run */
  changes?: Maybe<Array<AdvertiserConfigSyncChange>>;
  /** Failure description, only set when state is FAILED */
  error?: Maybe<Scalars['String']['output']>;
  failureCounter?: Maybe<Scalars['Int']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  lastRun?: Maybe<Scalars['String']['output']>;
  lastSuccess?: Maybe<Scalars['String']['output']>;
  runtime?: Maybe<Scalars['String']['output']>;
  state: AdvertiserConfigSyncState;
  triggeredAt?: Maybe<Scalars['String']['output']>;
};

/**
 * On-demand syncing of an AdvertiserConfig through farmer.
 * Result of triggering a sync. If a trigger for the config was already pending,
 * the existing trigger is returned instead of starting a new run.
 */
export type AdvertiserConfigSyncTrigger = {
  alreadyPending: Scalars['Boolean']['output'];
  configId: Scalars['String']['output'];
  triggeredAt: Scalars['String']['output'];
};

export type AdvertiserConnection = {
  edges: Array<AdvertiserEdge>;
  totalCount: Scalars['Int']['output'];
};

export type AdvertiserContact = {
  advertiserId: Scalars['String']['output'];
  businessRole?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isNotifiable: Scalars['Boolean']['output'];
  isPrimary: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  needsUser: Scalars['Boolean']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  skypeId?: Maybe<Scalars['String']['output']>;
  status: Status;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AdvertiserContactFilter = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
};

export type AdvertiserContactInput = {
  advertiserId: Scalars['String']['input'];
  businessRole?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  isNotifiable: Scalars['Boolean']['input'];
  isPrimary: Scalars['Boolean']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  needsUser: Scalars['Boolean']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  skypeId?: InputMaybe<Scalars['String']['input']>;
  status: Status;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AdvertiserContactSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<AdvertiserContactSortBy>;
};

export enum AdvertiserContactSortBy {
  AdvertiserContactId = 'ADVERTISER_CONTACT_ID',
  AdvertiserId = 'ADVERTISER_ID',
  Name = 'NAME'
}

export type AdvertiserCounts = {
  activeOffers: Scalars['Int']['output'];
  importedOffers: Scalars['Int']['output'];
  servedOffers: Scalars['Int']['output'];
};

export type AdvertiserCoupon = {
  code: Scalars['String']['output'];
  defaultPublisher: Publisher;
  endDate?: Maybe<Scalars['LocalDateTime']['output']>;
  id: Scalars['String']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  offer: Offer;
  startDate: Scalars['LocalDateTime']['output'];
  trackingLink: Scalars['String']['output'];
};

export type AdvertiserCouponConnection = {
  edges?: Maybe<Array<AdvertiserCouponEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type AdvertiserCouponEdge = {
  node: AdvertiserCoupon;
};

export type AdvertiserCouponFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdvertiserCouponInput = {
  code: Scalars['String']['input'];
  defaultPublisherId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  offerId: Scalars['String']['input'];
  startDate: Scalars['LocalDateTime']['input'];
};

export type AdvertiserEdge = {
  node: Advertiser;
};

/** Describes the fields on which the advertiser can be filtered on */
export type AdvertiserFilter = {
  accountManagerId?: InputMaybe<Scalars['String']['input']>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  salesManagerId?: InputMaybe<Scalars['String']['input']>;
  salesManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<AdvertiserStatus>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AdvertiserInput = {
  accountManagerId: Scalars['String']['input'];
  accountType: AdvertiserType;
  address?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  salesManagerId?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  status: AdvertiserStatus;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AdvertiserInvoice = {
  advertiser?: Maybe<Advertiser>;
  advertiserId: Scalars['String']['output'];
  balance: Scalars['Float']['output'];
  billTo?: Maybe<AdvertiserInvoiceBillTo>;
  createdAt: Scalars['LocalDateTime']['output'];
  currency: Scalars['String']['output'];
  /** Signed, short-lived link path (prefix with the API host); null until a PDF exists */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['LocalDate']['output']>;
  emails: Array<AdvertiserInvoiceEmail>;
  id: Scalars['String']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['LocalDate']['output']>;
  lineItems: Array<AdvertiserInvoiceLineItem>;
  notes?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  /** Unpaid (ISSUED/SENT/PARTIALLY_PAID) and past the due date */
  overdue: Scalars['Boolean']['output'];
  paidAmount: Scalars['Float']['output'];
  payments: Array<AdvertiserInvoicePayment>;
  pdfGeneratedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  periodEnd: Scalars['LocalDate']['output'];
  periodStart: Scalars['LocalDate']['output'];
  /** Sum of platformAmount over PLATFORM lines */
  platformTotal: Scalars['Float']['output'];
  status: AdvertiserInvoiceStatus;
  subtotal: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  taxRate: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type AdvertiserInvoiceBillTo = {
  address?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type AdvertiserInvoiceBillToInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type AdvertiserInvoiceCandidate = {
  advertiser?: Maybe<Advertiser>;
  advertiserId: Scalars['String']['output'];
  conversions: Scalars['Float']['output'];
  /** A non-void invoice of this advertiser whose period overlaps the requested one */
  existingInvoiceId?: Maybe<Scalars['String']['output']>;
  existingInvoiceNumber?: Maybe<Scalars['String']['output']>;
  hasBillingProfile: Scalars['Boolean']['output'];
  revenue: Scalars['Float']['output'];
};

export type AdvertiserInvoiceConnection = {
  edges: Array<AdvertiserInvoiceEdge>;
  totalCount: Scalars['Int']['output'];
};

export type AdvertiserInvoiceEdge = {
  node: AdvertiserInvoice;
};

export type AdvertiserInvoiceEmail = {
  cc: Array<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['LocalDateTime']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  to: Array<Scalars['String']['output']>;
};

export type AdvertiserInvoiceEmailDraft = {
  cc: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  replyTo?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  to: Array<Scalars['String']['output']>;
};

export type AdvertiserInvoiceFilter = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches number, advertiser name or id */
  keyword?: InputMaybe<Scalars['String']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Invoices whose period overlaps [periodFrom, periodTo] */
  periodFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  periodTo?: InputMaybe<Scalars['LocalDate']['input']>;
  statuses?: InputMaybe<Array<AdvertiserInvoiceStatus>>;
};

export type AdvertiserInvoiceInput = {
  advertiserId: Scalars['String']['input'];
  billTo?: InputMaybe<AdvertiserInvoiceBillToInput>;
  dueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  lineItems: Array<AdvertiserInvoiceLineItemInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  periodEnd: Scalars['LocalDate']['input'];
  periodStart: Scalars['LocalDate']['input'];
  status?: InputMaybe<AdvertiserInvoiceStatus>;
  taxRate: Scalars['Float']['input'];
};

/** How platform revenue is split into invoice lines */
export enum AdvertiserInvoiceLineGrouping {
  Offer = 'OFFER',
  OfferEvent = 'OFFER_EVENT',
  Total = 'TOTAL'
}

export type AdvertiserInvoiceLineItem = {
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  eventTypeId?: Maybe<Scalars['String']['output']>;
  offerId?: Maybe<Scalars['String']['output']>;
  /** Revenue the platform reported for this line when it was calculated (PLATFORM lines) */
  platformAmount?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  source: AdvertiserInvoiceLineSource;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type AdvertiserInvoiceLineItemInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  eventTypeId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  platformAmount?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  source?: InputMaybe<AdvertiserInvoiceLineSource>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export enum AdvertiserInvoiceLineSource {
  Manual = 'MANUAL',
  Platform = 'PLATFORM'
}

export type AdvertiserInvoicePayment = {
  amount: Scalars['Float']['output'];
  date: Scalars['LocalDate']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type AdvertiserInvoicePaymentInput = {
  amount: Scalars['Float']['input'];
  date: Scalars['LocalDate']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type AdvertiserInvoiceSendInput = {
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  message: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  to: Array<Scalars['String']['input']>;
};

export type AdvertiserInvoiceSettings = {
  billingAddress?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  defaultLineGrouping?: Maybe<AdvertiserInvoiceLineGrouping>;
  defaultPaymentTermDays?: Maybe<Scalars['Int']['output']>;
  /** Fraction, e.g. 0.19 for 19% */
  defaultTaxRate?: Maybe<Scalars['Float']['output']>;
  emailCc?: Maybe<Array<Scalars['String']['output']>>;
  emailMessage?: Maybe<Scalars['String']['output']>;
  /** Macros: {number} {advertiser} {total} {dueDate} {periodStart} {periodEnd} {company} */
  emailSubject?: Maybe<Scalars['String']['output']>;
  invoiceFooter?: Maybe<Scalars['String']['output']>;
  invoiceHeader?: Maybe<Scalars['String']['output']>;
  /** Description of the single line when grouping is TOTAL */
  lineItemText?: Maybe<Scalars['String']['output']>;
  numberPrefix?: Maybe<Scalars['String']['output']>;
  numberStart?: Maybe<Scalars['Int']['output']>;
  paymentInstructions?: Maybe<Scalars['String']['output']>;
  replyTo?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type AdvertiserInvoiceSettingsInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  defaultLineGrouping?: InputMaybe<AdvertiserInvoiceLineGrouping>;
  defaultPaymentTermDays?: InputMaybe<Scalars['Int']['input']>;
  defaultTaxRate?: InputMaybe<Scalars['Float']['input']>;
  emailCc?: InputMaybe<Array<Scalars['String']['input']>>;
  emailMessage?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  invoiceFooter?: InputMaybe<Scalars['String']['input']>;
  invoiceHeader?: InputMaybe<Scalars['String']['input']>;
  lineItemText?: InputMaybe<Scalars['String']['input']>;
  numberPrefix?: InputMaybe<Scalars['String']['input']>;
  numberStart?: InputMaybe<Scalars['Int']['input']>;
  paymentInstructions?: InputMaybe<Scalars['String']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Advertiser invoices: drafts from platform revenue (approved weGet), reviewed and issued by a person,
 * rendered to PDF and emailed. Money is in platform currency base units (microcents internally).
 */
export enum AdvertiserInvoiceStatus {
  Draft = 'DRAFT',
  Issued = 'ISSUED',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Sent = 'SENT',
  Void = 'VOID'
}

export type AdvertiserInvoiceSummary = {
  currency: Scalars['String']['output'];
  draftCount: Scalars['Int']['output'];
  outstanding: Scalars['Float']['output'];
  overdue: Scalars['Float']['output'];
  overdueCount: Scalars['Int']['output'];
  paidThisMonth: Scalars['Float']['output'];
};

export type AdvertiserNetworkRelationship = {
  advertiserId: Scalars['String']['output'];
  networkId: Scalars['String']['output'];
  status: AdvertiserNetworkRelationshipStatus;
};

export type AdvertiserNetworkRelationshipFilter = {
  organizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<AdvertiserNetworkRelationshipStatus>>;
};

export type AdvertiserNetworkRelationshipInput = {
  advertiserId: Scalars['String']['input'];
  networkId: Scalars['String']['input'];
  status: AdvertiserNetworkRelationshipStatus;
};

export enum AdvertiserNetworkRelationshipStatus {
  Approved = 'APPROVED',
  Blocked = 'BLOCKED',
  Pending = 'PENDING',
  RejectedByNetwork = 'REJECTED_BY_NETWORK'
}

export type AdvertiserOfferFilter = {
  isApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OfferStatus>;
  visibility?: InputMaybe<OfferVisibility>;
};

export type AdvertiserOfferSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<AdvertiserOfferSortBy>;
  sortQuery?: InputMaybe<SortQuery>;
};

export enum AdvertiserOfferSortBy {
  Clicks = 'CLICKS',
  Conversions = 'CONVERSIONS',
  NumberOfJumps = 'NUMBER_OF_JUMPS',
  OfferId = 'OFFER_ID',
  OfferName = 'OFFER_NAME',
  Profit = 'PROFIT',
  RemainingDailyClickBudget = 'REMAINING_DAILY_CLICK_BUDGET',
  RemainingDailyConversionBudget = 'REMAINING_DAILY_CONVERSION_BUDGET',
  RemainingDailyImpressionBudget = 'REMAINING_DAILY_IMPRESSION_BUDGET',
  RemainingDailyRevenueBudget = 'REMAINING_DAILY_REVENUE_BUDGET',
  RemainingForeverClickBudget = 'REMAINING_FOREVER_CLICK_BUDGET',
  RemainingForeverConversionBudget = 'REMAINING_FOREVER_CONVERSION_BUDGET',
  RemainingForeverImpressionBudget = 'REMAINING_FOREVER_IMPRESSION_BUDGET',
  RemainingForeverRevenueBudget = 'REMAINING_FOREVER_REVENUE_BUDGET',
  RemainingHourlyClickBudget = 'REMAINING_HOURLY_CLICK_BUDGET',
  RemainingHourlyConversionBudget = 'REMAINING_HOURLY_CONVERSION_BUDGET',
  RemainingHourlyImpressionBudget = 'REMAINING_HOURLY_IMPRESSION_BUDGET',
  RemainingHourlyRevenueBudget = 'REMAINING_HOURLY_REVENUE_BUDGET',
  RemainingMonthlyConversionBudget = 'REMAINING_MONTHLY_CONVERSION_BUDGET',
  RemainingMonthlyRevenueBudget = 'REMAINING_MONTHLY_REVENUE_BUDGET',
  TheyGet = 'THEY_GET',
  WeGet = 'WE_GET'
}

export type AdvertiserRebate = {
  advertisers?: Maybe<Array<Advertiser>>;
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['LocalDateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  offers?: Maybe<Array<Offer>>;
  rate: Scalars['Float']['output'];
  start?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type AdvertiserRebateConnection = {
  edges: Array<AdvertiserRebateEdge>;
  totalCount: Scalars['Int']['output'];
};

export type AdvertiserRebateEdge = {
  node: AdvertiserRebate;
};

export type AdvertiserRebateFilter = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdvertiserRebateInput = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['LocalDateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  rate: Scalars['Float']['input'];
  start?: InputMaybe<Scalars['LocalDateTime']['input']>;
};

export enum AdvertiserReportImportColumnFormat {
  BlenderNetwork = 'BLENDER_NETWORK',
  DateAuto = 'DATE_AUTO',
  DateDdMmYyyy = 'DATE_DD_MM_YYYY',
  DateMinusDdMmYyyy = 'DATE_MINUS_DD_MM_YYYY',
  DateMinusMmDdYyyy = 'DATE_MINUS_MM_DD_YYYY',
  DateMmDdYyyy = 'DATE_MM_DD_YYYY',
  MonetaryCommaSeparator = 'MONETARY_COMMA_SEPARATOR',
  MonetaryDotSeparator = 'MONETARY_DOT_SEPARATOR',
  RiseNetwork = 'RISE_NETWORK',
  String = 'STRING'
}

export enum AdvertiserReportImportField {
  AdvertiserId = 'ADVERTISER_ID',
  AdvertiserOfferId = 'ADVERTISER_OFFER_ID',
  AdClicks = 'AD_CLICKS',
  Country = 'COUNTRY',
  Currency = 'CURRENCY',
  EventTypeId = 'EVENT_TYPE_ID',
  Hour = 'HOUR',
  MonetizedSearches = 'MONETIZED_SEARCHES',
  OfferId = 'OFFER_ID',
  PublisherId = 'PUBLISHER_ID',
  PublisherSubId = 'PUBLISHER_SUB_ID',
  PubGroup = 'PUB_GROUP',
  Searches = 'SEARCHES',
  Term = 'TERM',
  TheyGet = 'THEY_GET',
  Time = 'TIME',
  Tq = 'TQ',
  WeGet = 'WE_GET'
}

export type AdvertiserReportImportFieldPosition = {
  defaultValue?: Maybe<Scalars['String']['output']>;
  field: AdvertiserReportImportField;
  format: AdvertiserReportImportColumnFormat;
  position?: Maybe<Scalars['Int']['output']>;
};

export type AdvertiserReportImportFieldPositionInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  field: AdvertiserReportImportField;
  format: AdvertiserReportImportColumnFormat;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type AdvertiserReportImportSpec = {
  csvSeparator?: Maybe<Scalars['String']['output']>;
  csvSkipRows?: Maybe<Scalars['Int']['output']>;
  cumulativeModeEnabled?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<AdvertiserReportImportFieldPosition>;
  id: Scalars['String']['output'];
  inboxEmail?: Maybe<Scalars['String']['output']>;
  inboxEmailEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  tasks?: Maybe<Array<AdvertiserReportImportTask>>;
};

export type AdvertiserReportImportSpecConnection = {
  edges?: Maybe<Array<AdvertiserReportImportSpecEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type AdvertiserReportImportSpecEdge = {
  node: AdvertiserReportImportSpec;
};

export type AdvertiserReportImportSpecFilter = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdvertiserReportImportSpecInput = {
  csvSeparator?: InputMaybe<Scalars['String']['input']>;
  csvSkipRows?: InputMaybe<Scalars['Int']['input']>;
  cumulativeModeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields: Array<AdvertiserReportImportFieldPositionInput>;
  inboxEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type AdvertiserReportImportTask = {
  createdAt?: Maybe<Scalars['LocalDateTime']['output']>;
  fileUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  result?: Maybe<AdvertiserReportImportTaskResult>;
  spec: AdvertiserReportImportSpec;
  status: AdvertiserReportImportTaskStatus;
  statusMessage?: Maybe<Scalars['String']['output']>;
  submittedViaEmail: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type AdvertiserReportImportTaskConnection = {
  edges?: Maybe<Array<AdvertiserReportImportTaskEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type AdvertiserReportImportTaskEdge = {
  node: AdvertiserReportImportTask;
};

export type AdvertiserReportImportTaskFilter = {
  specIds?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<AdvertiserReportImportTaskStatus>>;
};

export type AdvertiserReportImportTaskInput = {
  fileUrl: Scalars['String']['input'];
  specId: Scalars['String']['input'];
};

export type AdvertiserReportImportTaskResult = {
  end: Scalars['LocalDateTime']['output'];
  offerIds: Array<Scalars['String']['output']>;
  publisherIds: Array<Scalars['String']['output']>;
  start: Scalars['LocalDateTime']['output'];
};

export enum AdvertiserReportImportTaskStatus {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Queued = 'QUEUED'
}

/** Specific sort type for Advertisers */
export type AdvertiserSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<AdvertiserSortBy>;
  sortQuery?: InputMaybe<SortQuery>;
};

/** Describes the fields on which the Advertiser can be sorted on */
export enum AdvertiserSortBy {
  AdvertiserId = 'ADVERTISER_ID',
  Clicks = 'CLICKS',
  Conversions = 'CONVERSIONS',
  Profit = 'PROFIT',
  TheyGet = 'THEY_GET',
  WeGet = 'WE_GET'
}

/** The status of the advertiser */
export enum AdvertiserStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Deleted = 'DELETED',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type AdvertiserTag = {
  advertisers?: Maybe<Array<Advertiser>>;
  name: Scalars['String']['output'];
  numberOfAdvertisers: Scalars['Int']['output'];
  preApproved: Scalars['Boolean']['output'];
};

export enum AdvertiserType {
  Agency = 'AGENCY',
  Direct = 'DIRECT',
  Fbmarketer = 'FBMARKETER',
  Network = 'NETWORK'
}

export type App = {
  advertiser: Advertiser;
  eventTypes: Array<AppEventType>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  report: Array<Report>;
  storeApps?: Maybe<Array<StoreApp>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};


export type AppReportArgs = {
  queries: Array<ReportQuery>;
};

export type AppConnection = {
  edges?: Maybe<Array<AppEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type AppDetails = {
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  screenshots?: Maybe<Array<Scalars['String']['output']>>;
  storeUrl?: Maybe<Scalars['String']['output']>;
};

export type AppEdge = {
  node: App;
};

export enum AppEvent {
  Acquisition = 'ACQUISITION',
  Monetization = 'MONETIZATION',
  Quality = 'QUALITY'
}

export type AppEventType = {
  app: App;
  id: Scalars['String']['output'];
  mappingId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  types?: Maybe<Array<AppEvent>>;
};

export type AppEventTypeConnection = {
  edges?: Maybe<Array<AppEventTypeEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type AppEventTypeEdge = {
  node: AppEventType;
};

export type AppEventTypeFilter = {
  appIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AppEventTypeInput = {
  appId: Scalars['String']['input'];
  mappingId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  types?: InputMaybe<Array<AppEvent>>;
};

export type AppFilter = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  storeAppIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AppInput = {
  advertiserId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AppMetadata = {
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  developer?: Maybe<Scalars['String']['output']>;
  icons?: Maybe<Array<Maybe<AppMetadataIcon>>>;
  id?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  minVersion?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  thumbs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AppMetadataIcon = {
  size?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum AppReportDimension {
  AdvertiserId = 'ADVERTISER_ID',
  AppEventId = 'APP_EVENT_ID',
  AppEventName = 'APP_EVENT_NAME',
  AppId = 'APP_ID',
  AppSource = 'APP_SOURCE',
  AppStoreAppId = 'APP_STORE_APP_ID',
  InstallDay = 'INSTALL_DAY',
  InstallHour = 'INSTALL_HOUR',
  InstallMinute = 'INSTALL_MINUTE',
  InstallMonth = 'INSTALL_MONTH',
  InstallWeek = 'INSTALL_WEEK',
  OfferEventId = 'OFFER_EVENT_ID',
  OfferEventName = 'OFFER_EVENT_NAME',
  /** POSTBACK_GEO_UTC_OFFSET, */
  OfferId = 'OFFER_ID',
  OfferName = 'OFFER_NAME',
  PostbackDeviceLanguage = 'POSTBACK_DEVICE_LANGUAGE',
  PostbackDeviceMake = 'POSTBACK_DEVICE_MAKE',
  PostbackDeviceModel = 'POSTBACK_DEVICE_MODEL',
  PostbackDeviceOs = 'POSTBACK_DEVICE_OS',
  PostbackDeviceOsVersion = 'POSTBACK_DEVICE_OS_VERSION',
  PostbackGeoCity = 'POSTBACK_GEO_CITY',
  PostbackGeoCountry = 'POSTBACK_GEO_COUNTRY',
  PostbackGeoRegion = 'POSTBACK_GEO_REGION',
  PublisherAppId = 'PUBLISHER_APP_ID',
  PublisherAppName = 'PUBLISHER_APP_NAME',
  PublisherCreative = 'PUBLISHER_CREATIVE',
  PublisherId = 'PUBLISHER_ID',
  PublisherName = 'PUBLISHER_NAME',
  PublisherPlacement = 'PUBLISHER_PLACEMENT',
  PublisherSite = 'PUBLISHER_SITE',
  PublisherSubId = 'PUBLISHER_SUB_ID',
  PublisherSubSubId = 'PUBLISHER_SUB_SUB_ID',
  PublisherUnique1 = 'PUBLISHER_UNIQUE1',
  PublisherUnique2 = 'PUBLISHER_UNIQUE2',
  PublisherUnique3 = 'PUBLISHER_UNIQUE3'
}

export type AppReportDimensionRecord = {
  field: AppReportDimension;
  value: UserProvidedValue;
};

export type AppReportFilter = {
  field: AppReportDimension;
  operator: GenericFilterOperator;
  values: Array<Scalars['String']['input']>;
};

export enum AppReportGranularity {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type AppSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<AppSortBy>;
  sortQuery?: InputMaybe<SortQuery>;
};

export enum AppSortBy {
  AppId = 'APP_ID',
  AppName = 'APP_NAME'
}

export enum AppStoreType {
  AppStore = 'APP_STORE',
  HuaweiStore = 'HUAWEI_STORE',
  NoStore = 'NO_STORE',
  PlayStore = 'PLAY_STORE',
  SamsungStore = 'SAMSUNG_STORE',
  Web = 'WEB'
}

export type AppToken = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  test?: Maybe<Scalars['Boolean']['output']>;
  token: Scalars['String']['output'];
  type: AppTokenType;
  url: Scalars['String']['output'];
};

export type AppTokenInput = {
  name: Scalars['String']['input'];
  storeAppId: Scalars['String']['input'];
  test?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
  type: AppTokenType;
};

export enum AppTokenType {
  S2S = 'S2S',
  Sdk = 'SDK'
}

export type AppsflyerBlockingReportConnection = {
  csvDownloadUrl: Scalars['String']['output'];
  edges: Array<AppsflyerBlockingReportEdge>;
  totalCount: Scalars['Int']['output'];
};

export type AppsflyerBlockingReportEdge = {
  node: AppsflyerBlockingReportRow;
};

export enum AppsflyerBlockingReportField {
  Ad = 'AD',
  Adset = 'ADSET',
  AdsetId = 'ADSET_ID',
  AdvertisingId = 'ADVERTISING_ID',
  AdId = 'AD_ID',
  AdType = 'AD_TYPE',
  AmazoneFireId = 'AMAZONE_FIRE_ID',
  AndroidId = 'ANDROID_ID',
  AppsFlyerId = 'APPS_FLYER_ID',
  AppId = 'APP_ID',
  AppName = 'APP_NAME',
  AppVersion = 'APP_VERSION',
  Att = 'ATT',
  AttributedTouchTime = 'ATTRIBUTED_TOUCH_TIME',
  AttributedTouchType = 'ATTRIBUTED_TOUCH_TYPE',
  AttributionLookback = 'ATTRIBUTION_LOOKBACK',
  BlockedReason = 'BLOCKED_REASON',
  BlockedReasonRule = 'BLOCKED_REASON_RULE',
  BlockedReasonValue = 'BLOCKED_REASON_VALUE',
  BlockedSubReason = 'BLOCKED_SUB_REASON',
  BlockingType = 'BLOCKING_TYPE',
  BundleId = 'BUNDLE_ID',
  Campaign = 'CAMPAIGN',
  CampaignId = 'CAMPAIGN_ID',
  Carrier = 'CARRIER',
  Channel = 'CHANNEL',
  City = 'CITY',
  Contributor1Campaign = 'CONTRIBUTOR1_CAMPAIGN',
  Contributor1MatchType = 'CONTRIBUTOR1_MATCH_TYPE',
  Contributor1MediaSource = 'CONTRIBUTOR1_MEDIA_SOURCE',
  Contributor1Partner = 'CONTRIBUTOR1_PARTNER',
  Contributor1TouchTime = 'CONTRIBUTOR1_TOUCH_TIME',
  Contributor1TouchType = 'CONTRIBUTOR1_TOUCH_TYPE',
  Contributor2Campaign = 'CONTRIBUTOR2_CAMPAIGN',
  Contributor2MatchType = 'CONTRIBUTOR2_MATCH_TYPE',
  Contributor2MediaSource = 'CONTRIBUTOR2_MEDIA_SOURCE',
  Contributor2Partner = 'CONTRIBUTOR2_PARTNER',
  Contributor2TouchTime = 'CONTRIBUTOR2_TOUCH_TIME',
  Contributor2TouchType = 'CONTRIBUTOR2_TOUCH_TYPE',
  Contributor3Campaign = 'CONTRIBUTOR3_CAMPAIGN',
  Contributor3MatchType = 'CONTRIBUTOR3_MATCH_TYPE',
  Contributor3MediaSource = 'CONTRIBUTOR3_MEDIA_SOURCE',
  Contributor3Partner = 'CONTRIBUTOR3_PARTNER',
  Contributor3TouchTime = 'CONTRIBUTOR3_TOUCH_TIME',
  Contributor3TouchType = 'CONTRIBUTOR3_TOUCH_TYPE',
  CostCurrency = 'COST_CURRENCY',
  CostModel = 'COST_MODEL',
  CostValue = 'COST_VALUE',
  Count = 'COUNT',
  CountryCode = 'COUNTRY_CODE',
  CustomerUserId = 'CUSTOMER_USER_ID',
  DeeplinkUrl = 'DEEPLINK_URL',
  DetectionDate = 'DETECTION_DATE',
  DeviceCategory = 'DEVICE_CATEGORY',
  DeviceModel = 'DEVICE_MODEL',
  DeviceType = 'DEVICE_TYPE',
  Dma = 'DMA',
  EventName = 'EVENT_NAME',
  EventRevenue = 'EVENT_REVENUE',
  EventRevenueCurrency = 'EVENT_REVENUE_CURRENCY',
  EventRevenueUsd = 'EVENT_REVENUE_USD',
  EventSource = 'EVENT_SOURCE',
  EventTimeDay = 'EVENT_TIME_DAY',
  EventTimeMonth = 'EVENT_TIME_MONTH',
  EventTimeWeek = 'EVENT_TIME_WEEK',
  EventTimeYear = 'EVENT_TIME_YEAR',
  EventValue = 'EVENT_VALUE',
  FraudReason = 'FRAUD_REASON',
  FraudSubReason = 'FRAUD_SUB_REASON',
  GooglePlayClickTime = 'GOOGLE_PLAY_CLICK_TIME',
  GooglePlayInstallBeginTime = 'GOOGLE_PLAY_INSTALL_BEGIN_TIME',
  GooglePlayReferrer = 'GOOGLE_PLAY_REFERRER',
  HttpReferer = 'HTTP_REFERER',
  Idfa = 'IDFA',
  Idfv = 'IDFV',
  Imei = 'IMEI',
  InstallTime = 'INSTALL_TIME',
  InstallTimeTz = 'INSTALL_TIME_TZ',
  Ip = 'IP',
  IsLat = 'IS_LAT',
  IsPrimaryAttribution = 'IS_PRIMARY_ATTRIBUTION',
  IsReceiptValidated = 'IS_RECEIPT_VALIDATED',
  IsRetargeting = 'IS_RETARGETING',
  Keywords = 'KEYWORDS',
  KeywordId = 'KEYWORD_ID',
  KeywordMatchType = 'KEYWORD_MATCH_TYPE',
  Language = 'LANGUAGE',
  MatchType = 'MATCH_TYPE',
  MediaSource = 'MEDIA_SOURCE',
  Oaid = 'OAID',
  Operator = 'OPERATOR',
  OriginalUrl = 'ORIGINAL_URL',
  OsVersion = 'OS_VERSION',
  Partner = 'PARTNER',
  Platform = 'PLATFORM',
  PostalCode = 'POSTAL_CODE',
  ReengagementWindow = 'REENGAGEMENT_WINDOW',
  Region = 'REGION',
  ReportType = 'REPORT_TYPE',
  RetargetingConversionType = 'RETARGETING_CONVERSION_TYPE',
  SdkVersion = 'SDK_VERSION',
  SiteId = 'SITE_ID',
  State = 'STATE',
  StoreReinstall = 'STORE_REINSTALL',
  SubParam1 = 'SUB_PARAM1',
  SubParam2 = 'SUB_PARAM2',
  SubParam3 = 'SUB_PARAM3',
  SubParam4 = 'SUB_PARAM4',
  SubParam5 = 'SUB_PARAM5',
  SubSiteId = 'SUB_SITE_ID',
  UserAgent = 'USER_AGENT',
  Wifi = 'WIFI'
}

export type AppsflyerBlockingReportFilter = {
  field: AppsflyerBlockingReportField;
  operator: GenericFilterOperator;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AppsflyerBlockingReportRecord = {
  field: AppsflyerBlockingReportField;
  value?: Maybe<UserProvidedValue>;
};

export type AppsflyerBlockingReportRow = {
  records: Array<AppsflyerBlockingReportRecord>;
};

export type AppsflyerBlockingReportSort = {
  field: AppsflyerBlockingReportField;
  order: SortOrder;
};

export type AppsflyerClickSigningConfig = {
  mode: AppsflyerClickSigningMode;
  token: Scalars['String']['output'];
};

export type AppsflyerClickSigningConfigInput = {
  mode: AppsflyerClickSigningMode;
  token: Scalars['String']['input'];
};

export type AppsflyerClickSigningFilter = {
  appId?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['LocalDateTime']['input'];
  hasBadClicks?: InputMaybe<Scalars['Boolean']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  partner?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['LocalDateTime']['input'];
};

export enum AppsflyerClickSigningMode {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Report = 'REPORT'
}

export type AppsflyerClickSigningReportConnection = {
  csvDownloadUrl: Scalars['String']['output'];
  edges?: Maybe<Array<AppsflyerClickSigningReportEdge>>;
  totalCount: Scalars['Long']['output'];
};

export type AppsflyerClickSigningReportEdge = {
  node?: Maybe<AppsflyerClickSigningRow>;
};

export type AppsflyerClickSigningRow = {
  appId: Scalars['String']['output'];
  expiredClicks?: Maybe<Scalars['Float']['output']>;
  invalidSignature?: Maybe<Scalars['Float']['output']>;
  missingSignature?: Maybe<Scalars['Float']['output']>;
  noActiveSecrets?: Maybe<Scalars['Float']['output']>;
  offers?: Maybe<Array<Offer>>;
  partner: Scalars['String']['output'];
  time: Scalars['String']['output'];
  totalClicks?: Maybe<Scalars['Float']['output']>;
  validClicks?: Maybe<Scalars['Float']['output']>;
};

export type AppsflyerMediaSourceMapping = {
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Exclusive */
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['String']['output'];
  mediaSources: Array<Scalars['String']['output']>;
  /** If null the mapping applies to every offer for the given publisher/mediaSource */
  offer?: Maybe<Offer>;
  publisher: Publisher;
  /** Inclusive */
  startDate?: Maybe<Scalars['LocalDate']['output']>;
};

export type AppsflyerMediaSourceMappingConnection = {
  edges: Array<AppsflyerMediaSourceMappingEdge>;
  totalCount: Scalars['Int']['output'];
};

export type AppsflyerMediaSourceMappingEdge = {
  node: AppsflyerMediaSourceMapping;
};

export type AppsflyerMediaSourceMappingFilter = {
  activeOn?: InputMaybe<Scalars['LocalDate']['input']>;
  mediaSource?: InputMaybe<Scalars['String']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AppsflyerMediaSourceMappingInput = {
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mediaSources: Array<Scalars['String']['input']>;
  /** Omit / null to make the mapping apply to every offer */
  offerId?: InputMaybe<Scalars['String']['input']>;
  publisherId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type AppsflyerNetworkCostUploadToken = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type AppsflyerNetworkCostUploadTokenInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type AppsflyerOfferConfig = {
  agency?: Maybe<Scalars['String']['output']>;
  appId: Scalars['String']['output'];
  campaignId?: Maybe<Scalars['String']['output']>;
  campaignName?: Maybe<Scalars['String']['output']>;
  costApiEnabled?: Maybe<Scalars['Boolean']['output']>;
  costToken?: Maybe<Scalars['String']['output']>;
  importDaysOffset: Scalars['Long']['output'];
  offerId: Scalars['String']['output'];
  retargeting?: Maybe<Scalars['String']['output']>;
  trackers: Array<AppsflyerOfferTracker>;
};

export type AppsflyerOfferConfigInput = {
  agency?: InputMaybe<Scalars['String']['input']>;
  appId: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  campaignName?: InputMaybe<Scalars['String']['input']>;
  costApiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  costToken?: InputMaybe<Scalars['String']['input']>;
  importDayOffset: Scalars['Long']['input'];
  offerId: Scalars['String']['input'];
  retargeting?: InputMaybe<Scalars['String']['input']>;
  tokenIds: Array<Scalars['String']['input']>;
};

export type AppsflyerOfferToken = {
  name: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type AppsflyerOfferTokenInput = {
  name: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type AppsflyerOfferTracker = {
  lastIngestedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  token: AppsflyerOfferToken;
};

export type AppsflyerPartnerByDateEntityEdge = {
  node: AppsflyerPartnerByDateRow;
};

export enum AppsflyerPartnerByDateField {
  AgencyPmd = 'AGENCY_PMD',
  AppId = 'APP_ID',
  Arpu = 'ARPU',
  Campaign = 'CAMPAIGN',
  Clicks = 'CLICKS',
  ConversionRate = 'CONVERSION_RATE',
  Country = 'COUNTRY',
  Ctr = 'CTR',
  CustomEvent1 = 'CUSTOM_EVENT1',
  CustomEvent2 = 'CUSTOM_EVENT2',
  CustomEvent3 = 'CUSTOM_EVENT3',
  CustomEvent4 = 'CUSTOM_EVENT4',
  CustomEvent5 = 'CUSTOM_EVENT5',
  CustomEvent6 = 'CUSTOM_EVENT6',
  CustomEvent7 = 'CUSTOM_EVENT7',
  CustomEvent8 = 'CUSTOM_EVENT8',
  CustomEvent9 = 'CUSTOM_EVENT9',
  CustomEvent10 = 'CUSTOM_EVENT10',
  CustomEvent11 = 'CUSTOM_EVENT11',
  CustomEvent12 = 'CUSTOM_EVENT12',
  CustomEvent13 = 'CUSTOM_EVENT13',
  CustomEvent14 = 'CUSTOM_EVENT14',
  CustomEvent15 = 'CUSTOM_EVENT15',
  CustomEvent16 = 'CUSTOM_EVENT16',
  CustomEvent17 = 'CUSTOM_EVENT17',
  CustomEvent18 = 'CUSTOM_EVENT18',
  CustomEvent19 = 'CUSTOM_EVENT19',
  CustomEvent20 = 'CUSTOM_EVENT20',
  CustomEvent21 = 'CUSTOM_EVENT21',
  CustomEvent22 = 'CUSTOM_EVENT22',
  CustomEvent23 = 'CUSTOM_EVENT23',
  CustomEvent24 = 'CUSTOM_EVENT24',
  CustomEvent25 = 'CUSTOM_EVENT25',
  CustomEvent26 = 'CUSTOM_EVENT26',
  CustomEvent27 = 'CUSTOM_EVENT27',
  CustomEvent28 = 'CUSTOM_EVENT28',
  CustomEvent29 = 'CUSTOM_EVENT29',
  CustomEvent30 = 'CUSTOM_EVENT30',
  CustomEvent31 = 'CUSTOM_EVENT31',
  CustomEvent32 = 'CUSTOM_EVENT32',
  CustomEvent33 = 'CUSTOM_EVENT33',
  CustomEvent34 = 'CUSTOM_EVENT34',
  CustomEvent35 = 'CUSTOM_EVENT35',
  CustomEvent36 = 'CUSTOM_EVENT36',
  CustomEvent37 = 'CUSTOM_EVENT37',
  CustomEvent38 = 'CUSTOM_EVENT38',
  CustomEvent39 = 'CUSTOM_EVENT39',
  CustomEventName1 = 'CUSTOM_EVENT_NAME1',
  CustomEventName2 = 'CUSTOM_EVENT_NAME2',
  CustomEventName3 = 'CUSTOM_EVENT_NAME3',
  CustomEventName4 = 'CUSTOM_EVENT_NAME4',
  CustomEventName5 = 'CUSTOM_EVENT_NAME5',
  CustomEventName6 = 'CUSTOM_EVENT_NAME6',
  CustomEventName7 = 'CUSTOM_EVENT_NAME7',
  CustomEventName8 = 'CUSTOM_EVENT_NAME8',
  CustomEventName9 = 'CUSTOM_EVENT_NAME9',
  CustomEventName10 = 'CUSTOM_EVENT_NAME10',
  CustomEventName11 = 'CUSTOM_EVENT_NAME11',
  CustomEventName12 = 'CUSTOM_EVENT_NAME12',
  CustomEventName13 = 'CUSTOM_EVENT_NAME13',
  CustomEventName14 = 'CUSTOM_EVENT_NAME14',
  CustomEventName15 = 'CUSTOM_EVENT_NAME15',
  CustomEventName16 = 'CUSTOM_EVENT_NAME16',
  CustomEventName17 = 'CUSTOM_EVENT_NAME17',
  CustomEventName18 = 'CUSTOM_EVENT_NAME18',
  CustomEventName19 = 'CUSTOM_EVENT_NAME19',
  CustomEventName20 = 'CUSTOM_EVENT_NAME20',
  CustomEventName21 = 'CUSTOM_EVENT_NAME21',
  CustomEventName22 = 'CUSTOM_EVENT_NAME22',
  CustomEventName23 = 'CUSTOM_EVENT_NAME23',
  CustomEventName24 = 'CUSTOM_EVENT_NAME24',
  CustomEventName25 = 'CUSTOM_EVENT_NAME25',
  CustomEventName26 = 'CUSTOM_EVENT_NAME26',
  CustomEventName27 = 'CUSTOM_EVENT_NAME27',
  CustomEventName28 = 'CUSTOM_EVENT_NAME28',
  CustomEventName29 = 'CUSTOM_EVENT_NAME29',
  CustomEventName30 = 'CUSTOM_EVENT_NAME30',
  CustomEventName31 = 'CUSTOM_EVENT_NAME31',
  CustomEventName32 = 'CUSTOM_EVENT_NAME32',
  CustomEventName33 = 'CUSTOM_EVENT_NAME33',
  CustomEventName34 = 'CUSTOM_EVENT_NAME34',
  CustomEventName35 = 'CUSTOM_EVENT_NAME35',
  CustomEventName36 = 'CUSTOM_EVENT_NAME36',
  CustomEventName37 = 'CUSTOM_EVENT_NAME37',
  CustomEventName38 = 'CUSTOM_EVENT_NAME38',
  CustomEventName39 = 'CUSTOM_EVENT_NAME39',
  DateDay = 'DATE_DAY',
  DateMonth = 'DATE_MONTH',
  DateWeek = 'DATE_WEEK',
  DateYear = 'DATE_YEAR',
  Impressions = 'IMPRESSIONS',
  Installs = 'INSTALLS',
  LoyalUsers = 'LOYAL_USERS',
  LoyalUsersInstalls = 'LOYAL_USERS_INSTALLS',
  MediaSource = 'MEDIA_SOURCE',
  Roi = 'ROI',
  Sessions = 'SESSIONS',
  TotalCost = 'TOTAL_COST',
  TotalRevenue = 'TOTAL_REVENUE'
}

export type AppsflyerPartnerByDateFilter = {
  field: AppsflyerPartnerByDateField;
  operator: GenericFilterOperator;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AppsflyerPartnerByDateRecord = {
  customLabel?: Maybe<Scalars['String']['output']>;
  field: AppsflyerPartnerByDateField;
  value?: Maybe<UserProvidedValue>;
};

export type AppsflyerPartnerByDateRow = {
  records: Array<AppsflyerPartnerByDateRecord>;
};

export type AppsflyerPartnersByDateConnection = {
  csvDownloadUrl: Scalars['String']['output'];
  edges: Array<AppsflyerPartnerByDateEntityEdge>;
  totalCount: Scalars['Long']['output'];
};

export type AppsflyerPartnersByDateSort = {
  field: AppsflyerPartnerByDateField;
  order: SortOrder;
};

export type AppsflyerPostbackInfo = {
  adNetworkName: Scalars['String']['output'];
};

export type AppsflyerPostbackInfoInput = {
  adNetworkName: Scalars['String']['input'];
};

export type AppsflyerPublisherConfig = {
  appsflyerMediaSources: Array<Scalars['String']['output']>;
  sendPostbacks?: Maybe<Scalars['Boolean']['output']>;
};

export type AppsflyerPublisherConfigInput = {
  appsflyerMediaSources: Array<Scalars['String']['input']>;
};

export type AppsflyerUploadConfig = {
  appId?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  campaignName?: Maybe<Scalars['String']['output']>;
  mediaSource?: Maybe<Scalars['String']['output']>;
  networkCostConfigTokenId?: Maybe<Scalars['String']['output']>;
  offerId: Scalars['String']['output'];
};

export type AppsflyerUploadConfigInput = {
  appId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  campaignName?: InputMaybe<Scalars['String']['input']>;
  mediaSource?: InputMaybe<Scalars['String']['input']>;
  networkCostConfigTokenId?: InputMaybe<Scalars['String']['input']>;
  offerId: Scalars['String']['input'];
};

export type AttributionExpiration = {
  offerId?: Maybe<Scalars['String']['output']>;
  pubId?: Maybe<Scalars['String']['output']>;
  windowSeconds: Scalars['Long']['output'];
};

export type AttributionExpirationFilter = {
  offerId?: InputMaybe<Scalars['String']['input']>;
  pubId?: InputMaybe<Scalars['String']['input']>;
};

export type AttributionExpirationInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
  pubId?: InputMaybe<Scalars['String']['input']>;
  windowSeconds: Scalars['Long']['input'];
};

export type AttributionExpirationKey = {
  offerId?: InputMaybe<Scalars['String']['input']>;
  pubId?: InputMaybe<Scalars['String']['input']>;
};

export type AttributionPartnerData = {
  adGroupName?: Maybe<Scalars['String']['output']>;
  adid?: Maybe<Scalars['String']['output']>;
  appId?: Maybe<Scalars['String']['output']>;
  appTitle?: Maybe<Scalars['String']['output']>;
  appVersion?: Maybe<Scalars['String']['output']>;
  clickAttributionWindow?: Maybe<Scalars['String']['output']>;
  clickTimestamp?: Maybe<Scalars['String']['output']>;
  conversionDuration?: Maybe<Scalars['String']['output']>;
  conversionTimestamp?: Maybe<Scalars['String']['output']>;
  cpuType?: Maybe<Scalars['String']['output']>;
  creativeName?: Maybe<Scalars['String']['output']>;
  deeplink?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  eventValue?: Maybe<Scalars['String']['output']>;
  gpInstalledAt?: Maybe<Scalars['String']['output']>;
  gpOpenedAt?: Maybe<Scalars['String']['output']>;
  hardwareName?: Maybe<Scalars['String']['output']>;
  impressionBased?: Maybe<Scalars['Boolean']['output']>;
  installBeginTime?: Maybe<Scalars['String']['output']>;
  installFinishTime?: Maybe<Scalars['String']['output']>;
  installTimestamp?: Maybe<Scalars['String']['output']>;
  isOrganic?: Maybe<Scalars['Boolean']['output']>;
  lifetimeSessionCount?: Maybe<Scalars['String']['output']>;
  matchType?: Maybe<Scalars['String']['output']>;
  networkType?: Maybe<Scalars['String']['output']>;
  originalSaleAmount?: Maybe<Scalars['String']['output']>;
  originalSaleAmountCurrency?: Maybe<Scalars['String']['output']>;
  partnerParameters?: Maybe<Scalars['String']['output']>;
  postbackId?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  rejectionReasonValue?: Maybe<Scalars['String']['output']>;
  saleAmount?: Maybe<Scalars['String']['output']>;
  saleAmountCurrency?: Maybe<Scalars['String']['output']>;
  sdkVersion?: Maybe<Scalars['String']['output']>;
  sessionsCount?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trackerName?: Maybe<Scalars['String']['output']>;
  trackingEnabled?: Maybe<Scalars['Boolean']['output']>;
  trackingLimited?: Maybe<Scalars['Boolean']['output']>;
};

export type AttributionPartnerDataInput = {
  adGroupName?: InputMaybe<Scalars['String']['input']>;
  adid?: InputMaybe<Scalars['String']['input']>;
  appId?: InputMaybe<Scalars['String']['input']>;
  appTitle?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  clickAttributionWindow?: InputMaybe<Scalars['String']['input']>;
  clickTimestamp?: InputMaybe<Scalars['String']['input']>;
  conversionDuration?: InputMaybe<Scalars['String']['input']>;
  conversionTimestamp?: InputMaybe<Scalars['String']['input']>;
  cpuType?: InputMaybe<Scalars['String']['input']>;
  creativeName?: InputMaybe<Scalars['String']['input']>;
  deeplink?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  eventValue?: InputMaybe<Scalars['String']['input']>;
  gpInstalledAt?: InputMaybe<Scalars['String']['input']>;
  gpOpenedAt?: InputMaybe<Scalars['String']['input']>;
  hardwareName?: InputMaybe<Scalars['String']['input']>;
  impressionBased?: InputMaybe<Scalars['Boolean']['input']>;
  installBeginTime?: InputMaybe<Scalars['String']['input']>;
  installFinishTime?: InputMaybe<Scalars['String']['input']>;
  installTimestamp?: InputMaybe<Scalars['String']['input']>;
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  lifetimeSessionCount?: InputMaybe<Scalars['String']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  networkType?: InputMaybe<Scalars['String']['input']>;
  partnerParameters?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonValue?: InputMaybe<Scalars['String']['input']>;
  saleAmount?: InputMaybe<Scalars['String']['input']>;
  saleAmountCurrency?: InputMaybe<Scalars['String']['input']>;
  sdkVersion?: InputMaybe<Scalars['String']['input']>;
  sessionsCount?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  trackerName?: InputMaybe<Scalars['String']['input']>;
  trackingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  trackingLimited?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AttributionType {
  JsPixel = 'JS_PIXEL',
  JsSwaarmSdk = 'JS_SWAARM_SDK',
  Mmp = 'MMP',
  Swaarm = 'SWAARM'
}

export type Audience = {
  description: Scalars['String']['output'];
  filters: Array<AudienceFilter>;
  id: Scalars['String']['output'];
  lastGeneratedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  name: Scalars['String']['output'];
  pushNotifications: PushNotificationConnection;
  users: Array<RewardedUser>;
};


export type AudiencePushNotificationsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PushNotificationStatus>;
};

export type AudienceConnection = {
  edges: Array<AudienceEdge>;
  totalCount: Scalars['Int']['output'];
};

export type AudienceEdge = {
  node: Audience;
};

export type AudienceFilter = {
  field: AudienceFilterField;
  operator: AudienceFilterOperator;
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export enum AudienceFilterField {
  RewardedUserId = 'REWARDED_USER_ID',
  UserCompletedAtLeastOneOfferWithTag = 'USER_COMPLETED_AT_LEAST_ONE_OFFER_WITH_TAG',
  UserCompletedOffer = 'USER_COMPLETED_OFFER',
  UserCompletedOfferAndEvent = 'USER_COMPLETED_OFFER_AND_EVENT',
  UserDeviceIsInCountry = 'USER_DEVICE_IS_IN_COUNTRY',
  UserDeviceOs = 'USER_DEVICE_OS',
  UserGainedPointsInPeriodOfTime = 'USER_GAINED_POINTS_IN_PERIOD_OF_TIME',
  UserHasAtLeastPoints = 'USER_HAS_AT_LEAST_POINTS',
  UserHasOffer = 'USER_HAS_OFFER',
  UserHasOfferWithTag = 'USER_HAS_OFFER_WITH_TAG',
  UserHasPaidPayment = 'USER_HAS_PAID_PAYMENT',
  UserIsActive = 'USER_IS_ACTIVE',
  UserIsNotActive = 'USER_IS_NOT_ACTIVE',
  UserOpenPayment = 'USER_OPEN_PAYMENT'
}

export type AudienceFilterInput = {
  field: AudienceFilterField;
  operator: AudienceFilterOperator;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum AudienceFilterOperator {
  In = 'IN',
  NotIn = 'NOT_IN'
}

export type AudienceInput = {
  description: Scalars['String']['input'];
  filters: Array<AudienceFilterInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type AudiencesFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type Audit = {
  advertiser?: Maybe<Advertiser>;
  advertiserBatchOperation?: Maybe<AdvertiserBatchOperation>;
  affectedEntityId: Scalars['String']['output'];
  budget?: Maybe<Budget>;
  changedAt: Scalars['String']['output'];
  changedBy: Scalars['String']['output'];
  eventType?: Maybe<EventType>;
  fields: Array<AuditChangeField>;
  id: Scalars['ID']['output'];
  kpi?: Maybe<Kpi>;
  offer?: Maybe<Offer>;
  offerBatchOperation?: Maybe<OfferBatchOperation>;
  op: AuditOperation;
  payout?: Maybe<Payout>;
  publisher?: Maybe<Publisher>;
  publisherBatchOperation?: Maybe<PublisherBatchOperation>;
  rule?: Maybe<AutomationRule>;
  type: AuditEntityType;
  undoable: Scalars['Boolean']['output'];
};

export type AuditChangeField = {
  current?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  previous?: Maybe<Scalars['String']['output']>;
};

export type AuditConnection = {
  edges: Array<AuditEdge>;
  totalCount: Scalars['Int']['output'];
};

export type AuditEdge = {
  node: Audit;
};

export enum AuditEntityType {
  AdjustUploadConfig = 'ADJUST_UPLOAD_CONFIG',
  AdvancedTargeting = 'ADVANCED_TARGETING',
  Advertiser = 'ADVERTISER',
  AdvertiserBatchOperations = 'ADVERTISER_BATCH_OPERATIONS',
  AdvertiserBillingProfile = 'ADVERTISER_BILLING_PROFILE',
  AdvertiserBlockedPublisher = 'ADVERTISER_BLOCKED_PUBLISHER',
  AdvertiserConfig = 'ADVERTISER_CONFIG',
  AdvertiserContact = 'ADVERTISER_CONTACT',
  AdvertiserInvoice = 'ADVERTISER_INVOICE',
  AdvertiserRebate = 'ADVERTISER_REBATE',
  AdvertiserReportImportSpec = 'ADVERTISER_REPORT_IMPORT_SPEC',
  AdvertiserReportImportTask = 'ADVERTISER_REPORT_IMPORT_TASK',
  App = 'APP',
  AppsflyerMediaSourceMapping = 'APPSFLYER_MEDIA_SOURCE_MAPPING',
  AppsflyerOfferConfig = 'APPSFLYER_OFFER_CONFIG',
  AppsflyerUploadConfig = 'APPSFLYER_UPLOAD_CONFIG',
  AppEventType = 'APP_EVENT_TYPE',
  AppToken = 'APP_TOKEN',
  AttributionExpiration = 'ATTRIBUTION_EXPIRATION',
  Audience = 'AUDIENCE',
  AutomationRule = 'AUTOMATION_RULE',
  AutoApprovalConfig = 'AUTO_APPROVAL_CONFIG',
  BigQueryExportConfig = 'BIG_QUERY_EXPORT_CONFIG',
  BlacklistedSubid = 'BLACKLISTED_SUBID',
  Budget = 'BUDGET',
  ClickBudget = 'CLICK_BUDGET',
  ControlledAccess = 'CONTROLLED_ACCESS',
  CreativePack = 'CREATIVE_PACK',
  EvaluatedPostback = 'EVALUATED_POSTBACK',
  EventLogFile = 'EVENT_LOG_FILE',
  EventType = 'EVENT_TYPE',
  EventValueExtractionRule = 'EVENT_VALUE_EXTRACTION_RULE',
  FeedApiConfiguration = 'FEED_API_CONFIGURATION',
  Filler = 'FILLER',
  FormDefinition = 'FORM_DEFINITION',
  FraudPolicyConfig = 'FRAUD_POLICY_CONFIG',
  ImpressionBudget = 'IMPRESSION_BUDGET',
  Kpi = 'KPI',
  LandingPage = 'LANDING_PAGE',
  LeadForwardingEndpoint = 'LEAD_FORWARDING_ENDPOINT',
  Offer = 'OFFER',
  OfferAccess = 'OFFER_ACCESS',
  OfferBatchOperations = 'OFFER_BATCH_OPERATIONS',
  OfferFlags = 'OFFER_FLAGS',
  OfferIntegration = 'OFFER_INTEGRATION',
  Organization = 'ORGANIZATION',
  PartnerPublisherConfig = 'PARTNER_PUBLISHER_CONFIG',
  Payout = 'PAYOUT',
  PayoutConversionPolicy = 'PAYOUT_CONVERSION_POLICY',
  PayoutMargin = 'PAYOUT_MARGIN',
  PointsExchange = 'POINTS_EXCHANGE',
  PostbackLink = 'POSTBACK_LINK',
  PostbackModification = 'POSTBACK_MODIFICATION',
  Publisher = 'PUBLISHER',
  PublisherApiKey = 'PUBLISHER_API_KEY',
  PublisherBatchOperations = 'PUBLISHER_BATCH_OPERATIONS',
  PublisherContact = 'PUBLISHER_CONTACT',
  PublisherGroup = 'PUBLISHER_GROUP',
  PublisherIntegration = 'PUBLISHER_INTEGRATION',
  PublisherMargin = 'PUBLISHER_MARGIN',
  PublisherPayment = 'PUBLISHER_PAYMENT',
  PubGroup = 'PUB_GROUP',
  PushNotification = 'PUSH_NOTIFICATION',
  RealtimeIntegration = 'REALTIME_INTEGRATION',
  RecommendationLink = 'RECOMMENDATION_LINK',
  RedirectionRule = 'REDIRECTION_RULE',
  RewardedUser = 'REWARDED_USER',
  RewardedUserSupportTicket = 'REWARDED_USER_SUPPORT_TICKET',
  RewardosApp = 'REWARDOS_APP',
  RuleCustomization = 'RULE_CUSTOMIZATION',
  SanForwardingSettings = 'SAN_FORWARDING_SETTINGS',
  SearchIntegration = 'SEARCH_INTEGRATION',
  ServiceConfig = 'SERVICE_CONFIG',
  SkadMapping = 'SKAD_MAPPING',
  SkadNetwork = 'SKAD_NETWORK',
  SkadPostbackLink = 'SKAD_POSTBACK_LINK',
  SmartLink = 'SMART_LINK',
  SmartLinkLandingPage = 'SMART_LINK_LANDING_PAGE',
  StoreApp = 'STORE_APP',
  TargetedLead = 'TARGETED_LEAD',
  TargetedPayout = 'TARGETED_PAYOUT',
  TheyGetPayout = 'THEY_GET_PAYOUT',
  TheyGetPointsPayout = 'THEY_GET_POINTS_PAYOUT',
  TrafficTags = 'TRAFFIC_TAGS',
  TrafficTargeting = 'TRAFFIC_TARGETING',
  User = 'USER',
  WeGetPayout = 'WE_GET_PAYOUT',
  WeGetPointsPayout = 'WE_GET_POINTS_PAYOUT'
}

export type AuditFilter = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  advertiserWorkflowIds?: InputMaybe<Array<Scalars['String']['input']>>;
  changedBy?: InputMaybe<Scalars['String']['input']>;
  entityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  isRobot?: InputMaybe<Array<AuditUserType>>;
  kpiIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offerWorkflowIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherWorkflowIds?: InputMaybe<Array<Scalars['String']['input']>>;
  rewardedUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ruleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  time?: InputMaybe<AuditFilterTime>;
  types?: InputMaybe<Array<AuditEntityType>>;
  undoable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuditFilterTime = {
  end: Scalars['LocalDateTime']['input'];
  start: Scalars['LocalDateTime']['input'];
};

export enum AuditOperation {
  Create = 'CREATE',
  Delete = 'DELETE',
  Undo = 'UNDO',
  Update = 'UPDATE'
}

export enum AuditUserType {
  Organic = 'ORGANIC',
  Robot = 'ROBOT'
}

export enum AuthChallenge {
  AccountMigrationRequired = 'ACCOUNT_MIGRATION_REQUIRED',
  NewPasswordRequired = 'NEW_PASSWORD_REQUIRED',
  None = 'NONE'
}

export type AuthChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  newPasswordConfirm: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type AuthChangePasswordNewUserInput = {
  newPassword: Scalars['String']['input'];
  newPasswordConfirm: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type AuthLog = {
  createdAt: Scalars['LocalDateTime']['output'];
  geo: Geo;
  id: Scalars['String']['output'];
  user?: Maybe<User>;
  userAgent: Scalars['String']['output'];
  userIp: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type AuthLogConnection = {
  edges?: Maybe<Array<AuthLogEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type AuthLogEdge = {
  node: AuthLog;
};

export type AuthLoginInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type AuthRefreshTokenInput = {
  refreshToken: Scalars['String']['input'];
};

export type AuthResponse = {
  authChallenge: AuthChallenge;
  isNewUser?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<AuthToken>;
  user?: Maybe<User>;
};

export type AuthToken = {
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  refreshToken: Scalars['String']['output'];
  tokenType: Scalars['String']['output'];
};

export type AutoApprovalConfig = {
  advertisers: Array<Advertiser>;
  containsTracker?: Maybe<Scalars['Boolean']['output']>;
  countries: Array<Scalars['String']['output']>;
  defaultBudget?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  maxJumps?: Maybe<Scalars['Int']['output']>;
  maxRepetitions?: Maybe<Scalars['Int']['output']>;
  maxWeGet?: Maybe<Scalars['Float']['output']>;
  minWeGet?: Maybe<Scalars['Float']['output']>;
  noDirectOffers?: Maybe<Scalars['Boolean']['output']>;
  platforms: Array<PlatformType>;
  reachesStore?: Maybe<Scalars['Boolean']['output']>;
  useConfigTargeting?: Maybe<Scalars['Boolean']['output']>;
};

export type AutoApprovalConfigFilter = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
};

export type AutoApprovalConfigInput = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  containsTracker?: InputMaybe<Scalars['Boolean']['input']>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultBudget?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxJumps?: InputMaybe<Scalars['Int']['input']>;
  maxRepetitions?: InputMaybe<Scalars['Int']['input']>;
  maxWeGet?: InputMaybe<Scalars['Float']['input']>;
  minWeGet?: InputMaybe<Scalars['Float']['input']>;
  noDirectOffers?: InputMaybe<Scalars['Boolean']['input']>;
  platforms?: InputMaybe<Array<PlatformType>>;
  reachesStore?: InputMaybe<Scalars['Boolean']['input']>;
  useConfigTargeting?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutomationRule = {
  actions: Array<AutomationRuleAction>;
  description?: Maybe<Scalars['String']['output']>;
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  filters?: Maybe<Array<AutomationRuleFilter>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  retroactive?: Maybe<Scalars['Boolean']['output']>;
  status: AutomationRuleStaus;
  trigger: AutomationRuleTrigger;
};

export type AutomationRuleAction = {
  actionType: AutomationRuleActionType;
  value?: Maybe<AutomationRuleValue>;
  valueType: AutomationRuleValueType;
};

export type AutomationRuleActionInput = {
  actionType: AutomationRuleActionType;
  value?: InputMaybe<AutomationRuleValueInput>;
  valueType: AutomationRuleValueType;
};

export enum AutomationRuleActionType {
  ApproveOnSelectedOffers = 'APPROVE_ON_SELECTED_OFFERS',
  ApprovePublisher = 'APPROVE_PUBLISHER',
  ApprovePublisherIfNotBlocked = 'APPROVE_PUBLISHER_IF_NOT_BLOCKED',
  ApprovePublisherOnAllPrivateOffers = 'APPROVE_PUBLISHER_ON_ALL_PRIVATE_OFFERS',
  ApprovePublisherOnAllPublicOffers = 'APPROVE_PUBLISHER_ON_ALL_PUBLIC_OFFERS',
  BlockOnSelectedOffers = 'BLOCK_ON_SELECTED_OFFERS',
  BlockPublisher = 'BLOCK_PUBLISHER',
  BlockPublisherIfApproved = 'BLOCK_PUBLISHER_IF_APPROVED',
  BlockPublisherOnAllOffers = 'BLOCK_PUBLISHER_ON_ALL_OFFERS',
  BlockSubPublisher = 'BLOCK_SUB_PUBLISHER',
  CreateOfferPubClickBudget = 'CREATE_OFFER_PUB_CLICK_BUDGET',
  CreateOfferPubConversionBudget = 'CREATE_OFFER_PUB_CONVERSION_BUDGET',
  CreateOfferPubMarginPayout = 'CREATE_OFFER_PUB_MARGIN_PAYOUT',
  CreateOfferPubRevenueBudget = 'CREATE_OFFER_PUB_REVENUE_BUDGET',
  OfferTag = 'OFFER_TAG',
  SendAnEmailToAdvertiserContact = 'SEND_AN_EMAIL_TO_ADVERTISER_CONTACT',
  /** Deprecated keeping for BC with old rules */
  SendAnEmailToAm = 'SEND_AN_EMAIL_TO_AM',
  SendAnEmailToPublisherContact = 'SEND_AN_EMAIL_TO_PUBLISHER_CONTACT',
  UpdateAllOfferPrivacy = 'UPDATE_ALL_OFFER_PRIVACY',
  UpdateAllOfferStatus = 'UPDATE_ALL_OFFER_STATUS',
  UpdateOfferStatus = 'UPDATE_OFFER_STATUS'
}

export type AutomationRuleExecutionLog = {
  messages: Array<Scalars['String']['output']>;
  ruleId: Scalars['String']['output'];
};

export type AutomationRuleFilter = {
  filterType: AutomationRuleFilterType;
  operation?: Maybe<AutomationRuleOperation>;
  value?: Maybe<AutomationRuleValue>;
  valueType?: Maybe<AutomationRuleValueType>;
};

export type AutomationRuleFilterInput = {
  filterType: AutomationRuleFilterType;
  operation: AutomationRuleOperation;
  value: AutomationRuleValueInput;
  valueType: AutomationRuleValueType;
};

export type AutomationRuleFilterOperationValueType = {
  operation: AutomationRuleOperation;
  valueType: AutomationRuleValueType;
};

export enum AutomationRuleFilterType {
  AdvertiserAccounttype = 'ADVERTISER_ACCOUNTTYPE',
  AdvertiserAm = 'ADVERTISER_AM',
  AdvertiserId = 'ADVERTISER_ID',
  AdvertiserName = 'ADVERTISER_NAME',
  AdvertiserSm = 'ADVERTISER_SM',
  AdvertiserStatus = 'ADVERTISER_STATUS',
  IsAtt = 'IS_ATT',
  OfferAdvertiserId = 'OFFER_ADVERTISER_ID',
  OfferCountry = 'OFFER_COUNTRY',
  OfferEventtypeId = 'OFFER_EVENTTYPE_ID',
  OfferId = 'OFFER_ID',
  OfferIsapprovalrequired = 'OFFER_ISAPPROVALREQUIRED',
  OfferIsprivate = 'OFFER_ISPRIVATE',
  OfferName = 'OFFER_NAME',
  OfferOfferaccessStatus = 'OFFER_OFFERACCESS_STATUS',
  OfferPayoutTheyget = 'OFFER_PAYOUT_THEYGET',
  OfferPayoutWeget = 'OFFER_PAYOUT_WEGET',
  OfferPhantomContainstracker = 'OFFER_PHANTOM_CONTAINSTRACKER',
  OfferPhantomNoofjumps = 'OFFER_PHANTOM_NOOFJUMPS',
  OfferPhantomNoofjumpsforstorereached = 'OFFER_PHANTOM_NOOFJUMPSFORSTOREREACHED',
  OfferPhantomReachesstore = 'OFFER_PHANTOM_REACHESSTORE',
  OfferPhantomReachestracker = 'OFFER_PHANTOM_REACHESTRACKER',
  OfferPlatform = 'OFFER_PLATFORM',
  OfferStatsClicks = 'OFFER_STATS_CLICKS',
  OfferStatsConversions = 'OFFER_STATS_CONVERSIONS',
  OfferStatsCr = 'OFFER_STATS_CR',
  OfferStatsEr = 'OFFER_STATS_ER',
  OfferStatsEvents = 'OFFER_STATS_EVENTS',
  OfferStatus = 'OFFER_STATUS',
  OfferTag = 'OFFER_TAG',
  PublisherAccounttype = 'PUBLISHER_ACCOUNTTYPE',
  PublisherAm = 'PUBLISHER_AM',
  PublisherClicks = 'PUBLISHER_CLICKS',
  PublisherConversions = 'PUBLISHER_CONVERSIONS',
  PublisherCr = 'PUBLISHER_CR',
  PublisherEr = 'PUBLISHER_ER',
  PublisherId = 'PUBLISHER_ID',
  PublisherIsapipublisher = 'PUBLISHER_ISAPIPUBLISHER',
  PublisherSm = 'PUBLISHER_SM',
  PublisherStatus = 'PUBLISHER_STATUS',
  SubpublisherClicks = 'SUBPUBLISHER_CLICKS',
  SubpublisherConversions = 'SUBPUBLISHER_CONVERSIONS',
  SubpublisherCr = 'SUBPUBLISHER_CR',
  SubpublisherEr = 'SUBPUBLISHER_ER',
  Timeframe = 'TIMEFRAME'
}

export type AutomationRuleInput = {
  actions: Array<AutomationRuleActionInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Array<AutomationRuleFilterInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  retroactive?: InputMaybe<Scalars['Boolean']['input']>;
  status: AutomationRuleStaus;
  trigger: AutomationRuleTrigger;
};

export enum AutomationRuleOperation {
  Contains = 'CONTAINS',
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  In = 'IN',
  Lt = 'LT',
  Lte = 'LTE',
  Ne = 'NE',
  NotContains = 'NOT_CONTAINS',
  NotIn = 'NOT_IN'
}

export type AutomationRuleReadFilter = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export enum AutomationRuleStaus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum AutomationRuleTrigger {
  AdvertiserChange = 'ADVERTISER_CHANGE',
  OfferChange = 'OFFER_CHANGE',
  PublisherChange = 'PUBLISHER_CHANGE',
  StatsChange = 'STATS_CHANGE'
}

export type AutomationRuleValue = {
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  listValue?: Maybe<Array<Scalars['String']['output']>>;
  numericValue?: Maybe<Scalars['Float']['output']>;
  textValue?: Maybe<Scalars['String']['output']>;
};

export type AutomationRuleValueInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  listValue?: InputMaybe<Array<Scalars['String']['input']>>;
  numericValue?: InputMaybe<Scalars['Float']['input']>;
  textValue?: InputMaybe<Scalars['String']['input']>;
};

export enum AutomationRuleValueType {
  Boolean = 'BOOLEAN',
  DateInterval = 'DATE_INTERVAL',
  Duration = 'DURATION',
  List = 'LIST',
  None = 'NONE',
  Numeric = 'NUMERIC',
  Percentage = 'PERCENTAGE',
  Text = 'TEXT'
}

/** An entry of the banned-users store (one per failed click). */
export type BannedUser = {
  advertiser?: Maybe<Advertiser>;
  advertiserId?: Maybe<Scalars['String']['output']>;
  clickId: Scalars['String']['output'];
  /** Accumulated evaluation rules that failed for this click (e.g. ENFORCE_EVENT_SETTINGS). */
  failedRules: Array<Scalars['String']['output']>;
  /** Accumulated sub-rules that failed for this click (e.g. ENFORCE_EVENT_SETTINGS_NEEDS_INSTALL). */
  failedSubRules: Array<Scalars['String']['output']>;
  offer?: Maybe<Offer>;
  offerId?: Maybe<Scalars['String']['output']>;
  publisher?: Maybe<Publisher>;
  publisherId?: Maybe<Scalars['String']['output']>;
  /** Publisher-side user id of the click (click.user.ids.id, falling back to the publisher click id). */
  userId?: Maybe<Scalars['String']['output']>;
};

export type BannedUserConnection = {
  edges: Array<BannedUserEdge>;
  totalCount: Scalars['Long']['output'];
};

export type BannedUserEdge = {
  node: BannedUser;
};

export type BannedUsersFilter = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  /** Exact click ids; when given, the other criteria only narrow these entries. */
  clickIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  /** Exact rule or sub-rule name that must be among the entry's failed rules / sub-rules. */
  rule?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum BatchOperationFilterOperator {
  Contains = 'CONTAINS',
  DoesNotMatchRegex = 'DOES_NOT_MATCH_REGEX',
  GreaterEqual = 'GREATER_EQUAL',
  In = 'IN',
  IsEmpty = 'IS_EMPTY',
  IsNotEmpty = 'IS_NOT_EMPTY',
  LowerEqual = 'LOWER_EQUAL',
  MatchesRegex = 'MATCHES_REGEX',
  NotContains = 'NOT_CONTAINS',
  NotIn = 'NOT_IN'
}

export type BatchOperationLogActionEntry = {
  messages?: Maybe<Array<Scalars['String']['output']>>;
  type: BatchOperationLogActionEntryType;
};

export enum BatchOperationLogActionEntryType {
  AdvancedTargetingChange = 'ADVANCED_TARGETING_CHANGE',
  AdvertiserStatusChange = 'ADVERTISER_STATUS_CHANGE',
  AdvertiserTagsChange = 'ADVERTISER_TAGS_CHANGE',
  FireWebhook = 'FIRE_WEBHOOK',
  OfferBudgetsChange = 'OFFER_BUDGETS_CHANGE',
  OfferCreatePublisherGroups = 'OFFER_CREATE_PUBLISHER_GROUPS',
  OfferDetailsChange = 'OFFER_DETAILS_CHANGE',
  OfferEventTypeVisibilityChange = 'OFFER_EVENT_TYPE_VISIBILITY_CHANGE',
  OfferPublisherChange = 'OFFER_PUBLISHER_CHANGE',
  OfferStatusChange = 'OFFER_STATUS_CHANGE',
  OfferTagsChange = 'OFFER_TAGS_CHANGE',
  PublisherOfferAccessChange = 'PUBLISHER_OFFER_ACCESS_CHANGE',
  PublisherStatusChange = 'PUBLISHER_STATUS_CHANGE',
  PublisherTagsChange = 'PUBLISHER_TAGS_CHANGE'
}

export type BatchOperationSchedule = {
  onEveryChange?: Maybe<Scalars['Boolean']['output']>;
  onSchedule?: Maybe<Scalars['String']['output']>;
  oneTime?: Maybe<Scalars['Boolean']['output']>;
};

export type BatchOperationScheduleInput = {
  onEveryChange?: InputMaybe<Scalars['Boolean']['input']>;
  onSchedule?: InputMaybe<Scalars['String']['input']>;
  oneTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BatchOperationWebhookMethod {
  Delete = 'DELETE',
  Get = 'GET',
  Post = 'POST',
  Put = 'PUT'
}

export type BatchPayout = {
  margin?: Maybe<Scalars['Float']['output']>;
  theyGet?: Maybe<Scalars['Float']['output']>;
  weGet?: Maybe<Scalars['Float']['output']>;
};

export type BatchPayoutInput = {
  margin?: InputMaybe<Scalars['Float']['input']>;
  theyGet?: InputMaybe<Scalars['Float']['input']>;
  weGet?: InputMaybe<Scalars['Float']['input']>;
};

export type BigQueryConnectionTestResult = {
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type BigQueryEventSyncState = {
  eventType: BigQueryEventType;
  lastSyncedAt?: Maybe<Scalars['LocalDateTime']['output']>;
};

export enum BigQueryEventType {
  Clicks = 'CLICKS',
  EvaluatedPostbacks = 'EVALUATED_POSTBACKS',
  Impressions = 'IMPRESSIONS'
}

export type BigQueryExportConfig = {
  backfillFrom?: Maybe<Scalars['LocalDateTime']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  enabledEventTypes: Array<BigQueryEventType>;
  gcpProjectId?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  /** True when service-account credentials are stored. The credentials themselves are never returned. */
  serviceAccountConfigured: Scalars['Boolean']['output'];
  syncIntervalMinutes?: Maybe<Scalars['Int']['output']>;
  syncState: Array<BigQueryEventSyncState>;
};

export type BigQueryExportConfigInput = {
  backfillFrom?: InputMaybe<Scalars['LocalDateTime']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledEventTypes?: InputMaybe<Array<BigQueryEventType>>;
  gcpProjectId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  /** Service-account JSON. Leave blank to keep the stored credentials unchanged. */
  serviceAccountJson?: InputMaybe<Scalars['String']['input']>;
  syncIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type BlacklistedSubId = {
  advertiser?: Maybe<Advertiser>;
  createdAt: Scalars['LocalDateTime']['output'];
  createdBy?: Maybe<User>;
  offer?: Maybe<Offer>;
  publisher?: Maybe<Publisher>;
  reason?: Maybe<Scalars['String']['output']>;
  subId: Scalars['String']['output'];
};

export type BlacklistedSubIdConnection = {
  edges?: Maybe<Array<BlacklistedSubIdEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type BlacklistedSubIdEdge = {
  node: BlacklistedSubId;
};

export type BlacklistedSubIdInput = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  subIds: Array<Scalars['String']['input']>;
};

export type BlacklistedSubIdKey = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  subId: Scalars['String']['input'];
};

export type BlacklistedSubIdsFilter = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<BlacklistedSubIdKey>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type BooleanValue = {
  value: Scalars['Boolean']['output'];
};

/** Budget object describes the amount of events/monetary units available and consumed for a given combination of entities */
export type Budget = {
  advertiser: Advertiser;
  /** the total amount available in the given period */
  amount: Scalars['Float']['output'];
  audits: Array<Audit>;
  /** the consumed amount for the given period */
  consumed: Scalars['Float']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  /** estimated amount at the end of validity period */
  estimated: Scalars['Float']['output'];
  eventType?: Maybe<EventType>;
  offer?: Maybe<Offer>;
  publisher?: Maybe<Publisher>;
  specificity: OfferPublisherBudgetType;
  status: Status;
  threshold: BudgetThreshold;
  type: BudgetType;
  validity: BudgetValidity;
};

export type BudgetEmailContext = {
  amount?: Maybe<Scalars['String']['output']>;
  consumed?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['String']['output']>;
};

export type BudgetInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  key: BudgetKey;
};

export type BudgetKey = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  eventTypeId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  threshold: BudgetThreshold;
  type: BudgetType;
  validity: BudgetValidity;
};

/** The threshold for the budgets, hard budgets stop clicks and postbacks, soft budgets only postbacks */
export enum BudgetThreshold {
  Hard = 'HARD',
  Soft = 'SOFT'
}

/** The type of the budget, either monetary or based on number of events */
export enum BudgetType {
  Click = 'CLICK',
  Event = 'EVENT',
  Impression = 'IMPRESSION',
  Theyget = 'THEYGET',
  Weget = 'WEGET'
}

/** The amount of time for which we count postbacks into the consumed field. Daily budgets restart at midnight the next day, monthly ones on the 1st of the next month. */
export enum BudgetValidity {
  Daily = 'DAILY',
  Forever = 'FOREVER',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY'
}

export type CalculatedMetric = {
  /** We return the original metric minus the delta metric over the delta metric */
  changeFactorPercentage?: Maybe<Scalars['Float']['output']>;
  /** We return the absolute value of the delta dataset metric */
  difference?: Maybe<Scalars['Float']['output']>;
  /** We return the absolute value of the delta dataset metric */
  identity?: Maybe<Scalars['Float']['output']>;
};

export type Carrier = {
  code?: Maybe<Scalars['String']['output']>;
  mcc?: Maybe<Scalars['String']['output']>;
  mnc?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Click = {
  id: Scalars['String']['output'];
  offer?: Maybe<ClickOfferData>;
  publisher: PublisherData;
  recommendationLinkId?: Maybe<Scalars['String']['output']>;
  time: Scalars['LocalDateTime']['output'];
  user?: Maybe<UserData>;
};

export type ClickBudget = {
  advertiser: Advertiser;
  /** the total amount available in the given period */
  amount: Scalars['Float']['output'];
  /** the consumed amount for the given period */
  consumed: Scalars['Float']['output'];
  /** estimated amount at the end of validity period. It is calculated the same as the ConsumedBudget by totalPeriod / periodPassedSoFar * consumed */
  estimated: Scalars['Float']['output'];
  offer?: Maybe<Offer>;
  publisher?: Maybe<Publisher>;
  validity?: Maybe<BudgetValidity>;
};

export type ClickBudgetId = {
  advertiserId: Scalars['String']['input'];
  offerId?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  validity?: InputMaybe<BudgetValidity>;
};

export type ClickBudgetInput = {
  advertiserId: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  offerId?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  validity?: InputMaybe<BudgetValidity>;
};

export type ClickBudgetTargetingRecommendation = {
  recency?: Maybe<Scalars['Int']['output']>;
};

export type ClickHouseColumn = {
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ClickHouseQueryResult = {
  columns: Array<Scalars['String']['output']>;
  rowCount: Scalars['Int']['output'];
  rows: Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>;
};

export type ClickHouseReport = {
  earliestFullStatsDay?: Maybe<Scalars['LocalDate']['output']>;
  earliestRecord?: Maybe<Scalars['LocalDateTime']['output']>;
  latestFullStatsDay?: Maybe<Scalars['LocalDate']['output']>;
  latestHourlyRecords: Array<HourlyRecordCount>;
  latestRecord?: Maybe<Scalars['LocalDateTime']['output']>;
  name: RawStatsMetric;
};

export type ClickHouseTableDescription = {
  columns: Array<ClickHouseColumn>;
  table: Scalars['String']['output'];
};

export type ClickInput = {
  offer: ClickOfferDataInput;
  publisher: PublisherDataInput;
  time: Scalars['LocalDateTime']['input'];
  user?: InputMaybe<UserDataInput>;
};

export type ClickOfferData = {
  advertiserId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lpId?: Maybe<Scalars['String']['output']>;
  managerId?: Maybe<Scalars['String']['output']>;
};

export type ClickOfferDataInput = {
  advertiserId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  lpId?: InputMaybe<Scalars['String']['input']>;
  managerId?: InputMaybe<Scalars['String']['input']>;
};

export enum ClickRule {
  AdscoreScriptRule = 'ADSCORE_SCRIPT_RULE',
  AdvancedTargetingMismatch = 'ADVANCED_TARGETING_MISMATCH',
  AdvertiserBlockedPublisher = 'ADVERTISER_BLOCKED_PUBLISHER',
  AnonymousProxyIp = 'ANONYMOUS_PROXY_IP',
  AnuraRule = 'ANURA_RULE',
  AnuraScriptRule = 'ANURA_SCRIPT_RULE',
  BlacklistedSubId = 'BLACKLISTED_SUB_ID',
  BudgetReached = 'BUDGET_REACHED',
  CleartrustScriptRule = 'CLEARTRUST_SCRIPT_RULE',
  ClickBudgetReached = 'CLICK_BUDGET_REACHED',
  ClientSideSearchLatency = 'CLIENT_SIDE_SEARCH_LATENCY',
  DoesNotReachStore = 'DOES_NOT_REACH_STORE',
  DoesNotReachTracker = 'DOES_NOT_REACH_TRACKER',
  ImpressionBudgetReached = 'IMPRESSION_BUDGET_REACHED',
  InactiveAdvertiser = 'INACTIVE_ADVERTISER',
  InactiveOffer = 'INACTIVE_OFFER',
  InactivePublisher = 'INACTIVE_PUBLISHER',
  InvalidRequest = 'INVALID_REQUEST',
  InvalidUserIdentifier = 'INVALID_USER_IDENTIFIER',
  IpRateLimit = 'IP_RATE_LIMIT',
  IpRecency = 'IP_RECENCY',
  IpUaRateLimit = 'IP_UA_RATE_LIMIT',
  MassIpBlock = 'MASS_IP_BLOCK',
  OfferTargetingMismatch = 'OFFER_TARGETING_MISMATCH',
  PublisherNotApproved = 'PUBLISHER_NOT_APPROVED',
  Recency = 'RECENCY',
  SearchLatency = 'SEARCH_LATENCY',
  TrafficControl = 'TRAFFIC_CONTROL',
  TrafficTargeting = 'TRAFFIC_TARGETING',
  TwentyFourMetricsRule = 'TWENTY_FOUR_METRICS_RULE',
  VerisoulScriptRule = 'VERISOUL_SCRIPT_RULE'
}

export enum ClickShieldRule {
  ActiveOffer = 'ACTIVE_OFFER',
  AdvancedTargeting = 'ADVANCED_TARGETING',
  AdvertiserBlockedPublisher = 'ADVERTISER_BLOCKED_PUBLISHER',
  BlockedReferrerRule = 'BLOCKED_REFERRER_RULE',
  ClickBudgetReached = 'CLICK_BUDGET_REACHED',
  HardCap = 'HARD_CAP',
  MissingLandingPage = 'MISSING_LANDING_PAGE',
  OfferExists = 'OFFER_EXISTS',
  OfferTargeting = 'OFFER_TARGETING',
  ProtectedFromExperimental = 'PROTECTED_FROM_EXPERIMENTAL',
  PublisherApproved = 'PUBLISHER_APPROVED',
  RecyclingPartner = 'RECYCLING_PARTNER',
  RequiredQueryParameters = 'REQUIRED_QUERY_PARAMETERS',
  SubIdNotBlocked = 'SUB_ID_NOT_BLOCKED'
}

export type ClickShieldRules = {
  offerId?: Maybe<Scalars['String']['output']>;
  publisherId?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Array<Maybe<ClickShieldRule>>>;
};

export type ClickShieldRulesInput = {
  offerId: Scalars['String']['input'];
  publisherId?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<ClickShieldRule>>>;
};

export type ClickShieldRulesKey = {
  offerId: Scalars['String']['input'];
  publisherId?: InputMaybe<Scalars['String']['input']>;
};

export enum CohortMetric {
  CostCount = 'COST_COUNT',
  CostSum = 'COST_SUM',
  Events = 'EVENTS',
  RetentionPercent = 'RETENTION_PERCENT',
  RetentionUsers = 'RETENTION_USERS',
  RevenueCount = 'REVENUE_COUNT',
  RevenueSum = 'REVENUE_SUM',
  Roas = 'ROAS',
  Sessions = 'SESSIONS',
  SessionsPerUser = 'SESSIONS_PER_USER'
}

export type CohortQuery = {
  appIds?: InputMaybe<Array<Scalars['String']['input']>>;
  end: Scalars['LocalDateTime']['input'];
  filters?: InputMaybe<Array<AppReportFilter>>;
  first: Scalars['Int']['input'];
  granularity: AppReportGranularity;
  groupBy?: InputMaybe<Array<AppReportDimension>>;
  metric: CohortMetric;
  minCohortUsers?: InputMaybe<Scalars['Int']['input']>;
  numberOfPeriods: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sort?: InputMaybe<Array<CohortSort>>;
  start: Scalars['LocalDateTime']['input'];
  storeAppIds?: InputMaybe<Array<Scalars['String']['input']>>;
  valueType: CohortValueType;
};

export type CohortReportConnection = {
  csvDownloadUrl: Scalars['String']['output'];
  edges: Array<CohortReportEdge>;
  totalCount: Scalars['Int']['output'];
};

export type CohortReportEdge = {
  node: CohortReportRow;
};

export type CohortReportMetricRecord = {
  field: CohortMetric;
  value: Scalars['Float']['output'];
};

export type CohortReportPeriod = {
  granularity: AppReportGranularity;
  metric: CohortReportMetricRecord;
  number: Scalars['Int']['output'];
};

export type CohortReportRow = {
  dimensions: Array<AppReportDimensionRecord>;
  periods: Array<CohortReportPeriod>;
};

export type CohortSort = {
  dimension: AppReportDimension;
  direction?: InputMaybe<SortOrder>;
};

export enum CohortValueType {
  Cumulative = 'CUMULATIVE',
  OriginalValues = 'ORIGINAL_VALUES'
}

export type Connection = {
  ip?: Maybe<Scalars['String']['output']>;
  isp?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ConnectionType>;
};

export type ConnectionInput = {
  ip?: InputMaybe<Scalars['String']['input']>;
  isp?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ConnectionType>;
};

export enum ConnectionType {
  CableDsl = 'CABLE_DSL',
  Cellular = 'CELLULAR',
  Corporate = 'CORPORATE',
  Dialup = 'DIALUP'
}

export enum ControlledAccessField {
  AppId = 'APP_ID',
  AppName = 'APP_NAME',
  Creative = 'CREATIVE',
  OriginalSubid = 'ORIGINAL_SUBID',
  Placement = 'PLACEMENT',
  Site = 'SITE',
  Subid = 'SUBID',
  Subsubid = 'SUBSUBID'
}

export type ControlledAccessObject = {
  advertiser?: Maybe<Advertiser>;
  createdAt: Scalars['LocalDateTime']['output'];
  createdBy?: Maybe<User>;
  field: ControlledAccessField;
  id: Scalars['String']['output'];
  offer?: Maybe<Offer>;
  publisher?: Maybe<Publisher>;
  reason?: Maybe<Scalars['String']['output']>;
  type: ControlledAccessType;
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type ControlledAccessObjectConnection = {
  edges: Array<ControlledAccessObjectEdge>;
  totalCount: Scalars['Int']['output'];
};

export type ControlledAccessObjectEdge = {
  node: ControlledAccessObject;
};

export type ControlledAccessObjectFilter = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  fields?: InputMaybe<Array<ControlledAccessField>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<ControlledAccessType>>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ControlledAccessObjectInput = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  field: ControlledAccessField;
  id?: InputMaybe<Scalars['String']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  type: ControlledAccessType;
  values: Array<Scalars['String']['input']>;
};

export enum ControlledAccessType {
  Blacklist = 'BLACKLIST',
  Whitelist = 'WHITELIST'
}

/** A conversion is the lead postback event. All further postback events derive from this initial one. */
export type Conversion = {
  date?: Maybe<Scalars['String']['output']>;
  postback?: Maybe<ConversionPostback>;
};

/** The click that triggered the conversion */
export type ConversionClick = {
  id?: Maybe<Scalars['String']['output']>;
  publisher?: Maybe<ConversionPublisher>;
  time?: Maybe<Scalars['String']['output']>;
};

/** All device information */
export type ConversionDevice = {
  generated?: Maybe<ConversionDeviceMeta>;
  ids?: Maybe<Ids>;
  ip?: Maybe<Scalars['String']['output']>;
  ua?: Maybe<Scalars['String']['output']>;
};

/** The device of the user that triggered the conversion and its geographic position */
export type ConversionDeviceMeta = {
  geo?: Maybe<ConversionGeo>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
};

/** All the fields that can be used to filter conversions for */
export type ConversionFilter = {
  date?: InputMaybe<Scalars['String']['input']>;
  postbackClickPublisherApp?: InputMaybe<Scalars['String']['input']>;
  postbackClickPublisherId?: InputMaybe<Scalars['String']['input']>;
  postbackClickPublisherSite?: InputMaybe<Scalars['String']['input']>;
  postbackClickPublisherSubId?: InputMaybe<Scalars['String']['input']>;
  postbackOfferOfferId?: InputMaybe<Scalars['String']['input']>;
  postbackStatus?: InputMaybe<Scalars['String']['input']>;
};

/** The Geo of the user that triggered the conversion */
export type ConversionGeo = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
};

/** The offer information of the conversion */
export type ConversionOffer = {
  offerId?: Maybe<Scalars['String']['output']>;
  theyGetStd?: Maybe<Scalars['Float']['output']>;
};

/** The postback of the conversion */
export type ConversionPostback = {
  click?: Maybe<ConversionClick>;
  device?: Maybe<ConversionDevice>;
  offer?: Maybe<ConversionOffer>;
  status?: Maybe<Scalars['String']['output']>;
};

/** The publisher information of the conversion */
export type ConversionPublisher = {
  app?: Maybe<Scalars['String']['output']>;
  clickId?: Maybe<Scalars['String']['output']>;
  creative?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  placement?: Maybe<Scalars['String']['output']>;
  site?: Maybe<Scalars['String']['output']>;
  subId?: Maybe<Scalars['String']['output']>;
  unique1?: Maybe<Scalars['String']['output']>;
  unique2?: Maybe<Scalars['String']['output']>;
};

export enum ConversionReportField {
  AdvertiserId = 'ADVERTISER_ID',
  AdvertiserManagerId = 'ADVERTISER_MANAGER_ID',
  AdvertiserManagerName = 'ADVERTISER_MANAGER_NAME',
  AdvertiserName = 'ADVERTISER_NAME',
  AdvertiserOfferId = 'ADVERTISER_OFFER_ID',
  AdvertiserPostback = 'ADVERTISER_POSTBACK',
  AppCustomEventNumericValue = 'APP_CUSTOM_EVENT_NUMERIC_VALUE',
  AppCustomEventValue = 'APP_CUSTOM_EVENT_VALUE',
  AppEventId = 'APP_EVENT_ID',
  AppEventName = 'APP_EVENT_NAME',
  AppId = 'APP_ID',
  AppName = 'APP_NAME',
  AppSource = 'APP_SOURCE',
  AppStoreAppId = 'APP_STORE_APP_ID',
  AppStoreAppName = 'APP_STORE_APP_NAME',
  AppVendorUserId = 'APP_VENDOR_USER_ID',
  AttributionPartnerAdGroupName = 'ATTRIBUTION_PARTNER_AD_GROUP_NAME',
  AttributionPartnerAdId = 'ATTRIBUTION_PARTNER_AD_ID',
  AttributionPartnerAggregatedEventValue = 'ATTRIBUTION_PARTNER_AGGREGATED_EVENT_VALUE',
  AttributionPartnerAggregatedEventValueCurrency = 'ATTRIBUTION_PARTNER_AGGREGATED_EVENT_VALUE_CURRENCY',
  AttributionPartnerAppVersion = 'ATTRIBUTION_PARTNER_APP_VERSION',
  AttributionPartnerClickAttributionWindow = 'ATTRIBUTION_PARTNER_CLICK_ATTRIBUTION_WINDOW',
  AttributionPartnerClickTime = 'ATTRIBUTION_PARTNER_CLICK_TIME',
  AttributionPartnerConversionDuration = 'ATTRIBUTION_PARTNER_CONVERSION_DURATION',
  AttributionPartnerConversionTime = 'ATTRIBUTION_PARTNER_CONVERSION_TIME',
  AttributionPartnerCpuType = 'ATTRIBUTION_PARTNER_CPU_TYPE',
  AttributionPartnerCreativeName = 'ATTRIBUTION_PARTNER_CREATIVE_NAME',
  AttributionPartnerDeeplink = 'ATTRIBUTION_PARTNER_DEEPLINK',
  AttributionPartnerDomain = 'ATTRIBUTION_PARTNER_DOMAIN',
  AttributionPartnerEventId = 'ATTRIBUTION_PARTNER_EVENT_ID',
  AttributionPartnerEventName = 'ATTRIBUTION_PARTNER_EVENT_NAME',
  AttributionPartnerEventValue = 'ATTRIBUTION_PARTNER_EVENT_VALUE',
  AttributionPartnerFirstEvent = 'ATTRIBUTION_PARTNER_FIRST_EVENT',
  AttributionPartnerGpInstalledAt = 'ATTRIBUTION_PARTNER_GP_INSTALLED_AT',
  AttributionPartnerGpOpenedAt = 'ATTRIBUTION_PARTNER_GP_OPENED_AT',
  AttributionPartnerHardwareName = 'ATTRIBUTION_PARTNER_HARDWARE_NAME',
  AttributionPartnerIdForVendor = 'ATTRIBUTION_PARTNER_ID_FOR_VENDOR',
  AttributionPartnerImpressionBased = 'ATTRIBUTION_PARTNER_IMPRESSION_BASED',
  AttributionPartnerInstallBeginTime = 'ATTRIBUTION_PARTNER_INSTALL_BEGIN_TIME',
  AttributionPartnerInstallFinishTime = 'ATTRIBUTION_PARTNER_INSTALL_FINISH_TIME',
  AttributionPartnerInstallTime = 'ATTRIBUTION_PARTNER_INSTALL_TIME',
  AttributionPartnerLifetimeSessionsCount = 'ATTRIBUTION_PARTNER_LIFETIME_SESSIONS_COUNT',
  AttributionPartnerMatchType = 'ATTRIBUTION_PARTNER_MATCH_TYPE',
  AttributionPartnerNetworkType = 'ATTRIBUTION_PARTNER_NETWORK_TYPE',
  AttributionPartnerPartnerParameters = 'ATTRIBUTION_PARTNER_PARTNER_PARAMETERS',
  AttributionPartnerPostbackId = 'ATTRIBUTION_PARTNER_POSTBACK_ID',
  AttributionPartnerPublisherSubId = 'ATTRIBUTION_PARTNER_PUBLISHER_SUB_ID',
  AttributionPartnerRejectionReason = 'ATTRIBUTION_PARTNER_REJECTION_REASON',
  AttributionPartnerRejectionReasonSubValue = 'ATTRIBUTION_PARTNER_REJECTION_REASON_SUB_VALUE',
  AttributionPartnerRejectionReasonValue = 'ATTRIBUTION_PARTNER_REJECTION_REASON_VALUE',
  AttributionPartnerRetargeting = 'ATTRIBUTION_PARTNER_RETARGETING',
  AttributionPartnerSaleAmount = 'ATTRIBUTION_PARTNER_SALE_AMOUNT',
  AttributionPartnerSaleAmountCurrency = 'ATTRIBUTION_PARTNER_SALE_AMOUNT_CURRENCY',
  AttributionPartnerSdkVersion = 'ATTRIBUTION_PARTNER_SDK_VERSION',
  AttributionPartnerSessionsCount = 'ATTRIBUTION_PARTNER_SESSIONS_COUNT',
  AttributionPartnerSkadMMPProvided = 'ATTRIBUTION_PARTNER_SKAD_M_M_P_PROVIDED',
  AttributionPartnerStatus = 'ATTRIBUTION_PARTNER_STATUS',
  AttributionPartnerTrackerName = 'ATTRIBUTION_PARTNER_TRACKER_NAME',
  AttributionPartnerTrackingEnabled = 'ATTRIBUTION_PARTNER_TRACKING_ENABLED',
  AttributionPartnerTrackingLimited = 'ATTRIBUTION_PARTNER_TRACKING_LIMITED',
  AttributionPartnerUniquenessIdentifier = 'ATTRIBUTION_PARTNER_UNIQUENESS_IDENTIFIER',
  ClickId = 'CLICK_ID',
  ClickOfferAdgroupId = 'CLICK_OFFER_ADGROUP_ID',
  ClickOfferAdgroupName = 'CLICK_OFFER_ADGROUP_NAME',
  ClickOfferAdId = 'CLICK_OFFER_AD_ID',
  ClickOfferAdName = 'CLICK_OFFER_AD_NAME',
  ClickOfferCampaignId = 'CLICK_OFFER_CAMPAIGN_ID',
  ClickOfferCampaignName = 'CLICK_OFFER_CAMPAIGN_NAME',
  ClickOfferLandingPageId = 'CLICK_OFFER_LANDING_PAGE_ID',
  ClickPeaChain = 'CLICK_PEA_CHAIN',
  ClickPublisherClickId = 'CLICK_PUBLISHER_CLICK_ID',
  ClickRecommendationLinkId = 'CLICK_RECOMMENDATION_LINK_ID',
  ClickTime = 'CLICK_TIME',
  ClickUserConnectionCarrierCode = 'CLICK_USER_CONNECTION_CARRIER_CODE',
  ClickUserConnectionIp = 'CLICK_USER_CONNECTION_IP',
  ClickUserConnectionIsp = 'CLICK_USER_CONNECTION_ISP',
  ClickUserConnectionMcc = 'CLICK_USER_CONNECTION_MCC',
  ClickUserConnectionMnc = 'CLICK_USER_CONNECTION_MNC',
  ClickUserConnectionType = 'CLICK_USER_CONNECTION_TYPE',
  ClickUserDeviceBrowser = 'CLICK_USER_DEVICE_BROWSER',
  ClickUserDeviceBrowserVersion = 'CLICK_USER_DEVICE_BROWSER_VERSION',
  ClickUserDeviceInApp = 'CLICK_USER_DEVICE_IN_APP',
  ClickUserDeviceLanguage = 'CLICK_USER_DEVICE_LANGUAGE',
  ClickUserDeviceMake = 'CLICK_USER_DEVICE_MAKE',
  ClickUserDeviceModel = 'CLICK_USER_DEVICE_MODEL',
  ClickUserDeviceOs = 'CLICK_USER_DEVICE_OS',
  ClickUserDeviceOsVersion = 'CLICK_USER_DEVICE_OS_VERSION',
  ClickUserDevicePreferredLanguage = 'CLICK_USER_DEVICE_PREFERRED_LANGUAGE',
  ClickUserDeviceType = 'CLICK_USER_DEVICE_TYPE',
  ClickUserDeviceUa = 'CLICK_USER_DEVICE_UA',
  ClickUserGeoCity = 'CLICK_USER_GEO_CITY',
  ClickUserGeoCountry = 'CLICK_USER_GEO_COUNTRY',
  ClickUserGeoLat = 'CLICK_USER_GEO_LAT',
  ClickUserGeoLon = 'CLICK_USER_GEO_LON',
  ClickUserGeoRegion = 'CLICK_USER_GEO_REGION',
  ClickUserGeoUtcOffset = 'CLICK_USER_GEO_UTC_OFFSET',
  ClickUserIdsCategory = 'CLICK_USER_IDS_CATEGORY',
  ClickUserIdsEmail = 'CLICK_USER_IDS_EMAIL',
  ClickUserIdsGaid = 'CLICK_USER_IDS_GAID',
  ClickUserIdsId = 'CLICK_USER_IDS_ID',
  ClickUserIdsIdfa = 'CLICK_USER_IDS_IDFA',
  ClickUserIdsMsisdn = 'CLICK_USER_IDS_MSISDN',
  ClickUserIdsPhone = 'CLICK_USER_IDS_PHONE',
  EvaluationDecision = 'EVALUATION_DECISION',
  EvaluationDecisionActiveRules = 'EVALUATION_DECISION_ACTIVE_RULES',
  EvaluationDecisionFailedRules = 'EVALUATION_DECISION_FAILED_RULES',
  EvaluationDecisionFailedSubRules = 'EVALUATION_DECISION_FAILED_SUB_RULES',
  EvaluationOriginalDecision = 'EVALUATION_ORIGINAL_DECISION',
  EvaluationOriginalStatus = 'EVALUATION_ORIGINAL_STATUS',
  EvaluationStatus = 'EVALUATION_STATUS',
  EvaluationStatusActiveRules = 'EVALUATION_STATUS_ACTIVE_RULES',
  EvaluationStatusFailedRules = 'EVALUATION_STATUS_FAILED_RULES',
  EvaluationStatusFailedSubRules = 'EVALUATION_STATUS_FAILED_SUB_RULES',
  OfferAdvertiserEventId = 'OFFER_ADVERTISER_EVENT_ID',
  OfferEventId = 'OFFER_EVENT_ID',
  OfferEventName = 'OFFER_EVENT_NAME',
  OfferId = 'OFFER_ID',
  OfferName = 'OFFER_NAME',
  OfferOriginalCurrency = 'OFFER_ORIGINAL_CURRENCY',
  OfferOriginalTheyGet = 'OFFER_ORIGINAL_THEY_GET',
  OfferOriginalWeGet = 'OFFER_ORIGINAL_WE_GET',
  OfferTargetedPayoutId = 'OFFER_TARGETED_PAYOUT_ID',
  OfferTargetedPayoutName = 'OFFER_TARGETED_PAYOUT_NAME',
  OfferTheyGet = 'OFFER_THEY_GET',
  OfferTheyGetCurrency = 'OFFER_THEY_GET_CURRENCY',
  OfferTheyGetPoints = 'OFFER_THEY_GET_POINTS',
  OfferWeGet = 'OFFER_WE_GET',
  OfferWeGetCurrency = 'OFFER_WE_GET_CURRENCY',
  PostbackConnectionCarrierCode = 'POSTBACK_CONNECTION_CARRIER_CODE',
  PostbackConnectionIp = 'POSTBACK_CONNECTION_IP',
  PostbackConnectionIsp = 'POSTBACK_CONNECTION_ISP',
  PostbackConnectionMcc = 'POSTBACK_CONNECTION_MCC',
  PostbackConnectionMnc = 'POSTBACK_CONNECTION_MNC',
  PostbackConnectionType = 'POSTBACK_CONNECTION_TYPE',
  PostbackCtit = 'POSTBACK_CTIT',
  PostbackDeviceBrowser = 'POSTBACK_DEVICE_BROWSER',
  PostbackDeviceBrowserVersion = 'POSTBACK_DEVICE_BROWSER_VERSION',
  PostbackDeviceInApp = 'POSTBACK_DEVICE_IN_APP',
  PostbackDeviceLanguage = 'POSTBACK_DEVICE_LANGUAGE',
  PostbackDeviceMake = 'POSTBACK_DEVICE_MAKE',
  PostbackDeviceModel = 'POSTBACK_DEVICE_MODEL',
  PostbackDeviceOs = 'POSTBACK_DEVICE_OS',
  PostbackDeviceOsVersion = 'POSTBACK_DEVICE_OS_VERSION',
  PostbackDeviceType = 'POSTBACK_DEVICE_TYPE',
  PostbackDeviceUa = 'POSTBACK_DEVICE_UA',
  PostbackExtOfferId = 'POSTBACK_EXT_OFFER_ID',
  PostbackExtPublisherId = 'POSTBACK_EXT_PUBLISHER_ID',
  PostbackGeoCity = 'POSTBACK_GEO_CITY',
  PostbackGeoCountry = 'POSTBACK_GEO_COUNTRY',
  PostbackGeoLat = 'POSTBACK_GEO_LAT',
  PostbackGeoLon = 'POSTBACK_GEO_LON',
  PostbackGeoRegion = 'POSTBACK_GEO_REGION',
  PostbackGeoUtcOffset = 'POSTBACK_GEO_UTC_OFFSET',
  PostbackGeoZip = 'POSTBACK_GEO_ZIP',
  PostbackId = 'POSTBACK_ID',
  PostbackIdsCategory = 'POSTBACK_IDS_CATEGORY',
  PostbackIdsEmail = 'POSTBACK_IDS_EMAIL',
  PostbackIdsGaid = 'POSTBACK_IDS_GAID',
  PostbackIdsIdfa = 'POSTBACK_IDS_IDFA',
  PostbackIdsPhone = 'POSTBACK_IDS_PHONE',
  PostbackImpressionAttribution = 'POSTBACK_IMPRESSION_ATTRIBUTION',
  PostbackModificationDescriptions = 'POSTBACK_MODIFICATION_DESCRIPTIONS',
  PostbackPeaChain = 'POSTBACK_PEA_CHAIN',
  PostbackReversed = 'POSTBACK_REVERSED',
  PostbackSecurityToken = 'POSTBACK_SECURITY_TOKEN',
  PostbackServerIp = 'POSTBACK_SERVER_IP',
  PostbackServerUa = 'POSTBACK_SERVER_UA',
  PostbackTime = 'POSTBACK_TIME',
  PostbackWasModified = 'POSTBACK_WAS_MODIFIED',
  PublisherAcceptHeader = 'PUBLISHER_ACCEPT_HEADER',
  PublisherAppId = 'PUBLISHER_APP_ID',
  PublisherAppName = 'PUBLISHER_APP_NAME',
  PublisherCreative = 'PUBLISHER_CREATIVE',
  PublisherCreativeId = 'PUBLISHER_CREATIVE_ID',
  PublisherGroupId = 'PUBLISHER_GROUP_ID',
  PublisherId = 'PUBLISHER_ID',
  PublisherManagerId = 'PUBLISHER_MANAGER_ID',
  PublisherManagerName = 'PUBLISHER_MANAGER_NAME',
  PublisherName = 'PUBLISHER_NAME',
  PublisherOriginalSubId = 'PUBLISHER_ORIGINAL_SUB_ID',
  PublisherPeaChain = 'PUBLISHER_PEA_CHAIN',
  PublisherPlacement = 'PUBLISHER_PLACEMENT',
  PublisherPostbackHttpStatusCode = 'PUBLISHER_POSTBACK_HTTP_STATUS_CODE',
  PublisherPostbackUrl = 'PUBLISHER_POSTBACK_URL',
  PublisherProposedTheyGet = 'PUBLISHER_PROPOSED_THEY_GET',
  PublisherReferrer = 'PUBLISHER_REFERRER',
  PublisherSite = 'PUBLISHER_SITE',
  PublisherSubId = 'PUBLISHER_SUB_ID',
  PublisherSubSubId = 'PUBLISHER_SUB_SUB_ID',
  PublisherTerm = 'PUBLISHER_TERM',
  PublisherUnique1 = 'PUBLISHER_UNIQUE1',
  PublisherUnique2 = 'PUBLISHER_UNIQUE2',
  PublisherUnique3 = 'PUBLISHER_UNIQUE3',
  PublisherUnique4 = 'PUBLISHER_UNIQUE4',
  PublisherUnique5 = 'PUBLISHER_UNIQUE5',
  PublisherUnique6 = 'PUBLISHER_UNIQUE6',
  PublisherUnique7 = 'PUBLISHER_UNIQUE7',
  PublisherUnique8 = 'PUBLISHER_UNIQUE8',
  PublisherUnique9 = 'PUBLISHER_UNIQUE9',
  RedirectUrl = 'REDIRECT_URL',
  SearchMetricsAdClicks = 'SEARCH_METRICS_AD_CLICKS',
  SearchMetricsMonetizedSearches = 'SEARCH_METRICS_MONETIZED_SEARCHES',
  SearchMetricsSearches = 'SEARCH_METRICS_SEARCHES',
  SearchQualityAdvertiserCoverage = 'SEARCH_QUALITY_ADVERTISER_COVERAGE',
  SearchQualityAdvertiserScore = 'SEARCH_QUALITY_ADVERTISER_SCORE',
  SearchQualityFollowupSearches = 'SEARCH_QUALITY_FOLLOWUP_SEARCHES',
  SearchQualityInitialSearches = 'SEARCH_QUALITY_INITIAL_SEARCHES',
  SearchQualitySearchEngineCoverage = 'SEARCH_QUALITY_SEARCH_ENGINE_COVERAGE',
  SearchQualitySearchEngineFollowupSearches = 'SEARCH_QUALITY_SEARCH_ENGINE_FOLLOWUP_SEARCHES',
  SearchQualitySearchEngineInitialSearches = 'SEARCH_QUALITY_SEARCH_ENGINE_INITIAL_SEARCHES',
  SearchQualitySearchEngineScore = 'SEARCH_QUALITY_SEARCH_ENGINE_SCORE',
  SkadPostbackAdNetworkId = 'SKAD_POSTBACK_AD_NETWORK_ID',
  SkadPostbackAppId = 'SKAD_POSTBACK_APP_ID',
  SkadPostbackAttributionSignature = 'SKAD_POSTBACK_ATTRIBUTION_SIGNATURE',
  SkadPostbackCampaignId = 'SKAD_POSTBACK_CAMPAIGN_ID',
  SkadPostbackConversionValue = 'SKAD_POSTBACK_CONVERSION_VALUE',
  SkadPostbackEventId = 'SKAD_POSTBACK_EVENT_ID',
  SkadPostbackFidelityType = 'SKAD_POSTBACK_FIDELITY_TYPE',
  SkadPostbackRedownload = 'SKAD_POSTBACK_REDOWNLOAD',
  SkadPostbackSaleAmount = 'SKAD_POSTBACK_SALE_AMOUNT',
  SkadPostbackSaleAmountCurrency = 'SKAD_POSTBACK_SALE_AMOUNT_CURRENCY',
  SkadPostbackSourceAppId = 'SKAD_POSTBACK_SOURCE_APP_ID',
  SkadPostbackTransactionId = 'SKAD_POSTBACK_TRANSACTION_ID',
  SkadPostbackValid = 'SKAD_POSTBACK_VALID',
  SkadPostbackVersion = 'SKAD_POSTBACK_VERSION',
  SkadPostbackWon = 'SKAD_POSTBACK_WON'
}

export type ConversionReportFilter = {
  field: ConversionReportField;
  operator: GenericFilterOperator;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ConversionReportFilterSnapshot = {
  field: ConversionReportField;
  operator: GenericFilterOperator;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ConversionReportRecord = {
  field: ConversionReportField;
  value?: Maybe<UserProvidedValue>;
};

export type ConversionReportRow = {
  records: Array<ConversionReportRecord>;
};

export type ConversionReportRowConnection = {
  csvDownloadUrl: Scalars['String']['output'];
  edges?: Maybe<Array<ConversionReportRowEdge>>;
  totalCount: Scalars['Long']['output'];
};

export type ConversionReportRowEdge = {
  node: ConversionReportRow;
};

export type ConversionReportSort = {
  field: ConversionReportField;
  order: SortOrder;
};

export type ConversionReportSortSnapshot = {
  field: ConversionReportField;
  order: SortOrder;
};

/** The sorting direction for time - conversions are automatically sorted by time either ASC or DESC */
export type ConversionSort = {
  direction?: InputMaybe<SortOrder>;
};

export type CountryRepetition = {
  country: Scalars['String']['output'];
  repetitions: Scalars['Int']['output'];
};

export type Creative = {
  active: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<CreativeType>;
  url: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CreativeInput = {
  active: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  hidden: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CreativeType>;
  url: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CreativePack = {
  creatives: Array<Creative>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  offer: Offer;
  title: Scalars['String']['output'];
};

export type CreativePackInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  offerId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export enum CreativeType {
  Archive = 'ARCHIVE',
  Html = 'HTML',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type DataReportField = {
  defaultable: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: DataReportFieldType;
  weight: Scalars['Int']['output'];
};

export enum DataReportFieldType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Number = 'NUMBER',
  Text = 'TEXT'
}

export type DataReportFilter = {
  field: Scalars['String']['input'];
  operator: GenericFilterOperator;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DataReportRecord = {
  field: Scalars['String']['output'];
  value?: Maybe<UserProvidedValue>;
};

export type DataReportRow = {
  records: Array<DataReportRecord>;
};

export type DataReportRowConnection = {
  csvDownloadUrl: Scalars['String']['output'];
  edges?: Maybe<Array<DataReportRowEdge>>;
  totalCount: Scalars['Long']['output'];
};

export type DataReportRowEdge = {
  node: DataReportRow;
};

export type DataReportSort = {
  field: Scalars['String']['input'];
  order: SortOrder;
};

export type DateValue = {
  value: Scalars['LocalDateTime']['output'];
};

export type DeleteLeadsInput = {
  end?: InputMaybe<Scalars['LocalDateTime']['input']>;
  filters?: InputMaybe<Array<DataReportFilter>>;
  start?: InputMaybe<Scalars['LocalDateTime']['input']>;
};

export type DeltaMetrics = {
  activeUsers?: Maybe<CalculatedMetric>;
  adClicks?: Maybe<CalculatedMetric>;
  arpu?: Maybe<CalculatedMetric>;
  /** The cost of infrastructure to handle the click amount */
  clickCost?: Maybe<CalculatedMetric>;
  clicks?: Maybe<CalculatedMetric>;
  conversions?: Maybe<CalculatedMetric>;
  coverage?: Maybe<CalculatedMetric>;
  /** The conversion rate */
  cr?: Maybe<CalculatedMetric>;
  events?: Maybe<CalculatedMetric>;
  /** weGet - theyGet - clickCost */
  finalProfit?: Maybe<CalculatedMetric>;
  impressions?: Maybe<CalculatedMetric>;
  /** actTheyGet / actWeGet */
  margin?: Maybe<CalculatedMetric>;
  monetizedSearches?: Maybe<CalculatedMetric>;
  newUsers?: Maybe<CalculatedMetric>;
  /** Amount of conversions that have a monetary value attached to it */
  paidConversions?: Maybe<CalculatedMetric>;
  /** weGet - theyGet */
  profit?: Maybe<CalculatedMetric>;
  pubConversions?: Maybe<CalculatedMetric>;
  pubPaidConversions?: Maybe<CalculatedMetric>;
  roas?: Maybe<CalculatedMetric>;
  searchCtr?: Maybe<CalculatedMetric>;
  searchMonetizedCtr?: Maybe<CalculatedMetric>;
  searchMonetizedRpm?: Maybe<CalculatedMetric>;
  searchQualityAdvertiserCoverage?: Maybe<CalculatedMetric>;
  searchQualityAdvertiserScore?: Maybe<CalculatedMetric>;
  searchQualityFollowupSearches?: Maybe<CalculatedMetric>;
  searchQualityInitialSearches?: Maybe<CalculatedMetric>;
  searchQualitySearchEngineCoverage?: Maybe<CalculatedMetric>;
  searchQualitySearchEngineFollowupSearches?: Maybe<CalculatedMetric>;
  searchQualitySearchEngineInitialSearches?: Maybe<CalculatedMetric>;
  searchQualitySearchEngineScore?: Maybe<CalculatedMetric>;
  searchRpc?: Maybe<CalculatedMetric>;
  searchRpm?: Maybe<CalculatedMetric>;
  searches?: Maybe<CalculatedMetric>;
  sessions?: Maybe<CalculatedMetric>;
  /** Amount the pub is paid in USD */
  theyGet?: Maybe<CalculatedMetric>;
  theyGetPoints?: Maybe<CalculatedMetric>;
  /** Amount we got in USD */
  weGet?: Maybe<CalculatedMetric>;
};

export type DeltaParameters = {
  /** The distance in time between the original dataset and the delta dataset as a ISO 8601 duration. Durations that are time granular will be calculated exactly with regards to DST changes. Non-time granular durations will be treated calendaristicaly. */
  timeDistance?: InputMaybe<Scalars['String']['input']>;
};

export enum DeltaSortOperation {
  ChangeFactor = 'CHANGE_FACTOR',
  Difference = 'DIFFERENCE',
  Identity = 'IDENTITY'
}

export type DeltaSortParameters = {
  operation?: InputMaybe<DeltaSortOperation>;
  timeDistance?: InputMaybe<Scalars['String']['input']>;
};

export type Device = {
  browser?: Maybe<Scalars['String']['output']>;
  browserVersion?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  inApp?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  osv?: Maybe<Scalars['String']['output']>;
  ua?: Maybe<Scalars['String']['output']>;
};

export type DeviceInput = {
  browser?: InputMaybe<Scalars['String']['input']>;
  browserVersion?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  inApp?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  osv?: InputMaybe<Scalars['String']['input']>;
  ua?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceValues = {
  browser: Array<Scalars['String']['output']>;
  carriers: Array<Carrier>;
  cities: Array<Scalars['String']['output']>;
  makes: Array<Scalars['String']['output']>;
  models: Array<Scalars['String']['output']>;
  os: Array<Scalars['String']['output']>;
  states: Array<Scalars['String']['output']>;
};


export type DeviceValuesBrowserArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
};


export type DeviceValuesCarriersArgs = {
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
};


export type DeviceValuesCitiesArgs = {
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
};


export type DeviceValuesMakesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
};


export type DeviceValuesModelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  make?: InputMaybe<Array<Scalars['String']['input']>>;
  prefix?: InputMaybe<Scalars['String']['input']>;
};


export type DeviceValuesOsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
};


export type DeviceValuesStatesArgs = {
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
};

export type Domain = {
  isDefault: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type DomainCustomization = {
  advertiserId?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  offerId?: Maybe<Scalars['String']['output']>;
  publisherId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DomainCustomizationType>;
};

export type DomainCustomizationConnection = {
  edges?: Maybe<Array<DomainCustomizationEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type DomainCustomizationEdge = {
  node?: Maybe<DomainCustomization>;
};

export type DomainCustomizationFilter = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  domain?: InputMaybe<Scalars['String']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<DomainCustomizationType>;
};

export type DomainCustomizationInput = {
  advertiserIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domain: Scalars['String']['input'];
  offerIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publisherIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: DomainCustomizationType;
};

export enum DomainCustomizationType {
  Tracking = 'TRACKING'
}

export type DomainInput = {
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export enum EmailFrequency {
  Daily = 'DAILY',
  Never = 'NEVER',
  PerMemo = 'PER_MEMO'
}

export type EstimatedMetrics = {
  activeUsers?: Maybe<CalculatedMetric>;
  adClicks?: Maybe<CalculatedMetric>;
  arpu?: Maybe<CalculatedMetric>;
  /** The cost of infrastructure to handle the click amount */
  clickCost?: Maybe<CalculatedMetric>;
  clicks?: Maybe<CalculatedMetric>;
  conversions?: Maybe<CalculatedMetric>;
  coverage?: Maybe<CalculatedMetric>;
  /** The conversion rate */
  cr?: Maybe<CalculatedMetric>;
  events?: Maybe<CalculatedMetric>;
  /** weGet - theyGet - clickCost */
  finalProfit?: Maybe<CalculatedMetric>;
  /** actTheyGet / actWeGet */
  margin?: Maybe<CalculatedMetric>;
  monetizedSearches?: Maybe<CalculatedMetric>;
  newUsers?: Maybe<CalculatedMetric>;
  /** weGet - theyGet */
  profit?: Maybe<CalculatedMetric>;
  pubConversions?: Maybe<CalculatedMetric>;
  pubPaidConversions?: Maybe<CalculatedMetric>;
  roas?: Maybe<CalculatedMetric>;
  searchCtr?: Maybe<CalculatedMetric>;
  searchMonetizedCtr?: Maybe<CalculatedMetric>;
  searchMonetizedRpm?: Maybe<CalculatedMetric>;
  searchQualityAdvertiserCoverage?: Maybe<CalculatedMetric>;
  searchQualityAdvertiserScore?: Maybe<CalculatedMetric>;
  searchQualityFollowupSearches?: Maybe<CalculatedMetric>;
  searchQualityInitialSearches?: Maybe<CalculatedMetric>;
  searchQualitySearchEngineCoverage?: Maybe<CalculatedMetric>;
  searchQualitySearchEngineFollowupSearches?: Maybe<CalculatedMetric>;
  searchQualitySearchEngineInitialSearches?: Maybe<CalculatedMetric>;
  searchQualitySearchEngineScore?: Maybe<CalculatedMetric>;
  searchRpc?: Maybe<CalculatedMetric>;
  searchRpm?: Maybe<CalculatedMetric>;
  searches?: Maybe<CalculatedMetric>;
  sessions?: Maybe<CalculatedMetric>;
  /** Amount the pub is paid in USD */
  theyGet?: Maybe<CalculatedMetric>;
  theyGetPoints?: Maybe<CalculatedMetric>;
  /** Amount we got in USD */
  weGet?: Maybe<CalculatedMetric>;
};

export type EstimationParameters = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type EstimationSortParameters = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  operation?: InputMaybe<DeltaSortOperation>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type EvaluatedPostback = {
  attributionPartner?: Maybe<AttributionPartnerData>;
  click: Click;
  clickId: Scalars['String']['output'];
  evaluation: PostbackEvaluation;
  id: Scalars['String']['output'];
  metrics: EvaluatedPostbackMetrics;
  offer: OfferData;
  postbackResponse: Array<PostbackResponse>;
  queryString?: Maybe<Scalars['String']['output']>;
  reversed?: Maybe<Scalars['Boolean']['output']>;
  serverIp?: Maybe<Scalars['String']['output']>;
  serverUa?: Maybe<Scalars['String']['output']>;
  status: PostbackStatus;
  time: Scalars['LocalDateTime']['output'];
  user?: Maybe<UserData>;
  vta?: Maybe<Scalars['Boolean']['output']>;
};

export type EvaluatedPostbackFilter = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  clickIds?: InputMaybe<Array<Scalars['String']['input']>>;
  decisions?: InputMaybe<Array<PostbackDecision>>;
  endTime: Scalars['LocalDateTime']['input'];
  eventTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offerTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  postbackIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherSubIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recommendationLinkId?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['LocalDateTime']['input'];
  statuses?: InputMaybe<Array<PostbackState>>;
  theyGets?: InputMaybe<Array<PayoutBound>>;
  weGets?: InputMaybe<Array<PayoutBound>>;
};

export type EvaluatedPostbackInput = {
  attributionPartner?: InputMaybe<AttributionPartnerDataInput>;
  click: ClickInput;
  evaluation: PostbackEvaluationInput;
  offer: OfferDataInput;
  postbackResponse?: InputMaybe<Array<PostbackResponseInput>>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  serverIp?: InputMaybe<Scalars['String']['input']>;
  serverUa?: InputMaybe<Scalars['String']['input']>;
  status: PostbackStatusInput;
  time: Scalars['LocalDateTime']['input'];
  user?: InputMaybe<UserDataInput>;
  vta?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvaluatedPostbackMetrics = {
  ctitInHours: Scalars['Int']['output'];
  ctitInSeconds: Scalars['Int']['output'];
};

export type EventComparison = {
  eventTypeA?: Maybe<EventType>;
  eventTypeB?: Maybe<EventType>;
  timing: TimingStats;
  usersWithBoth: Scalars['Int']['output'];
};

export type EventLogFile = {
  createdAt: Scalars['LocalDateTime']['output'];
  generationSpec: EventLogFileSpec;
  id: Scalars['String']['output'];
  status: EventLogFileStatus;
  updatedAt: Scalars['LocalDateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type EventLogFileConnection = {
  edges?: Maybe<Array<EventLogFileEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type EventLogFileEdge = {
  node: EventLogFile;
};

export type EventLogFileFilter = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherSubIds?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EventLogType>;
};

export type EventLogFileSpec = {
  advertisers?: Maybe<Array<Advertiser>>;
  end: Scalars['LocalDateTime']['output'];
  offers?: Maybe<Array<Offer>>;
  publisherSubIds?: Maybe<Array<Scalars['String']['output']>>;
  publishers?: Maybe<Array<Publisher>>;
  start: Scalars['LocalDateTime']['output'];
  type: EventLogType;
};

export type EventLogFileSpecInput = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  end: Scalars['LocalDateTime']['input'];
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherSubIds?: InputMaybe<Array<Scalars['String']['input']>>;
  start: Scalars['LocalDateTime']['input'];
  type: EventLogType;
};

export enum EventLogFileStatus {
  Empty = 'EMPTY',
  Processing = 'PROCESSING',
  Queued = 'QUEUED',
  Ready = 'READY'
}

export enum EventLogType {
  Click = 'CLICK',
  ClickRedirection = 'CLICK_REDIRECTION',
  Impression = 'IMPRESSION'
}

export type EventProgressionStep = {
  eventType?: Maybe<EventType>;
  order?: Maybe<Scalars['Int']['output']>;
  previousEventType?: Maybe<EventType>;
  reachRate: Scalars['Float']['output'];
  timing: TimingStats;
  totalInstalls: Scalars['Int']['output'];
  usersReached: Scalars['Int']['output'];
};

export type EventSinceInstallStep = {
  eventType?: Maybe<EventType>;
  order?: Maybe<Scalars['Int']['output']>;
  reachRate: Scalars['Float']['output'];
  timing: TimingStats;
  totalInstalls: Scalars['Int']['output'];
  usersReached: Scalars['Int']['output'];
};

export type EventTimingInput = {
  end: Scalars['LocalDateTime']['input'];
  postbackDecisions?: InputMaybe<Array<Scalars['String']['input']>>;
  postbackStatus?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['LocalDateTime']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  userIdentifier: UserIdentifierType;
};

export type EventTimingOutlier = {
  deviationFactor: Scalars['Float']['output'];
  eventType?: Maybe<EventType>;
  medianSeconds: Scalars['Float']['output'];
  secondsSinceInstall: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type EventTimingReport = {
  comparison?: Maybe<EventComparison>;
  outliers: Array<EventTimingOutlier>;
  progression: Array<EventProgressionStep>;
  sinceInstall: Array<EventSinceInstallStep>;
};


export type EventTimingReportComparisonArgs = {
  eventTypeIdA?: InputMaybe<Scalars['String']['input']>;
  eventTypeIdB?: InputMaybe<Scalars['String']['input']>;
};


export type EventTimingReportOutliersArgs = {
  deviationMultiplier?: Scalars['Float']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** An event type describes and event associated to an offer that can be fired by the advertiser */
export type EventType = {
  advertiserEventTypeId?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  classification: EventTypeClassification;
  creativeThumbnail?: Maybe<Scalars['String']['output']>;
  creativeUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  isMultiplePostbacksAllowed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  offer?: Maybe<Offer>;
  payouts: Array<Payout>;
  postbackUrl: Scalars['String']['output'];
  settings?: Maybe<EventTypeSettings>;
  status: Status;
  virtualEventConditions?: Maybe<VirtualEventConditions>;
  visibility: EventTypeVisibility;
};


/** An event type describes and event associated to an offer that can be fired by the advertiser */
export type EventTypePayoutsArgs = {
  payoutSpecificity?: InputMaybe<Array<OfferPublisherPayoutType>>;
  status?: InputMaybe<Array<Status>>;
};

export enum EventTypeClassification {
  Monetization = 'MONETIZATION',
  Quality = 'QUALITY'
}

export type EventTypeFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
};

export type EventTypeInput = {
  advertiserEventTypeId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  creativeThumbnail?: InputMaybe<Scalars['String']['input']>;
  creativeUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isMultiplePostbacksAllowed: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
  settings?: InputMaybe<EventTypeSettingsInput>;
  virtualEventConditions?: InputMaybe<VirtualEventConditionsInput>;
  visibility: EventTypeVisibility;
};

export type EventTypeSettings = {
  maxTimeSinceInstall?: Maybe<Scalars['Long']['output']>;
  maxTimeSincePreviousEvent?: Maybe<Scalars['Long']['output']>;
  minTimeSinceInstall?: Maybe<Scalars['Long']['output']>;
  minTimeSincePreviousEvent?: Maybe<Scalars['Long']['output']>;
  needsInstall?: Maybe<Scalars['Boolean']['output']>;
  needsPreviousEvent?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type EventTypeSettingsInput = {
  maxTimeSinceInstall?: InputMaybe<Scalars['Long']['input']>;
  maxTimeSincePreviousEvent?: InputMaybe<Scalars['Long']['input']>;
  minTimeSinceInstall?: InputMaybe<Scalars['Long']['input']>;
  minTimeSincePreviousEvent?: InputMaybe<Scalars['Long']['input']>;
  needsInstall?: InputMaybe<Scalars['Boolean']['input']>;
  needsPreviousEvent?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type EventTypeSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<EventTypeSortBy>;
};

export enum EventTypeSortBy {
  EventTypeId = 'EVENT_TYPE_ID'
}

export enum EventTypeVisibility {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type EventUsage = {
  clicks?: Maybe<Scalars['Long']['output']>;
  discardedClicks?: Maybe<Scalars['Long']['output']>;
  discardedImpressions?: Maybe<Scalars['Long']['output']>;
  end: Scalars['LocalDate']['output'];
  impressions?: Maybe<Scalars['Long']['output']>;
  postbacks?: Maybe<Scalars['Long']['output']>;
  start: Scalars['LocalDate']['output'];
  total?: Maybe<Scalars['Long']['output']>;
  unattributedPostbacks?: Maybe<Scalars['Long']['output']>;
};

export type EventUsageConnection = {
  edges?: Maybe<Array<Maybe<EventUsageEdge>>>;
  totalCount: Scalars['Int']['output'];
};

export type EventUsageEdge = {
  node?: Maybe<EventUsage>;
};

/**
 * Extracts a number from the advertiser's raw event_value payload (jq expression) into
 * aggregatedEventValue or saleAmount while the postback is evaluated.
 */
export type EventValueExtractionRule = {
  active: Scalars['Boolean']['output'];
  advertiser: Advertiser;
  advertiserId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['LocalDateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<EventType>;
  /** null = applies to every event type of the matched offer(s); "null-<offerId>" targets the offer's default event */
  eventTypeId?: Maybe<Scalars['String']['output']>;
  /** jq expression; input is the attribution partner JSON with eventValue pre-parsed (eventValueRaw keeps the original string) */
  expression: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<Offer>;
  /** null = applies to every offer of the advertiser */
  offerId?: Maybe<Scalars['String']['output']>;
  /** false = only fill the target when it is empty or zero */
  overwriteExisting: Scalars['Boolean']['output'];
  /** higher wins among rules of the same specificity (event type > offer > advertiser) */
  priority?: Maybe<Scalars['Int']['output']>;
  target: EventValueExtractionTarget;
  updatedAt?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type EventValueExtractionRuleConnection = {
  edges: Array<EventValueExtractionRuleEdge>;
  totalCount: Scalars['Int']['output'];
};

export type EventValueExtractionRuleEdge = {
  node: EventValueExtractionRule;
};

export type EventValueExtractionRuleFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  eventTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targets?: InputMaybe<Array<EventValueExtractionTarget>>;
};

export type EventValueExtractionRuleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  advertiserId: Scalars['String']['input'];
  eventTypeId?: InputMaybe<Scalars['String']['input']>;
  expression: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  overwriteExisting?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  target: EventValueExtractionTarget;
};

/** Sample attribution partner data to dry-run an expression against */
export type EventValueExtractionSampleInput = {
  aggregatedEventValue?: InputMaybe<Scalars['Float']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  /** raw event_value as received (JSON or url-encoded JSON) */
  eventValue: Scalars['String']['input'];
  saleAmount?: InputMaybe<Scalars['String']['input']>;
  saleAmountCurrency?: InputMaybe<Scalars['String']['input']>;
};

/** Which attribution partner field an event value extraction rule writes into */
export enum EventValueExtractionTarget {
  AggregatedEventValue = 'AGGREGATED_EVENT_VALUE',
  SaleAmount = 'SALE_AMOUNT'
}

export type EventValueExtractionTestResult = {
  /** compile / runtime error, null on success */
  error?: Maybe<Scalars['String']['output']>;
  /** the JSON document the expression was evaluated against */
  input: Scalars['String']['output'];
  /** first jq output as JSON text */
  rawResult?: Maybe<Scalars['String']['output']>;
  /** numeric value that would be written; null when the expression yielded nothing usable */
  value?: Maybe<Scalars['Float']['output']>;
};

export enum ExportAdvertiserField {
  AccountManagerEmail = 'ACCOUNT_MANAGER_EMAIL',
  AccountManagerName = 'ACCOUNT_MANAGER_NAME',
  AccountType = 'ACCOUNT_TYPE',
  ActiveOffers = 'ACTIVE_OFFERS',
  Address = 'ADDRESS',
  AdvertiserContactEmail = 'ADVERTISER_CONTACT_EMAIL',
  AdvertiserContactName = 'ADVERTISER_CONTACT_NAME',
  AdvertiserContactPhone = 'ADVERTISER_CONTACT_PHONE',
  AdvertiserContactSkypeId = 'ADVERTISER_CONTACT_SKYPE_ID',
  Clicks = 'CLICKS',
  Conversions = 'CONVERSIONS',
  Cost = 'COST',
  Country = 'COUNTRY',
  Id = 'ID',
  ImportedOffers = 'IMPORTED_OFFERS',
  Impressions = 'IMPRESSIONS',
  InternalNote = 'INTERNAL_NOTE',
  LiveOffers = 'LIVE_OFFERS',
  Name = 'NAME',
  Phone = 'PHONE',
  Profit = 'PROFIT',
  Revenue = 'REVENUE',
  SalesManagerEmail = 'SALES_MANAGER_EMAIL',
  SalesManagerName = 'SALES_MANAGER_NAME',
  Status = 'STATUS',
  TaxNumber = 'TAX_NUMBER'
}

export enum ExportOfferField {
  AdditionalInformation = 'ADDITIONAL_INFORMATION',
  AdvertiserAccountManagerEmail = 'ADVERTISER_ACCOUNT_MANAGER_EMAIL',
  AdvertiserAccountManagerName = 'ADVERTISER_ACCOUNT_MANAGER_NAME',
  AdvertiserId = 'ADVERTISER_ID',
  AdvertiserName = 'ADVERTISER_NAME',
  AdvertiserOfferId = 'ADVERTISER_OFFER_ID',
  AdvertiserTrackingUrl = 'ADVERTISER_TRACKING_URL',
  ApprovalRequired = 'APPROVAL_REQUIRED',
  AppStoreId = 'APP_STORE_ID',
  Clicks = 'CLICKS',
  ClickBudget = 'CLICK_BUDGET',
  ClickBudgetConsumed = 'CLICK_BUDGET_CONSUMED',
  Conversions = 'CONVERSIONS',
  ConversionBudget = 'CONVERSION_BUDGET',
  ConversionBudgetConsumed = 'CONVERSION_BUDGET_CONSUMED',
  Cost = 'COST',
  CreativesUrl = 'CREATIVES_URL',
  Description = 'DESCRIPTION',
  EventTypeId = 'EVENT_TYPE_ID',
  EventTypeName = 'EVENT_TYPE_NAME',
  Id = 'ID',
  Impressions = 'IMPRESSIONS',
  Jumps = 'JUMPS',
  Kpi = 'KPI',
  Leadflow = 'LEADFLOW',
  Name = 'NAME',
  Note = 'NOTE',
  PayoutMargin = 'PAYOUT_MARGIN',
  PayoutTheyGet = 'PAYOUT_THEY_GET',
  PayoutWeGet = 'PAYOUT_WE_GET',
  PreviewUrl = 'PREVIEW_URL',
  Private = 'PRIVATE',
  Profit = 'PROFIT',
  Restrictions = 'RESTRICTIONS',
  Revenue = 'REVENUE',
  RevenueBudget = 'REVENUE_BUDGET',
  RevenueBudgetConsumed = 'REVENUE_BUDGET_CONSUMED',
  RevenueShare = 'REVENUE_SHARE',
  SalesAccountManagerEmail = 'SALES_ACCOUNT_MANAGER_EMAIL',
  SalesAccountManagerName = 'SALES_ACCOUNT_MANAGER_NAME',
  SourceOfferId = 'SOURCE_OFFER_ID',
  Status = 'STATUS',
  Tags = 'TAGS',
  TargetingCountries = 'TARGETING_COUNTRIES',
  TargetingOs = 'TARGETING_OS',
  TrackerName = 'TRACKER_NAME'
}

export enum ExportPublisherField {
  AccountManagerEmail = 'ACCOUNT_MANAGER_EMAIL',
  AccountManagerName = 'ACCOUNT_MANAGER_NAME',
  AccountType = 'ACCOUNT_TYPE',
  ActiveOffers = 'ACTIVE_OFFERS',
  Address = 'ADDRESS',
  Clicks = 'CLICKS',
  Conversions = 'CONVERSIONS',
  Cost = 'COST',
  Country = 'COUNTRY',
  Id = 'ID',
  Impressions = 'IMPRESSIONS',
  IsApiPublisher = 'IS_API_PUBLISHER',
  LiveOffers = 'LIVE_OFFERS',
  Name = 'NAME',
  Phone = 'PHONE',
  Profit = 'PROFIT',
  PublisherContactEmail = 'PUBLISHER_CONTACT_EMAIL',
  PublisherContactName = 'PUBLISHER_CONTACT_NAME',
  PublisherContactPhone = 'PUBLISHER_CONTACT_PHONE',
  PublisherContactSkypeId = 'PUBLISHER_CONTACT_SKYPE_ID',
  Revenue = 'REVENUE',
  SalesManagerEmail = 'SALES_MANAGER_EMAIL',
  SalesManagerName = 'SALES_MANAGER_NAME',
  Status = 'STATUS',
  TaxNumber = 'TAX_NUMBER'
}

export type FeedApiConfiguration = {
  numberOfOffers?: Maybe<Scalars['Int']['output']>;
  publisherId?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<FeedApiSection>>;
};

export enum FeedApiConfigurationFilterType {
  Advertiser = 'ADVERTISER',
  Country = 'COUNTRY',
  DisableMultiGeoOffers = 'DISABLE_MULTI_GEO_OFFERS',
  Os = 'OS',
  ReachesStore = 'REACHES_STORE',
  ReachesTracker = 'REACHES_TRACKER',
  Tag = 'TAG'
}

export type FeedApiConfigurationInput = {
  publisherId?: InputMaybe<Scalars['String']['input']>;
  /** null means default */
  sections: Array<FeedApiSectionInput>;
};

export type FeedApiSection = {
  blacklistedOffers?: Maybe<Array<Scalars['String']['output']>>;
  boostExitHoursInApi?: Maybe<Scalars['Int']['output']>;
  boostExitNoOfClicks?: Maybe<Scalars['Int']['output']>;
  boostExitNoOfClicksForPeriodInHours?: Maybe<Scalars['Int']['output']>;
  boostLimit?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exploratoryExitHoursInApi?: Maybe<Scalars['Int']['output']>;
  exploratoryExitNoOfClicks?: Maybe<Scalars['Int']['output']>;
  exploratoryExitNoOfClicksForPeriodInHours?: Maybe<Scalars['Int']['output']>;
  exploratoryLimit?: Maybe<Scalars['Int']['output']>;
  exploratoryPeriodInHours?: Maybe<Scalars['Int']['output']>;
  filters?: Maybe<Array<FeedApiSpecFilter>>;
  performanceLimit?: Maybe<Scalars['Int']['output']>;
  performancePeriodInHours?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  whitelistedOffers?: Maybe<Array<Scalars['String']['output']>>;
};

export type FeedApiSectionInput = {
  blacklistedOffers?: InputMaybe<Array<Scalars['String']['input']>>;
  boostExitHoursInApi?: InputMaybe<Scalars['Int']['input']>;
  boostExitNoOfClicks?: InputMaybe<Scalars['Int']['input']>;
  boostExitNoOfClicksForPeriodInHours?: InputMaybe<Scalars['Int']['input']>;
  boostLimit?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  exploratoryExitHoursInApi?: InputMaybe<Scalars['Int']['input']>;
  exploratoryExitNoOfClicks?: InputMaybe<Scalars['Int']['input']>;
  exploratoryExitNoOfClicksForPeriodInHours?: InputMaybe<Scalars['Int']['input']>;
  exploratoryLimit?: InputMaybe<Scalars['Int']['input']>;
  exploratoryPeriodInHours?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<FeedApiSpecFilterInput>>;
  performanceLimit?: InputMaybe<Scalars['Int']['input']>;
  performancePeriodInHours?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  whitelistedOffers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FeedApiSpecFilter = {
  filterType: FeedApiConfigurationFilterType;
  value: Array<Scalars['String']['output']>;
};

export type FeedApiSpecFilterInput = {
  filterType: FeedApiConfigurationFilterType;
  value: Array<Scalars['String']['input']>;
};

export type FeedApiStatus = {
  blockingReasons?: Maybe<Array<FeedApiStatusBlockingReason>>;
  live?: Maybe<Scalars['Boolean']['output']>;
};

export enum FeedApiStatusBlockingReason {
  AdvertiserBlocked = 'ADVERTISER_BLOCKED',
  AdvertiserNotActive = 'ADVERTISER_NOT_ACTIVE',
  ClickOfferBudgetReached = 'CLICK_OFFER_BUDGET_REACHED',
  ClickPublisherBudgetReached = 'CLICK_PUBLISHER_BUDGET_REACHED',
  FeedApiConfiguratorDisallowed = 'FEED_API_CONFIGURATOR_DISALLOWED',
  ImpressionOfferBudgetReached = 'IMPRESSION_OFFER_BUDGET_REACHED',
  ImpressionPublisherBudgetReached = 'IMPRESSION_PUBLISHER_BUDGET_REACHED',
  OfferApprovalNeeded = 'OFFER_APPROVAL_NEEDED',
  OfferBudgetReached = 'OFFER_BUDGET_REACHED',
  OfferNotActive = 'OFFER_NOT_ACTIVE',
  OfferPublisherBudgetReached = 'OFFER_PUBLISHER_BUDGET_REACHED',
  OfferTimeTargeting = 'OFFER_TIME_TARGETING'
}

export type Filler = {
  adKeywordImportSpec?: Maybe<AdKeywordImportSpec>;
  advertiserTags?: Maybe<Array<Scalars['String']['output']>>;
  advertisers?: Maybe<Array<Advertiser>>;
  country?: Maybe<Scalars['String']['output']>;
  fieldName: FillerFieldName;
  forceOverride?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  offerTags?: Maybe<Array<Scalars['String']['output']>>;
  offers?: Maybe<Array<Offer>>;
  os?: Maybe<PlatformType>;
  publisherTags?: Maybe<Array<Scalars['String']['output']>>;
  publishers?: Maybe<Array<Publisher>>;
  recencyPeriod?: Maybe<FillerRecencyPeriod>;
  trafficTags?: Maybe<Array<Scalars['String']['output']>>;
  values: Array<WeightedValue>;
};

export type FillerConnection = {
  edges?: Maybe<Array<FillerEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type FillerEdge = {
  node: Filler;
};

export enum FillerFieldName {
  App = 'APP',
  AppId = 'APP_ID',
  AppName = 'APP_NAME',
  Creative = 'CREATIVE',
  Placement = 'PLACEMENT',
  Site = 'SITE',
  Subid = 'SUBID',
  Subsubid = 'SUBSUBID',
  Term = 'TERM'
}

export type FillerFilter = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  advertiserTags?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<FillerFieldName>;
  id?: InputMaybe<Scalars['String']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offerTags?: InputMaybe<Array<Scalars['String']['input']>>;
  os?: InputMaybe<PlatformType>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherTags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FillerInput = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  advertiserTags?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Scalars['String']['input']>;
  fieldName: FillerFieldName;
  forceOverride?: InputMaybe<Scalars['Boolean']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offerTags?: InputMaybe<Array<Scalars['String']['input']>>;
  os?: InputMaybe<PlatformType>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherTags?: InputMaybe<Array<Scalars['String']['input']>>;
  recencyPeriod?: InputMaybe<FillerRecencyPeriod>;
  trafficTags?: InputMaybe<Array<Scalars['String']['input']>>;
  values?: InputMaybe<Array<WeightedValueInput>>;
};

export enum FillerRecencyPeriod {
  Day = 'DAY',
  None = 'NONE'
}

export enum FilterOperator {
  Eq = 'EQ',
  Neq = 'NEQ'
}

export type FirePostbacksResponse = {
  failed: Scalars['Int']['output'];
  successful: Scalars['Int']['output'];
};

export type FloatValue = {
  value?: Maybe<Scalars['Float']['output']>;
};

export type Form = {
  fields: Array<FormField>;
  id: Scalars['String']['output'];
  tag?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FormField = {
  allowedValues?: Maybe<Array<Scalars['String']['output']>>;
  correspondingEntityField?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  mandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: FormFieldType;
};

export type FormFieldInput = {
  allowedValues?: InputMaybe<Array<Scalars['String']['input']>>;
  correspondingEntityField?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  mandatory: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  type: FormFieldType;
};

export type FormFieldResult = {
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FormFieldResultInput = {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum FormFieldType {
  Checkbox = 'CHECKBOX',
  CountryMultiSelect = 'COUNTRY_MULTI_SELECT',
  CountrySelect = 'COUNTRY_SELECT',
  Email = 'EMAIL',
  Select = 'SELECT',
  StaticText = 'STATIC_TEXT',
  Text = 'TEXT',
  TextArea = 'TEXT_AREA',
  Url = 'URL'
}

export type FormInput = {
  fields: Array<FormFieldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormResult = {
  form: Form;
  formId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  pubReferral?: Maybe<Publisher>;
  referral?: Maybe<User>;
  results: Array<FormFieldResult>;
  submissionTime: Scalars['LocalDateTime']['output'];
};

export type FormResultInput = {
  formId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  pubReferralId?: InputMaybe<Scalars['String']['input']>;
  referralId?: InputMaybe<Scalars['String']['input']>;
  results: Array<FormFieldResultInput>;
};

/** Fraud scoring policy (per organization) */
export type FraudPolicyConfig = {
  /** When true, users crossing the auto-ban tier/score are moved to BANNED_FOR_FRAUD; otherwise scoring is flag-only. */
  autoBanEnabled: Scalars['Boolean']['output'];
  /** Optional absolute-score override (0-100). Null disables it. */
  autoBanScoreThreshold?: Maybe<Scalars['Float']['output']>;
  /** Ban users at or above this tier. Null disables tier-based banning. */
  autoBanTier?: Maybe<FraudRiskTier>;
  /** Rolling window (days) the fraud reports scan. */
  lookbackDays: Scalars['Int']['output'];
  /** Master switch for the daily scheduled scan. */
  scanEnabled: Scalars['Boolean']['output'];
  /** The identifier that keys a rewarded user across all fraud reports and the scan. */
  userIdentifier: UserIdentifierType;
};

export type FraudPolicyConfigInput = {
  autoBanEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoBanScoreThreshold?: InputMaybe<Scalars['Float']['input']>;
  autoBanTier?: InputMaybe<FraudRiskTier>;
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  scanEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  userIdentifier?: InputMaybe<UserIdentifierType>;
};

export type FraudReportConnection = {
  edges: Array<FraudReportEdge>;
  totalCount: Scalars['Int']['output'];
};

export enum FraudReportDimension {
  AdvertiserId = 'ADVERTISER_ID',
  AdvertiserName = 'ADVERTISER_NAME',
  AdvertiserTags = 'ADVERTISER_TAGS',
  AppId = 'APP_ID',
  Country = 'COUNTRY',
  Day = 'DAY',
  DeviceModel = 'DEVICE_MODEL',
  Hour = 'HOUR',
  Month = 'MONTH',
  OfferId = 'OFFER_ID',
  OfferName = 'OFFER_NAME',
  OfferTags = 'OFFER_TAGS',
  Os = 'OS',
  PubId = 'PUB_ID',
  PubName = 'PUB_NAME',
  PubTags = 'PUB_TAGS',
  StoreAppId = 'STORE_APP_ID',
  SubId = 'SUB_ID',
  Time = 'TIME',
  Ua = 'UA',
  Week = 'WEEK'
}

export type FraudReportDimensionRecord = {
  dimension: FraudReportDimension;
  value: UserProvidedValue;
};

export type FraudReportEdge = {
  node: FraudReportRow;
};

export type FraudReportFilter = {
  dimension: FraudReportDimension;
  operator: GenericFilterOperator;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum FraudReportGranularity {
  All = 'ALL',
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK'
}

export enum FraudReportLevelOfDetail {
  Offer = 'OFFER',
  OfferPub = 'OFFER_PUB',
  OfferPubSubid = 'OFFER_PUB_SUBID'
}

export enum FraudReportMetric {
  Clicks = 'CLICKS',
  Cr = 'CR',
  FraudulentConversions = 'FRAUDULENT_CONVERSIONS',
  Percent = 'PERCENT',
  TotalConversions = 'TOTAL_CONVERSIONS'
}

export type FraudReportMetricRecord = {
  metric: FraudReportMetric;
  value: Scalars['Float']['output'];
};

export type FraudReportQuery = {
  end: Scalars['LocalDateTime']['input'];
  filters?: InputMaybe<Array<FraudReportFilter>>;
  granularity: FraudReportGranularity;
  groupBy?: InputMaybe<FraudReportDimension>;
  levelOfDetail: FraudReportLevelOfDetail;
  maxThreshold: Scalars['Float']['input'];
  minApplicableConversions?: InputMaybe<Scalars['Int']['input']>;
  minThreshold: Scalars['Float']['input'];
  sort?: InputMaybe<Array<FraudReportSort>>;
  start: Scalars['LocalDateTime']['input'];
};

export type FraudReportRow = {
  dimensions: Array<FraudReportDimensionRecord>;
  metrics: Array<FraudReportMetricRecord>;
  offerStatus: OfferStatus;
  publisherBlocked?: Maybe<Scalars['Boolean']['output']>;
  subIdBlocked?: Maybe<Scalars['Boolean']['output']>;
};

export type FraudReportSort = {
  dimension?: InputMaybe<FraudReportDimension>;
  direction?: InputMaybe<SortOrder>;
  metric?: InputMaybe<FraudReportMetric>;
};

export enum FraudRiskTier {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type FraudSignalEvidence = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum FraudSignalType {
  MultiAccountDevice = 'MULTI_ACCOUNT_DEVICE',
  MultiAccountIp = 'MULTI_ACCOUNT_IP',
  ReferralAbuse = 'REFERRAL_ABUSE',
  Reversal = 'REVERSAL',
  RuleViolations = 'RULE_VIOLATIONS',
  TimeOfDayAnomaly = 'TIME_OF_DAY_ANOMALY',
  TimingCluster = 'TIMING_CLUSTER',
  VelocityBurst = 'VELOCITY_BURST',
  VpnUsage = 'VPN_USAGE'
}

export enum FunnelMetric {
  RatioOfUsers = 'RATIO_OF_USERS',
  Users = 'USERS'
}

export type FunnelQuery = {
  appIds?: InputMaybe<Array<Scalars['String']['input']>>;
  end: Scalars['LocalDateTime']['input'];
  eventSequence: Array<InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Array<AppReportFilter>>;
  first: Scalars['Int']['input'];
  groupBy?: InputMaybe<Array<AppReportDimension>>;
  metrics: Array<FunnelMetric>;
  offset: Scalars['Int']['input'];
  sort?: InputMaybe<Array<FunnelSort>>;
  start: Scalars['LocalDateTime']['input'];
  storeAppIds?: InputMaybe<Array<Scalars['String']['input']>>;
  windowSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type FunnelReportConnection = {
  csvDownloadUrl: Scalars['String']['output'];
  edges: Array<FunnelReportEdge>;
  totalCount: Scalars['Int']['output'];
};

export type FunnelReportEdge = {
  node: FunnelReportRow;
};

export type FunnelReportMetricRecord = {
  field: FunnelMetric;
  value: Scalars['Float']['output'];
};

export type FunnelReportRow = {
  appEventType?: Maybe<AppEventType>;
  completedSteps: Scalars['Int']['output'];
  dimensions: Array<AppReportDimensionRecord>;
  metrics: Array<FunnelReportMetricRecord>;
};

export type FunnelSort = {
  byCompletedSteps?: InputMaybe<Scalars['Boolean']['input']>;
  dimension?: InputMaybe<AppReportDimension>;
  direction?: InputMaybe<SortOrder>;
};

export enum GenericFilterOperator {
  BetweenIncluding = 'BETWEEN_INCLUDING',
  Contains = 'CONTAINS',
  GreaterEqual = 'GREATER_EQUAL',
  In = 'IN',
  IsEmpty = 'IS_EMPTY',
  IsNotEmpty = 'IS_NOT_EMPTY',
  LowerEqual = 'LOWER_EQUAL',
  NotContains = 'NOT_CONTAINS',
  NotIn = 'NOT_IN'
}

export type Geo = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  utcoffset?: Maybe<Scalars['Float']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type GeoInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  utcoffset?: InputMaybe<Scalars['Float']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Results of a search grouped by their type */
export type GroupedSearchResult = {
  entries?: Maybe<Array<Maybe<SearchEntity>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type HourlyRecordCount = {
  hour: Scalars['LocalDateTime']['output'];
  numberOfRecords: Scalars['Int']['output'];
};

/** Device advertising ids for both iOS and Android */
export type Ids = {
  gaid?: Maybe<Scalars['String']['output']>;
  idfa?: Maybe<Scalars['String']['output']>;
};

export type IdsInput = {
  gaid?: InputMaybe<Scalars['String']['input']>;
  idfa?: InputMaybe<Scalars['String']['input']>;
};

export type ImportedBudget = {
  amount: Scalars['Float']['output'];
  eventType?: Maybe<ImportedEventType>;
  type: BudgetType;
  validity: BudgetValidity;
};

export type ImportedClickBudget = {
  amount: Scalars['Float']['output'];
  validity: BudgetValidity;
};

export type ImportedEventType = {
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** An imported offer is an offer that is available from a partner network but not yet created in our system */
export type ImportedOffer = {
  active?: Maybe<Scalars['Boolean']['output']>;
  advertiser: Advertiser;
  advertiserOfferId: Scalars['String']['output'];
  advertiserTrackingUrl?: Maybe<Scalars['String']['output']>;
  appStoreId: Scalars['String']['output'];
  approvalTime?: Maybe<Scalars['LocalDateTime']['output']>;
  budgets: Array<ImportedBudget>;
  clickBudgets: Array<ImportedClickBudget>;
  dailyConversions?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventTypes: Array<ImportedEventType>;
  id: Scalars['String']['output'];
  impressionTrackingUrl?: Maybe<Scalars['String']['output']>;
  kpi?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  offer?: Maybe<Offer>;
  payouts: Array<ImportedPayouts>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  repetitions: Repetitions;
  revenueShareEnabled?: Maybe<Scalars['Boolean']['output']>;
  targeting?: Maybe<Targeting>;
  updated: Scalars['LocalDateTime']['output'];
  weGet?: Maybe<Scalars['Float']['output']>;
};

export type ImportedOfferConnection = {
  edges: Array<ImportedOfferrEdge>;
  totalCount: Scalars['Int']['output'];
};

export enum ImportedOfferField {
  AdvancedTargeting = 'ADVANCED_TARGETING',
  AdvertiserTrackingUrl = 'ADVERTISER_TRACKING_URL',
  BlacklistedSubids = 'BLACKLISTED_SUBIDS',
  Budgets = 'BUDGETS',
  ClickBudgets = 'CLICK_BUDGETS',
  Creatives = 'CREATIVES',
  CreativesUrl = 'CREATIVES_URL',
  Description = 'DESCRIPTION',
  EventTypes = 'EVENT_TYPES',
  EventTypeNames = 'EVENT_TYPE_NAMES',
  ImpressionBudgets = 'IMPRESSION_BUDGETS',
  ImpressionTrackingUrl = 'IMPRESSION_TRACKING_URL',
  IsApprovalRequired = 'IS_APPROVAL_REQUIRED',
  IsPrivate = 'IS_PRIVATE',
  Kpi = 'KPI',
  Leadflow = 'LEADFLOW',
  Name = 'NAME',
  Payouts = 'PAYOUTS',
  PayoutTheyGet = 'PAYOUT_THEY_GET',
  PayoutTheyGetPoints = 'PAYOUT_THEY_GET_POINTS',
  PayoutWeGet = 'PAYOUT_WE_GET',
  PayoutWeGetMargin = 'PAYOUT_WE_GET_MARGIN',
  PayoutWeGetPoints = 'PAYOUT_WE_GET_POINTS',
  PreviewUrl = 'PREVIEW_URL',
  RevenueShareEnabled = 'REVENUE_SHARE_ENABLED',
  Status = 'STATUS',
  Targeting = 'TARGETING'
}

export type ImportedOfferFieldSetting = {
  create: Scalars['Boolean']['output'];
  defaultValue?: Maybe<UserProvidedValue>;
  field: ImportedOfferField;
  sync: Scalars['Boolean']['output'];
};

export type ImportedOfferFieldSettingInput = {
  create: Scalars['Boolean']['input'];
  defaultBoolValue?: InputMaybe<Scalars['Boolean']['input']>;
  defaultFloatValue?: InputMaybe<Scalars['Float']['input']>;
  defaultIntValue?: InputMaybe<Scalars['Int']['input']>;
  defaultStringArrayValue?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultStringValue?: InputMaybe<Scalars['String']['input']>;
  field: ImportedOfferField;
  sync: Scalars['Boolean']['input'];
};

export type ImportedOfferFilter = {
  advertiser?: InputMaybe<Scalars['String']['input']>;
  advertiserOfferId?: InputMaybe<Scalars['String']['input']>;
  advertiserOfferIds?: InputMaybe<Array<Scalars['String']['input']>>;
  advertisers?: InputMaybe<Array<Scalars['String']['input']>>;
  appStoreId?: InputMaybe<Scalars['String']['input']>;
  appStoreIds?: InputMaybe<Array<Scalars['String']['input']>>;
  areActive?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  hasOffer?: InputMaybe<Scalars['Boolean']['input']>;
  hasOffers?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  managerId?: InputMaybe<Scalars['String']['input']>;
  managerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  maxRepetitions?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<PlatformType>;
  platforms?: InputMaybe<Array<PlatformType>>;
};

export type ImportedOfferSort = {
  field: ImportedOfferSortField;
  order: SortOrder;
};

export enum ImportedOfferSortField {
  AdvertiserId = 'ADVERTISER_ID',
  LastChanged = 'LAST_CHANGED',
  OfferApprovalTime = 'OFFER_APPROVAL_TIME',
  Repeated = 'REPEATED',
  WeGet = 'WE_GET'
}

export type ImportedOfferrEdge = {
  node: ImportedOffer;
};

export type ImportedPayouts = {
  eventType?: Maybe<ImportedEventType>;
  theyGet?: Maybe<Scalars['Float']['output']>;
  theyGetPoints?: Maybe<Scalars['Float']['output']>;
  weGet?: Maybe<Scalars['Float']['output']>;
  weGetMargin?: Maybe<Scalars['Float']['output']>;
  weGetPoints?: Maybe<Scalars['Float']['output']>;
};

export type ImpressionBudget = {
  advertiser: Advertiser;
  /** the total amount available in the given period */
  amount: Scalars['Float']['output'];
  /** the consumed amount for the given period */
  consumed: Scalars['Float']['output'];
  /** estimated amount at the end of validity period. It is calculated the same as the ConsumedBudget by totalPeriod / periodPassedSoFar * consumed */
  estimated: Scalars['Float']['output'];
  offer?: Maybe<Offer>;
  publisher?: Maybe<Publisher>;
  validity?: Maybe<BudgetValidity>;
};

export type ImpressionBudgetId = {
  advertiserId: Scalars['String']['input'];
  offerId?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  validity?: InputMaybe<BudgetValidity>;
};

export type ImpressionBudgetInput = {
  advertiserId: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  offerId?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  validity?: InputMaybe<BudgetValidity>;
};

export type IntValue = {
  value: Scalars['Long']['output'];
};

export type InventoryConfig = {
  dynamicOfferFeatures?: Maybe<Array<OfferFeatures>>;
  staticOfferIds?: Maybe<Array<Scalars['String']['output']>>;
  targeting?: Maybe<AdvancedTargetingGroup>;
  unwantedOfferIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type InventoryConfigInput = {
  dynamicOfferFeatures?: InputMaybe<Array<OfferFeaturesInput>>;
  staticOfferIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targeting?: InputMaybe<AdvancedTargetingGroupInput>;
  unwantedOfferIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A login code generated by an admin for a contact; shown once, never emailed. */
export type IssuedLoginCode = {
  /** The six-digit code. */
  code: Scalars['String']['output'];
  /** Email of the account the code belongs to. */
  email: Scalars['String']['output'];
  /** When the code stops working. */
  expiresAt: Scalars['LocalDateTime']['output'];
};

export type JumpAnalysis = {
  country?: Maybe<Scalars['String']['output']>;
  jumps?: Maybe<Scalars['Int']['output']>;
  lastScannedAt?: Maybe<Scalars['String']['output']>;
  offerWall: Scalars['Boolean']['output'];
  os?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  protocolSwitching?: Maybe<Scalars['Boolean']['output']>;
  redirectMethod?: Maybe<Scalars['String']['output']>;
  storeReached?: Maybe<Scalars['Boolean']['output']>;
  trackerName?: Maybe<Scalars['String']['output']>;
  urlChain?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type JumpAnalysisFilter = {
  country?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  storeReached?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Kpi = {
  actions: Array<KpiAction>;
  active: Scalars['Boolean']['output'];
  advertisers?: Maybe<Array<Advertiser>>;
  alerting: Scalars['Boolean']['output'];
  check: KpiCheck;
  createdAt: Scalars['LocalDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<KpiFilter>>;
  history?: Maybe<KpiHistory>;
  id: Scalars['String']['output'];
  lastTriggeredAt?: Maybe<Scalars['LocalDateTime']['output']>;
  name: Scalars['String']['output'];
  offers?: Maybe<Array<Offer>>;
  publishers?: Maybe<Array<Publisher>>;
  target: KpiTarget;
};

export type KpiAction = {
  type: KpiActionType;
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type KpiActionInput = {
  type: KpiActionType;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum KpiActionType {
  BlacklistSubId = 'BLACKLIST_SUB_ID',
  ChangeOfferAccessState = 'CHANGE_OFFER_ACCESS_STATE',
  ChangeOfferStatus = 'CHANGE_OFFER_STATUS',
  ChangePublisherStatus = 'CHANGE_PUBLISHER_STATUS',
  DeleteBlacklistSubId = 'DELETE_BLACKLIST_SUB_ID',
  NotifyAdmin = 'NOTIFY_ADMIN',
  NotifyAdvertiserAccountManager = 'NOTIFY_ADVERTISER_ACCOUNT_MANAGER',
  NotifyPublisher = 'NOTIFY_PUBLISHER',
  NotifyPublisherAccountManager = 'NOTIFY_PUBLISHER_ACCOUNT_MANAGER',
  NotifyUser = 'NOTIFY_USER'
}

export type KpiCheck = {
  operator: KpiCheckOperator;
  thresholds: Array<KpiThreshold>;
  timeframe: Scalars['Long']['output'];
};

export type KpiCheckInput = {
  operator: KpiCheckOperator;
  thresholds: Array<KpiThresholdInput>;
  timeframe: Scalars['Long']['input'];
};

export enum KpiCheckOperator {
  All = 'ALL',
  Any = 'ANY'
}

export type KpiConnection = {
  edges?: Maybe<Array<KpiEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type KpiEdge = {
  node: Kpi;
};

export type KpiFilter = {
  operator: KpiFilterOperator;
  type: KpiFilterType;
  values: Array<Scalars['String']['output']>;
};

export type KpiFilterInput = {
  operator: KpiFilterOperator;
  type: KpiFilterType;
  values: Array<Scalars['String']['input']>;
};

export enum KpiFilterOperator {
  In = 'IN',
  NotIn = 'NOT_IN'
}

export enum KpiFilterType {
  AdvertiserId = 'ADVERTISER_ID',
  AdvertiserTags = 'ADVERTISER_TAGS',
  OfferId = 'OFFER_ID',
  OfferStatus = 'OFFER_STATUS',
  OfferTags = 'OFFER_TAGS',
  PublisherId = 'PUBLISHER_ID',
  PublisherTags = 'PUBLISHER_TAGS'
}

export type KpiHistory = {
  items: Array<KpiHistoryItem>;
};

export type KpiHistoryItem = {
  alerting: Scalars['Boolean']['output'];
  end?: Maybe<Scalars['LocalDateTime']['output']>;
  start?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type KpiInput = {
  actions: Array<KpiActionInput>;
  active: Scalars['Boolean']['input'];
  check: KpiCheckInput;
  description?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<KpiFilterInput>>;
  name: Scalars['String']['input'];
  target: KpiTarget;
};

export type KpiLog = {
  entries: Array<Scalars['String']['output']>;
  type: KpiActionType;
};

export type KpiLogConnection = {
  edges: Array<KpiLogEdge>;
  totalCount: Scalars['Int']['output'];
};

export type KpiLogEdge = {
  node: KpiLog;
};

export enum KpiMetric {
  AdvertiserRejectedConversions = 'ADVERTISER_REJECTED_CONVERSIONS',
  AdClicks = 'AD_CLICKS',
  Clicks = 'CLICKS',
  Conversions = 'CONVERSIONS',
  Cr = 'CR',
  Ctr = 'CTR',
  EventRate = 'EVENT_RATE',
  Impressions = 'IMPRESSIONS',
  MonetizedSearches = 'MONETIZED_SEARCHES',
  MonetizedSearchCtr = 'MONETIZED_SEARCH_CTR',
  NonPaidConversions = 'NON_PAID_CONVERSIONS',
  PaidConversions = 'PAID_CONVERSIONS',
  PaidCr = 'PAID_CR',
  Searches = 'SEARCHES',
  SearchCtr = 'SEARCH_CTR',
  SearchQualityAdvertiserCoverage = 'SEARCH_QUALITY_ADVERTISER_COVERAGE',
  SearchQualityAdvertiserScore = 'SEARCH_QUALITY_ADVERTISER_SCORE',
  SearchQualityFollowupSearches = 'SEARCH_QUALITY_FOLLOWUP_SEARCHES',
  SearchQualityInitialSearches = 'SEARCH_QUALITY_INITIAL_SEARCHES',
  SearchQualitySearchEngineCoverage = 'SEARCH_QUALITY_SEARCH_ENGINE_COVERAGE',
  SearchQualitySearchEngineFollowupSearches = 'SEARCH_QUALITY_SEARCH_ENGINE_FOLLOWUP_SEARCHES',
  SearchQualitySearchEngineInitialSearches = 'SEARCH_QUALITY_SEARCH_ENGINE_INITIAL_SEARCHES',
  SearchQualitySearchEngineScore = 'SEARCH_QUALITY_SEARCH_ENGINE_SCORE',
  TheyGet = 'THEY_GET',
  WeGet = 'WE_GET'
}

export enum KpiOperator {
  Equals = 'EQUALS',
  Gte = 'GTE',
  Lte = 'LTE',
  NotEquals = 'NOT_EQUALS'
}

export type KpiReadFilter = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  alerting?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type KpiSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<KpiSortBy>;
};

export enum KpiSortBy {
  Id = 'ID'
}

export enum KpiTarget {
  Advertiser = 'ADVERTISER',
  Global = 'GLOBAL',
  Offer = 'OFFER',
  OfferPublisher = 'OFFER_PUBLISHER',
  OfferSubPublisher = 'OFFER_SUB_PUBLISHER',
  Publisher = 'PUBLISHER'
}

export type KpiThreshold = {
  arguments?: Maybe<KpiThresholdArguments>;
  metric: KpiMetric;
  operator: KpiOperator;
  value: Scalars['Float']['output'];
};

export type KpiThresholdArguments = {
  eventTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  states?: Maybe<Array<PostbackState>>;
};

export type KpiThresholdArgumentsInput = {
  eventTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  states?: InputMaybe<Array<PostbackState>>;
};

export type KpiThresholdInput = {
  arguments?: InputMaybe<KpiThresholdArgumentsInput>;
  metric: KpiMetric;
  operator: KpiOperator;
  value: Scalars['Float']['input'];
};

export type KochavaPostbackInfo = {
  subdomain: Scalars['String']['output'];
};

export type KochavaPostbackInfoInput = {
  subdomain: Scalars['String']['input'];
};

export type LandingPage = {
  advertiserTrackingUrl: Scalars['String']['output'];
  deeplink?: Maybe<Scalars['String']['output']>;
  htmlBody?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  impressionTargeting?: Maybe<AdvancedTargeting>;
  impressionTrackingUrl?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  jitter?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  offer: Offer;
  parallelTrackingEnabled?: Maybe<Scalars['Boolean']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
  targetCtr?: Maybe<Scalars['Float']['output']>;
  targeting?: Maybe<AdvancedTargeting>;
};

export type LandingPageInput = {
  advertiserTrackingUrl: Scalars['String']['input'];
  deeplink?: InputMaybe<Scalars['String']['input']>;
  htmlBody?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  impressionTargeting?: InputMaybe<AdvancedTargetingInput>;
  impressionTrackingUrl?: InputMaybe<Scalars['String']['input']>;
  isDefault: Scalars['Boolean']['input'];
  jitter?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
  parallelTrackingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
  targetCtr?: InputMaybe<Scalars['Float']['input']>;
  targeting?: InputMaybe<AdvancedTargetingInput>;
};

export enum LeadEvaluationRule {
  AnonymousProxy = 'ANONYMOUS_PROXY',
  DuplicatedEmail = 'DUPLICATED_EMAIL',
  InvalidEmail = 'INVALID_EMAIL',
  IpRecency = 'IP_RECENCY',
  LeadTargeting = 'LEAD_TARGETING',
  Recency = 'RECENCY'
}

export enum LeadForwardContentType {
  ApplicationFormUrlEncoded = 'APPLICATION_FORM_URL_ENCODED',
  ApplicationJson = 'APPLICATION_JSON',
  MultipartFormData = 'MULTIPART_FORM_DATA',
  PlainText = 'PLAIN_TEXT'
}

export type LeadForwardingEndpoint = {
  advertiser: Advertiser;
  body?: Maybe<Scalars['String']['output']>;
  contentType: LeadForwardContentType;
  expectedResponseBody?: Maybe<Scalars['String']['output']>;
  expectedResponseStatusCode?: Maybe<Scalars['Int']['output']>;
  headers?: Maybe<Array<LeadForwardingHeader>>;
  id: Scalars['String']['output'];
  method: LeadForwardingMethod;
  prePingBody?: Maybe<Scalars['String']['output']>;
  prePingExpectedResponseBody?: Maybe<Scalars['String']['output']>;
  prePingExpectedResponseStatusCode?: Maybe<Scalars['Int']['output']>;
  prePingMethod?: Maybe<LeadForwardingMethod>;
  prePingUrl?: Maybe<Scalars['String']['output']>;
  redirectUrlExpression?: Maybe<Scalars['String']['output']>;
  targeting?: Maybe<Array<TargetedLead>>;
  url: Scalars['String']['output'];
  variables?: Maybe<Array<LeadForwardingVariable>>;
};

export type LeadForwardingEndpointConnection = {
  edges?: Maybe<Array<LeadForwardingEndpointEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type LeadForwardingEndpointEdge = {
  node: LeadForwardingEndpoint;
};

export type LeadForwardingEndpointInput = {
  advertiserId: Scalars['String']['input'];
  body?: InputMaybe<Scalars['String']['input']>;
  contentType: LeadForwardContentType;
  expectedResponseBody?: InputMaybe<Scalars['String']['input']>;
  expectedResponseStatusCode?: InputMaybe<Scalars['Int']['input']>;
  headers?: InputMaybe<Array<LeadForwardingHeaderInput>>;
  method: LeadForwardingMethod;
  prePingBody?: InputMaybe<Scalars['String']['input']>;
  prePingExpectedResponseBody?: InputMaybe<Scalars['String']['input']>;
  prePingExpectedResponseStatusCode?: InputMaybe<Scalars['Int']['input']>;
  prePingMethod?: InputMaybe<LeadForwardingMethod>;
  prePingUrl?: InputMaybe<Scalars['String']['input']>;
  redirectUrlExpression?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  variables?: InputMaybe<Array<LeadForwardingVariableInput>>;
};

export type LeadForwardingFilter = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  contentTypes?: InputMaybe<Array<LeadForwardContentType>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  methods?: InputMaybe<Array<LeadForwardingMethod>>;
};

export type LeadForwardingHeader = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LeadForwardingHeaderInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum LeadForwardingMethod {
  Get = 'GET',
  Post = 'POST',
  Put = 'PUT'
}

export type LeadForwardingRequest = {
  body?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LeadForwardingRequestInput = {
  end?: InputMaybe<Scalars['LocalDateTime']['input']>;
  filters?: InputMaybe<Array<DataReportFilter>>;
  leadForwardingEndpointIds: Array<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['LocalDateTime']['input']>;
};

export type LeadForwardingResponse = {
  body?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type LeadForwardingResult = {
  forwardingLeadId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  leadId: Scalars['String']['output'];
  request?: Maybe<LeadForwardingRequest>;
  response?: Maybe<LeadForwardingResponse>;
  success: Scalars['Boolean']['output'];
};

export type LeadForwardingVariable = {
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LeadForwardingVariableInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type LeadImport = {
  numberOfLeadsImported: Scalars['Int']['output'];
};

export enum LeadImportField {
  ConnectionIp = 'CONNECTION_IP',
  ConnectionIsp = 'CONNECTION_ISP',
  ConnectionType = 'CONNECTION_TYPE',
  DetailsEmail = 'DETAILS_EMAIL',
  DetailsFirstName = 'DETAILS_FIRST_NAME',
  DetailsFreeParametersParam1 = 'DETAILS_FREE_PARAMETERS_PARAM1',
  DetailsFreeParametersParam2 = 'DETAILS_FREE_PARAMETERS_PARAM2',
  DetailsFreeParametersParam3 = 'DETAILS_FREE_PARAMETERS_PARAM3',
  DetailsFreeParametersParam4 = 'DETAILS_FREE_PARAMETERS_PARAM4',
  DetailsFreeParametersParam5 = 'DETAILS_FREE_PARAMETERS_PARAM5',
  DetailsFreeParametersParam6 = 'DETAILS_FREE_PARAMETERS_PARAM6',
  DetailsFreeParametersParam7 = 'DETAILS_FREE_PARAMETERS_PARAM7',
  DetailsFreeParametersParam8 = 'DETAILS_FREE_PARAMETERS_PARAM8',
  DetailsFreeParametersParam9 = 'DETAILS_FREE_PARAMETERS_PARAM9',
  DetailsFullName = 'DETAILS_FULL_NAME',
  DetailsLastName = 'DETAILS_LAST_NAME',
  DetailsPhoneNumber = 'DETAILS_PHONE_NUMBER',
  DeviceBrowser = 'DEVICE_BROWSER',
  DeviceBrowserVersion = 'DEVICE_BROWSER_VERSION',
  DeviceDeviceType = 'DEVICE_DEVICE_TYPE',
  DeviceInApp = 'DEVICE_IN_APP',
  DeviceLanguage = 'DEVICE_LANGUAGE',
  DeviceMake = 'DEVICE_MAKE',
  DeviceModel = 'DEVICE_MODEL',
  DeviceOs = 'DEVICE_OS',
  DeviceOsv = 'DEVICE_OSV',
  DeviceUa = 'DEVICE_UA',
  GeoCity = 'GEO_CITY',
  GeoCountry = 'GEO_COUNTRY',
  GeoRegion = 'GEO_REGION',
  GeoUtcOffset = 'GEO_UTC_OFFSET',
  GeoZip = 'GEO_ZIP',
  OfferAdvertiserId = 'OFFER_ADVERTISER_ID',
  OfferId = 'OFFER_ID',
  OfferManagerId = 'OFFER_MANAGER_ID',
  PublisherApp = 'PUBLISHER_APP',
  PublisherId = 'PUBLISHER_ID',
  PublisherManagerId = 'PUBLISHER_MANAGER_ID',
  PublisherSite = 'PUBLISHER_SITE',
  PublisherSubId = 'PUBLISHER_SUB_ID',
  PublisherSubSubId = 'PUBLISHER_SUB_SUB_ID'
}

export type LeadImportFieldPosition = {
  field: LeadImportField;
  position: Scalars['Int']['input'];
};

export type LeadImportInput = {
  csvSeparator?: InputMaybe<Scalars['String']['input']>;
  evaluate?: InputMaybe<Scalars['Boolean']['input']>;
  fields: Array<LeadImportFieldPosition>;
  url: Scalars['String']['input'];
};

export enum Leadflow {
  Cpa = 'CPA',
  Cpc = 'CPC',
  Cpi = 'CPI',
  Cpl = 'CPL',
  Cpm = 'CPM',
  Cps = 'CPS'
}

export type MmpPostbackInfo = {
  adjust?: Maybe<AdjustPostbackInfo>;
  appsflyer?: Maybe<AppsflyerPostbackInfo>;
  kochava?: Maybe<KochavaPostbackInfo>;
};

export type MmpPostbackInfoInput = {
  adjust?: InputMaybe<AdjustPostbackInfoInput>;
  appsflyer?: InputMaybe<AppsflyerPostbackInfoInput>;
  kochava?: InputMaybe<KochavaPostbackInfoInput>;
};

export type MarketplaceAdvertiserPartner = {
  organization: MarketplaceOrganization;
  status: AdvertiserNetworkRelationshipStatus;
};

export type MarketplaceAdvertiserPartnerConnection = {
  edges?: Maybe<Array<MarketplaceAdvertiserPartnerEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type MarketplaceAdvertiserPartnerEdge = {
  node: MarketplaceAdvertiserPartner;
};

export type MarketplaceNetworkPartner = {
  organization: MarketplaceOrganization;
  status: AdvertiserNetworkRelationshipStatus;
};

export type MarketplaceNetworkPartnerConnection = {
  edges?: Maybe<Array<MarketplaceNetworkPartnerEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type MarketplaceNetworkPartnerEdge = {
  node: MarketplaceNetworkPartner;
};

export type MarketplaceOrganization = {
  adTypes?: Maybe<Array<Scalars['String']['output']>>;
  address?: Maybe<Scalars['String']['output']>;
  brandmarkUrl?: Maybe<Scalars['String']['output']>;
  capabilities?: Maybe<Array<Scalars['String']['output']>>;
  companyColor?: Maybe<Scalars['String']['output']>;
  contactInfo?: Maybe<MarketplaceOrganizationContact>;
  countryCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  geos?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  internalType?: Maybe<OrganizationInternalType>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  owner: Scalars['Boolean']['output'];
  platforms?: Maybe<Array<Scalars['String']['output']>>;
  pricingModels?: Maybe<Array<Scalars['String']['output']>>;
  products: ProductConnection;
  representatives?: Maybe<Array<OrganizationRepresentative>>;
  requests: OrganizationRequestConnection;
  sanType?: Maybe<SanType>;
  shortDescription: Scalars['String']['output'];
  type: MarketplaceOrganizationType;
  verticals?: Maybe<Array<Scalars['String']['output']>>;
  website?: Maybe<Scalars['String']['output']>;
};


export type MarketplaceOrganizationProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type MarketplaceOrganizationRequestsArgs = {
  filter?: InputMaybe<OrganizationRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MarketplaceOrganizationConnection = {
  edges?: Maybe<Array<MarketplaceOrganizationEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type MarketplaceOrganizationContact = {
  email?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceOrganizationContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceOrganizationEdge = {
  node: MarketplaceOrganization;
};

export type MarketplaceOrganizationFilter = {
  adTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  capabilities?: InputMaybe<Array<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  geos?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['Boolean']['input']>;
  platforms?: InputMaybe<Array<Scalars['String']['input']>>;
  pricingModels?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<MarketplaceOrganizationType>>;
  verticals?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MarketplaceOrganizationInput = {
  adTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  address?: InputMaybe<Scalars['String']['input']>;
  brandmarkUrl?: InputMaybe<Scalars['String']['input']>;
  capabilities?: InputMaybe<Array<Scalars['String']['input']>>;
  companyColor?: InputMaybe<Scalars['String']['input']>;
  contactInfo?: InputMaybe<MarketplaceOrganizationContactInput>;
  countryCode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  geos?: InputMaybe<Array<Scalars['String']['input']>>;
  internalType?: InputMaybe<OrganizationInternalType>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  platforms?: InputMaybe<Array<Scalars['String']['input']>>;
  pricingModels?: InputMaybe<Array<Scalars['String']['input']>>;
  shortDescription: Scalars['String']['input'];
  type: MarketplaceOrganizationType;
  verticals?: InputMaybe<Array<Scalars['String']['input']>>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export enum MarketplaceOrganizationType {
  Advertiser = 'ADVERTISER',
  Agency = 'AGENCY',
  Developer = 'DEVELOPER',
  Network = 'NETWORK',
  Publisher = 'PUBLISHER'
}

export type MarketplacePostbackLink = {
  organizationId: Scalars['String']['output'];
  postbackUrl: Scalars['String']['output'];
};

export type MarketplacePostbackLinkInput = {
  organizationId: Scalars['String']['input'];
  postbackUrl: Scalars['String']['input'];
};

export type Memo = {
  id: Scalars['String']['output'];
  mediums: Array<MemoMedium>;
  message: Scalars['String']['output'];
  read: Scalars['Boolean']['output'];
  relatedEntities: Array<MemoRelatedEntity>;
  severity: MemoSeverity;
  tag: MemoTag;
  time: Scalars['LocalDateTime']['output'];
  title: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type MemoConnection = {
  edges: Array<MemoEdge>;
  totalCount: Scalars['Int']['output'];
};

export type MemoEdge = {
  node: Memo;
};

export type MemoFilter = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  kpiIds?: InputMaybe<Array<Scalars['String']['input']>>;
  mediums?: InputMaybe<Array<MemoMedium>>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  severity?: InputMaybe<MemoSeverity>;
  tags?: InputMaybe<Array<MemoTag>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MemoInput = {
  read: Scalars['Boolean']['input'];
};

export enum MemoMedium {
  Email = 'EMAIL',
  Internal = 'INTERNAL'
}

export type MemoRelatedEntity = {
  advertiser?: Maybe<Advertiser>;
  advertiserConfig?: Maybe<AdvertiserConfig>;
  kpi?: Maybe<Kpi>;
  offer?: Maybe<Offer>;
  publisher?: Maybe<Publisher>;
};

export enum MemoSeverity {
  Critical = 'CRITICAL',
  Info = 'INFO',
  Warn = 'WARN'
}

export type MemoSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<MemoSortBy>;
};

export enum MemoSortBy {
  Read = 'READ',
  Severity = 'SEVERITY',
  Time = 'TIME',
  UserId = 'USER_ID'
}

export enum MemoTag {
  BrokenNetworkIntegration = 'BROKEN_NETWORK_INTEGRATION',
  Kpi = 'KPI',
  PayoutChange = 'PAYOUT_CHANGE',
  RewardedSupportTicket = 'REWARDED_SUPPORT_TICKET',
  RewardedSuspiciousUser = 'REWARDED_SUSPICIOUS_USER',
  RewardedWithdrawalRequest = 'REWARDED_WITHDRAWAL_REQUEST'
}

export enum Metric {
  ActiveUsers = 'ACTIVE_USERS',
  AdClicks = 'AD_CLICKS',
  Arpu = 'ARPU',
  Clicks = 'CLICKS',
  ClickCost = 'CLICK_COST',
  Conversions = 'CONVERSIONS',
  Coverage = 'COVERAGE',
  Cr = 'CR',
  Epc = 'EPC',
  Events = 'EVENTS',
  FinalProfit = 'FINAL_PROFIT',
  Impressions = 'IMPRESSIONS',
  Margin = 'MARGIN',
  MonetizedSearches = 'MONETIZED_SEARCHES',
  NewUsers = 'NEW_USERS',
  PaidConversions = 'PAID_CONVERSIONS',
  Profit = 'PROFIT',
  PubConversions = 'PUB_CONVERSIONS',
  PubPaidConversions = 'PUB_PAID_CONVERSIONS',
  Roas = 'ROAS',
  Searches = 'SEARCHES',
  SearchCtr = 'SEARCH_CTR',
  SearchMonetizedCtr = 'SEARCH_MONETIZED_CTR',
  SearchMonetizedRpm = 'SEARCH_MONETIZED_RPM',
  SearchQualityAdvertiserCoverage = 'SEARCH_QUALITY_ADVERTISER_COVERAGE',
  SearchQualityAdvertiserScore = 'SEARCH_QUALITY_ADVERTISER_SCORE',
  SearchQualityFollowupSearches = 'SEARCH_QUALITY_FOLLOWUP_SEARCHES',
  SearchQualityInitialSearches = 'SEARCH_QUALITY_INITIAL_SEARCHES',
  SearchQualitySearchEngineCoverage = 'SEARCH_QUALITY_SEARCH_ENGINE_COVERAGE',
  SearchQualitySearchEngineFollowupSearches = 'SEARCH_QUALITY_SEARCH_ENGINE_FOLLOWUP_SEARCHES',
  SearchQualitySearchEngineInitialSearches = 'SEARCH_QUALITY_SEARCH_ENGINE_INITIAL_SEARCHES',
  SearchQualitySearchEngineScore = 'SEARCH_QUALITY_SEARCH_ENGINE_SCORE',
  SearchRpc = 'SEARCH_RPC',
  SearchRpm = 'SEARCH_RPM',
  Sessions = 'SESSIONS',
  TheyGet = 'THEY_GET',
  TheyGetPoints = 'THEY_GET_POINTS',
  WeGet = 'WE_GET'
}

export type MigrationState = {
  advertiser: Advertiser;
  syncing: Scalars['Boolean']['output'];
};

export type ModificationBatch = {
  /** Conversions created by a CSV import ("Create conversions"), as opposed to modified. */
  createdAmount: Scalars['Int']['output'];
  createdAt: Scalars['LocalDateTime']['output'];
  editInput?: Maybe<PostbackEditModificationBatchInput>;
  failedAmount: Scalars['Int']['output'];
  fileInput?: Maybe<PostbackModificationFileBatchInput>;
  id: Scalars['ID']['output'];
  progress: Scalars['Float']['output'];
  source: ModificationBatchSource;
  totalModificationAmount: Scalars['Int']['output'];
  totalRemainingAmount: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
};

export type ModificationBatchConnection = {
  edges?: Maybe<Array<ModificationBatchEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type ModificationBatchEdge = {
  node: ModificationBatch;
};

export enum ModificationBatchSource {
  Edit = 'EDIT',
  File = 'FILE'
}

/** Multi-Accounting Detection */
export enum MultiAccountGroupBy {
  /** User-agent derived device attributes of the postback's click. */
  Device = 'DEVICE',
  Ip = 'IP',
  /** App-generated persistent id (persId) kept in the keychain on the user's devices; groups span offers, so offer/advertiser/publisher are null. */
  PersId = 'PERS_ID'
}

export enum MultiAccountSortBy {
  TheyGet = 'THEY_GET',
  TotalPostbacks = 'TOTAL_POSTBACKS',
  UserCount = 'USER_COUNT',
  WeGet = 'WE_GET'
}

export type Mutation = {
  addAdvertiserInvoicePayment: AdvertiserInvoice;
  /**
   * Adds the given tags to the selected advertisers (existing tags are kept) and returns the affected advertisers. When preApproved is true, the tags are also added to the list of pre-approved advertiser tags. Without advertiserIds no advertiser is changed and an empty list is returned.
   *
   * Network (cockpit) users only.
   */
  addAdvertiserTags?: Maybe<Array<Advertiser>>;
  /**
   * Adds the given tags to the selected offers (existing tags are kept) and returns the updated offers. When preApproved is true, the tags are also added to the list of pre-approved offer tags. Without offerIds no offer is changed and an empty list is returned, which can be used together with preApproved to only register pre-approved tags.
   *
   * Network (cockpit) users only.
   */
  addOfferTags?: Maybe<Array<Offer>>;
  /**
   * Adds the given tags to the selected publishers (existing tags are kept) and returns the affected publishers. When preApproved is true, the tags are also added to the list of pre-approved publisher tags. Without publisherIds no publisher is changed and an empty list is returned.
   *
   * Network (cockpit) users only.
   */
  addPublisherTags?: Maybe<Array<Publisher>>;
  /** Changes the password for the user to the new password given. Available only to admin users */
  adminChangePassword: AuthResponse;
  /**
   * Approves an imported offer (an offer pulled from an advertiser integration) and creates a regular offer from it. Returns the created offer.
   *
   * Fails if the imported offer does not exist or an offer was already created from it. Network (cockpit) users only; not available to read-only users.
   */
  approveImportedOffer: Offer;
  /**
   * Reverts the changes recorded in the audit entries matching the filter, restoring the affected objects to their state before those changes. Objects that were created within the matched changes are deleted, where the object type supports it. Up to 9,000 matching audit entries are considered.
   *
   * With `preview: true` nothing is changed and the audit entries the undo would produce are returned; otherwise the changes are applied and an empty list is returned. The filter must include audit types or audit ids, and an error is returned if there is nothing to undo. Network (cockpit) users only.
   */
  auditsUndo?: Maybe<Array<Audit>>;
  /** Change password endpoint */
  changePassword: User;
  /**
   * Replaces the temporary password of a newly invited user with a permanent one and logs the user in. Use it after `login` returned `NEW_PASSWORD_REQUIRED`.
   *
   * Fails if the temporary password is wrong or expired, if the account does not require a password change, if `newPassword` and `newPasswordConfirm` differ, or if the new password does not meet the password policy. Can be called without authentication.
   */
  changePasswordNewUser: AuthResponse;
  /**
   * Sets the status of a support ticket (OPEN or CLOSED) and returns the updated ticket. Network (cockpit) users can change any ticket; partner users only tickets they are the partner user of.
   *
   * Fails if the ticket does not exist.
   */
  changeSupportTicketStatus: SupportTicket;
  /**
   * Creates a copy of an offer and returns the new offer. The copy gets a new id and its name is prefixed with `[CLONED]`. Related settings are copied only if listed in `fieldToClone` (payouts, targeted payouts, budgets, click budgets, landing pages, advanced targeting, events, offer access and per-publisher payouts and budgets).
   *
   * Fails if the offer or the given advertiser does not exist. Network (cockpit) users only; not available to read-only users.
   */
  cloneOffer: Offer;
  /** Closes a rewarded user's support ticket by setting its status to CLOSED; no further messages can be added afterwards. Returns the updated ticket. Fails if the ticket does not exist. Network (cockpit) users only; account managers restricted to specific publishers can only close tickets of players of those publishers. */
  closeRewardedSupportTicket: RewardedUserSupportTicket;
  /**
   * Completes the account re-confirmation started by the `ACCOUNT_MIGRATION_REQUIRED` login challenge: verifies the emailed code, sets the chosen password and logs the user in, returning tokens like `login`.
   *
   * Fails if the code is wrong or expired, the account does not need migration, or the password does not meet the password policy. Attempts are rate limited. Can be called without authentication.
   */
  completeAccountMigration: AuthResponse;
  /**
   * Creates an ad keyword import spec, which fills a filler (macro value list) with keywords from the ad keyword catalogue. Keywords matching the spec's filters (for example monetized on Google or Bing, categories, keywords) are written to the filler, up to `importMaxNumberOfKeywords`, replacing its previous values. The import runs in the background, either once or daily, according to `schedule`. Returns the created spec.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  createAdKeywordImportSpec: AdKeywordImportSpec;
  /**
   * Sets the advanced targeting rules of an offer: nested AND/OR groups of conditions that clicks must satisfy. An offer has at most one advanced targeting; calling this for an offer that already has one replaces it. Returns the saved targeting.
   *
   * Fails if the offer does not exist. The change is audited. Network (cockpit) users only; not available to read-only users.
   */
  createAdvancedTargeting: AdvancedTargeting;
  /**
   * Creates an advanced targeting value bundle: a named, reusable list of values for one targeting field (for example a list of sub ids or device models) that targeting rules can reference instead of repeating the values. Returns the created bundle.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  createAdvancedTargetingValueBundle: AdvancedTargetingValueBundle;
  /**
   * Creates an advertiser and returns it.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  createAdvertiser: Advertiser;
  /**
   * Creates an advertiser batch operation: a saved rule that applies actions (change status, add/remove tags, fire a webhook) to all advertisers matching its filters, on the configured schedule (one time, on every change, and/or a cron expression). Returns the created operation.
   *
   * The filters and schedule are validated; at least one schedule option must be set, cron expressions must be valid and filter values must match the filter field's type, otherwise a validation error is returned. Network (cockpit) users only.
   */
  createAdvertiserBatchOperation: AdvertiserBatchOperation;
  /**
   * Blocks a publisher for an advertiser, so the publisher is excluded from that advertiser's offers. Returns the created block.
   *
   * Fails if the advertiser or publisher does not exist, or if the publisher is already blocked for that advertiser.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  createAdvertiserBlockedPublisher: AdvertiserBlockedPublisher;
  /**
   * Creates an advertiser API integration (the configuration used to import offers automatically from an advertiser or network) and returns it. An advertiser can have only one integration; creating a second one fails. If `margin` is set, it is stored as the advertiser-level margin. An offer import run is triggered right away.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  createAdvertiserConfig: AdvertiserConfig;
  /**
   * Adds a contact person to an advertiser and returns it.
   *
   * With `needsUser: true` an advertiser portal login is created (or an existing user with the same email is linked). If that email had no contact account yet and `isNotifiable` is true, the contact receives a registration email with a temporary password.
   *
   * Fails if the advertiser does not exist. Network (cockpit) users only; not available to read-only users.
   */
  createAdvertiserContact: AdvertiserContact;
  /**
   * Creates a coupon code for an offer and returns it. Conversions reported with this coupon code are attributed to the coupon's default publisher during its validity period.
   *
   * The default publisher is automatically approved for the offer. Fails if the offer or publisher does not exist, if the offer already has a coupon with the same code, or if the start date is after the end date. Network (cockpit) users only.
   */
  createAdvertiserCoupon: AdvertiserCoupon;
  createAdvertiserInvoice: AdvertiserInvoice;
  /** Creates one DRAFT per advertiser from platform revenue; nothing is issued or sent */
  createAdvertiserInvoiceDrafts: Array<AdvertiserInvoice>;
  /**
   * Creates an advertiser report import spec: a reusable template describing how an advertiser's CSV report maps to conversions (column positions, value formats and default values, separator, number of header rows to skip, and whether values are cumulative).
   *
   * When `inboxEmailEnabled` is true, a dedicated inbox email address is generated for the spec; reports emailed to it as attachments are imported automatically. Returns the created spec. Fails if no field has a column position.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  createAdvertiserReportImportSpec: AdvertiserReportImportSpec;
  /**
   * Queues the import of an advertiser report (CSV file at a URL) using an existing advertiser report import spec, which defines how the file's columns map to conversion fields. The task is created in a queued state and processed in the background; the call does not wait for it to finish. Track its progress, result or failure reason through the advertiser report import tasks query. Fails if the spec does not exist.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  createAdvertiserReportImportTask: AdvertiserReportImportTask;
  /** Creates an app for an advertiser and returns it. The app also gets the default "Open" and "Reinstall" app event types. Network (cockpit) users only. */
  createApp: App;
  /**
   * Creates an in-app event type for an app and returns it. A matching event is added to the app's offers, so events reported under `mappingId` are tracked on them.
   *
   * The app must already have at least one store app, otherwise an error is returned. Network (cockpit) users only.
   */
  createAppEventType: AppEventType;
  /** Creates an SDK app token for a store app and returns it. The token's platform (iOS or Android) is derived from the store app's store type. Network (cockpit) users only. */
  createAppToken: AppToken;
  /**
   * Creates an auto-approval configuration: criteria (advertisers, countries, platforms, payout range, redirect checks, etc.) under which imported offers are approved into regular offers automatically. Returns the saved configuration.
   *
   * Right after saving, the active imported offers of the matching advertisers are checked against the configuration in the background, so new offers may appear within a few minutes. Network (cockpit) users only; not available to read-only users.
   */
  createAutoApprovalConfig: AutoApprovalConfig;
  /** Manages the automation rules in the system */
  createAutomationRule: AutomationRule;
  /** Creates one blacklisted sub id. If no offerId,pubId combination exists, one is created, otheriwse we append the given subids to the current combination */
  createBlacklistedSubId: BlacklistedSubId;
  /** Creates blacklisted sub ids. If no offerId,pubId combination exists, one is created, otheriwse we append the given subids to the current combination */
  createBlacklistedSubIds: Array<BlacklistedSubId>;
  /** Creates budget */
  createBudget: Budget;
  /** Creates click budget */
  createClickBudget: ClickBudget;
  /** Create click shield rules */
  createClickShieldRules: ClickShieldRules;
  /**
   * Manually creates one or more conversions (evaluated postbacks) from the given click, offer, status and payout data, for example to book conversions the advertiser reported outside of tracking. Returns the first created conversion.
   *
   * `time` is interpreted in the platform's timezone. When several conversions are created, each gets a slightly different time within the same minute so their ids are unique. Created conversions appear in reports after a short delay. Network (cockpit) users only; not available to read-only users.
   */
  createEvaluatedPostback: EvaluatedPostback;
  /**
   * Creates a new event type (conversion event, e.g. registration or purchase) on an offer and returns it with its generated id.
   *
   * Fails if the offer does not exist. Network (cockpit) users only; not available to read-only users.
   */
  createEventType: EventType;
  /**
   * Saves an offer feed API configuration: the sections (filters, whitelisted/blacklisted offers, title, performance limits) that determine which offers appear in the offer feed. With a publisherId the configuration applies to that publisher only; without one it is the default configuration used for publishers that have no own configuration. If a configuration already exists for the same publisher (or the default), it is replaced.
   *
   * Returns the saved configuration including the number of offers it currently matches. Network (cockpit) users only.
   */
  createFeedApiConfiguration: FeedApiConfiguration;
  /**
   * Creates a filler: a list of values (e.g. sub ids, site, app name, placement) that is filled into clicks that arrive without that parameter, optionally scoped by advertisers, offers, publishers, tags, country and OS. Values can carry weights; then either all values or none must have a weight. With `forceOverride` the value also replaces parameters the publisher did send.
   *
   * Fails if a filler with the same field and scope already exists. Network (cockpit) users only; not available to read-only users.
   */
  createFiller: Filler;
  /**
   * Creates a form definition (for example a publisher sign-up form) and returns it with its generated id.
   *
   * Fails if the input already contains an id. Network (cockpit) users only; not available to read-only users.
   */
  createForm: Form;
  /**
   * Submits answers to a form (for example a publisher sign-up) and returns the stored submission with its generated id and submission time.
   *
   * Can be called without authentication, so public sign-up pages can use it. Fails if the input already contains an id.
   */
  createFormSubmission: FormResult;
  /**
   * Returns a URL that starts the Google OAuth login used to authorize a Google Ads integration. Open it in a browser; after the user grants access, the Google Ads account is linked to the platform and the browser is redirected back.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  createGoogleAdsAuthorizationUrl: Scalars['String']['output'];
  /** Creates impression budget */
  createImpressionBudget: ImpressionBudget;
  /**
   * Creates a KPI rule: a set of metric thresholds checked over a timeframe for offers, advertisers, publishers or offer/publisher combinations matching the filters, with actions to take when the thresholds are met (notifications, offer/publisher status changes, offer access changes, sub id blacklisting). If the new KPI is active, it is evaluated once immediately, so its actions may already be applied.
   *
   * Returns the created KPI. Network (cockpit) users only.
   */
  createKPI: Kpi;
  /**
   * Creates a landing page for an offer (an alternative destination URL with optional targeting, traffic ratio, impression tracking and deeplink) and returns it. Any `id` in the input is ignored; a new id is assigned.
   *
   * Fails if the offer does not exist, or if `isDefault` is true and the offer already has a default landing page.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  createLandingPage: LandingPage;
  /**
   * Creates a lead forwarding endpoint: an HTTP destination (URL, method, content type, body template, headers, variables, optional pre-ping request and expected responses) belonging to an advertiser, to which leads can be sent. Returns the created endpoint. Fails if the advertiser does not exist.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  createLeadForwardingEndpoint: LeadForwardingEndpoint;
  createMarketplaceOrganization: MarketplaceOrganization;
  /**
   * Creates an offer and returns it. A default landing page is created from the offer's advertiser tracking URL and preview URL. If the platform has a default margin configured, the new offer also gets that margin and a default (zero) payout.
   *
   * Fails if the advertiser does not exist. On search platforms, the advertiser offer id must be unique per advertiser.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  createOffer: Offer;
  /** Creates offer access */
  createOfferAccess: PublisherOfferView;
  /**
   * Creates an offer batch operation: a named rule that applies one or more actions (change status, change tags, configure publishers, create publisher group, change budgets, advanced targeting, change offer details, fire a webhook) to all offers matching its filters. The schedule decides when it runs: once, on every offer change, or on a recurring schedule. Only active operations run.
   *
   * Fails with a validation error if the filters are invalid. Returns the created operation. Network (cockpit) users only.
   */
  createOfferBatchOperation: OfferBatchOperation;
  /** Creates offer flags */
  createOfferFlags: OfferFlag;
  /** Creates mail notification for offer-publisher views */
  createOfferForPublisherNotification: Notification;
  /** Creates offer integration configuration with third parties */
  createOfferIntegration: OfferIntegration;
  /** Creates mail notification for offer */
  createOfferNotification: Notification;
  /** Creates offer recency period */
  createOfferRecencyPeriod: OfferRecencyPeriod;
  createOrganizationIntegrationRequest: OrganizationIntegrationRequest;
  createOrganizationRepresentative: OrganizationRepresentative;
  createOrganizationRequest: OrganizationRequest;
  /** Creates payout */
  createPayout: Payout;
  /**
   * Sets a payout margin for a scope (advertiser, offer, publisher, offer and publisher, optionally per event type). The margin is a fraction: the publisher payout is derived as `theyGet = weGet × (1 − margin)`, so 0.3 keeps 30% of the revenue. If a margin already exists for the same key it is overwritten.
   *
   * After saving, existing payouts in the affected scopes are recalculated so their publisher payout reflects the margin. Fails if any id in the key does not exist. Network (cockpit) users only; not available to read-only users.
   */
  createPayoutMargin: PayoutMargin;
  /**
   * Creates a postback link: a URL the platform calls to notify a publisher about conversions. A link can be global (no publisher and no offer), publisher-wide, or for one publisher and offer, and can be limited to specific event types, postback states/decisions and other conditions. Returns the created link.
   *
   * Validation: event types can only be restricted on a link that has an offer, and an INCLUDE/EXCLUDE event type mode needs at least one event type. Event type ids may also be given as the advertiser's event ids; they are mapped to the offer's event types.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  createPostbackLink: PostbackLink;
  /**
   * Edits existing conversions in bulk: sets revenue (`weGet`), publisher payout (`theyGet`), state and/or decision. Fields left null in the input are not changed. Returns the created modifications.
   *
   * Select conversions either by `postbackIds`, or by conversion report `filters` within the `start`..`end` window (both required when no ids are given). Modifications are applied asynchronously; reports reflect them within a few minutes, and progress can be followed per batch. With `firePostbacks: true` the updated conversions are also sent again to the publisher's postback links.
   *
   * Money values are in the platform currency. Network (cockpit) users only; not available to read-only users.
   */
  createPostbackModifications: Array<PostbackModification>;
  /** Create postback shield rules */
  createPostbackShieldRules: PostbackShieldRules;
  /**
   * Creates a publisher (partner) and returns it.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  createPublisher: Publisher;
  /**
   * Creates a publisher batch operation: a saved rule that applies actions (change status, add/remove tags, change offer access state, fire a webhook) to all publishers matching its filters, on the configured schedule (one time, on every change, and/or a cron expression). Returns the created operation.
   *
   * The filters and schedule are validated; at least one schedule option must be set, cron expressions must be valid and filter values must match the filter field's type, otherwise a validation error is returned. Network (cockpit) users only.
   */
  createPublisherBatchOperation: PublisherBatchOperation;
  /**
   * Adds a contact person to a publisher (partner) and returns it.
   *
   * With `needsUser: true` a partner portal login is created (or an existing user with the same email is linked). If that email had no contact account yet and `sendEmails` is true (the default), the contact receives a registration email with a temporary password.
   *
   * Fails if the publisher does not exist. Network (cockpit) users only; not available to read-only users.
   */
  createPublisherContact: PublisherContact;
  /** Creates new publisher group member */
  createPublisherGroupMember: PublisherGroupMember;
  /**
   * Creates an ad-platform integration for a publisher, linking it to a Google Ads customer account and/or a Meta (Facebook) ad account and choosing which campaigns to sync (specific campaigns or all). Account authorization is completed separately through the platform's OAuth login. Returns the created integration. Fails if the publisher does not exist.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  createPublisherIntegration: PublisherIntegration;
  /**
   * Generates API keys for a publisher and returns them together with the platform's default click tracking URL. Each key is a random UUID.
   *
   * Fails if the publisher already has keys (delete them first to regenerate) or if `numberOfKeysToGenerate` is outside 1-20.
   *
   * Network (cockpit) users, or partner portal publishers for their own publisher account. Not available to read-only users.
   */
  createPublisherKey: PublisherKey;
  /** Create publisher margin */
  createPublisherMargin: PublisherMargin;
  /** Creates mail notification for publisher */
  createPublisherNotification: Notification;
  /**
   * Creates a payment record for a publisher (or for a rewarded user, in which case the user's publisher is used) and returns it. Amounts are in the account currency.
   *
   * If invoice details are supplied without an invoice URL, an invoice PDF is generated for the payment. Fails if the publisher does not exist. Network (cockpit) users only.
   */
  createPublisherPayment: PublisherPayment;
  /**
   * Creates a publisher referral plan: a named commission scheme defining, per referral level, the percentage a referring publisher earns and what it is calculated on. Returns the created plan.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  createPublisherReferralPlan: PublisherReferralPlan;
  /**
   * Schedules a push notification to all rewarded users in an audience. The notification is created with status PENDING and sent shortly after its scheduled `time` has passed (a time in the past sends it right away); its status then moves to RUNNING and COMPLETED, or FAILED.
   *
   * An optional deep link opens a specific screen of the rewarded app when the notification is tapped. OFFER and REWARD deep links require `deepLinkEntityId`; for the other types the entity id is ignored. Passing `deepLinkEntityId` without `deepLinkType` is rejected. Returns the created notification. Network (cockpit) users only.
   */
  createPushNotification: PushNotification;
  /**
   * Creates the retargeting list for an offer from previously uploaded files of user identifiers (one identifier per line), to be used by the user identifier optimization rule. Returns the created retargeting file.
   *
   * Each offer can have only one retargeting file; use `updateRetargetingFile` to replace its data. Fails if the uploaded files are empty or cannot be read. Network (cockpit) users only.
   */
  createRetargetingFile: RetargetingFile;
  createRewardedSupportTicket: RewardedUserSupportTicket;
  /**
   * Adds a reply from the calling account manager to a rewarded user's support ticket. The message may contain text and up to 5 picture attachments uploaded beforehand. Returns the ticket, including the new message.
   *
   * Fails if the ticket does not exist or is closed. Network (cockpit) users only; account managers restricted to specific publishers can only answer tickets of players of those publishers. Players reply with `rewardedCreateSupportTicketMessage` instead.
   */
  createRewardedSupportTicketMessage: RewardedUserSupportTicket;
  /**
   * Signs up a new rewarded app user with email and password. Creates the user's publisher (partner) account, a login for the email address, and the rewarded user profile, and returns the profile. Can be called without authentication.
   *
   * Only available on platforms with the rewarded product enabled. Fails if the email address is already registered.
   */
  createRewardedUser: RewardedUser;
  /** Creates saved raw query */
  createSavedRawQuery: SavedRawQueryType;
  /**
   * Schedules a set of changes to be applied automatically at a given time: budget, payout, offer, offer status and offer access changes. The time is interpreted in the platform's time zone. Returns the scheduled change in QUEUED state.
   *
   * Notifications included in the input are created immediately to announce the upcoming change: offer notifications go to the listed publishers; payout change notifications go to approved publishers on the offer (account managers are notified for publishers with publisher-specific payouts).
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  createScheduledChange: ScheduledChange;
  /** SmartLinkLandingPage */
  createSmartLinkLandingPage: SmartLinkLandingPage;
  /**
   * Adds a store listing (App Store, Google Play, other stores or web) to an app and returns it. An "Organic" offer for the listing is created at the same time, targeting all countries on the store's platform, with the organic publisher approved on it.
   *
   * Fails if the app does not exist. Network (cockpit) users only.
   */
  createStoreApp: StoreApp;
  /**
   * Adds a new message from the calling user to an existing support ticket and returns the created message.
   *
   * Fails if the message body is empty or the ticket does not exist. Requires an authenticated platform user.
   */
  createSupportTicketMessage: SupportTicketMessage;
  /**
   * Creates a targeted lead rule that automatically forwards incoming leads to a lead forwarding endpoint. Leads matching the rule's advanced targeting conditions are sent to the endpoint; `priority` orders rules, `mode` selects parallel or cascading delivery, and `enablePrePing` sends the endpoint's pre-ping request first. Only active rules are applied. The change is recorded against the calling user. Returns the created rule.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  createTargetedLead: TargetedLead;
  /**
   * Sends payments to Tipalti for payout. Only payments in status `APPROVED` whose publisher is set up for Tipalti are sent, further narrowed by the filter.
   *
   * Payments that Tipalti accepts move to status `SENT_TO_PAYMENT_PROCESSOR`; the others keep their status. In both cases Tipalti's response is stored on the payment. Returns the processed payments, or an empty list if no payment qualified. The filter may not contain `status` or `paymentDetails`.
   */
  createTipaltiPayments?: Maybe<Array<PublisherPayment>>;
  /**
   * Creates a traffic tag: a label that is attached to incoming traffic matching the tag's advanced targeting rules, so the traffic can be segmented and reported on by tag. Only active tags are applied. Returns the created tag.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  createTrafficTag: TrafficTag;
  /**
   * Creates an account-wide traffic targeting rule and returns it. While the rule is active, every click that matches its `target` conditions must also satisfy its `trafficRule` conditions; clicks that do not are rejected.
   *
   * Network (cockpit) users only.
   */
  createTrafficTarget: TrafficTargeting;
  /**
   * Creates a network (cockpit) user and returns it. The email is stored in lower case and the cockpit-user role is always added. The new user receives a registration email with login details.
   *
   * If a user with the same email already exists (for example a partner portal user), that user is given cockpit access instead: the given roles are added and name, status and expiry date are updated.
   *
   * Admins only; not available to read-only users.
   */
  createUser: User;
  /**
   * Deletes an ad keyword import spec, stopping further keyword imports for it. Values already written to the filler are kept. Returns the deleted spec. Fails if no spec exists with the given id.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  deleteAdKeywordImportSpec: AdKeywordImportSpec;
  /**
   * Removes the advanced targeting rules from an offer and returns the removed targeting.
   *
   * Fails if the offer has no advanced targeting. The change is audited. Network (cockpit) users only; not available to read-only users.
   */
  deleteAdvancedTargeting: AdvancedTargeting;
  /**
   * Deletes a value bundle and returns it. Fails if the bundle does not exist or is still referenced by any targeting rule; remove it from those rules first.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  deleteAdvancedTargetingValueBundle: AdvancedTargetingValueBundle;
  /** Deletes advertiser */
  deleteAdvertiser: Advertiser;
  /** Deletes an advertiser batch operation so it no longer runs, and returns the deleted operation. Changes it already made to advertisers are not reverted. Fails if the id does not exist. Network (cockpit) users only. */
  deleteAdvertiserBatchOperation: AdvertiserBatchOperation;
  /**
   * Removes the block between an advertiser and a publisher and returns the removed block. Fails if the advertiser or publisher does not exist, or if no such block exists.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  deleteAdvertiserBlockedPublisher: AdvertiserBlockedPublisher;
  /**
   * Deletes an advertiser API integration and returns it. Offers already imported are not deleted. Fails if the integration does not exist.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  deleteAdvertiserConfig: AdvertiserConfig;
  /**
   * Deletes an advertiser contact and returns it. Its portal login is deleted too, unless it is still used by another contact or belongs to a network (cockpit) user.
   *
   * Fails if the contact does not exist. Network (cockpit) users only; not available to read-only users.
   */
  deleteAdvertiserContact: AdvertiserContact;
  /** Deletes a coupon and returns the deleted coupon. The publisher's access to the offer is left unchanged. Fails if the id does not exist. Network (cockpit) users only. */
  deleteAdvertiserCoupon: AdvertiserCoupon;
  deleteAdvertiserInvoice: AdvertiserInvoice;
  /**
   * Deletes an advertiser rebate so it is no longer applied in reports. Always returns null; deleting a rebate that does not exist is not an error.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  deleteAdvertiserRebate?: Maybe<Scalars['String']['output']>;
  /**
   * Deletes an advertiser report import spec together with all import tasks created from it. Conversions already imported are not affected. Returns the deleted spec. Fails if no spec exists with the given id.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  deleteAdvertiserReportImportSpec: AdvertiserReportImportSpec;
  /**
   * Deletes an advertiser report import task record and returns it. Conversions already created by the task are not affected; use `undoAdvertiserReportImportTask` to reverse them. Fails if no task exists with the given id.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  deleteAdvertiserReportImportTask: AdvertiserReportImportTask;
  /**
   * Removes the postback security token from an advertiser and returns the updated advertiser. After removal, postbacks from this advertiser are no longer verified with a token.
   *
   * Fails with an error if the advertiser does not exist. Network (cockpit) users only.
   */
  deleteAdvertiserSecurityToken: Advertiser;
  /**
   * Removes the given tags from advertisers and returns the affected advertisers. With advertiserIds, only those advertisers are changed; without advertiserIds, the tags are removed from all advertisers.
   *
   * Network (cockpit) users only.
   */
  deleteAdvertiserTags?: Maybe<Array<Advertiser>>;
  /** Deletes app */
  deleteApp: App;
  /** Deletes an app event type and returns it as it was before deletion. Fails if the event type does not exist. Network (cockpit) users only. */
  deleteAppEventType: AppEventType;
  /** Deletes an app token and returns it. Fails if the token does not exist. Network (cockpit) users only. */
  deleteAppToken: AppToken;
  /**
   * Deletes an AppsFlyer media source mapping so it no longer applies to future imports. Data already imported is not changed. Returns the given id; deleting a mapping that does not exist is not an error.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  deleteAppsflyerMediaSourceMapping: Scalars['String']['output'];
  deleteAttributionExpiration: AttributionExpiration;
  /** Deletes an audience and returns it as it was before deletion. Fails if the audience does not exist. Network (cockpit) users only. */
  deleteAudience: Audience;
  /**
   * Deletes an auto-approval configuration and returns it. Offers that were already approved through it are not affected.
   *
   * Fails if the configuration does not exist. Network (cockpit) users only; not available to read-only users.
   */
  deleteAutoApprovalConfig: AutoApprovalConfig;
  deleteAutomationRule: AutomationRule;
  /** Removes a blacklisted sub id entry */
  deleteBlacklistedSubId: BlacklistedSubId;
  /** Removes multiple blacklisted sub id entries */
  deleteBlacklistedSubIds: Array<BlacklistedSubId>;
  /** Removes all blacklisted subids that match the given filter */
  deleteBlacklistedSubIdsV2: Array<BlacklistedSubId>;
  /** Deletes budget */
  deleteBudget: Budget;
  /** Deletes click budget */
  deleteClickBudget: ClickBudget;
  /** Deletes click shield rules */
  deleteClickShieldRules: ClickShieldRules;
  /** Deletes all whitelist/blacklist entries that match the filter and returns how many were deleted (0 when nothing matched). Network (cockpit) users only. */
  deleteControlledAccessObjects: Scalars['Int']['output'];
  /** Deletes creative */
  deleteCreative: Creative;
  /** Deletes a creative pack together with all of its creatives and their thumbnails, and returns the deleted pack. Fails if the pack does not exist. Network (cockpit) users only. */
  deleteCreativePack: CreativePack;
  /** Deletes custom domain entries for every combination of the given advertiserIds, offerIds and publisherIds (an omitted list means the entry without a value for that dimension). Combinations that have no entry are skipped. Returns the deleted entries. */
  deleteDomainCustomization?: Maybe<Array<DomainCustomization>>;
  /** Deletes an event log file, including the generated file if it exists, and returns the deleted entry. Fails if the id does not exist. Network (cockpit) users only. */
  deleteEventLogFile: EventLogFile;
  /**
   * Deletes an event type and returns it. Payouts and budgets configured for this event on its offer are deleted as well.
   *
   * Fails if the event type does not exist. Network (cockpit) users only; not available to read-only users.
   */
  deleteEventType: EventType;
  /** Deletes an event value extraction rule and returns its id. Network (cockpit) users only. */
  deleteEventValueExtractionRule: Scalars['String']['output'];
  /** Deletes feed api configuration, if publisher id then default configuration is deleted */
  deleteFeedApiConfiguration: FeedApiConfiguration;
  /**
   * Deletes a filler together with its values and returns it.
   *
   * Fails if the filler does not exist. Network (cockpit) users only; not available to read-only users.
   */
  deleteFiller: Filler;
  /**
   * Deletes a form definition and returns it.
   *
   * Fails if the form does not exist. Network (cockpit) users only; not available to read-only users.
   */
  deleteForm: Form;
  /**
   * Deletes a form submission and returns it.
   *
   * Fails if the submission does not exist. Network (cockpit) users only; not available to read-only users.
   */
  deleteFormSubmission: FormResult;
  /** Deletes impression budget */
  deleteImpressionBudget: ImpressionBudget;
  /**
   * Deletes a KPI rule and returns the deleted KPI. Fails if no KPI with the given id exists.
   *
   * Network (cockpit) users only.
   */
  deleteKPI: Kpi;
  /**
   * Deletes a landing page and returns it. Fails if no landing page with that id exists.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  deleteLandingPage: LandingPage;
  /** Deletes lead by id */
  deleteLead?: Maybe<Scalars['String']['output']>;
  /**
   * Deletes a lead forwarding endpoint and returns it as it was before deletion. Fails if no endpoint exists with the given id.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  deleteLeadForwardingEndpoint: LeadForwardingEndpoint;
  /**
   * Marks multiple leads as deleted. Leads are selected with report filters and/or the `start`/`end` time range: a single filter on the `ID` field (and no time range) deletes exactly those ids; any other selection deletes up to 10,000 matching leads. At least one filter or a time range is required. Deletion is processed asynchronously. Returns the ids of the leads marked for deletion.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  deleteLeads?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deleteMarketplaceOrganization: MarketplaceOrganization;
  /** Deletes offer */
  deleteOffer: Offer;
  /**
   * Removes the access entry of a publisher on an offer, returning the pair to the offer's default visibility for that publisher. Returns null. Fails if no such access entry exists.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  deleteOfferAccess?: Maybe<Scalars['String']['output']>;
  /** Deletes offer accesses */
  deleteOfferAccesses?: Maybe<Scalars['String']['output']>;
  /**
   * Deletes an offer batch operation and returns the deleted operation. Changes it already applied to offers are not reverted. Fails if the operation does not exist.
   *
   * Network (cockpit) users only.
   */
  deleteOfferBatchOperation: OfferBatchOperation;
  /** Deletes offer flags */
  deleteOfferFlags: OfferFlag;
  /** Deletes offer integration */
  deleteOfferIntegration: OfferIntegration;
  /** Deletes offer recency period */
  deleteOfferRecencyPeriod: OfferRecencyPeriod;
  /**
   * Removes the given tags from offers and returns the updated offers. With offerIds, only those offers are changed; without offerIds, the tags are removed from every offer that carries any of them. The tags are also removed from the list of pre-approved offer tags.
   *
   * Network (cockpit) users only.
   */
  deleteOfferTags?: Maybe<Array<Offer>>;
  deleteOrganizationIntegrationRequest: OrganizationIntegrationRequest;
  deleteOrganizationRepresentative: OrganizationRepresentative;
  deleteOrganizationRequest: OrganizationRequest;
  /** Deletes a payment request and returns it. Only payments in status `REQUESTED` can be deleted. Partner portal publishers can only delete their own requests; network (cockpit) users can delete any. */
  deletePartnerPublisherPayment: PartnerPublisherPayment;
  /** Deletes payout */
  deletePayout: Payout;
  /** Deletes the payout conversion policy of an advertiser, so its payouts are no longer adjusted by a policy. Returns true; deleting a policy that does not exist also returns true. Network (cockpit) users only. */
  deletePayoutConversionPolicy: Scalars['Boolean']['output'];
  /**
   * Deletes the payout margin for the given scope and returns it. Payouts already calculated with this margin keep their current values.
   *
   * Fails if no margin exists for the key. Network (cockpit) users only; not available to read-only users.
   */
  deletePayoutMargin: PayoutMargin;
  /**
   * Deletes a postback link and returns the deleted link. Fails if no link with that id exists.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  deletePostbackLink: PostbackLink;
  /** Delete a postback modification that has not yet been processed */
  deletePostbackModification: PostbackModification;
  /** Deletes postback shield rules */
  deletePostbackShieldRules: PostbackShieldRules;
  deleteProduct: Scalars['String']['output'];
  /**
   * Deletes a publisher group and returns the deleted group, or null if no group with the given id exists.
   *
   * Network (cockpit) users only.
   */
  deletePubGroup?: Maybe<PubGroup>;
  /** Deletes publisher */
  deletePublisher: Publisher;
  /** Deletes a publisher batch operation so it no longer runs, and returns the deleted operation. Changes it already made to publishers are not reverted. Fails if the id does not exist. Network (cockpit) users only. */
  deletePublisherBatchOperation: PublisherBatchOperation;
  /**
   * Deletes a publisher contact and returns it. Its partner portal login is deleted too, unless it is still used by another contact or belongs to a network (cockpit) user.
   *
   * Fails if the contact does not exist. Network (cockpit) users only; not available to read-only users.
   */
  deletePublisherContact: PublisherContact;
  /** Deletes publisher group member by id */
  deletePublisherGroupMember: PublisherGroupMember;
  /**
   * Deletes a publisher's ad-platform integration, stopping further campaign data syncs for it. Returns the deleted integration. Fails if no integration exists with the given id.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  deletePublisherIntegration: PublisherIntegration;
  /**
   * Deletes all API keys of a publisher and returns the deleted keys. Fails if the publisher has no keys.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  deletePublisherKey: PublisherKey;
  /** Delete publisher margin */
  deletePublisherMargin: PublisherMargin;
  /** Deletes a publisher payment regardless of its status and returns the deleted payment. Fails if the id does not exist. Network (cockpit) users only. */
  deletePublisherPayment: PublisherPayment;
  /**
   * Deletes a publisher referral plan and returns it as it was before deletion. Fails if no plan exists with the given id.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  deletePublisherReferralPlan: PublisherReferralPlan;
  /**
   * Removes the given tags from publishers and returns the affected publishers. With publisherIds, only those publishers are changed; without publisherIds, the tags are removed from all publishers. The tags are also removed from the list of pre-approved publisher tags.
   *
   * Network (cockpit) users only.
   */
  deletePublisherTags?: Maybe<Array<Publisher>>;
  /** Deletes a push notification and returns it as it was before deletion. Deleting a notification that has not been sent yet cancels it. Fails if the notification does not exist. Network (cockpit) users only. */
  deletePushNotification: PushNotification;
  /** Deletes a realtime integration and returns it as it was before deletion. Its container offer is kept, but no longer resolves to live network offers. Fails if the integration does not exist. Network (cockpit) users only. */
  deleteRealtimeIntegration: RealtimeIntegration;
  /**
   * Deletes a smart link together with its fallback landing pages, redirection rules and recommendation settings, and returns its id. Landing pages of other smart links that redirected to it lose that destination.
   *
   * Fails if the smart link does not exist. Network (cockpit) users only; not available to read-only users.
   */
  deleteRecommendationSmartLink: Scalars['ID']['output'];
  /**
   * Deletes a retargeting file together with its uploaded identifier files, so the offer's user-identifier optimization rule no longer has a list to match against. Returns the deleted retargeting file. Fails if no retargeting file exists with the given id.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  deleteRetargetingFile: RetargetingFile;
  /** Deletes a RewardOS app and returns it as it was before deletion. Its publisher and players are not deleted. Fails if the app does not exist. Network (cockpit) users only. */
  deleteRewardOsApp: RewardOsApp;
  /**
   * Deletes the SKAdNetwork campaign mapping identified by network id, app id and campaign id, and returns the deleted mapping. Fails with an error if no such mapping exists.
   *
   * Network (cockpit) users only.
   */
  deleteSKAdMapping: SkAdMapping;
  /**
   * Deletes the SKAdNetwork ad network entry with the given network id and returns that id. Deleting an id that does not exist is not an error.
   *
   * Network (cockpit) users only.
   */
  deleteSKAdNetwork: Scalars['String']['output'];
  /**
   * Deletes the SKAdNetwork postback link identified by network id, offer id and campaign id, and returns the deleted link. Fails with an error if no such link exists.
   *
   * Network (cockpit) users only.
   */
  deleteSKAdPostbackLink: SkAdPostbackLink;
  /**
   * Removes the self-attributing network conversion forwarding settings of an offer, so its conversions are no longer forwarded. Always returns null; deleting settings that do not exist is not an error.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  deleteSanForwardingSettings?: Maybe<Scalars['String']['output']>;
  /**
   * Deletes a saved raw report query and returns the deleted query. Fails with a not-found error if no saved query has the given id.
   *
   * Network (cockpit) users only.
   */
  deleteSavedRawQuery: SavedRawQueryType;
  /**
   * Deletes a scheduled change so it will not be applied, and returns it. Fails if no scheduled change with that id exists.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  deleteScheduledChange: ScheduledChange;
  /** Removes the event link from an SDK breakpoint and returns the removed link. Fails if the breakpoint has no link. Network (cockpit) users only. */
  deleteSdkTrackedBreakpoint?: Maybe<SdkTrackedBreakpoint>;
  /**
   * Deletes a search-feed integration, stopping further automatic imports for it. Data already imported is kept. Returns the deleted integration. Fails if no integration exists with the given id.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  deleteSearchIntegration: SearchIntegration;
  deleteSmartLinkLandingPage: SmartLinkLandingPage;
  /** Deletes app store */
  deleteStoreApp: StoreApp;
  /**
   * Removes the Meta (Facebook) install referrer decryption key from a store app. Returns the updated store app. Fails if the store app does not exist.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  deleteStoreAppFacebookInstallReferrerDecryptionKey: StoreApp;
  /** Deletes support ticket, with all related ticket messages */
  deleteSupportTicket: SupportTicket;
  /**
   * Deletes a targeted lead rule so incoming leads are no longer forwarded by it. The change is recorded against the calling user. Returns the deleted rule. Fails if the rule does not exist.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  deleteTargetedLead: TargetedLead;
  /**
   * Deletes a targeted payout and returns its id. Deleting an id that does not exist is not an error.
   *
   * Network (cockpit) users only.
   */
  deleteTargetedPayout: Scalars['String']['output'];
  /**
   * Deletes a tracking rule customization and returns it. The rule falls back to its default behaviour or to a broader customization.
   *
   * Fails if the customization does not exist. Network (cockpit) users only; not available to read-only users.
   */
  deleteTrackingCustomization: RuleCustomization;
  /**
   * Deletes a traffic tag so it is no longer applied to new traffic. Traffic already tagged keeps its tag. Returns the deleted tag. Fails if no tag exists with the given id.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  deleteTrafficTag: TrafficTag;
  /** Deletes a traffic targeting rule so it no longer affects clicks, and returns the deleted rule. Fails if no rule with the given id exists. Network (cockpit) users only. */
  deleteTrafficTarget: TrafficTargeting;
  /**
   * Deletes a platform user and removes their login credentials, so the account can no longer sign in. Returns the deleted user.
   *
   * Fails if the user id does not exist or if you try to delete your own account. Admins only; not available to read-only users.
   */
  deleteUser: User;
  /**
   * Edits or creates conversions from a CSV file. Each row identifies conversions by postback id, by click id, or by click id plus event; the input maps CSV columns (zero-based) to the values to set (state, decision, revenue, payout, time) or gives fixed values for all rows. Returns how many rows matched and lists unmatched click and postback ids and invalid event ids.
   *
   * With `preview: true` nothing is changed and only the matching result is returned. With `createPostbacks: true`, clicks that have no conversion for the row's event get one created (requires a click id column). Changes are applied asynchronously and show up in reports within a few minutes. Network (cockpit) users only; not available to read-only users.
   */
  executeFilePostbackModification: PostbackFileModification;
  /**
   * Re-sends (fires) publisher postbacks for existing conversions, using the publisher postback links that match each conversion. Conversions are selected by postbackIds and/or conversion report filters and an optional time range; all given criteria are combined. Conversions that happened less than one hour ago are skipped. Each fired conversion gets a note in its modification history.
   *
   * Returns how many conversions were fired successfully and how many of the matching conversions were not. Network (cockpit) users only.
   */
  firePublisherPostbacks: FirePostbacksResponse;
  /**
   * Starts a password reset: if an active account exists for the email, a reset link is emailed that is valid for 15 minutes and is used with `resetPassword`. Returns the email.
   *
   * The response is the same whether or not the account exists. Requests are rate limited per email and IP. Can be called without authentication.
   */
  forgotPasswordRequest: Scalars['String']['output'];
  /**
   * Sends existing leads to one or more lead forwarding endpoints on demand and waits for the responses. Leads are selected with the given report filters within the `start`/`end` time range; every selected lead is sent to every listed endpoint.
   *
   * Returns one result per lead and endpoint, with the request sent, the response received and whether it matched the endpoint's expected response. The results are also stored with the lead's forwarding history. Fails if the selection matches more than 10,000 leads or no leads at all. Endpoint ids that do not exist are skipped.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  forwardLeads?: Maybe<Array<LeadForwardingResult>>;
  /**
   * Generates a new random security token for an advertiser and returns the updated advertiser. The token is used to verify that incoming postbacks really come from this advertiser. Any previously generated token is replaced, so postback URLs using the old token must be updated.
   *
   * Fails with an error if the advertiser does not exist. Network (cockpit) users only.
   */
  generateAdvertiserSecurityToken: Advertiser;
  /**
   * Requests a downloadable log file of raw clicks, impressions or click redirections for the given offers, publishers, publisher sub ids and/or advertisers. Returns immediately with status `QUEUED`; the file is generated asynchronously and its status moves to `PROCESSING` and then `READY` (with a download `url`) or `EMPTY` when no events matched.
   *
   * The period must be at most 7 days and `start` must be before `end`; at least one offer, publisher, publisher sub id or advertiser must be given. Generated files are removed automatically after 7 days. Network (cockpit) users only.
   */
  generateEventLogFile: EventLogFile;
  /**
   * Creates payment records with status `OPEN` for all publishers, using each publisher's total payout earned in the given period (in the account currency). Returns the created payments.
   *
   * Publishers below `threshold` are skipped. With `smartPaymentCalculation`, a publisher whose latest payment overlaps the period is only paid from the end of that payment onwards, which avoids paying the same time span twice. Network (cockpit) users only.
   */
  generatePublisherPayments?: Maybe<Array<PublisherPayment>>;
  /**
   * Starts an on-demand AppsFlyer data import for an offer for one day, using the offer's AppsFlyer configuration. The import runs in the background; results appear in reports once it finishes. Always returns null. If the offer has no AppsFlyer configuration, nothing happens. On some accounts the day must lie within a recent window, otherwise a validation error is returned.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  importAppsflyerData?: Maybe<Scalars['String']['output']>;
  /**
   * Imports payout changes from a CSV file at the given URL and returns how many payouts were created and updated, plus per-row errors.
   *
   * The first line is a header. Each row has the columns: advertiser id, offer id, publisher id (empty = all publishers), event type id (empty = default event), weGet, theyGet (decimals in the platform currency). Rows are skipped with an error when the advertiser, offer, publisher or event type does not exist, the event type belongs to another offer, or the publisher has no access to the offer. Empty weGet and theyGet delete the payout; margins stored for imported keys are removed. Files with more than 50,000 rows are rejected.
   *
   * Network (cockpit) users only; not available to read-only users. Changes are audited.
   */
  importPayoutEditCSV: PayoutEditImportResult;
  /** Assigns a number (if missing), issue/due dates and renders the PDF */
  issueAdvertiserInvoice: AdvertiserInvoice;
  /**
   * Generates a six-digit, single-use login code for a publisher or advertiser contact's portal login and returns it instead of emailing it, for contacts who do not receive our emails. Hand it over through another channel; the contact logs in with `loginWithCode` (the "Email code" tab of the partner portal) within 15 minutes. It replaces any pending code and, for an account that was never migrated from Cognito, the login migrates it.
   *
   * Admin only. Fails if the user is not linked to a contact, is inactive or expired, has no login yet, or is blocked by too many wrong codes today.
   */
  issueContactLoginCode: IssuedLoginCode;
  /**
   * Imports leads from a CSV file available at a URL. The first row is treated as a header and skipped; each following row becomes one lead, with columns mapped to lead fields by position (1-based) as given in `fields`. Empty cells are ignored.
   *
   * When `evaluate` is true, the imported leads go through the same evaluation as leads submitted live; otherwise they are stored directly as approved leads. Leads are processed asynchronously and show up in lead reports shortly after the call returns. Returns the number of rows read from the file. Fails if the file cannot be downloaded or parsed.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  leadImport: LeadImport;
  /**
   * Logs in with email and password and returns an access token and a refresh token. The email is matched case-insensitively.
   *
   * Check `authChallenge` in the response before using the token:
   * - `NONE`: login succeeded and `token` is set.
   * - `NEW_PASSWORD_REQUIRED`: the account still has a temporary (invitation) password; call `changePasswordNewUser` to set a permanent one.
   * - `ACCOUNT_MIGRATION_REQUIRED`: the account must be re-confirmed; a verification code was emailed and the user finishes with `completeAccountMigration`.
   *
   * Wrong credentials return an error. Repeated failed attempts from the same email or IP are temporarily blocked; `loginWithCode` still works during such a block. Can be called without authentication.
   */
  login: AuthResponse;
  /**
   * Logs in with a code sent by `requestLoginCode` and returns the same response as `login`. A successful code login also lifts any failed-password login block for that email.
   *
   * A wrong or expired code returns an error. At most 10 wrong codes are accepted per account and day; after that the pending code is invalidated and further attempts are rejected until the next day. Can be called without authentication.
   */
  loginWithCode: AuthResponse;
  /** Marks memos (in-app notifications) as read or unread. Select memos either by ids or by filter; if both are given, the filter is used. Only memos addressed to the calling user are changed. Returns the selected memos, or an empty list if nothing matched. */
  markMemosAsRead: Array<Memo>;
  /**
   * Adds or removes a marketplace organization from the export list of all offers matching the filter, and returns the updated offers. An offer is flagged as marketplace-exported while at least one marketplace organization is on its list.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  markOffersForMarketplace?: Maybe<Array<Offer>>;
  /**
   * Applies the same change (currently the offer status) to many offers at once and returns the updated offers.
   *
   * Offers are selected by `filter` when it is given (then `ids` is ignored), otherwise by `ids`. Caution: with no filter and an empty `ids` list, all offers are updated. At most 5000 offers can be archived in one call. Fails if an id does not exist. Network (cockpit) users only; not available to read-only users.
   */
  offerBatchUpdate: Array<Offer>;
  /**
   * Creates a postback link from the partner portal, for the logged-in publisher. Behaves like `createPostbackLink` (same fields and validation) and returns the created link.
   *
   * Partner portal publishers can only create links for their own publisher account, and only for offers that are public or that their account is approved for. Network (cockpit) users may also call it. Not available to read-only users.
   */
  partnerPublisherCreatePostbackLink: PostbackLink;
  /**
   * Deletes a postback link from the partner portal and returns the deleted link. Fails if the link does not exist.
   *
   * Partner portal publishers can only delete links that belong to their own publisher account and to offers that are public or approved for them. Network (cockpit) users may also call it. Not available to read-only users.
   */
  partnerPublisherDeletePostbackLink: PostbackLink;
  /**
   * Requests access for a publisher to an offer that requires approval. The publisher's access to the offer is set to pending until the network approves or rejects it. Returns the offer as seen by the publisher.
   *
   * Fails if the offer or the publisher is not active, or if the offer is private and the publisher has no access to it. Partner portal publishers can only request approval for their own publisher; network (cockpit) users can request it on behalf of any publisher. Not available to read-only users.
   */
  partnerPublisherRequestApproval: PartnerPublisherOffer;
  /**
   * Replaces an existing postback link from the partner portal; fields not supplied are cleared or reset to their defaults. Returns the updated link. Fails if no link with that id exists.
   *
   * Partner portal publishers can only save links for their own publisher account and for offers that are public or approved for them. Network (cockpit) users may also call it. Not available to read-only users.
   */
  partnerPublisherUpdatePostbackLink: PostbackLink;
  /** Immediately recomputes the fraud signals and fraud score of one rewarded user using the current fraud policy and its lookback window, and returns the updated user. If auto-ban is enabled in the policy and the new score or tier crosses the configured threshold, an active or pending user is banned for fraud as part of this call. Fails if the user does not exist. Network (cockpit) users only. */
  recomputeRewardedUserFraudScore: RewardedUser;
  /** Replaces PLATFORM lines with current numbers, keeps MANUAL lines */
  refreshAdvertiserInvoiceLines: AdvertiserInvoice;
  /**
   * Exchanges a refresh token for a new access token. Refresh tokens rotate: the response contains a new refresh token and the one you sent is no longer valid, so always store the returned one.
   *
   * Fails if the refresh token is unknown, expired or revoked (for example after a password change) or the user is disabled; the client must then log in again. Can be called without authentication.
   */
  refreshToken: AuthResponse;
  regenerateAdvertiserInvoicePdf: AdvertiserInvoice;
  registerThirdPartyOrganization: MarketplaceOrganization;
  removeAdvertiserInvoicePayment: AdvertiserInvoice;
  /**
   * Sends (or re-sends) the six-digit verification code for accounts that must be re-confirmed before they can log in (the `ACCOUNT_MIGRATION_REQUIRED` login challenge). The code is valid for 1 hour and is used with `completeAccountMigration`. Returns the email.
   *
   * No email is sent for accounts that do not need this step; the response is the same. Rate limited per email and IP. Can be called without authentication.
   */
  requestAccountMigration?: Maybe<Scalars['String']['output']>;
  /**
   * Emails a six-digit, single-use login code to the given address for passwordless login with `loginWithCode`. The code is valid for 15 minutes.
   *
   * Always returns true, also for unknown or inactive emails, so it does not reveal which accounts exist. Not affected by the failed-password login block, but requests are rate limited per email and IP. Can be called without authentication.
   */
  requestLoginCode: Scalars['Boolean']['output'];
  /**
   * Lets a publisher request a payout. Creates a payment with status `REQUESTED` for the given amount and returns it.
   *
   * The payment period is set automatically: it starts where the publisher's latest payment ended (or at the start of the previous month if there is none) and ends at the end of yesterday; the `start` and `end` values in the input are not used. Partner portal publishers can only request payments for themselves; network (cockpit) users can request on behalf of any publisher.
   */
  requestPublisherPayment: PartnerPublisherPayment;
  /**
   * Requests a payout (withdrawal) of a rewarded user's earned balance. The payment is created with status REQUESTED and account managers are notified; it is then reviewed and paid out by the network.
   *
   * Validation: the amount must be greater than zero, at least the configured minimum payment amount (see `rewardedMinimumDepositAmount`) and not more than the user's available balance. Players of apps that do not allow cashing out, or without a verified email address where one is required, are rejected. Only one request per user is processed at a time; a concurrent request fails with a retry message.
   *
   * Callable by the rewarded user (player) for their own account with their own token, and by network (cockpit) users.
   */
  requestRewardedUserPayment: PartnerPublisherPayment;
  /** Admin only: lifts the "too many failed login attempts" ban (and password reset throttles) of a user on all instances */
  resetLoginBlock: Scalars['Boolean']['output'];
  /**
   * Sets a new password using the token from the password reset email and logs the user in, returning tokens like `login`.
   *
   * Fails if the token is wrong or expired (15 minutes), or the new password does not meet the password policy. Repeated failures are rate limited. Can be called without authentication.
   */
  resetPassword: AuthResponse;
  /** Requests a payout through the platform's payment provider; needs a verified email. */
  rewardOsCashOut: RewardOsTransaction;
  /**
   * Opens an offer-wall session for previewing a RewardOS app from the network's dashboard. Without `rewardedUserId` the session belongs to the app's dedicated preview player (created on first use); with it, the session signs in as that player so you see exactly what they see. Returns the session, including a player access token and the wall's client configuration.
   *
   * Fails if the app does not exist, the player does not belong to the app, or the player is not active. Network (cockpit) users only.
   */
  rewardOsPreviewSession: RewardOsSession;
  /** Emails a 6-digit code to the address; it becomes the player's email once rewardOsVerifyEmail confirms it. */
  rewardOsSetEmail: Scalars['Boolean']['output'];
  /** Debits points so the host app can credit its own currency. The same idempotencyKey returns the first transfer. */
  rewardOsSpendPoints: RewardOsTransaction;
  /** Public. Starts (or creates) the player's session from the app key and the customer's user id. */
  rewardOsStartSession: RewardOsSession;
  rewardOsVerifyEmail: Scalars['Boolean']['output'];
  rewardedAppDetails?: Maybe<RewardedAppDetails>;
  /**
   * Reports that the signed-in rewarded user opened the rewarded app on a device. The device entry (identified by `deviceId`) is created or updated on the user's profile with the supplied device details, the push notification token, and the IP address, language, geo location and VPN/proxy detection derived from the request. An app-open event is also recorded for reporting. Returns "OK".
   *
   * Called by the rewarded app with the player's own token; it always applies to the calling player.
   */
  rewardedAppOpen?: Maybe<Scalars['String']['output']>;
  /**
   * Opens a new support conversation for a rewarded user with a title and a first message (text plus up to 5 picture attachments uploaded beforehand). The ticket starts with status OPEN, is assigned to one of the account managers who handle support tickets, and the support team is notified. Returns the created ticket.
   *
   * Fails if `ticket.id` is set or if no account manager is available to handle support tickets. Callable by the rewarded user (player) for their own account with their own token, and by network (cockpit) users for players they manage.
   */
  rewardedCreateSupportTicket: RewardedUserSupportTicket;
  /**
   * Adds a message from the rewarded user to one of their support tickets. The message may contain text and up to 5 picture attachments uploaded beforehand. Returns the ticket, including the new message.
   *
   * Fails if the ticket does not exist or is closed. Callable by the ticket's rewarded user (player) with their own token; network (cockpit) users can also call it for players they manage, but the message is then still attributed to the player (account managers reply with `createRewardedSupportTicketMessage`).
   */
  rewardedCreateSupportTicketMessage: RewardedUserSupportTicket;
  rewardedReadSupportTicket: RewardedUserSupportTicket;
  /**
   * Deletes the signed-in rewarded user's account at their own request. The login is removed, the profile is anonymized (name, nickname, email and custom profile fields are overwritten) and the account is set to INACTIVE, so the user can no longer sign in. This cannot be undone. Returns true.
   *
   * Called by the rewarded app with the player's own token; it always applies to the calling player.
   */
  rewardedRequestDeletion: Scalars['Boolean']['output'];
  /**
   * Starts a password reset for a rewarded user: emails a 6-digit reset code, valid for one hour, to the address. Always returns the email address passed in, whether or not an account exists for it, so the call cannot be used to find out which emails are registered. Complete the reset with `rewardedResetPassword`.
   *
   * Can be called without authentication. Requests are rate-limited per IP address.
   */
  rewardedRequestPasswordReset?: Maybe<Scalars['String']['output']>;
  /**
   * Sets a new password for a rewarded user using the code from `rewardedRequestPasswordReset`. Returns true on success, after which the code can no longer be used. Returns false when the code is wrong or expired, or no account exists for the email (the response does not reveal which). The new password must be at least 8 characters long.
   *
   * Can be called without authentication. Attempts are rate-limited per IP address.
   */
  rewardedResetPassword: Scalars['Boolean']['output'];
  /**
   * Tutorial mode: the signed-in rewarded user chooses which of the configured tutorial offers to complete as their guided first earning. The choice can be changed until the first task of the selected offer has been completed. Returns the updated tutorial state.
   *
   * Fails if the tutorial is not active for the user, the offer is not one of the tutorial offers available to them, or the current selection can no longer be changed. Called by the rewarded app with the player's own token; it always applies to the calling player.
   */
  rewardedSelectTutorialOffer: RewardedTutorialState;
  /**
   * Signs a rewarded user in with Google, Facebook or Apple. The provider token is verified with the provider and the account is matched by the verified email address. If no rewarded user exists for that email, a new active, email-verified account is created (applying `referralCode` if given) and `isNewUser` is true. Returns an access token for the rewarded user.
   *
   * Fails when the token cannot be verified, the provider does not supply an email address, the email is not verified by the provider, or the existing account is not active. Google sign-in is only accepted for Gmail and Google Workspace addresses; other addresses must use email and password. Can be called without authentication.
   */
  rewardedSocialLogin: AuthResponse;
  /**
   * Records a batch of client-side telemetry events (screen views, interactions, ...) for the signed-in rewarded user. At most 200 events are processed per call; extra events are ignored. Each event's `time` is used only if it is not in the future and not older than one day, otherwise the server time is used. Returns the number of events accepted (0 when event tracking is not enabled for the platform).
   *
   * Called by the rewarded app with the player's own token; it always applies to the calling player.
   */
  rewardedTrackEvents: Scalars['Int']['output'];
  /**
   * Sends (or re-sends) the email verification code to a rewarded user who registered with email and password and has not verified yet. A new 6-digit code, valid for one hour, replaces any previous one. Nothing is sent if the user is already verified or not pending verification. Always returns null.
   *
   * Can be called without authentication (used during sign-up in the rewarded app). Requests are rate-limited per IP address. Prefer `rewardedTriggerVerificationEmailByEmail` when only the email address is known.
   */
  rewardedTriggerVerificationEmail?: Maybe<Scalars['String']['output']>;
  /** Re-sends the verification code to an unverified rewarded user. Always returns the email, whether or not it is registered. */
  rewardedTriggerVerificationEmailByEmail?: Maybe<Scalars['String']['output']>;
  /** Uploads a picture (PNG, JPEG, GIF or WebP, at most 10 MB) to attach to a support ticket message. Rewarded or cockpit user. */
  rewardedUploadSupportTicketAttachment: UploadResult;
  /** Same as rewardedUploadSupportTicketAttachment for a plain JSON request: the picture as base64 text, with or without a data:image/...;base64, prefix. */
  rewardedUploadSupportTicketAttachmentBase64: UploadResult;
  /**
   * Verifies a rewarded user's email address with the 6-digit code sent by email. On success the user becomes ACTIVE, the code is consumed, and a pending referral reward for the inviting user is credited if eligible; returns true. Returns false when the code is wrong or expired, or the user is not awaiting verification. Fails if no rewarded user has this email.
   *
   * Can be called without authentication. Attempts are rate-limited per IP address and per email address.
   */
  rewardedVerifyEmail: Scalars['Boolean']['output'];
  /** Replaces one secret of a RewardOS app with a newly generated value and returns the updated app. The previous value stops working immediately, so the customer's backend or app must be updated with the new one. Fails if the app does not exist. Network (cockpit) users only. */
  rotateRewardOsAppSecret: RewardOsApp;
  /**
   * Starts an on-demand import from an advertiser's search-feed integration for every day from `start` to `end` (inclusive; only the date part is used). The import is scheduled in the background; the call returns an empty list once it has been scheduled.
   *
   * For each day, the provider's data is fetched first; if it contains data, it replaces the previously imported data for that day, otherwise the existing data is kept. Results appear in reports once the import finishes. Fails immediately with an error if the advertiser has no search integration or `end` is before `start`.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  runSearchIntegration: Array<Scalars['String']['output']>;
  /**
   * Creates or replaces the Adjust ad spend upload configuration of an offer. Two upload methods exist:
   * - API (default): cost is sent to Adjust per conversion; costType and tag are required.
   * - EMAIL: a daily ad spend CSV is emailed to Adjust; emailRecipient is required and must look like automate.import.sa+<identifier>@adjust.com. Store id/type and campaign name/id are optional and default to values derived from the offer.
   *
   * The history of previously sent emails is kept. Returns the saved configuration; fails with a validation error if required fields for the chosen method are missing. Network (cockpit) users only.
   */
  saveAdjustUploadConfig: AdjustUploadConfig;
  saveAdvertiserBillingProfile: AdvertiserBillingProfile;
  /** Advertiser invoices (ADMIN/ADOPS) */
  saveAdvertiserInvoiceSettings: AdvertiserInvoiceSettings;
  saveAdvertiserNetworkRelationship: AdvertiserNetworkRelationship;
  /**
   * Creates or updates an advertiser rebate: a rate (a fraction, e.g. 0.05 for 5%) of revenue returned to an advertiser, scoped to advertisers and/or offers and an optional time window. Pass `id` to update an existing rebate; omit it to create a new one.
   *
   * Rebates do not change stored conversions; they are applied when reports compute the rebate metrics (rebate amount and revenue, cost and profit net of rebate). Returns the saved rebate.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  saveAdvertiserRebate?: Maybe<AdvertiserRebate>;
  /**
   * Configures AppsFlyer click signing (Protect360) for the account: stores the AppsFlyer API token and sets the requested signing mode in AppsFlyer. Fails with an error if AppsFlyer rejects the token as invalid.
   *
   * Returns the saved token and mode. Network (cockpit) users only.
   */
  saveAppsflyerClickSigningConfig: AppsflyerClickSigningConfig;
  /**
   * Creates or updates a mapping that assigns AppsFlyer media sources to a publisher during AppsFlyer imports. Imported rows whose media source matches one of the patterns (exact name, `*`, `prefix*` or `*suffix`) are attributed to the publisher, for the given offer (or all offers when `offerId` is omitted) and within the optional date range (start inclusive, end exclusive). Exact matches take precedence over wildcard matches.
   *
   * Pass `id` to update an existing mapping (all its fields are replaced); omit it to create a new one. The change is audited. Returns the saved mapping.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  saveAppsflyerMediaSourceMapping: AppsflyerMediaSourceMapping;
  /** Creates or updates multiple appsflyer media source -> publisher mappings */
  saveAppsflyerMediaSourceMappings: Array<AppsflyerMediaSourceMapping>;
  /**
   * Creates or updates one named AppsFlyer token used to upload network cost data to AppsFlyer. If id is empty, a new token with a generated id is created; otherwise the token with that id is replaced. Other tokens are not affected.
   *
   * Returns the saved token. Network (cockpit) users only.
   */
  saveAppsflyerNetworkCostUploadToken: AppsflyerNetworkCostUploadToken;
  /**
   * Creates, updates or deletes the AppsFlyer data import configuration of an offer (AppsFlyer app id, import day offset, which API tokens to import with, cost API settings, campaign, agency and retargeting settings). Passing a null config deletes the offer's configuration and returns null.
   *
   * Token ids in tokenIds are added to the offer's import trackers; trackers that already exist keep their import progress. Returns the saved configuration. Network (cockpit) users only.
   */
  saveAppsflyerOfferConfig?: Maybe<AppsflyerOfferConfig>;
  /**
   * Replaces the account's list of named AppsFlyer API tokens that can be assigned to AppsFlyer offer configurations for data import. Passing null deletes all stored tokens and returns null; otherwise the full list is stored and returned.
   *
   * Network (cockpit) users only.
   */
  saveAppsflyerOfferTokens?: Maybe<Array<AppsflyerOfferToken>>;
  /**
   * Sets the AppsFlyer media sources of a publisher, i.e. which AppsFlyer media source names belong to this publisher when AppsFlyer data is imported. Replaces the publisher's existing AppsFlyer settings and returns the saved config.
   *
   * Fails with an error if the publisher does not exist. Network (cockpit) users only.
   */
  saveAppsflyerPublisherConfig?: Maybe<AppsflyerPublisherConfig>;
  /**
   * Creates or replaces the AppsFlyer cost upload configuration of an offer: the AppsFlyer app id, which network cost upload token to use, and the media source and campaign id/name under which cost is reported. The previous configuration of the offer is overwritten.
   *
   * Returns the saved configuration. Network (cockpit) users only.
   */
  saveAppsflyerUploadConfig: AppsflyerUploadConfig;
  /** AttributionExpiration */
  saveAttributionExpiration: AttributionExpiration;
  /**
   * Creates or updates an audience: a named segment of rewarded users defined by a list of filters (field, operator, values). Audiences are used as targets of push notifications. Pass `id` in the input to update an existing audience; all fields are replaced.
   *
   * After saving, the audience's member list is recalculated in the background, so `users` may take a moment to reflect the new filters. Returns the saved audience. Network (cockpit) users only.
   */
  saveAudience: Audience;
  /** Sets the timezone used for an offer's daily budget periods and time-of-day targeting, and returns the updated offer. Only this setting is changed; other offer fields are kept. Network (cockpit) users only. */
  saveBudgetTimezone: Offer;
  /**
   * Creates or updates whitelist/blacklist entries that allow or block traffic by app id, app name, site, creative, placement or sub id values, optionally scoped to an advertiser, a publisher and/or offers. Returns the saved entries.
   *
   * One entry is stored per offer id given in an input item; without offer ids a single entry is stored for the item. Values may contain `%` as a wildcard. Supplying an `id` updates that entry. Network (cockpit) users only.
   */
  saveControlledAccessObjects: Array<ControlledAccessObject>;
  /** Creates/updates creative */
  saveCreative: Creative;
  /**
   * Creates a creative pack for an offer, or updates its title, description and offer when `input.id` refers to an existing pack. Returns the saved pack. The creatives already in the pack are kept; use `saveCreatives` to change them.
   *
   * Fails if the offer does not exist. Network (cockpit) users only.
   */
  saveCreativePack: CreativePack;
  /**
   * Replaces the full list of creatives in a creative pack with the given list and returns the saved creatives. Creatives that are not in the list are removed from the pack.
   *
   * Creatives without an `id` get a newly generated id; thumbnails are generated where possible. Fails if the pack does not exist. Network (cockpit) users only.
   */
  saveCreatives: Array<Creative>;
  /**
   * Assigns a custom tracking domain to combinations of advertisers, offers and publishers. One entry is saved for every combination of the given advertiserIds, offerIds and publisherIds; an omitted list acts as "any" for that dimension. When tracking links are generated, the most specific matching entry is used, otherwise the account's default tracking domain. An existing entry for the same combination and type is overwritten.
   *
   * Fails if any given advertiser, offer or publisher does not exist. Returns the saved entries.
   */
  saveDomainCustomization?: Maybe<Array<DomainCustomization>>;
  /**
   * Creates or updates an event value extraction rule. A rule runs a jq expression over the attribution partner data of incoming conversions (with the advertiser's raw `event_value` payload pre-parsed) and writes the resulting number into the conversion's aggregated event value or sale amount. Rules apply to an advertiser, optionally narrowed to one offer and one of its event types; the most specific rule wins, then the highest `priority`. With `overwriteExisting` false, the target is only filled when it is empty or zero.
   *
   * Pass `id` to update an existing rule; all fields are replaced, `active` defaults to true. Fails if the advertiser, offer or event type does not exist, the offer does not belong to the advertiser, the event type does not belong to the offer, an event type is given without an offer, or the expression is invalid. Network (cockpit) users only.
   */
  saveEventValueExtractionRule: EventValueExtractionRule;
  saveMarketplacePostbackLink: MarketplacePostbackLink;
  /**
   * Creates or replaces the payout conversion policy of an advertiser. The policy defines how the amount a network reports for its offers (the primary signal: what we get or what the user gets, in USD or points) is turned into the end user's reward: the target unit (USD or points), the adjustment strategy (EXACT, MARGIN or MULTIPLIER with `adjustmentValue`) and the points-per-USD rate used when converting between money and points.
   *
   * The policy is applied when payouts are shown and evaluated; a payout value stored manually always takes precedence over a policy-derived one. All fields are replaced by the input. Fails if the advertiser does not exist. Network (cockpit) users only.
   */
  savePayoutConversionPolicy: PayoutConversionPolicy;
  /**
   * Saves the split payout components for one payout key (offer, optionally narrowed to a publisher and/or event type) in a single atomic operation. Each component (`weGet`, `weGetPoints`, `theyGet`, `theyGetPoints`) is optional: a component left out (null) is not changed, while a present component is either upserted or deleted according to its `op`. One call can therefore create one component, update another and delete a third.
   *
   * Monetary components are in USD; points components are raw points. Values written here are marked as manual. Returns the resulting payout for the key. Network (cockpit) users only.
   */
  savePayoutV2: PayoutV2;
  /** Batch variant of `savePayoutV2`: applies several composite payout saves in one transaction, so either all of them are stored or none. Returns the resulting payouts in the same order as the input; an empty list returns an empty result. Network (cockpit) users only. */
  savePayoutsV2: Array<PayoutV2>;
  /**
   * Saves the account-wide permission settings and returns them. Currently this defines, for advertisers, publishers and offers separately, the minimum user role that is allowed to edit tags.
   *
   * The whole configuration is replaced on every call. Network (cockpit) users only.
   */
  savePermissionConfig: PermissionConfig;
  /** Sets the points exchange rate of a publisher: the number of points credited per 1 USD of user payout (theyGet) whenever a payout has no explicit points value. Pass null as `rate` to remove the publisher's rate. Returns the stored rate, or null when it was removed. Network (cockpit) users only. */
  savePointsExchangeRate?: Maybe<Scalars['Float']['output']>;
  /** Save pre approved advertiser tags */
  savePreApprovedAdvertiserTags?: Maybe<Array<Scalars['String']['output']>>;
  /** Save pre approved publisher tags */
  savePreApprovedPublisherTags?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Creates or updates a publisher group: a set of publishers (with traffic ratios, or all active publishers) that run an offer or advertiser under a shared, rotating group id and optionally rotating sub ids, with KPI thresholds. Pass the id of an existing group to update it, or omit it to create a new one. If groupId is omitted, a random numeric group id that is unique for the offer/advertiser is generated.
   *
   * Returns the saved group. Network (cockpit) users only.
   */
  savePubGroup: PubGroup;
  /**
   * Saves how a publisher wants to be paid (PayPal, Payoneer, bank transfer, Tipalti, Capitalist, Paxum, Tremendous or crypto wallet) and returns the saved details. The publisher's previous payment details are replaced entirely; methods not supplied are removed.
   *
   * Fails if the publisher does not exist. Partner portal publishers can only change their own details; network (cockpit) users can change any publisher's.
   */
  savePublisherPaymentDetails: PublisherPaymentDetails;
  /** Saves publisher payment scheduler settings */
  savePublisherPaymentSchedulerSettings: PublisherPaymentSchedulerSettings;
  /**
   * Creates or updates a realtime integration: a connection to a network whose offers are fetched live when the rewarded offer list is served, instead of being imported in advance. On first save, a container offer is created under the given advertiser to represent the integration's items in tracking and reporting; later saves keep the same container offer.
   *
   * The provider `type` must be one of `realtimeIntegrationAdapters`. Fails if the advertiser does not exist, the provider type is unknown, or `id` is given but no such integration exists. Returns the saved integration. Network (cockpit) users only.
   */
  saveRealtimeIntegration: RealtimeIntegration;
  /**
   * Creates or updates a smart link: one tracking link that picks the best offer per click, with fallback landing pages, redirection rules and offer inventory settings. Without an `id` a new smart link is created; with an `id` the existing one is replaced. Returns the saved smart link.
   *
   * On update, fallback landing pages not included in the input are deleted, redirection rules are replaced, and omitting `inventoryConfigs` removes the offer recommendation settings. Fails if the given id does not exist. Network (cockpit) users only; not available to read-only users.
   */
  saveRecommendationSmartLink: SmartRecommendationLink;
  /**
   * Creates or updates a RewardOS app: a host app that embeds the RewardOS SDK offer wall. On creation the app key and all secrets (user signing secret, server API key, callback secret) are generated; they can only be changed later with `rotateRewardOsAppSecret`. A new app without `publisherId` gets its own publisher named after the app; an app's publisher can never be changed afterwards, and a publisher can belong to only one app.
   *
   * All settings are replaced by the input: omitted optional fields are cleared, `enabled` defaults to true, `requireSignedUsers` to false and `pointsUse` to BOTH. Fails if the name is empty, the publisher does not exist or is already used, the in-app exchange rate is not positive, or a URL is invalid. Network (cockpit) users only.
   */
  saveRewardOsApp: RewardOsApp;
  /**
   * Creates or updates an SKAdNetwork campaign mapping, which links an SKAdNetwork network id, app id and campaign id to an offer and publisher (optionally with an external campaign id/name). A mapping with the same network id, app id and campaign id is overwritten.
   *
   * Returns the saved mapping. Network (cockpit) users only.
   */
  saveSKAdMapping: SkAdMapping;
  /**
   * Creates or updates an Apple SKAdNetwork ad network entry identified by its network id, together with the key pair associated with it. An existing entry with the same network id is overwritten.
   *
   * Returns the saved entry. Network (cockpit) users only.
   */
  saveSKAdNetwork: SkAdNetwork;
  /**
   * Creates or updates an SKAdNetwork postback link for an offer: where and how (HTTP method, MMP type such as AppsFlyer, Adjust, Kochava, Singular or generic, URL, payload) SKAdNetwork postbacks are forwarded, and whether they should be validated with the MMP. A link with the same network id, offer id and campaign id is overwritten.
   *
   * Returns the saved link. Network (cockpit) users only.
   */
  saveSKAdPostbackLink: SkAdPostbackLink;
  /**
   * Creates or replaces the conversion forwarding settings of an offer for a self-attributing network (Google or Meta). Conversions of the offer are then sent to that network's conversion API using the given access token, pixel id, source URL and event name. An offer has at most one set of forwarding settings; saving again overwrites it. Returns the saved settings.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  saveSanForwardingSettings: SanForwardingSettings;
  /**
   * Saves a custom report (a raw report query with a name), optionally with a relative time range and a scheduled email, and returns it. If `id` matches an existing saved query it is replaced.
   *
   * Fails if the email schedule is not a valid cron expression. Network (cockpit) users only; not available to read-only users.
   */
  saveSavedRawQuery: SavedRawQueryType;
  /** Sets the list of device app set ids that are allowed to collect SDK breakpoints (screens) while running the app, e.g. test devices used to set up screen-based event tracking. The list is replaced entirely and returned. Network (cockpit) users only. */
  saveSdkBreakpointCollectorAppSetIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Links a screen (breakpoint) captured by the SDK to an app event type, so that the event is tracked when users reach that screen. Saving again for the same breakpoint replaces its link. Returns the saved link. Network (cockpit) users only. */
  saveSdkTrackedBreakpoint?: Maybe<SdkTrackedBreakpoint>;
  /**
   * Creates or updates an advertiser's search-feed integration of the given provider type: the provider credentials and settings, and the import schedule. If the advertiser already has an integration of that type it is updated, otherwise a new one is created. Configuration keys not supplied fall back to the provider's defaults.
   *
   * Once saved, search statistics (searches, ad clicks, revenue) are imported from the provider automatically on the configured schedule and recorded as conversions for the advertiser. Returns the saved integration. Fails if the advertiser does not exist or the provider type is unknown.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  saveSearchIntegration: SearchIntegration;
  /**
   * Sets manual offer weights for a smart link, replacing all previously saved manual weights. Returns the saved weights with their offers.
   *
   * Fails if the smart link does not exist or has no offer recommendation settings. Network (cockpit) users only; not available to read-only users.
   */
  saveSmartLinkManualWeights?: Maybe<Array<OfferWithWeight>>;
  /**
   * Sets or replaces the Meta (Facebook) install referrer decryption key of a store app. The key is used to decrypt Meta install referrer data received for installs of the app, so those installs can be attributed to Meta campaigns. Returns the updated store app. Fails if the store app does not exist.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  saveStoreAppFacebookInstallReferrerDecryptionKey: StoreApp;
  /**
   * Creates a support ticket between a partner user and an account manager, with the given title and a first message written by the calling user. The ticket starts with status OPEN. If an id is supplied, the ticket with that id is overwritten with the new title, participants and single message.
   *
   * Fails if the title is empty. Requires an authenticated platform user.
   */
  saveSupportTicket: SupportTicket;
  /**
   * Creates or updates a targeted payout: a payout for an offer (optionally limited to a publisher and/or event type) that applies only to traffic matching an advanced targeting rule. Provide the rule either as advancedTargetingGroup or as advancedTargetingJson. Amounts (weGet, theyGet) are in the account currency; if margin is set (a fraction, e.g. 0.2 for 20%), the publisher payout is derived from weGet and the margin instead of theyGet. Pass an existing id to update it.
   *
   * Fails if the offer, publisher or event type does not exist. Returns the saved targeted payout. Network (cockpit) users only.
   */
  saveTargetedPayout: TargetedPayout;
  /**
   * Creates or updates several targeted payouts at once (see saveTargetedPayout). All inputs are validated first and saved together; if any input refers to a non-existent offer, publisher or event type, nothing is saved.
   *
   * Returns the saved targeted payouts. Network (cockpit) users only.
   */
  saveTargetedPayouts?: Maybe<Array<TargetedPayout>>;
  /**
   * Sends the Adjust ad spend CSV email for an offer immediately, independent of the daily schedule, for example to provide a sample file during Adjust onboarding or to resend past days. Only works for offers whose Adjust upload config uses the EMAIL method; fails otherwise or if the offer has no Adjust upload config.
   *
   * from and to must be given together or not at all, from must not be after to, to must not be in the future, and the range can cover at most 93 days. Without them the regular scheduled range (the most recent days up to yesterday) is sent. Adjust overwrites its data per date, campaign and store, so resending a range replaces what Adjust had for those days. Manual sends do not affect the daily schedule.
   *
   * Returns the offer's Adjust upload configuration including the last sent email. Network (cockpit) users only.
   */
  sendAdjustCostEmail: AdjustUploadConfig;
  /** Issues first when still a draft, then emails the PDF */
  sendAdvertiserInvoice: AdvertiserInvoice;
  /**
   * Sends a test email built from a rewarded-app email template (for example the verification or password-reset email) so it can be previewed before saving. Template placeholders are filled with sample values (the recipient's first name, the rewarded app name and a random 6-digit code) and the subject is prefixed with `[TEST]`.
   *
   * The template does not need to be saved first. Returns the address the email was sent to. Fails if no recipient is given and the calling user has no email address. Network (cockpit) users only.
   */
  sendRewardedTestEmail: Scalars['String']['output'];
  /**
   * Starts setting up recurring billing for the account through Mollie. Creates a Mollie customer and a small verification payment, and returns the checkout URL where the user completes the payment form, plus the Mollie customer id. A previously configured Mollie customer is replaced.
   *
   * Billing details must already be configured for the account, otherwise an error is returned. Network (cockpit) users only.
   */
  setupOrganizationRecurringMolliePayment: OrganizationRecurringPaymentMethodMollie;
  /**
   * Tests the stored BigQuery export configuration by authenticating with the stored service-account credentials and looking up the configured dataset. Does not change anything. Returns success=false with an explanatory message if no configuration or dataset id is set, the dataset is not found, or the connection fails.
   *
   * Network (cockpit) users only.
   */
  testBigQueryConnection: BigQueryConnectionTestResult;
  /**
   * Tests an offer integration end to end: opens the given tracking link from a country targeted by the offer, looks for a click id in the redirect chain, reports a test conversion for that click and checks whether a publisher postback was fired.
   *
   * Returns `success: true` with the fired postback URL(s), or `success: false` with an error message explaining which step failed. The call waits for the result and can take up to about half a minute. The offer must have country and OS targeting. Network (cockpit) users only.
   */
  testPublisherIntegration: PublisherIntegrationTest;
  /**
   * Dry-runs a saved realtime integration against the network and returns a human-readable result line per step: listing items (up to 5) and resolving a click on the first item. Each line reports success or the error that occurred. The request is made with a test user id and with the caller's own IP address and user agent, since many networks return nothing without a plausible end-user context.
   *
   * No clicks, conversions or other tracking data are created. Fails if the integration or its provider does not exist. Network (cockpit) users only.
   */
  testRealtimeIntegration: Array<Scalars['String']['output']>;
  /**
   * Runs an advertiser batch operation immediately: its actions are applied to every advertiser that currently matches its filters, and the operation is returned once the run has finished.
   *
   * The run happens regardless of the operation's `active` flag or schedule. Fails if no batch operation with the given id exists. Network (cockpit) users only.
   */
  triggerAdvertiserBatchOperation: AdvertiserBatchOperation;
  /**
   * Starts an on-demand sync of an advertiser config (network offer import) instead of waiting for the next scheduled run. If a sync triggered earlier for the same config is still pending, no new run is started and the existing trigger is returned with `alreadyPending: true`.
   *
   * The sync runs in the background; poll `advertiserConfigSyncStatus` for its outcome. Fails if the advertiser config does not exist. Network (cockpit) users only.
   */
  triggerAdvertiserConfigSync: AdvertiserConfigSyncTrigger;
  /** Triggers the KPI */
  triggerKPI: KpiLogConnection;
  /**
   * Runs an offer batch operation immediately: its actions are applied to every offer that currently matches its filters, and the operation is returned once the run has finished.
   *
   * The run happens regardless of the operation's `active` flag or schedule. Fails if no batch operation with the given id exists. Network (cockpit) users only.
   */
  triggerOfferBatchOperation: OfferBatchOperation;
  /**
   * Runs a publisher batch operation immediately: its actions are applied to every publisher that currently matches its filters, and the operation is returned once the run has finished.
   *
   * The run happens regardless of the operation's `active` flag or schedule. Fails if no batch operation with the given id exists. Network (cockpit) users only.
   */
  triggerPublisherBatchOperation: PublisherBatchOperation;
  /** Starts a full fraud scan over all rewarded users, the same work as the daily scheduled scan, using the current fraud policy. The scan runs in the background, so the call returns immediately: true when a scan was started, false when a manually triggered scan is already running. It runs even when the daily scan is disabled in the policy. Users can be auto-banned during the scan if the policy enables it. Network (cockpit) users only. */
  triggerRewardedFraudScan: Scalars['Boolean']['output'];
  /**
   * Lifts bans applied by the BANNED_USER postback evaluation rule by removing entries from the banned-users list. Entries can be removed by click id, and/or all entries of a publisher-side user id (optionally limited to one publisher). At least one click id or a user id is required.
   *
   * Returns the click ids that were removed and the requested click ids that had no entry (already unbanned or never banned). Network (cockpit) users only.
   */
  unbanUsers: UnbanUsersResult;
  /**
   * Reverses a completed advertiser report import by marking every conversion created by the task (within the time range it imported) as rejected. The change is applied asynchronously and shows up in reports shortly afterwards; it is recorded as a conversion modification made by the calling user. Returns the task. Fails if no task exists with the given id.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  undoAdvertiserReportImportTask: AdvertiserReportImportTask;
  /**
   * Replaces the settings of an existing ad keyword import spec. The time of the last run is kept. Returns the updated spec. Fails if the spec does not exist.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  updateAdKeywordImportSpec: AdKeywordImportSpec;
  /**
   * Replaces the advanced targeting rules of an offer and returns the saved targeting.
   *
   * Fails if the offer does not exist or has no advanced targeting yet (use `createAdvancedTargeting`). The change is audited. Network (cockpit) users only; not available to read-only users.
   */
  updateAdvancedTargeting: AdvancedTargeting;
  /**
   * Replaces the field type, name and values of an existing value bundle. Targeting rules that reference the bundle are updated to use the new values. Returns the updated bundle. Fails if the bundle does not exist.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  updateAdvancedTargetingValueBundle: AdvancedTargetingValueBundle;
  /**
   * Replaces an existing advertiser with the given definition and returns it. Fields not supplied are cleared; creation metadata and the advertiser's security token are preserved. Fails if the advertiser does not exist.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  updateAdvertiser: Advertiser;
  /**
   * Replaces the configuration of an existing advertiser batch operation with the given input and returns the updated operation. Fields not supplied in the input are cleared.
   *
   * Saving an active one-time operation re-arms it so it runs again. The same validation as on create applies. Fails if the id does not exist. Network (cockpit) users only.
   */
  updateAdvertiserBatchOperation: AdvertiserBatchOperation;
  /**
   * Replaces an advertiser API integration with the given definition and returns it. If `margin` is set, the advertiser-level margin is updated as well. An offer import run is triggered right away. Fails if the integration does not exist.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  updateAdvertiserConfig: AdvertiserConfig;
  /**
   * Turns automatic offer syncing on or off for an advertiser API integration and returns the integration. Calling it with the current value changes nothing. Fails if the integration does not exist.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  updateAdvertiserConfigSync: AdvertiserConfig;
  /**
   * Updates an advertiser contact and returns it. All fields are replaced by the input.
   *
   * Switching `needsUser` from false to true creates a portal login and, if `isNotifiable` is true, emails the registration details. Switching it to false deactivates the linked login when no other advertiser contact uses it.
   *
   * Fails if the contact or the advertiser does not exist. Network (cockpit) users only; not available to read-only users.
   */
  updateAdvertiserContact: AdvertiserContact;
  /**
   * Replaces an existing coupon with the given values and returns it. The default publisher is (re)approved for the offer.
   *
   * The same validation as on create applies (unique code per offer, existing offer and publisher, start not after end). Fails if the coupon id does not exist. Network (cockpit) users only.
   */
  updateAdvertiserCoupon: AdvertiserCoupon;
  /** Any status can be edited; an existing PDF is re-rendered */
  updateAdvertiserInvoice: AdvertiserInvoice;
  /**
   * Replaces the settings of an existing advertiser report import spec. An inbox email address is generated if `inboxEmailEnabled` is true and the spec does not have one yet; an existing address is kept. Returns the updated spec. Fails if the spec does not exist or if no field has a column position.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  updateAdvertiserReportImportSpec: AdvertiserReportImportSpec;
  /** Replaces the name, tags and advertiser of an existing app and returns it. Fails if the app does not exist. Network (cockpit) users only. */
  updateApp: App;
  /**
   * Replaces an app event type's values and returns it. The name and mapping of the matching events on the app's offers are updated as well.
   *
   * Fails if the event type does not exist or the app has no store app. Network (cockpit) users only.
   */
  updateAppEventType: AppEventType;
  /** Replaces an existing app token's values and returns it. Fails if the token does not exist. Network (cockpit) users only. */
  updateAppToken: AppToken;
  /**
   * Saves an auto-approval configuration under the id in the input and returns it. All fields are replaced by the input; fields you leave out are cleared.
   *
   * After saving, the active imported offers of the matching advertisers are re-checked in the background. Network (cockpit) users only; not available to read-only users.
   */
  updateAutoApprovalConfig: AutoApprovalConfig;
  updateAutomationRule: AutomationRule;
  /**
   * Creates or updates the account's Google BigQuery export configuration (enabled flag, GCP project, dataset, location, which event types to export, sync interval, backfill start, service-account credentials). Fields left null keep their current value; a blank serviceAccountJson keeps the stored credentials. The credentials are never returned.
   *
   * Returns the saved configuration including per-event-type sync state. Network (cockpit) users only.
   */
  updateBigQueryExportConfig: BigQueryExportConfig;
  /** Updates budget */
  updateBudget: Budget;
  /**
   * Creates, updates or deletes several budgets (money, event, click or impression caps) in one atomic call. Each budget is identified by its key (advertiser, offer, publisher, event type, validity period, type and threshold); setting `amount` to null deletes it. Monetary amounts are decimals in the platform currency.
   *
   * Returns the saved budgets with their current consumption; deleted budgets are not included. Fails if any referenced advertiser, offer, publisher or event type does not exist.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  updateBudgets: Array<Budget>;
  /** Updates click budget */
  updateClickBudget: ClickBudget;
  /** Updates click shield rules */
  updateClickShieldRules: ClickShieldRules;
  /**
   * Updates an event type and returns it. All fields are replaced by the input, so send the full definition; fields you leave out are cleared.
   *
   * If `eventTypeId` is null, the offer's default event is created or updated instead. Fails if the event type or the offer does not exist. Network (cockpit) users only; not available to read-only users.
   */
  updateEventType: EventType;
  /**
   * Replaces the offer feed API configuration of a publisher (or the default configuration when publisherId is empty) with the supplied sections. Behaves the same as createFeedApiConfiguration: the configuration is saved whether or not one existed before.
   *
   * Returns the saved configuration including the number of offers it currently matches. Network (cockpit) users only.
   */
  updateFeedApiConfiguration: FeedApiConfiguration;
  /**
   * Updates a filler and returns it. All fields, including the value list, are replaced by the input.
   *
   * Fails if the filler does not exist or if the values mix weighted and unweighted entries. Network (cockpit) users only; not available to read-only users.
   */
  updateFiller: Filler;
  /**
   * Updates a form definition and returns it. All fields are replaced by the input.
   *
   * Fails if the input has no id or the form does not exist. Existing submissions are kept. Network (cockpit) users only; not available to read-only users.
   */
  updateForm: Form;
  /** Updates a form submission */
  updateFormSubmission: FormResult;
  /** Updates the rewarded fraud scoring policy of the organization: whether the daily fraud scan runs, how many days of activity it looks back over, which identifier groups activity into users, and automatic banning (by risk tier and/or absolute score threshold). Only the fields supplied are changed; omitted fields keep their current value. Returns the updated policy. Network (cockpit) users only. */
  updateFraudPolicyConfig: FraudPolicyConfig;
  /**
   * Turns syncing on or off for the platform-wide migration from another tracking platform and returns the new state.
   *
   * Fails if the migration package is not enabled for your account. Network (cockpit) users only; not available to read-only users.
   */
  updateGeneralMigrationState: Scalars['Boolean']['output'];
  /** Updates impression budget */
  updateImpressionBudget: ImpressionBudget;
  /**
   * Updates an existing KPI rule with the supplied definition. If the KPI is active after the update, it is evaluated once immediately, so its actions may already be applied.
   *
   * Fails if no KPI with the given id exists. Returns the updated KPI. Network (cockpit) users only.
   */
  updateKPI: Kpi;
  /**
   * Replaces an existing landing page, identified by `input.id`, with the given definition and returns it. Fields not supplied are cleared.
   *
   * Fails if the landing page or offer does not exist, or if `isDefault` is true while another landing page of the offer is already the default.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  updateLandingPage: LandingPage;
  /**
   * Replaces the configuration of an existing lead forwarding endpoint with the given input. All settings are taken from the input; optional settings that are not supplied are cleared. Returns the updated endpoint. Fails if the endpoint or the advertiser does not exist.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  updateLeadForwardingEndpoint: LeadForwardingEndpoint;
  updateMarketplaceOrganization: MarketplaceOrganization;
  /** Updates the memo */
  updateMemo?: Maybe<Memo>;
  /**
   * Turns offer syncing on or off for one advertiser during a migration from another tracking platform. Returns the advertiser's new migration state.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  updateMigrationState: MigrationState;
  /**
   * Replaces an existing offer with the given definition and returns the updated offer. Fields not supplied are cleared, except `boost` and `invocaId`, which keep their current values when omitted; creation metadata is always preserved. The default landing page is updated with the new tracking URL.
   *
   * For offers imported from an advertiser integration with syncing enabled, an ACTIVE/PAUSED status follows the availability reported by the advertiser. Moving the offer to another advertiser also moves its budgets to the new advertiser.
   *
   * Fails if the offer or the advertiser does not exist. Network (cockpit) users only; not available to read-only users.
   */
  updateOffer: Offer;
  /** Updates offer access */
  updateOfferAccess: PublisherOfferView;
  /**
   * Sets the access state (APPROVED, PENDING, REJECTED or BLOCKED) of publishers on offers, creating the access entry when it does not exist yet. All entries are saved atomically and the changes are audited. Returns the resulting publisher-offer view for each entry.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  updateOfferAccesses: Array<Maybe<PublisherOfferView>>;
  /**
   * Sets the same access state for all publishers of one offer that match the filter (no filter = all publishers listed for the offer). Works like `updateOfferAccesses` for every matching publisher and returns the resulting publisher-offer views.
   *
   * Fails if the offer does not exist. Network (cockpit) users only; not available to read-only users. Changes are audited.
   */
  updateOfferAccessesForOffer: Array<PublisherOfferView>;
  /**
   * Sets the same access state for one publisher on all offers that match the filter (no filter = all offers listed for the publisher). Works like `updateOfferAccesses` for every matching offer and returns the resulting publisher-offer views.
   *
   * Fails if the publisher does not exist. Network (cockpit) users only; not available to read-only users. Changes are audited.
   */
  updateOfferAccessesForPublisher: Array<PublisherOfferView>;
  /**
   * Sets the same access state on every publisher-offer pair that matches the filter, across offers and publishers. Works like `updateOfferAccesses` for every matching pair and returns the resulting publisher-offer views. Use a narrow filter: an empty filter selects all pairs.
   *
   * Network (cockpit) users only; not available to read-only users. Changes are audited.
   */
  updateOfferAccessesForPublisherOffer: Array<PublisherOfferView>;
  /**
   * Replaces the definition of an existing offer batch operation. If the updated operation is an active one-time operation, its last execution time is cleared so that it runs again.
   *
   * Fails if the operation does not exist or the filters are invalid. Returns the updated operation. Network (cockpit) users only.
   */
  updateOfferBatchOperation: OfferBatchOperation;
  /** Updates offer flags */
  updateOfferFlags: OfferFlag;
  /** Updates offer integration configuration with third parties */
  updateOfferIntegration: OfferIntegration;
  /** Updates offer recencyperiod, fails if entry does not exist */
  updateOfferRecencyPeriod: OfferRecencyPeriod;
  /**
   * Updates your organization's profile and returns it: name, support email, legal entity, terms and conditions, privacy policy, white-label branding, domains and publisher billing details.
   *
   * `whiteLabel`, `domains` and `publisherBillingDetails` keep their current values when omitted; `termsAndConditions` and `privacyPolicy` are cleared when omitted. `type` cannot be changed through this mutation. Fails if a domain is already in use. Network (cockpit) users only; not available to read-only users.
   */
  updateOrganization: Organization;
  updateOrganizationIntegrationRequestStatus?: Maybe<OrganizationIntegrationRequest>;
  updateOrganizationRepresentative: OrganizationRepresentative;
  updateOrganizationRequest: OrganizationRequest;
  /**
   * Saves the account-wide settings of the publisher partner portal: terms and conditions, privacy policy, offer tag label, and which features publishers can use (offers, offer tags, events in reports, conversion report, support tickets, postback editing, dashboard offer metrics, smartlinks, referrals, smartlink feed exclusion). The stored settings are replaced by the supplied values.
   *
   * Returns the saved settings.
   */
  updatePartnerPublisherConfig: PartnerPublisherConfig;
  /**
   * Updates a payment request that is still in status `REQUESTED`, replacing its publisher, amount, period and publisher note; the payment stays `REQUESTED`. Returns the updated payment.
   *
   * Fails if the payment or publisher does not exist or the payment is no longer `REQUESTED`. Network (cockpit) users only.
   */
  updatePartnerPublisherPayment: PartnerPublisherPayment;
  /** Updates payout */
  updatePayout: Payout;
  /**
   * Changes an existing payout margin and returns it. The margin is a fraction: `theyGet = weGet × (1 − margin)`.
   *
   * Fails if no margin exists for the key or any id in the key does not exist. After saving, existing payouts in the affected scopes are recalculated. Network (cockpit) users only; not available to read-only users.
   */
  updatePayoutMargin: PayoutMargin;
  updatePayoutMargins: Array<PayoutMargin>;
  /** Partially updates the payout, only the theyGet will be set, the old weGet will be kept as is */
  updatePayoutTheyGet: Payout;
  /** Partially updates the payout, only the weGet will be set, the old weGet will be kept as is */
  updatePayoutWeGet: Payout;
  /**
   * Creates, updates or deletes several payouts in one atomic call and returns the resulting payouts. Each payout is identified by offer, optional publisher and optional event type. Amounts are decimals in the platform currency.
   *
   * - Setting both `weGet` and `theyGet` to null (and no `margin`) deletes the payout.
   * - When `margin` is set (a fraction, e.g. 0.2 for 20%), it is stored for that key and `theyGet` is derived from `weGet` (or from the offer-level `weGet` for publisher-specific payouts) as `weGet x (1 - margin)`.
   * - When `margin` is omitted, any margin stored for that key is removed.
   *
   * Fails if any referenced offer, publisher or event type does not exist. Network (cockpit) users only; not available to read-only users. Changes are audited.
   */
  updatePayouts: Array<Payout>;
  /** Update an existing modification of type edit */
  updatePostbackEditModification: PostbackModification;
  /**
   * Replaces an existing postback link with the given definition; fields not supplied are cleared or reset to their defaults. Returns the updated link. Fails if no link with that id exists, and applies the same validation as `createPostbackLink`.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  updatePostbackLink: PostbackLink;
  /** Updates postback shield rules */
  updatePostbackShieldRules: PostbackShieldRules;
  /**
   * Replaces an existing publisher with the given definition and returns it. Fields not supplied are cleared, except `invocaId`, which is kept when omitted; creation metadata and payment details are always preserved. Fails if the publisher does not exist.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  updatePublisher: Publisher;
  /**
   * Replaces the configuration of an existing publisher batch operation with the given input and returns the updated operation. Fields not supplied in the input are cleared.
   *
   * Saving an active one-time operation re-arms it so it runs again. The same validation as on create applies. Fails if the id does not exist. Network (cockpit) users only.
   */
  updatePublisherBatchOperation: PublisherBatchOperation;
  /**
   * Updates a publisher contact and returns it. All fields are replaced by the input.
   *
   * Switching `needsUser` from false to true creates a partner portal login and, if `sendEmails` is true (the default), emails the registration details. Switching it to false deactivates the linked login when no other contact uses it.
   *
   * Fails if the contact or the publisher does not exist. Network (cockpit) users only; not available to read-only users.
   */
  updatePublisherContact: PublisherContact;
  /** Updates existing publisher group member */
  updatePublisherGroupMember: PublisherGroupMember;
  /**
   * Updates a publisher's ad-platform integration settings (accounts and campaigns to sync). Authorization obtained earlier through OAuth is kept. A platform section left out of the input is removed from the integration.
   *
   * After saving, a campaign data sync is started right away for each platform present in the input. Returns the updated integration. Fails if the integration or the publisher does not exist.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  updatePublisherIntegration: PublisherIntegration;
  /** Updates publisher margin */
  updatePublisherMargin: PublisherMargin;
  /**
   * Replaces an existing publisher payment with the given values and returns it. Values not supplied are cleared.
   *
   * If invoice details are supplied without an invoice URL, the invoice PDF is (re)generated when its printed content changed; otherwise the existing invoice is kept. Fails if the payment or publisher does not exist. Network (cockpit) users only.
   */
  updatePublisherPayment: PublisherPayment;
  /** Sets the given status on every publisher payment that matches the filter and returns the updated payments. Returns an empty list when nothing matches. Network (cockpit) users only. */
  updatePublisherPaymentStatus?: Maybe<Array<PublisherPayment>>;
  /**
   * Replaces the settings and commission levels of an existing publisher referral plan with the given input. Returns the updated plan. Fails if the plan does not exist.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  updatePublisherReferralPlan: PublisherReferralPlan;
  /**
   * Replaces the user-identifier files of an existing retargeting file. Retargeting files hold lists of user identifiers (plain or SHA-256 hashed) that the user-identifier optimization rule of an offer matches traffic against.
   *
   * The new files are downloaded and processed synchronously; the previously processed data is discarded. The offer stays the one the retargeting file was created for: an `offerId` in the input is ignored. Fails if no retargeting file exists with the given id or if the files cannot be processed. Returns the updated retargeting file.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  updateRetargetingFile: RetargetingFile;
  /**
   * Updates the profile of the currently logged-in rewarded user: internal id, names, nickname, country, custom fields and referral id. All of these are replaced with the input values, so fields left out are cleared. The status cannot be changed with this mutation. Returns the updated profile.
   *
   * Only available on platforms with the rewarded product enabled, to the rewarded user themselves. Not available to read-only users.
   */
  updateRewardedUser: RewardedUser;
  /**
   * Changes the status of a rewarded user (active, pending or inactive) and returns the updated user. Other profile fields are unchanged.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  updateRewardedUserStatus: RewardedUser;
  /**
   * Sets a platform setting and returns it. Only the settings returned by the `serviceConfigs` query can be changed; any other service/key pair is rejected.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  updateServiceConfig: ServiceConfig;
  /**
   * Updates the profile of a specific rewarded user by id: internal id, names, nickname, country, custom fields, referral id and status. These values are replaced with the input, so fields left out are cleared. Returns the updated user. Fails if no rewarded user exists with the given id.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  updateSingleRewardedUser: RewardedUser;
  updateSmartLinkLandingPage: SmartLinkLandingPage;
  /**
   * Replaces the details of an existing store listing and returns it. If `storeAppIosIntegration` is omitted, the previously saved iOS integration credentials are kept.
   *
   * Fails if the store app or app does not exist. Network (cockpit) users only.
   */
  updateStoreApp: StoreApp;
  /**
   * Replaces the body of a message on a support ticket and returns the updated message. The message keeps its original time and is attributed to the calling user. If the ticket has no message with the given id, a new message with that id is added. Network (cockpit) users can edit any ticket; partner users only tickets they are the partner user of.
   *
   * Fails if the ticket does not exist.
   */
  updateSupportTicketMessage: SupportTicketMessage;
  /**
   * Replaces the settings of an existing targeted lead rule. The change is recorded against the calling user. Returns the updated rule. Fails if the rule does not exist.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  updateTargetedLead: TargetedLead;
  /**
   * Creates or updates a tracking rule customization: turns a tracking or fraud rule on or off and sets its parameters, either globally or for specific advertisers, offers and publishers. Without an `id` a new customization is created; with an `id` that customization is replaced. Parameters with a null value are dropped. Returns the saved customization.
   *
   * Network (cockpit) users only; not available to read-only users.
   */
  updateTrackingCustomizationRule: RuleCustomization;
  /**
   * Replaces the label, description, active flag and targeting rules of an existing traffic tag. The change applies to traffic received afterwards. Returns the updated tag. Fails if the tag does not exist.
   *
   * Network (cockpit) users only. Not available to read-only users.
   */
  updateTrafficTag: TrafficTag;
  /** Replaces an existing traffic targeting rule with the given values and returns it. Fails if no rule with the given id exists. Network (cockpit) users only. */
  updateTrafficTarget: TrafficTargeting;
  /**
   * Replaces the details of an existing user and returns the updated user. The cockpit-user role is always kept. Setting the status to INACTIVE disables the user's login; setting it back to ACTIVE re-enables it. `readOnly` keeps its current value when omitted.
   *
   * Fails if the user does not exist or the email is already used by another user. Non-admin users cannot change their own roles, and the roles of partner portal users cannot be changed.
   *
   * Admins only; not available to read-only users.
   */
  updateUser: User;
  /**
   * Updates a user's notification (memo) settings: per memo tag, whether it is active and how often emails are sent. Settings are merged by tag, so tags not included in the input keep their current settings.
   *
   * Fails if the user does not exist. Returns the user's complete settings after the update.
   */
  updateUserSettings: UserSettings;
  /**
   * Uploads a file (GraphQL multipart request) and returns its URL, for use in other fields such as creatives, logos or CSV imports. The file is stored under a random name that keeps the original extension.
   *
   * With `isPublic: true` the returned URL is publicly readable. Otherwise the file is served through your platform's own domain. Fails if the file is missing or empty. Network (cockpit) users only; not available to read-only users.
   */
  upload: UploadResult;
  /** Create or updates a user based on the email */
  upsertUser: User;
  voidAdvertiserInvoice: AdvertiserInvoice;
};


export type MutationAddAdvertiserInvoicePaymentArgs = {
  id: Scalars['String']['input'];
  input: AdvertiserInvoicePaymentInput;
};


export type MutationAddAdvertiserTagsArgs = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  preApproved?: InputMaybe<Scalars['Boolean']['input']>;
  tags: Array<Scalars['String']['input']>;
};


export type MutationAddOfferTagsArgs = {
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  preApproved?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationAddPublisherTagsArgs = {
  preApproved?: InputMaybe<Scalars['Boolean']['input']>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tags: Array<Scalars['String']['input']>;
};


export type MutationAdminChangePasswordArgs = {
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationApproveImportedOfferArgs = {
  id: Scalars['String']['input'];
};


export type MutationAuditsUndoArgs = {
  filter?: InputMaybe<AuditFilter>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationChangePasswordArgs = {
  input: AuthChangePasswordInput;
};


export type MutationChangePasswordNewUserArgs = {
  input: AuthChangePasswordNewUserInput;
};


export type MutationChangeSupportTicketStatusArgs = {
  id: Scalars['String']['input'];
  status?: InputMaybe<SupportTicketStatus>;
};


export type MutationCloneOfferArgs = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  fieldToClone: Array<OfferCloneField>;
  offerId: Scalars['String']['input'];
};


export type MutationCloseRewardedSupportTicketArgs = {
  ticketId: Scalars['String']['input'];
};


export type MutationCompleteAccountMigrationArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationCreateAdKeywordImportSpecArgs = {
  input: AdKeywordImportSpecInput;
};


export type MutationCreateAdvancedTargetingArgs = {
  advancedTargetingInput: AdvancedTargetingInput;
};


export type MutationCreateAdvancedTargetingValueBundleArgs = {
  input: AdvancedTargetingValueBundleInput;
};


export type MutationCreateAdvertiserArgs = {
  input: AdvertiserInput;
};


export type MutationCreateAdvertiserBatchOperationArgs = {
  input: AdvertiserBatchOperationInput;
};


export type MutationCreateAdvertiserBlockedPublisherArgs = {
  input: AdvertiserBlockedPublisherInput;
};


export type MutationCreateAdvertiserConfigArgs = {
  input: AdvertiserConfigInput;
};


export type MutationCreateAdvertiserContactArgs = {
  input: AdvertiserContactInput;
};


export type MutationCreateAdvertiserCouponArgs = {
  input: AdvertiserCouponInput;
};


export type MutationCreateAdvertiserInvoiceArgs = {
  input: AdvertiserInvoiceInput;
};


export type MutationCreateAdvertiserInvoiceDraftsArgs = {
  advertiserIds: Array<Scalars['String']['input']>;
  end: Scalars['LocalDate']['input'];
  start: Scalars['LocalDate']['input'];
};


export type MutationCreateAdvertiserReportImportSpecArgs = {
  input: AdvertiserReportImportSpecInput;
};


export type MutationCreateAdvertiserReportImportTaskArgs = {
  input: AdvertiserReportImportTaskInput;
};


export type MutationCreateAppArgs = {
  input: AppInput;
};


export type MutationCreateAppEventTypeArgs = {
  input: AppEventTypeInput;
};


export type MutationCreateAppTokenArgs = {
  input: AppTokenInput;
};


export type MutationCreateAutoApprovalConfigArgs = {
  input: AutoApprovalConfigInput;
};


export type MutationCreateAutomationRuleArgs = {
  input: AutomationRuleInput;
};


export type MutationCreateBlacklistedSubIdArgs = {
  input: BlacklistedSubIdInput;
};


export type MutationCreateBlacklistedSubIdsArgs = {
  input: Array<BlacklistedSubIdInput>;
};


export type MutationCreateBudgetArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  key: BudgetKey;
};


export type MutationCreateClickBudgetArgs = {
  input: ClickBudgetInput;
};


export type MutationCreateClickShieldRulesArgs = {
  input: ClickShieldRulesInput;
};


export type MutationCreateEvaluatedPostbackArgs = {
  input: EvaluatedPostbackInput;
  numberOfPostbacksToCreate: Scalars['Int']['input'];
};


export type MutationCreateEventTypeArgs = {
  eventTypeInput: EventTypeInput;
};


export type MutationCreateFeedApiConfigurationArgs = {
  input: FeedApiConfigurationInput;
};


export type MutationCreateFillerArgs = {
  input: FillerInput;
};


export type MutationCreateFormArgs = {
  input: FormInput;
};


export type MutationCreateFormSubmissionArgs = {
  input: FormResultInput;
};


export type MutationCreateImpressionBudgetArgs = {
  input: ImpressionBudgetInput;
};


export type MutationCreateKpiArgs = {
  input?: InputMaybe<KpiInput>;
};


export type MutationCreateLandingPageArgs = {
  input: LandingPageInput;
};


export type MutationCreateLeadForwardingEndpointArgs = {
  input: LeadForwardingEndpointInput;
};


export type MutationCreateMarketplaceOrganizationArgs = {
  input: MarketplaceOrganizationInput;
};


export type MutationCreateOfferArgs = {
  input: OfferInput;
};


export type MutationCreateOfferAccessArgs = {
  input: OfferAccess;
};


export type MutationCreateOfferBatchOperationArgs = {
  input: OfferBatchOperationInput;
};


export type MutationCreateOfferFlagsArgs = {
  flags: Array<Scalars['String']['input']>;
  offerId: Scalars['String']['input'];
};


export type MutationCreateOfferForPublisherNotificationArgs = {
  input: OfferForPublisherNotificationInput;
};


export type MutationCreateOfferIntegrationArgs = {
  input: OfferIntegrationInput;
};


export type MutationCreateOfferNotificationArgs = {
  input: OfferNotificationInput;
};


export type MutationCreateOfferRecencyPeriodArgs = {
  offerId: Scalars['String']['input'];
  period: Scalars['Int']['input'];
};


export type MutationCreateOrganizationIntegrationRequestArgs = {
  input?: InputMaybe<OrganizationIntegrationRequestInput>;
};


export type MutationCreateOrganizationRepresentativeArgs = {
  input: OrganizationRepresentativeInput;
};


export type MutationCreateOrganizationRequestArgs = {
  input: OrganizationRequestInput;
};


export type MutationCreatePayoutArgs = {
  key: PayoutKey;
  margin?: InputMaybe<Scalars['Float']['input']>;
  theyGet?: InputMaybe<Scalars['Float']['input']>;
  theyGetPoints?: InputMaybe<Scalars['Float']['input']>;
  weGet?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationCreatePayoutMarginArgs = {
  key: PayoutMarginKey;
  margin: Scalars['Float']['input'];
};


export type MutationCreatePostbackLinkArgs = {
  input: PostbackLinkInput;
};


export type MutationCreatePostbackModificationsArgs = {
  end?: InputMaybe<Scalars['LocalDateTime']['input']>;
  filters?: InputMaybe<Array<ConversionReportFilter>>;
  firePostbacks?: InputMaybe<Scalars['Boolean']['input']>;
  input: PostbackEditModificationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  postbackIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<ConversionReportSort>;
  start?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type MutationCreatePostbackShieldRulesArgs = {
  input: PostbackShieldRulesInput;
};


export type MutationCreatePublisherArgs = {
  input: PublisherInput;
};


export type MutationCreatePublisherBatchOperationArgs = {
  input: PublisherBatchOperationInput;
};


export type MutationCreatePublisherContactArgs = {
  input: PublisherContactInput;
};


export type MutationCreatePublisherGroupMemberArgs = {
  input: PublisherGroupMemberInput;
};


export type MutationCreatePublisherIntegrationArgs = {
  input: PublisherIntegrationInput;
};


export type MutationCreatePublisherKeyArgs = {
  input: PublisherKeyInput;
};


export type MutationCreatePublisherMarginArgs = {
  input: PublisherMarginInput;
};


export type MutationCreatePublisherNotificationArgs = {
  input: PublisherNotificationInput;
};


export type MutationCreatePublisherPaymentArgs = {
  input: PublisherPaymentInput;
};


export type MutationCreatePublisherReferralPlanArgs = {
  input: PublisherReferralPlanInput;
};


export type MutationCreatePushNotificationArgs = {
  audienceId: Scalars['String']['input'];
  body: Scalars['String']['input'];
  deepLinkEntityId?: InputMaybe<Scalars['String']['input']>;
  deepLinkType?: InputMaybe<PushNotificationDeepLinkType>;
  time: Scalars['LocalDateTime']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateRetargetingFileArgs = {
  input: RetargetingFileInput;
};


export type MutationCreateRewardedSupportTicketArgs = {
  ticket: RewardedUserSupportTicketInput;
};


export type MutationCreateRewardedSupportTicketMessageArgs = {
  message: RewardedUserSupportTicketMessageInput;
  ticketId: Scalars['String']['input'];
};


export type MutationCreateRewardedUserArgs = {
  input: RewardedUserInput;
};


export type MutationCreateSavedRawQueryArgs = {
  input: SavedRawQueryInput;
};


export type MutationCreateScheduledChangeArgs = {
  input: ScheduledChangeInput;
};


export type MutationCreateSmartLinkLandingPageArgs = {
  input: SmartLinkLandingPageInput;
};


export type MutationCreateStoreAppArgs = {
  input: StoreAppInput;
};


export type MutationCreateSupportTicketMessageArgs = {
  id: Scalars['String']['input'];
  input: SupportTicketMessageInput;
};


export type MutationCreateTargetedLeadArgs = {
  input: TargetedLeadInput;
};


export type MutationCreateTipaltiPaymentsArgs = {
  filter: PublisherPaymentFilter;
};


export type MutationCreateTrafficTagArgs = {
  input: TrafficTagInput;
};


export type MutationCreateTrafficTargetArgs = {
  input: TrafficTargetingInput;
};


export type MutationCreateUserArgs = {
  input: UserInput;
  user: UserInput;
};


export type MutationDeleteAdKeywordImportSpecArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAdvancedTargetingArgs = {
  offerId: Scalars['String']['input'];
};


export type MutationDeleteAdvancedTargetingValueBundleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAdvertiserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAdvertiserBatchOperationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAdvertiserBlockedPublisherArgs = {
  input: AdvertiserBlockedPublisherInput;
};


export type MutationDeleteAdvertiserConfigArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAdvertiserContactArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAdvertiserCouponArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAdvertiserInvoiceArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAdvertiserRebateArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAdvertiserReportImportSpecArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAdvertiserReportImportTaskArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAdvertiserSecurityTokenArgs = {
  advertiserId: Scalars['String']['input'];
};


export type MutationDeleteAdvertiserTagsArgs = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  preApproved?: InputMaybe<Scalars['Boolean']['input']>;
  tags: Array<Scalars['String']['input']>;
};


export type MutationDeleteAppArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAppEventTypeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAppTokenArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAppsflyerMediaSourceMappingArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAttributionExpirationArgs = {
  key: AttributionExpirationKey;
};


export type MutationDeleteAudienceArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAutoApprovalConfigArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAutomationRuleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteBlacklistedSubIdArgs = {
  input: BlacklistedSubIdKey;
};


export type MutationDeleteBlacklistedSubIdsArgs = {
  input: Array<BlacklistedSubIdKey>;
};


export type MutationDeleteBlacklistedSubIdsV2Args = {
  filter?: InputMaybe<BlacklistedSubIdsFilter>;
};


export type MutationDeleteBudgetArgs = {
  key: BudgetKey;
};


export type MutationDeleteClickBudgetArgs = {
  id: ClickBudgetId;
};


export type MutationDeleteClickShieldRulesArgs = {
  id: ClickShieldRulesKey;
};


export type MutationDeleteControlledAccessObjectsArgs = {
  filter: ControlledAccessObjectFilter;
};


export type MutationDeleteCreativeArgs = {
  creativeId: Scalars['String']['input'];
  creativePackId: Scalars['String']['input'];
};


export type MutationDeleteCreativePackArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDomainCustomizationArgs = {
  input: DomainCustomizationInput;
};


export type MutationDeleteEventLogFileArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteEventTypeArgs = {
  eventTypeId: Scalars['String']['input'];
};


export type MutationDeleteEventValueExtractionRuleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFeedApiConfigurationArgs = {
  publisherId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteFillerArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFormArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFormSubmissionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteImpressionBudgetArgs = {
  id: ImpressionBudgetId;
};


export type MutationDeleteKpiArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteLandingPageArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteLeadArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteLeadForwardingEndpointArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteLeadsArgs = {
  input: DeleteLeadsInput;
};


export type MutationDeleteMarketplaceOrganizationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOfferArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOfferAccessArgs = {
  input: OfferAccessKey;
};


export type MutationDeleteOfferAccessesArgs = {
  input: Array<OfferAccessKey>;
};


export type MutationDeleteOfferBatchOperationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOfferFlagsArgs = {
  offerId: Scalars['String']['input'];
};


export type MutationDeleteOfferIntegrationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOfferRecencyPeriodArgs = {
  offerId: Scalars['String']['input'];
};


export type MutationDeleteOfferTagsArgs = {
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  preApproved?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationDeleteOrganizationIntegrationRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOrganizationRepresentativeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteOrganizationRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePartnerPublisherPaymentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePayoutArgs = {
  key: PayoutKey;
};


export type MutationDeletePayoutConversionPolicyArgs = {
  advertiserId: Scalars['String']['input'];
};


export type MutationDeletePayoutMarginArgs = {
  key: PayoutMarginKey;
};


export type MutationDeletePostbackLinkArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePostbackModificationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePostbackShieldRulesArgs = {
  id: PostbackShieldRulesKey;
};


export type MutationDeleteProductArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePubGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePublisherArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePublisherBatchOperationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePublisherContactArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePublisherGroupMemberArgs = {
  id: PublisherGroupMemberId;
};


export type MutationDeletePublisherIntegrationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePublisherKeyArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePublisherMarginArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePublisherPaymentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePublisherReferralPlanArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePublisherTagsArgs = {
  preApproved?: InputMaybe<Scalars['Boolean']['input']>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tags: Array<Scalars['String']['input']>;
};


export type MutationDeletePushNotificationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteRealtimeIntegrationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteRecommendationSmartLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRetargetingFileArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteRewardOsAppArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSkAdMappingArgs = {
  id?: InputMaybe<SkAdMappingKey>;
};


export type MutationDeleteSkAdNetworkArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSkAdPostbackLinkArgs = {
  id?: InputMaybe<SkAdPostbackLinkKey>;
};


export type MutationDeleteSanForwardingSettingsArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSavedRawQueryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteScheduledChangeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSdkTrackedBreakpointArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSearchIntegrationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSmartLinkLandingPageArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteStoreAppArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteStoreAppFacebookInstallReferrerDecryptionKeyArgs = {
  storeAppId: Scalars['String']['input'];
};


export type MutationDeleteSupportTicketArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTargetedLeadArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTargetedPayoutArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTrackingCustomizationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTrafficTagArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTrafficTargetArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationExecuteFilePostbackModificationArgs = {
  input: PostbackModificationFileInstructionsInput;
};


export type MutationFirePublisherPostbacksArgs = {
  end?: InputMaybe<Scalars['LocalDateTime']['input']>;
  filters?: InputMaybe<Array<ConversionReportFilter>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  postbackIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<ConversionReportSort>;
  start?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type MutationForgotPasswordRequestArgs = {
  email: Scalars['String']['input'];
};


export type MutationForwardLeadsArgs = {
  input: LeadForwardingRequestInput;
};


export type MutationGenerateAdvertiserSecurityTokenArgs = {
  advertiserId: Scalars['String']['input'];
};


export type MutationGenerateEventLogFileArgs = {
  input: EventLogFileSpecInput;
};


export type MutationGeneratePublisherPaymentsArgs = {
  end: Scalars['LocalDateTime']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  smartPaymentCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  start: Scalars['LocalDateTime']['input'];
  threshold?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationImportAppsflyerDataArgs = {
  from: Scalars['LocalDate']['input'];
  offerId: Scalars['String']['input'];
};


export type MutationImportPayoutEditCsvArgs = {
  url: Scalars['String']['input'];
};


export type MutationIssueAdvertiserInvoiceArgs = {
  id: Scalars['String']['input'];
};


export type MutationIssueContactLoginCodeArgs = {
  userId: Scalars['String']['input'];
};


export type MutationLeadImportArgs = {
  input: LeadImportInput;
};


export type MutationLoginArgs = {
  input: AuthLoginInput;
};


export type MutationLoginWithCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationMarkMemosAsReadArgs = {
  filter?: InputMaybe<MemoFilter>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  read: Scalars['Boolean']['input'];
};


export type MutationMarkOffersForMarketplaceArgs = {
  exportable?: Scalars['Boolean']['input'];
  filter: OfferFilter;
  marketplaceOrganizationId: Scalars['String']['input'];
};


export type MutationOfferBatchUpdateArgs = {
  fieldsToUpdate?: InputMaybe<OfferFieldsToUpdateInput>;
  filter?: InputMaybe<OfferFilter>;
  ids: Array<Scalars['String']['input']>;
};


export type MutationPartnerPublisherCreatePostbackLinkArgs = {
  input: PostbackLinkInput;
};


export type MutationPartnerPublisherDeletePostbackLinkArgs = {
  id: Scalars['String']['input'];
};


export type MutationPartnerPublisherRequestApprovalArgs = {
  offerId: Scalars['String']['input'];
  publisherId: Scalars['String']['input'];
};


export type MutationPartnerPublisherUpdatePostbackLinkArgs = {
  id: Scalars['String']['input'];
  input: PostbackLinkInput;
};


export type MutationRecomputeRewardedUserFraudScoreArgs = {
  id: Scalars['String']['input'];
};


export type MutationRefreshAdvertiserInvoiceLinesArgs = {
  id: Scalars['String']['input'];
};


export type MutationRefreshTokenArgs = {
  input: AuthRefreshTokenInput;
};


export type MutationRegenerateAdvertiserInvoicePdfArgs = {
  id: Scalars['String']['input'];
};


export type MutationRegisterThirdPartyOrganizationArgs = {
  organization: MarketplaceOrganizationInput;
  representative?: InputMaybe<NewOrganizationRepresentativeInput>;
};


export type MutationRemoveAdvertiserInvoicePaymentArgs = {
  id: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};


export type MutationRequestAccountMigrationArgs = {
  email: Scalars['String']['input'];
};


export type MutationRequestLoginCodeArgs = {
  email: Scalars['String']['input'];
};


export type MutationRequestPublisherPaymentArgs = {
  input: PartnerPublisherPaymentInput;
};


export type MutationRequestRewardedUserPaymentArgs = {
  input: PartnerPublisherPaymentInput;
};


export type MutationResetLoginBlockArgs = {
  email: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationRewardOsCashOutArgs = {
  points: Scalars['Float']['input'];
};


export type MutationRewardOsPreviewSessionArgs = {
  appId: Scalars['String']['input'];
  rewardedUserId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRewardOsSetEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationRewardOsSpendPointsArgs = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  points: Scalars['Float']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRewardOsStartSessionArgs = {
  input: RewardOsSessionInput;
};


export type MutationRewardOsVerifyEmailArgs = {
  code: Scalars['String']['input'];
};


export type MutationRewardedAppOpenArgs = {
  input: RewardUserOpenEvent;
};


export type MutationRewardedCreateSupportTicketArgs = {
  ticket?: InputMaybe<RewardedUserSupportTicketInput>;
};


export type MutationRewardedCreateSupportTicketMessageArgs = {
  message: RewardedUserSupportTicketMessageInput;
  ticketId: Scalars['String']['input'];
};


export type MutationRewardedReadSupportTicketArgs = {
  messageIds: Array<Scalars['String']['input']>;
  ticketId: Scalars['String']['input'];
};


export type MutationRewardedRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationRewardedResetPasswordArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationRewardedSelectTutorialOfferArgs = {
  offerId: Scalars['String']['input'];
};


export type MutationRewardedSocialLoginArgs = {
  input: RewardedSocialLoginInput;
};


export type MutationRewardedTrackEventsArgs = {
  events: Array<RewardedUserEventInput>;
};


export type MutationRewardedTriggerVerificationEmailArgs = {
  id: Scalars['String']['input'];
};


export type MutationRewardedTriggerVerificationEmailByEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationRewardedUploadSupportTicketAttachmentArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationRewardedUploadSupportTicketAttachmentBase64Args = {
  content: Scalars['String']['input'];
};


export type MutationRewardedVerifyEmailArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationRotateRewardOsAppSecretArgs = {
  id: Scalars['String']['input'];
  secret: RewardOsSecretKind;
};


export type MutationRunSearchIntegrationArgs = {
  advertiserId: Scalars['String']['input'];
  end: Scalars['LocalDateTime']['input'];
  start: Scalars['LocalDateTime']['input'];
};


export type MutationSaveAdjustUploadConfigArgs = {
  input: AdjustUploadConfigInput;
};


export type MutationSaveAdvertiserBillingProfileArgs = {
  advertiserId: Scalars['String']['input'];
  input: AdvertiserBillingProfileInput;
};


export type MutationSaveAdvertiserInvoiceSettingsArgs = {
  input: AdvertiserInvoiceSettingsInput;
};


export type MutationSaveAdvertiserNetworkRelationshipArgs = {
  input: AdvertiserNetworkRelationshipInput;
};


export type MutationSaveAdvertiserRebateArgs = {
  input: AdvertiserRebateInput;
};


export type MutationSaveAppsflyerClickSigningConfigArgs = {
  input: AppsflyerClickSigningConfigInput;
};


export type MutationSaveAppsflyerMediaSourceMappingArgs = {
  input: AppsflyerMediaSourceMappingInput;
};


export type MutationSaveAppsflyerMediaSourceMappingsArgs = {
  input: Array<AppsflyerMediaSourceMappingInput>;
};


export type MutationSaveAppsflyerNetworkCostUploadTokenArgs = {
  input: AppsflyerNetworkCostUploadTokenInput;
};


export type MutationSaveAppsflyerOfferConfigArgs = {
  config?: InputMaybe<AppsflyerOfferConfigInput>;
  offerId: Scalars['String']['input'];
};


export type MutationSaveAppsflyerOfferTokensArgs = {
  tokens?: InputMaybe<Array<AppsflyerOfferTokenInput>>;
};


export type MutationSaveAppsflyerPublisherConfigArgs = {
  config?: InputMaybe<AppsflyerPublisherConfigInput>;
  id: Scalars['String']['input'];
};


export type MutationSaveAppsflyerUploadConfigArgs = {
  input: AppsflyerUploadConfigInput;
};


export type MutationSaveAttributionExpirationArgs = {
  input: AttributionExpirationInput;
};


export type MutationSaveAudienceArgs = {
  input: AudienceInput;
};


export type MutationSaveBudgetTimezoneArgs = {
  offerId: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveControlledAccessObjectsArgs = {
  input: Array<ControlledAccessObjectInput>;
};


export type MutationSaveCreativeArgs = {
  id: Scalars['String']['input'];
  input: CreativeInput;
};


export type MutationSaveCreativePackArgs = {
  input: CreativePackInput;
};


export type MutationSaveCreativesArgs = {
  id: Scalars['String']['input'];
  input: Array<CreativeInput>;
};


export type MutationSaveDomainCustomizationArgs = {
  input: DomainCustomizationInput;
};


export type MutationSaveEventValueExtractionRuleArgs = {
  input: EventValueExtractionRuleInput;
};


export type MutationSaveMarketplacePostbackLinkArgs = {
  input: MarketplacePostbackLinkInput;
};


export type MutationSavePayoutConversionPolicyArgs = {
  input: PayoutConversionPolicyInput;
};


export type MutationSavePayoutV2Args = {
  input: PayoutV2Input;
};


export type MutationSavePayoutsV2Args = {
  input: Array<PayoutV2Input>;
};


export type MutationSavePermissionConfigArgs = {
  permissions: PermissionConfigInput;
};


export type MutationSavePointsExchangeRateArgs = {
  publisherId: Scalars['String']['input'];
  rate?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationSavePreApprovedAdvertiserTagsArgs = {
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSavePreApprovedPublisherTagsArgs = {
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSavePubGroupArgs = {
  input: PubGroupInput;
};


export type MutationSavePublisherPaymentDetailsArgs = {
  input: PublisherPaymentDetailsInput;
};


export type MutationSavePublisherPaymentSchedulerSettingsArgs = {
  input: PublisherPaymentSchedulerSettingsInput;
};


export type MutationSaveRealtimeIntegrationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  input: RealtimeIntegrationInput;
};


export type MutationSaveRecommendationSmartLinkArgs = {
  input: SmartRecommendationLinkInput;
};


export type MutationSaveRewardOsAppArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  input: RewardOsAppInput;
};


export type MutationSaveSkAdMappingArgs = {
  input: SkAdMappingInput;
};


export type MutationSaveSkAdNetworkArgs = {
  input: SkAdNetworkInput;
};


export type MutationSaveSkAdPostbackLinkArgs = {
  input: SkAdPostbackLinkInput;
};


export type MutationSaveSanForwardingSettingsArgs = {
  input: SanForwardingSettingsInput;
};


export type MutationSaveSavedRawQueryArgs = {
  input: SavedRawQueryInput;
};


export type MutationSaveSdkBreakpointCollectorAppSetIdsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSaveSdkTrackedBreakpointArgs = {
  input: SdkTrackedBreakpointInput;
};


export type MutationSaveSearchIntegrationArgs = {
  advertiserId: Scalars['String']['input'];
  input: SearchIntegrationInput;
};


export type MutationSaveSmartLinkManualWeightsArgs = {
  id: Scalars['String']['input'];
  manualWeights: Array<OfferWithWeightInput>;
};


export type MutationSaveStoreAppFacebookInstallReferrerDecryptionKeyArgs = {
  input: StoreAppFacebookInstallReferrerDecryptionKeyInput;
};


export type MutationSaveSupportTicketArgs = {
  input: SupportTicketInput;
};


export type MutationSaveTargetedPayoutArgs = {
  input: TargetedPayoutInput;
};


export type MutationSaveTargetedPayoutsArgs = {
  input?: InputMaybe<Array<TargetedPayoutInput>>;
};


export type MutationSendAdjustCostEmailArgs = {
  from?: InputMaybe<Scalars['LocalDate']['input']>;
  offerId: Scalars['String']['input'];
  to?: InputMaybe<Scalars['LocalDate']['input']>;
};


export type MutationSendAdvertiserInvoiceArgs = {
  id: Scalars['String']['input'];
  input: AdvertiserInvoiceSendInput;
};


export type MutationSendRewardedTestEmailArgs = {
  body: Scalars['String']['input'];
  recipient?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};


export type MutationSetupOrganizationRecurringMolliePaymentArgs = {
  input: OrganizationRecurringPaymentMethodMollieInput;
};


export type MutationTestPublisherIntegrationArgs = {
  eventTypeId?: InputMaybe<Scalars['String']['input']>;
  offerId: Scalars['String']['input'];
  trackingUrl: Scalars['String']['input'];
};


export type MutationTestRealtimeIntegrationArgs = {
  id: Scalars['String']['input'];
};


export type MutationTriggerAdvertiserBatchOperationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggerAdvertiserConfigSyncArgs = {
  id: Scalars['String']['input'];
};


export type MutationTriggerKpiArgs = {
  first: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  preview: Scalars['Boolean']['input'];
};


export type MutationTriggerOfferBatchOperationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggerPublisherBatchOperationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnbanUsersArgs = {
  input: UnbanUsersInput;
};


export type MutationUndoAdvertiserReportImportTaskArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateAdKeywordImportSpecArgs = {
  id: Scalars['String']['input'];
  input: AdKeywordImportSpecInput;
};


export type MutationUpdateAdvancedTargetingArgs = {
  advancedTargetingInput: AdvancedTargetingInput;
};


export type MutationUpdateAdvancedTargetingValueBundleArgs = {
  id: Scalars['String']['input'];
  input: AdvancedTargetingValueBundleInput;
};


export type MutationUpdateAdvertiserArgs = {
  id: Scalars['String']['input'];
  input: AdvertiserInput;
};


export type MutationUpdateAdvertiserBatchOperationArgs = {
  id: Scalars['String']['input'];
  input: AdvertiserBatchOperationInput;
};


export type MutationUpdateAdvertiserConfigArgs = {
  id: Scalars['String']['input'];
  input: AdvertiserConfigInput;
};


export type MutationUpdateAdvertiserConfigSyncArgs = {
  id: Scalars['String']['input'];
  sync: Scalars['Boolean']['input'];
};


export type MutationUpdateAdvertiserContactArgs = {
  id: Scalars['String']['input'];
  input: AdvertiserContactInput;
};


export type MutationUpdateAdvertiserCouponArgs = {
  id: Scalars['String']['input'];
  input: AdvertiserCouponInput;
};


export type MutationUpdateAdvertiserInvoiceArgs = {
  id: Scalars['String']['input'];
  input: AdvertiserInvoiceInput;
};


export type MutationUpdateAdvertiserReportImportSpecArgs = {
  id: Scalars['String']['input'];
  input: AdvertiserReportImportSpecInput;
};


export type MutationUpdateAppArgs = {
  id: Scalars['String']['input'];
  input: AppInput;
};


export type MutationUpdateAppEventTypeArgs = {
  id: Scalars['String']['input'];
  input: AppEventTypeInput;
};


export type MutationUpdateAppTokenArgs = {
  id: Scalars['String']['input'];
  input: AppTokenInput;
};


export type MutationUpdateAutoApprovalConfigArgs = {
  input: AutoApprovalConfigInput;
};


export type MutationUpdateAutomationRuleArgs = {
  input: AutomationRuleInput;
};


export type MutationUpdateBigQueryExportConfigArgs = {
  input: BigQueryExportConfigInput;
};


export type MutationUpdateBudgetArgs = {
  amount: Scalars['Float']['input'];
  key: BudgetKey;
};


export type MutationUpdateBudgetsArgs = {
  budgets: Array<BudgetInput>;
};


export type MutationUpdateClickBudgetArgs = {
  amount: Scalars['Float']['input'];
  id?: InputMaybe<ClickBudgetId>;
};


export type MutationUpdateClickShieldRulesArgs = {
  id: ClickShieldRulesKey;
  input: ClickShieldRulesInput;
};


export type MutationUpdateEventTypeArgs = {
  eventTypeId?: InputMaybe<Scalars['String']['input']>;
  eventTypeInput: EventTypeInput;
};


export type MutationUpdateFeedApiConfigurationArgs = {
  input: FeedApiConfigurationInput;
};


export type MutationUpdateFillerArgs = {
  id: Scalars['String']['input'];
  input: FillerInput;
};


export type MutationUpdateFormArgs = {
  input: FormInput;
};


export type MutationUpdateFormSubmissionArgs = {
  input: FormResultInput;
};


export type MutationUpdateFraudPolicyConfigArgs = {
  input: FraudPolicyConfigInput;
};


export type MutationUpdateGeneralMigrationStateArgs = {
  syncing?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateImpressionBudgetArgs = {
  amount: Scalars['Float']['input'];
  id?: InputMaybe<ImpressionBudgetId>;
};


export type MutationUpdateKpiArgs = {
  id: Scalars['String']['input'];
  input?: InputMaybe<KpiInput>;
};


export type MutationUpdateLandingPageArgs = {
  input: LandingPageInput;
};


export type MutationUpdateLeadForwardingEndpointArgs = {
  id: Scalars['String']['input'];
  input: LeadForwardingEndpointInput;
};


export type MutationUpdateMarketplaceOrganizationArgs = {
  id: Scalars['String']['input'];
  input: MarketplaceOrganizationInput;
};


export type MutationUpdateMemoArgs = {
  id: Scalars['String']['input'];
  input: MemoInput;
};


export type MutationUpdateMigrationStateArgs = {
  advertiserId: Scalars['String']['input'];
  syncing: Scalars['Boolean']['input'];
};


export type MutationUpdateOfferArgs = {
  id: Scalars['String']['input'];
  input: OfferInput;
};


export type MutationUpdateOfferAccessArgs = {
  input: OfferAccess;
};


export type MutationUpdateOfferAccessesArgs = {
  input: Array<OfferAccess>;
};


export type MutationUpdateOfferAccessesForOfferArgs = {
  filter?: InputMaybe<OfferToPublisherFilter>;
  offerId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  state: OfferAccessInputState;
};


export type MutationUpdateOfferAccessesForPublisherArgs = {
  filter?: InputMaybe<PublisherToOfferFilter>;
  publisherId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  state: OfferAccessInputState;
};


export type MutationUpdateOfferAccessesForPublisherOfferArgs = {
  filter?: InputMaybe<PublisherOfferFilter>;
  reason?: InputMaybe<Scalars['String']['input']>;
  state: OfferAccessInputState;
};


export type MutationUpdateOfferBatchOperationArgs = {
  id: Scalars['String']['input'];
  input: OfferBatchOperationInput;
};


export type MutationUpdateOfferFlagsArgs = {
  flags: Array<Scalars['String']['input']>;
  offerId: Scalars['String']['input'];
};


export type MutationUpdateOfferIntegrationArgs = {
  id: Scalars['String']['input'];
  input: OfferIntegrationInput;
};


export type MutationUpdateOfferRecencyPeriodArgs = {
  offerId: Scalars['String']['input'];
  period: Scalars['Int']['input'];
};


export type MutationUpdateOrganizationArgs = {
  input: OrganizationInput;
};


export type MutationUpdateOrganizationIntegrationRequestStatusArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  status: OrganizationIntegrationRequestStatus;
};


export type MutationUpdateOrganizationRepresentativeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  input: OrganizationRepresentativeInput;
};


export type MutationUpdateOrganizationRequestArgs = {
  id: Scalars['String']['input'];
  input: OrganizationRequestInput;
};


export type MutationUpdatePartnerPublisherConfigArgs = {
  input: PartnerPublisherConfigInput;
};


export type MutationUpdatePartnerPublisherPaymentArgs = {
  id: Scalars['String']['input'];
  input: PartnerPublisherPaymentInput;
};


export type MutationUpdatePayoutArgs = {
  key: PayoutKey;
  margin?: InputMaybe<Scalars['Float']['input']>;
  theyGet?: InputMaybe<Scalars['Float']['input']>;
  theyGetPoints?: InputMaybe<Scalars['Float']['input']>;
  weGet?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdatePayoutMarginArgs = {
  key: PayoutMarginKey;
  margin: Scalars['Float']['input'];
};


export type MutationUpdatePayoutMarginsArgs = {
  margins: Array<PayoutMarginInput>;
};


export type MutationUpdatePayoutTheyGetArgs = {
  key: PayoutKey;
  theyGet?: InputMaybe<Scalars['Float']['input']>;
  theyGetPoints?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdatePayoutWeGetArgs = {
  key: PayoutKey;
  weGet?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdatePayoutsArgs = {
  payouts: Array<PayoutInput>;
};


export type MutationUpdatePostbackEditModificationArgs = {
  input: PostbackEditModificationInput;
};


export type MutationUpdatePostbackLinkArgs = {
  id: Scalars['String']['input'];
  input: PostbackLinkInput;
};


export type MutationUpdatePostbackShieldRulesArgs = {
  id: PostbackShieldRulesKey;
  input: PostbackShieldRulesInput;
};


export type MutationUpdatePublisherArgs = {
  id: Scalars['String']['input'];
  input: PublisherInput;
};


export type MutationUpdatePublisherBatchOperationArgs = {
  id: Scalars['String']['input'];
  input: PublisherBatchOperationInput;
};


export type MutationUpdatePublisherContactArgs = {
  id: Scalars['String']['input'];
  input: PublisherContactInput;
};


export type MutationUpdatePublisherGroupMemberArgs = {
  input: PublisherGroupMemberInput;
};


export type MutationUpdatePublisherIntegrationArgs = {
  id: Scalars['String']['input'];
  input: PublisherIntegrationInput;
};


export type MutationUpdatePublisherMarginArgs = {
  input: PublisherMarginInput;
};


export type MutationUpdatePublisherPaymentArgs = {
  id: Scalars['String']['input'];
  input: PublisherPaymentInput;
};


export type MutationUpdatePublisherPaymentStatusArgs = {
  filter: PublisherPaymentFilter;
  status: PublisherPaymentStatus;
};


export type MutationUpdatePublisherReferralPlanArgs = {
  id: Scalars['String']['input'];
  input: PublisherReferralPlanInput;
};


export type MutationUpdateRetargetingFileArgs = {
  id: Scalars['String']['input'];
  input: RetargetingFileInput;
};


export type MutationUpdateRewardedUserArgs = {
  input: RewardedUserUpdateInput;
};


export type MutationUpdateRewardedUserStatusArgs = {
  id: Scalars['String']['input'];
  status: RewardedUserStatus;
};


export type MutationUpdateServiceConfigArgs = {
  key: Scalars['String']['input'];
  service: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSingleRewardedUserArgs = {
  id: Scalars['String']['input'];
  input: RewardedUserUpdateInput;
};


export type MutationUpdateSmartLinkLandingPageArgs = {
  input: SmartLinkLandingPageInput;
};


export type MutationUpdateStoreAppArgs = {
  id: Scalars['String']['input'];
  input: StoreAppInput;
};


export type MutationUpdateSupportTicketMessageArgs = {
  id: Scalars['String']['input'];
  input: SupportTicketMessageInput;
  ticketId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTargetedLeadArgs = {
  id: Scalars['String']['input'];
  input: TargetedLeadInput;
};


export type MutationUpdateTrackingCustomizationRuleArgs = {
  input: RuleCustomizationInput;
};


export type MutationUpdateTrafficTagArgs = {
  id: Scalars['String']['input'];
  input: TrafficTagInput;
};


export type MutationUpdateTrafficTargetArgs = {
  id: Scalars['String']['input'];
  input: TrafficTargetingInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['String']['input'];
  user: UserInput;
};


export type MutationUpdateUserSettingsArgs = {
  input: UserSettingsInput;
  userId: Scalars['String']['input'];
};


export type MutationUploadArgs = {
  file: Scalars['Upload']['input'];
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpsertUserArgs = {
  user: UserInput;
};


export type MutationVoidAdvertiserInvoiceArgs = {
  id: Scalars['String']['input'];
};

export type NewOrganizationRepresentativeInput = {
  contactInfo?: InputMaybe<OrganizationRepresentativeContactInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  position?: InputMaybe<Scalars['String']['input']>;
};

export type Notification = {
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  emailContents: Array<Maybe<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  notificationContext: NotificationContext;
  notificationType: NotificationType;
  recipient: Array<Recipient>;
  status: NotificationStatus;
};

export type NotificationContext = {
  offer?: Maybe<OfferEmailContext>;
  offerPublisherViews?: Maybe<Array<Maybe<OfferPublisherViewEmailContext>>>;
  publisher?: Maybe<PublisherEmailContext>;
};

export type NotificationFilter = {
  offerId?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  publisherName?: InputMaybe<Scalars['String']['input']>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<NotificationSortBy>;
};

export enum NotificationSortBy {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

export enum NotificationStatus {
  Failed = 'FAILED',
  Sent = 'SENT'
}

export enum NotificationType {
  ForgotPassword = 'FORGOT_PASSWORD',
  General = 'GENERAL',
  Offer = 'OFFER',
  OfferForPublisher = 'OFFER_FOR_PUBLISHER',
  OfferPayoutChange = 'OFFER_PAYOUT_CHANGE',
  Publisher = 'PUBLISHER',
  User = 'USER'
}

export type OsInput = {
  platform: Platform;
  version?: InputMaybe<OsVersionInput>;
};

export type OsVersionInput = {
  maxVersion?: InputMaybe<Scalars['String']['input']>;
  minVersion?: InputMaybe<Scalars['String']['input']>;
};

/** Describes an ad that we can serve to users under certain restrictions */
export type Offer = {
  accessState?: Maybe<OfferAccessState>;
  additionalInformation?: Maybe<Scalars['String']['output']>;
  adjustUploadConfig?: Maybe<AdjustUploadConfig>;
  advancedTargeting?: Maybe<AdvancedTargeting>;
  advertiser: Advertiser;
  advertiserImpressionUrl?: Maybe<Scalars['String']['output']>;
  advertiserOfferId?: Maybe<Scalars['String']['output']>;
  advertiserTrackingUrl?: Maybe<Scalars['String']['output']>;
  /** Offer "App" metadata from 42matters */
  appMetadata?: Maybe<AppMetadata>;
  appStoreId?: Maybe<Scalars['String']['output']>;
  appsflyerAgency?: Maybe<Scalars['String']['output']>;
  appsflyerAudienceApiKey?: Maybe<Scalars['String']['output']>;
  appsflyerConfig?: Maybe<AppsflyerOfferConfig>;
  appsflyerUploadConfig?: Maybe<AppsflyerUploadConfig>;
  attributionType: AttributionType;
  audits: Array<Audit>;
  blacklistedSubIds: Array<BlacklistedSubId>;
  budgetTimezone?: Maybe<Scalars['String']['output']>;
  /** all the budgets associated to the offer */
  budgets: Array<Budget>;
  categories?: Maybe<Array<Scalars['Int']['output']>>;
  clickBudgets: Array<ClickBudget>;
  /** The click shield rules of current offer */
  clickShieldRules: Array<ClickShieldRules>;
  clickTrackingUrl: Scalars['String']['output'];
  conversionTrackingType?: Maybe<Scalars['Int']['output']>;
  counts?: Maybe<OfferCounts>;
  createdAt?: Maybe<Scalars['LocalDateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  creatives?: Maybe<Array<CreativePack>>;
  creativesURL?: Maybe<Scalars['String']['output']>;
  currentActivePublisher?: Maybe<Publisher>;
  customRestrictions?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventTimings: EventTimingReport;
  /** all the event types associated to the offer */
  eventTypes: Array<EventType>;
  feedApiStatus: FeedApiStatus;
  flags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  htmlServeUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  importedOfferId?: Maybe<Scalars['String']['output']>;
  impressionBudgets: Array<ImpressionBudget>;
  integration?: Maybe<OfferIntegration>;
  isApprovalRequired: Scalars['Boolean']['output'];
  isOrganic: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  javascriptPixelCode: Scalars['String']['output'];
  /** The jumps though which the browser goes in order to reach App/Play store */
  jumpAnalysis: Array<JumpAnalysis>;
  kpi?: Maybe<Scalars['String']['output']>;
  landingPages: Array<LandingPage>;
  leadflow: Leadflow;
  marketplaceExport?: Maybe<Scalars['Boolean']['output']>;
  marketplaceOrganizationIds?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /**
   * Return the publishers attached to the offer as a publisher-offer view
   * @deprecated Use offerPublishersV2 instead
   */
  offerPublishers: Array<PublisherOfferView>;
  offerPublishersCount: Scalars['Int']['output'];
  /** Return the publishers attached to the offer as a publisher-offer view */
  offerPublishersV2: PublisherOfferViewConnection;
  /** the first paid payout associated to the offer */
  paidPayout?: Maybe<Payout>;
  /**
   * The resolved offer-default split payout for one event type (no publisher in the key). Display only:
   * carries the rendered theyGet/margin values and the source labels for weGet/theyGet/theyGetPoints.
   */
  payoutV2: PayoutV2;
  /** all the payouts associated to the offer */
  payouts: Array<Payout>;
  /** the split payouts (weGet/theyGet/theyGetPoints) associated to the offer, grouped by publisher and event type */
  payoutsV2: Array<PayoutV2>;
  peaEnabled?: Maybe<Scalars['Boolean']['output']>;
  pixelTrackingUrl: Scalars['String']['output'];
  /** The postback shield rules of current offer */
  postbackShieldRules: Array<PostbackShieldRules>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  /** all the pub groups associated to this offer */
  pubGroups: PubGroupConnection;
  /** Publisher groups */
  publisherGroups: Array<Maybe<PublisherGroup>>;
  /** all the publishers for which the access state matches */
  publishers: Array<Publisher>;
  recencyPeriod?: Maybe<Scalars['Int']['output']>;
  redirectionType: RedirectionType;
  /** Stats associated to this offer represented as a time series. */
  report: Array<Report>;
  restrictions: Array<Maybe<Scalars['String']['output']>>;
  retargetingFile?: Maybe<RetargetingFile>;
  revenueShareEnabled?: Maybe<Scalars['Boolean']['output']>;
  sanForwardingSettings?: Maybe<SanForwardingSettings>;
  sdkToken: Scalars['String']['output'];
  skadMappings: Array<SkAdMapping>;
  skadPostbackLinks: Array<SkAdPostbackLink>;
  sourceOfferId?: Maybe<Scalars['String']['output']>;
  status: OfferStatus;
  storeApp?: Maybe<StoreApp>;
  swaarmSDKCode: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  targetedPayouts?: Maybe<Array<TargetedPayout>>;
  targeting: Targeting;
  trackingDomain?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  useShortClickIds?: Maybe<Scalars['Boolean']['output']>;
  verticals?: Maybe<Array<Scalars['String']['output']>>;
  vtaEnabled?: Maybe<Scalars['Boolean']['output']>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferAccessStateArgs = {
  publisherId: Scalars['String']['input'];
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferBlacklistedSubIdsArgs = {
  filter?: InputMaybe<BlacklistedSubIdsFilter>;
  pagination?: InputMaybe<Pagination>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferBudgetsArgs = {
  budgetSpecificity?: InputMaybe<Array<InputMaybe<OfferPublisherBudgetType>>>;
  eventTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<Status>>>;
  thresholds?: InputMaybe<Array<InputMaybe<BudgetThreshold>>>;
  validities?: InputMaybe<Array<InputMaybe<BudgetValidity>>>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferClickBudgetsArgs = {
  budgetType?: InputMaybe<OfferPublisherBudgetType>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferClickShieldRulesArgs = {
  publisherId?: InputMaybe<Scalars['String']['input']>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferEventTimingsArgs = {
  input: EventTimingInput;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferEventTypesArgs = {
  status?: InputMaybe<Array<InputMaybe<Status>>>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferImpressionBudgetsArgs = {
  budgetType?: InputMaybe<OfferPublisherBudgetType>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferJumpAnalysisArgs = {
  filter?: InputMaybe<JumpAnalysisFilter>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferOfferPublishersArgs = {
  filter?: InputMaybe<OfferToPublisherFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<OfferToPublisherSort>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferOfferPublishersCountArgs = {
  filter?: InputMaybe<OfferToPublisherFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<OfferToPublisherSort>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferOfferPublishersV2Args = {
  filter?: InputMaybe<OfferToPublisherFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OfferToPublisherSort>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferPayoutV2Args = {
  eventTypeId?: InputMaybe<Scalars['String']['input']>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferPayoutsArgs = {
  eventTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payoutSpecificity?: InputMaybe<Array<OfferPublisherPayoutType>>;
  status?: InputMaybe<Array<Status>>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferPayoutsV2Args = {
  payoutSpecificity?: InputMaybe<Array<OfferPublisherPayoutType>>;
  status?: InputMaybe<Array<Status>>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferPostbackShieldRulesArgs = {
  publisherId?: InputMaybe<Scalars['String']['input']>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferPubGroupsArgs = {
  filter?: InputMaybe<PubGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferPublisherGroupsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferPublishersArgs = {
  budgetType?: InputMaybe<OfferPublisherBudgetType>;
  payoutType?: InputMaybe<OfferPublisherPayoutType>;
  states?: InputMaybe<Array<InputMaybe<OfferAccessState>>>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferReportArgs = {
  queries: Array<ReportQuery>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferSkadMappingsArgs = {
  pagination?: InputMaybe<Pagination>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferSkadPostbackLinksArgs = {
  pagination?: InputMaybe<Pagination>;
};


/** Describes an ad that we can serve to users under certain restrictions */
export type OfferTargetedPayoutsArgs = {
  filter?: InputMaybe<TargetedPayoutFilter>;
};

export type OfferAccess = {
  offerId: Scalars['String']['input'];
  publisherId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  state: OfferAccessInputState;
};

export type OfferAccessChange = {
  offerId: Scalars['String']['output'];
  publisherId: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  state: OfferAccessInputState;
};

export enum OfferAccessInputState {
  Approved = 'APPROVED',
  Blocked = 'BLOCKED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type OfferAccessKey = {
  offerId: Scalars['String']['input'];
  publisherId: Scalars['String']['input'];
};

/** Describes the realtionship between an offer and a publisher */
export enum OfferAccessState {
  Approved = 'APPROVED',
  Blocked = 'BLOCKED',
  BlockedByAdvertiser = 'BLOCKED_BY_ADVERTISER',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Visible = 'VISIBLE'
}

export type OfferBatchChangeDetailsAction = {
  details: Array<OfferBatchChangeDetailsEntry>;
};

export type OfferBatchChangeDetailsActionInput = {
  details: Array<OfferBatchChangeDetailsEntryInput>;
};

export type OfferBatchChangeDetailsEntry = {
  field?: Maybe<OfferBatchOfferField>;
  values: Array<Scalars['String']['output']>;
};

export type OfferBatchChangeDetailsEntryInput = {
  field?: InputMaybe<OfferBatchOfferField>;
  values: Array<Scalars['String']['input']>;
};

export enum OfferBatchOfferField {
  IsApprovalRequired = 'IS_APPROVAL_REQUIRED',
  IsPrivate = 'IS_PRIVATE',
  Restrictions = 'RESTRICTIONS',
  RevenueShareEnabled = 'REVENUE_SHARE_ENABLED',
  VtaEnabled = 'VTA_ENABLED'
}

export type OfferBatchOperation = {
  active: Scalars['Boolean']['output'];
  advancedTargetingAction?: Maybe<OfferBatchOperationAdvancedTargetingAction>;
  changeBudgetsAction?: Maybe<OfferBatchOperationChangeBudgetsAction>;
  changeDetailsAction?: Maybe<OfferBatchChangeDetailsAction>;
  changeEventTypeVisibilityAction?: Maybe<OfferBatchOperationChangeEventTypeVisibilityAction>;
  changeStatusAction?: Maybe<OfferBatchOperationChangeStatusAction>;
  changeTagsAction?: Maybe<OfferBatchOperationChangeTagsAction>;
  configurePublishersActions?: Maybe<Array<OfferBatchOperationConfigurePublishersAction>>;
  createPublisherGroupAction?: Maybe<OfferBatchOperationCreatePublisherGroupAction>;
  description?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<OfferBatchOperationFilter>>;
  fireWebhookAction?: Maybe<OfferBatchOperationFireWebhook>;
  id: Scalars['String']['output'];
  lastExecutionAt?: Maybe<Scalars['LocalDateTime']['output']>;
  name: Scalars['String']['output'];
  schedule: BatchOperationSchedule;
};

export type OfferBatchOperationAdvancedTargetingAction = {
  forceOverride?: Maybe<Scalars['Boolean']['output']>;
  group: AdvancedTargetingGroup;
};

export type OfferBatchOperationAdvancedTargetingActionInput = {
  forceOverride?: InputMaybe<Scalars['Boolean']['input']>;
  group: AdvancedTargetingGroupInput;
};

export type OfferBatchOperationChangeBudgetsAction = {
  budgets?: Maybe<Array<Budget>>;
  forceOverride?: Maybe<Scalars['Boolean']['output']>;
};

export type OfferBatchOperationChangeBudgetsActionInput = {
  budgets?: InputMaybe<Array<BudgetInput>>;
  forceOverride?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OfferBatchOperationChangeEventTypeVisibilityAction = {
  visibility: EventTypeVisibility;
};

export type OfferBatchOperationChangeEventTypeVisibilityActionInput = {
  visibility: EventTypeVisibility;
};

export type OfferBatchOperationChangeStatusAction = {
  status: OfferStatus;
};

export type OfferBatchOperationChangeStatusActionInput = {
  status: OfferStatus;
};

export type OfferBatchOperationChangeTagsAction = {
  tagsToAdd?: Maybe<Array<Scalars['String']['output']>>;
  tagsToRemove?: Maybe<Array<Scalars['String']['output']>>;
};

export type OfferBatchOperationChangeTagsActionInput = {
  tagsToAdd?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsToRemove?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OfferBatchOperationConfigurePublishersAction = {
  budgets?: Maybe<Array<Budget>>;
  excludedPublisherIds?: Maybe<Array<Scalars['String']['output']>>;
  forceOverrideAccessState?: Maybe<Scalars['Boolean']['output']>;
  forceOverrideBudgets?: Maybe<Scalars['Boolean']['output']>;
  forceOverridePayouts?: Maybe<Scalars['Boolean']['output']>;
  offerAccessState?: Maybe<OfferAccessState>;
  payout?: Maybe<BatchPayout>;
  targetPublisherIds?: Maybe<Array<Scalars['String']['output']>>;
  useExistingApprovedPublishers?: Maybe<Scalars['Boolean']['output']>;
  useExistingBlockedPublishers?: Maybe<Scalars['Boolean']['output']>;
  useExistingPendingPublishers?: Maybe<Scalars['Boolean']['output']>;
  usePublishersWithTags?: Maybe<Array<Scalars['String']['output']>>;
};

export type OfferBatchOperationConfigurePublishersActionInput = {
  budgets?: InputMaybe<Array<BudgetInput>>;
  excludedPublisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  forceOverrideAccessState?: InputMaybe<Scalars['Boolean']['input']>;
  forceOverrideBudgets?: InputMaybe<Scalars['Boolean']['input']>;
  forceOverridePayouts?: InputMaybe<Scalars['Boolean']['input']>;
  offerAccessState?: InputMaybe<OfferAccessState>;
  payout?: InputMaybe<BatchPayoutInput>;
  targetPublisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  useExistingApprovedPublishers?: InputMaybe<Scalars['Boolean']['input']>;
  useExistingBlockedPublishers?: InputMaybe<Scalars['Boolean']['input']>;
  useExistingPendingPublishers?: InputMaybe<Scalars['Boolean']['input']>;
  usePublishersWithTags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OfferBatchOperationConnection = {
  edges?: Maybe<Array<OfferBatchOperationEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type OfferBatchOperationCreatePublisherGroupAction = {
  groupId?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<PubGroupMember>>;
  offerId?: Maybe<Scalars['String']['output']>;
  rotation: PubGroupRotation;
  useAllActivePublishers?: Maybe<Scalars['Boolean']['output']>;
};

export type OfferBatchOperationCreatePublisherGroupActionInput = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Array<PubGroupMemberInput>>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  rotation: PubGroupRotationInput;
  useAllActivePublishers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OfferBatchOperationEdge = {
  node: OfferBatchOperation;
};

export type OfferBatchOperationFilter = {
  field: OfferBatchOperationFilterField;
  operator: BatchOperationFilterOperator;
  values: Array<Scalars['String']['output']>;
};

export enum OfferBatchOperationFilterField {
  AccountManagerId = 'ACCOUNT_MANAGER_ID',
  AdvertiserId = 'ADVERTISER_ID',
  AdvertiserOfferId = 'ADVERTISER_OFFER_ID',
  ApprovedPublishers = 'APPROVED_PUBLISHERS',
  AppStoreId = 'APP_STORE_ID',
  BlockedPublishers = 'BLOCKED_PUBLISHERS',
  Clicks = 'CLICKS',
  Cr = 'CR',
  CreatedAt = 'CREATED_AT',
  DefaultConversions = 'DEFAULT_CONVERSIONS',
  Description = 'DESCRIPTION',
  Events = 'EVENTS',
  Id = 'ID',
  Impressions = 'IMPRESSIONS',
  InternalNote = 'INTERNAL_NOTE',
  IsApprovalRequired = 'IS_APPROVAL_REQUIRED',
  IsNew = 'IS_NEW',
  IsPrivate = 'IS_PRIVATE',
  Name = 'NAME',
  NonRejectedConversions = 'NON_REJECTED_CONVERSIONS',
  NoOfJumps = 'NO_OF_JUMPS',
  NoOfJumpsDoesNotReachStore = 'NO_OF_JUMPS_DOES_NOT_REACH_STORE',
  NoOfJumpsReachStore = 'NO_OF_JUMPS_REACH_STORE',
  NoOfOffersWithSameAppId = 'NO_OF_OFFERS_WITH_SAME_APP_ID',
  OfferAge = 'OFFER_AGE',
  PaidConversions = 'PAID_CONVERSIONS',
  PaidCr = 'PAID_CR',
  PayoutTheyGet = 'PAYOUT_THEY_GET',
  PayoutWeGet = 'PAYOUT_WE_GET',
  PendingPublishers = 'PENDING_PUBLISHERS',
  ReachesStore = 'REACHES_STORE',
  ReachesTracker = 'REACHES_TRACKER',
  RedirectionType = 'REDIRECTION_TYPE',
  RejectedConversions = 'REJECTED_CONVERSIONS',
  SalesManagerId = 'SALES_MANAGER_ID',
  Status = 'STATUS',
  Tags = 'TAGS',
  TargetingCountries = 'TARGETING_COUNTRIES',
  TargetingOs = 'TARGETING_OS',
  TheyGet = 'THEY_GET',
  TimeSinceLastOfferAccessChange = 'TIME_SINCE_LAST_OFFER_ACCESS_CHANGE',
  TimeSinceLastPublisherApproval = 'TIME_SINCE_LAST_PUBLISHER_APPROVAL',
  TotalConversions = 'TOTAL_CONVERSIONS',
  TrackerName = 'TRACKER_NAME',
  UpdatedAt = 'UPDATED_AT',
  WeGet = 'WE_GET'
}

export type OfferBatchOperationFilterInput = {
  field: OfferBatchOperationFilterField;
  operator: BatchOperationFilterOperator;
  values: Array<Scalars['String']['input']>;
};

export type OfferBatchOperationFireWebhook = {
  body?: Maybe<Scalars['String']['output']>;
  headers?: Maybe<Scalars['String']['output']>;
  method: BatchOperationWebhookMethod;
  url: Scalars['String']['output'];
};

export type OfferBatchOperationFireWebhookInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  headers?: InputMaybe<Scalars['String']['input']>;
  method: BatchOperationWebhookMethod;
  url: Scalars['String']['input'];
};

export type OfferBatchOperationInput = {
  active: Scalars['Boolean']['input'];
  advancedTargetingAction?: InputMaybe<OfferBatchOperationAdvancedTargetingActionInput>;
  changeBudgetsAction?: InputMaybe<OfferBatchOperationChangeBudgetsActionInput>;
  changeDetailsAction?: InputMaybe<OfferBatchChangeDetailsActionInput>;
  changeEventTypeVisibilityAction?: InputMaybe<OfferBatchOperationChangeEventTypeVisibilityActionInput>;
  changeStatusAction?: InputMaybe<OfferBatchOperationChangeStatusActionInput>;
  changeTagsAction?: InputMaybe<OfferBatchOperationChangeTagsActionInput>;
  configurePublishersActions?: InputMaybe<Array<OfferBatchOperationConfigurePublishersActionInput>>;
  createPublisherGroupAction?: InputMaybe<OfferBatchOperationCreatePublisherGroupActionInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<OfferBatchOperationFilterInput>>;
  fireWebhookAction?: InputMaybe<OfferBatchOperationFireWebhookInput>;
  name: Scalars['String']['input'];
  schedule: BatchOperationScheduleInput;
};

export type OfferBatchOperationLogConnection = {
  edges?: Maybe<Array<OfferBatchOperationLogEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type OfferBatchOperationLogEdge = {
  node: OfferBatchOperationLogEntry;
};

export type OfferBatchOperationLogEntry = {
  actions?: Maybe<Array<BatchOperationLogActionEntry>>;
  offer: Offer;
};

export type OfferBatchOperationReadFilter = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export enum OfferCloneField {
  AdvancedTargeting = 'ADVANCED_TARGETING',
  Budget = 'BUDGET',
  ClickBudget = 'CLICK_BUDGET',
  Events = 'EVENTS',
  LandingPages = 'LANDING_PAGES',
  OfferAccess = 'OFFER_ACCESS',
  OfferAccessBudgets = 'OFFER_ACCESS_BUDGETS',
  OfferAccessClickBudgets = 'OFFER_ACCESS_CLICK_BUDGETS',
  OfferAccessPayouts = 'OFFER_ACCESS_PAYOUTS',
  Payout = 'PAYOUT',
  TargetedPayout = 'TARGETED_PAYOUT'
}

export type OfferConnection = {
  edges: Array<OfferEdge>;
  totalCount: Scalars['Int']['output'];
};

export type OfferCounts = {
  approvedPublishers: Scalars['Int']['output'];
  servingPublishers: Scalars['Int']['output'];
};

export type OfferData = {
  advertiser: Advertiser;
  advertiserManagerId?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<EventType>;
  offer: Offer;
  originalCurrency?: Maybe<Scalars['String']['output']>;
  originalTheyGet?: Maybe<Scalars['Float']['output']>;
  originalWeGet?: Maybe<Scalars['Float']['output']>;
  theyGetCurrency?: Maybe<Scalars['String']['output']>;
  theyGetStd?: Maybe<Scalars['Float']['output']>;
  weGetCurrency?: Maybe<Scalars['String']['output']>;
  weGetStd?: Maybe<Scalars['Float']['output']>;
};

export type OfferDataInput = {
  advertiserId: Scalars['String']['input'];
  advertiserManagerId?: InputMaybe<Scalars['String']['input']>;
  eventTypeId?: InputMaybe<Scalars['String']['input']>;
  offerId: Scalars['String']['input'];
  theyGetStd?: InputMaybe<Scalars['Float']['input']>;
  weGetStd?: InputMaybe<Scalars['Float']['input']>;
};

export type OfferEdge = {
  node: Offer;
};

export type OfferEmailContext = {
  budget?: Maybe<BudgetEmailContext>;
  id?: Maybe<Scalars['String']['output']>;
  kpi?: Maybe<Scalars['String']['output']>;
  leadflow?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  payout?: Maybe<PayoutEmailContext>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  restrictions?: Maybe<Scalars['String']['output']>;
  targetingCountries?: Maybe<Scalars['String']['output']>;
  targetingOs?: Maybe<Scalars['String']['output']>;
  targetingOsVersion?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<TrackingEmailContext>;
};

export type OfferFacebookIntegration = {
  campaignId: Scalars['String']['output'];
};

export type OfferFacebookIntegrationInput = {
  campaignId: Scalars['String']['input'];
};

export enum OfferFeatureType {
  Advertiser = 'ADVERTISER',
  Country = 'COUNTRY',
  Os = 'OS',
  Tag = 'TAG',
  Tracker = 'TRACKER'
}

export type OfferFeatures = {
  featureType: OfferFeatureType;
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type OfferFeaturesInput = {
  featureType: OfferFeatureType;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OfferFieldsToUpdateInput = {
  status?: InputMaybe<OfferStatus>;
};

export type OfferFilter = {
  accessState?: InputMaybe<Array<OfferAccessState>>;
  accountManagerId?: InputMaybe<Scalars['String']['input']>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  advertiserOfferId?: InputMaybe<Array<Scalars['String']['input']>>;
  appStoreId?: InputMaybe<Scalars['String']['input']>;
  appStoreIds?: InputMaybe<Array<Scalars['String']['input']>>;
  appsflyerAgency?: InputMaybe<Scalars['String']['input']>;
  areApprovalRequired?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  arePrivate?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  importedOfferId?: InputMaybe<Scalars['String']['input']>;
  isApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  marketplaceExport?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organic?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<Platform>;
  platforms?: InputMaybe<Array<Platform>>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  salesManagerId?: InputMaybe<Scalars['String']['input']>;
  salesManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  smartlinkId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<OfferStatus>>;
  storeAppIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OfferFlag = {
  flags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  offerId?: Maybe<Scalars['String']['output']>;
};

export type OfferForPublisherNotificationInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  offerId: Array<InputMaybe<Scalars['String']['input']>>;
  publisherId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};

export type OfferGoogleIntegration = {
  campaignId: Scalars['String']['output'];
};

export type OfferGoogleIntegrationInput = {
  campaignId: Scalars['String']['input'];
};

export type OfferInput = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  advertiserId: Scalars['String']['input'];
  advertiserImpressionUrl?: InputMaybe<Scalars['String']['input']>;
  advertiserOfferId?: InputMaybe<Scalars['String']['input']>;
  advertiserTrackingUrl: Scalars['String']['input'];
  appStoreId?: InputMaybe<Scalars['String']['input']>;
  attributionType?: InputMaybe<AttributionType>;
  budgetTimezone?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<Scalars['Int']['input']>>;
  conversionTrackingType?: InputMaybe<Scalars['Int']['input']>;
  creativesURL?: InputMaybe<Scalars['String']['input']>;
  customRestrictions?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  importedOfferId?: InputMaybe<Scalars['String']['input']>;
  isApprovalRequired: Scalars['Boolean']['input'];
  isPrivate: Scalars['Boolean']['input'];
  kpi?: InputMaybe<Scalars['String']['input']>;
  leadflow: Leadflow;
  marketplaceExport?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceOrganizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  peaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  redirectionType: RedirectionType;
  restrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  revenueShareEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOfferId?: InputMaybe<Scalars['String']['input']>;
  status: OfferStatus;
  storeAppId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  targeting?: InputMaybe<TargetingInput>;
  useShortClickIds?: InputMaybe<Scalars['Boolean']['input']>;
  verticals?: InputMaybe<Array<Scalars['String']['input']>>;
  vtaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OfferIntegration = {
  facebookIntegration?: Maybe<OfferFacebookIntegration>;
  googleIntegration?: Maybe<OfferGoogleIntegration>;
  id: Scalars['String']['output'];
  offerId: Scalars['String']['output'];
};

export type OfferIntegrationInput = {
  facebookIntegration?: InputMaybe<OfferFacebookIntegrationInput>;
  googleIntegration?: InputMaybe<OfferGoogleIntegrationInput>;
  offerId: Scalars['String']['input'];
};

export type OfferNotificationInput = {
  offerId: Scalars['String']['input'];
  recipient?: InputMaybe<Array<RecipientInput>>;
  templateId: Scalars['String']['input'];
};

export type OfferPayoutChangeNotificationInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  offerId: Scalars['String']['input'];
  publisherMessage?: InputMaybe<Scalars['String']['input']>;
  publisherTemplateId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};

export enum OfferPublisherBudgetType {
  Default = 'DEFAULT',
  Specific = 'SPECIFIC'
}

export enum OfferPublisherPayoutType {
  Default = 'DEFAULT',
  Specific = 'SPECIFIC'
}

export type OfferPublisherViewEmailContext = {
  budget?: Maybe<BudgetEmailContext>;
  offer?: Maybe<OfferEmailContext>;
  payout?: Maybe<PayoutEmailContext>;
  publisher?: Maybe<PublisherEmailContext>;
  tracking?: Maybe<TrackingEmailContext>;
};

export type OfferRecencyPeriod = {
  offerId?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
};

export type OfferScanDeviceValues = {
  browsers: Array<Scalars['String']['output']>;
  makes: Array<Scalars['String']['output']>;
  models: Array<Scalars['String']['output']>;
  osVersion: Array<Scalars['String']['output']>;
  types: Array<Scalars['String']['output']>;
};


export type OfferScanDeviceValuesBrowsersArgs = {
  limit: Scalars['Int']['input'];
  prefix?: InputMaybe<Scalars['String']['input']>;
};


export type OfferScanDeviceValuesMakesArgs = {
  limit: Scalars['Int']['input'];
  prefix?: InputMaybe<Scalars['String']['input']>;
};


export type OfferScanDeviceValuesModelsArgs = {
  limit: Scalars['Int']['input'];
  makes?: InputMaybe<Array<Scalars['String']['input']>>;
  prefix?: InputMaybe<Scalars['String']['input']>;
};


export type OfferScanDeviceValuesOsVersionArgs = {
  limit: Scalars['Int']['input'];
  os: Scalars['String']['input'];
  prefix?: InputMaybe<Scalars['String']['input']>;
};


export type OfferScanDeviceValuesTypesArgs = {
  limit: Scalars['Int']['input'];
  prefix?: InputMaybe<Scalars['String']['input']>;
};

export type OfferSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<OfferSortBy>;
  sortQuery?: InputMaybe<SortQuery>;
};

export enum OfferSortBy {
  AdvertiserOfferId = 'ADVERTISER_OFFER_ID',
  Clicks = 'CLICKS',
  Conversions = 'CONVERSIONS',
  NumberOfJumps = 'NUMBER_OF_JUMPS',
  OfferId = 'OFFER_ID',
  PayoutTheyGet = 'PAYOUT_THEY_GET',
  PayoutWeGet = 'PAYOUT_WE_GET',
  Profit = 'PROFIT',
  RemainingDailyBudget = 'REMAINING_DAILY_BUDGET',
  RemainingDailyClickBudget = 'REMAINING_DAILY_CLICK_BUDGET',
  RemainingDailyConversionBudget = 'REMAINING_DAILY_CONVERSION_BUDGET',
  RemainingDailyImpressionBudget = 'REMAINING_DAILY_IMPRESSION_BUDGET',
  RemainingDailyRevenueBudget = 'REMAINING_DAILY_REVENUE_BUDGET',
  RemainingForeverClickBudget = 'REMAINING_FOREVER_CLICK_BUDGET',
  RemainingForeverConversionBudget = 'REMAINING_FOREVER_CONVERSION_BUDGET',
  RemainingForeverImpressionBudget = 'REMAINING_FOREVER_IMPRESSION_BUDGET',
  RemainingForeverRevenueBudget = 'REMAINING_FOREVER_REVENUE_BUDGET',
  RemainingHourlyClickBudget = 'REMAINING_HOURLY_CLICK_BUDGET',
  RemainingHourlyConversionBudget = 'REMAINING_HOURLY_CONVERSION_BUDGET',
  RemainingHourlyImpressionBudget = 'REMAINING_HOURLY_IMPRESSION_BUDGET',
  RemainingHourlyRevenueBudget = 'REMAINING_HOURLY_REVENUE_BUDGET',
  RemainingMonthlyBudget = 'REMAINING_MONTHLY_BUDGET',
  RemainingMonthlyConversionBudget = 'REMAINING_MONTHLY_CONVERSION_BUDGET',
  RemainingMonthlyRevenueBudget = 'REMAINING_MONTHLY_REVENUE_BUDGET',
  TheyGet = 'THEY_GET',
  WeGet = 'WE_GET'
}

export enum OfferStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED',
  Paused = 'PAUSED',
  Pending = 'PENDING'
}

export type OfferStatusChange = {
  offerId: Scalars['String']['output'];
  status: OfferStatus;
};

export type OfferStatusChangeInput = {
  offerId: Scalars['String']['input'];
  status: OfferStatus;
};

export type OfferTag = {
  name: Scalars['String']['output'];
  numberOfOffers: Scalars['Int']['output'];
  offers?: Maybe<Array<Offer>>;
  preApproved: Scalars['Boolean']['output'];
};

export type OfferToPublisherFilter = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  publisherManagerId?: InputMaybe<Scalars['String']['input']>;
  publisherStatus?: InputMaybe<PublisherStatus>;
  states?: InputMaybe<Array<InputMaybe<OfferAccessState>>>;
  theyGet?: InputMaybe<OfferPublisherPayoutType>;
  weGet?: InputMaybe<OfferPublisherPayoutType>;
};

export type OfferToPublisherSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<OfferToPublisherSortBy>;
  sortQuery?: InputMaybe<SortQuery>;
};

export enum OfferToPublisherSortBy {
  Clicks = 'CLICKS',
  Conversions = 'CONVERSIONS',
  Profit = 'PROFIT',
  PublisherId = 'PUBLISHER_ID',
  PublisherName = 'PUBLISHER_NAME',
  RemainingDailyClickBudget = 'REMAINING_DAILY_CLICK_BUDGET',
  RemainingDailyConversionBudget = 'REMAINING_DAILY_CONVERSION_BUDGET',
  RemainingDailyImpressionBudget = 'REMAINING_DAILY_IMPRESSION_BUDGET',
  RemainingDailyRevenueBudget = 'REMAINING_DAILY_REVENUE_BUDGET',
  RemainingForeverClickBudget = 'REMAINING_FOREVER_CLICK_BUDGET',
  RemainingForeverConversionBudget = 'REMAINING_FOREVER_CONVERSION_BUDGET',
  RemainingForeverImpressionBudget = 'REMAINING_FOREVER_IMPRESSION_BUDGET',
  RemainingForeverRevenueBudget = 'REMAINING_FOREVER_REVENUE_BUDGET',
  RemainingHourlyClickBudget = 'REMAINING_HOURLY_CLICK_BUDGET',
  RemainingHourlyConversionBudget = 'REMAINING_HOURLY_CONVERSION_BUDGET',
  RemainingHourlyImpressionBudget = 'REMAINING_HOURLY_IMPRESSION_BUDGET',
  RemainingHourlyRevenueBudget = 'REMAINING_HOURLY_REVENUE_BUDGET',
  RemainingMonthlyConversionBudget = 'REMAINING_MONTHLY_CONVERSION_BUDGET',
  RemainingMonthlyRevenueBudget = 'REMAINING_MONTHLY_REVENUE_BUDGET',
  TheyGet = 'THEY_GET',
  WeGet = 'WE_GET'
}

export enum OfferVisibility {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type OfferWeightVariant = {
  manualWeight?: Maybe<Scalars['Float']['output']>;
  offer: Offer;
  serveable: Scalars['Boolean']['output'];
  systemWeight: Scalars['Float']['output'];
};

export type OfferWeightVariantConnection = {
  edges: Array<OfferWeightVariantEdge>;
  totalCount: Scalars['Int']['output'];
};

export type OfferWeightVariantEdge = {
  node: OfferWeightVariant;
};

export type OfferWithWeight = {
  offer: Offer;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type OfferWithWeightInput = {
  offerId: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type Organization = {
  domains: OrganizationDomains;
  id: Scalars['Int']['output'];
  legalEntity: Scalars['String']['output'];
  name: Scalars['String']['output'];
  plan: OrganizationPlan;
  /** @deprecated Use PartnerPublisherConfig:privacyPolicy instead */
  privacyPolicy?: Maybe<Scalars['String']['output']>;
  productFeatures: Array<ProductFeature>;
  publisherBillingDetails?: Maybe<OrganizationPublisherBillingDetails>;
  supportEmail: Scalars['String']['output'];
  suspended: Scalars['Boolean']['output'];
  /** @deprecated Use PartnerPublisherConfig:termsAndConditions instead */
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OrganizationType>;
  whiteLabel: OrganizationWhiteLabel;
};

export type OrganizationDomains = {
  advertiserUrls: Array<Domain>;
  appUrls: Array<Domain>;
  farmerUrls: Array<Domain>;
  feedUrls: Array<Domain>;
  partnerUrls: Array<Domain>;
  postbackUrls: Array<Domain>;
  ratelimiterUrls: Array<Domain>;
  supersetUrls: Array<Domain>;
  surveyorUrls: Array<Domain>;
  trackingUrls: Array<Domain>;
  turniloUrls: Array<Domain>;
};

export type OrganizationDomainsInput = {
  advertiserUrls: Array<DomainInput>;
  appUrls: Array<DomainInput>;
  feedUrls: Array<DomainInput>;
  partnerUrls: Array<DomainInput>;
  postbackUrls: Array<DomainInput>;
  ratelimiterUrls: Array<DomainInput>;
  supersetUrls: Array<DomainInput>;
  trackingUrls: Array<DomainInput>;
  turniloUrls: Array<DomainInput>;
};

export type OrganizationInput = {
  domains?: InputMaybe<OrganizationDomainsInput>;
  legalEntity: Scalars['String']['input'];
  name: Scalars['String']['input'];
  privacyPolicy?: InputMaybe<Scalars['String']['input']>;
  publisherBillingDetails?: InputMaybe<OrganizationPublisherBillingDetailsInput>;
  supportEmail: Scalars['String']['input'];
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrganizationType>;
  whiteLabel?: InputMaybe<OrganizationWhiteLabelInput>;
};

export type OrganizationIntegrationRequest = {
  id: Scalars['String']['output'];
  sourceOrganization: MarketplaceOrganization;
  status: OrganizationIntegrationRequestStatus;
  targetOrganization: MarketplaceOrganization;
  type: OrganizationIntegrationRequestType;
};

export type OrganizationIntegrationRequestConnection = {
  edges?: Maybe<Array<OrganizationIntegrationRequestEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationIntegrationRequestEdge = {
  node: OrganizationIntegrationRequest;
};

export type OrganizationIntegrationRequestInput = {
  sourceOrganizationId: Scalars['String']['input'];
  targetOrganizationId: Scalars['String']['input'];
  type: OrganizationIntegrationRequestType;
};

export enum OrganizationIntegrationRequestStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Error = 'ERROR',
  Processed = 'PROCESSED',
  Requested = 'REQUESTED'
}

export enum OrganizationIntegrationRequestType {
  Advertiser = 'ADVERTISER',
  Publisher = 'PUBLISHER'
}

export enum OrganizationInternalType {
  ExternalAdNetwork = 'EXTERNAL_AD_NETWORK',
  SwaarmAdNetwork = 'SWAARM_AD_NETWORK',
  SwaarmMmp = 'SWAARM_MMP'
}

export type OrganizationInvoice = {
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  date: Scalars['LocalDateTime']['output'];
  dueDate?: Maybe<Scalars['LocalDateTime']['output']>;
  invoiceURL: Scalars['String']['output'];
  number: Scalars['String']['output'];
  status: OrganizationInvoiceStatus;
  statusDetails?: Maybe<Scalars['String']['output']>;
};

export type OrganizationInvoiceConnection = {
  edges?: Maybe<Array<OrganizationInvoiceEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationInvoiceEdge = {
  node: OrganizationInvoice;
};

export enum OrganizationInvoiceStatus {
  Cancellation = 'CANCELLATION',
  Cancelled = 'CANCELLED',
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export type OrganizationPlan = {
  type: OrganizationPlanType;
};

export enum OrganizationPlanType {
  App = 'APP',
  Core = 'CORE',
  Premium = 'PREMIUM'
}

export type OrganizationPublisherBillingDetails = {
  billingAddress: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  invoiceFooter?: Maybe<Scalars['String']['output']>;
  invoiceHeader?: Maybe<Scalars['String']['output']>;
  invoiceLineItemText: Scalars['String']['output'];
  numberPrefix: Scalars['String']['output'];
  numberStart: Scalars['Int']['output'];
};

export type OrganizationPublisherBillingDetailsInput = {
  billingAddress: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  invoiceFooter?: InputMaybe<Scalars['String']['input']>;
  invoiceHeader?: InputMaybe<Scalars['String']['input']>;
  invoiceLineItemText: Scalars['String']['input'];
  numberPrefix: Scalars['String']['input'];
  numberStart: Scalars['Int']['input'];
};

export type OrganizationRecurringPaymentMethodMollie = {
  customerId: Scalars['String']['output'];
  redirectURL: Scalars['String']['output'];
};

export type OrganizationRecurringPaymentMethodMollieInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  redirectURL: Scalars['String']['input'];
};

export type OrganizationRecurringPaymentMethodMollieIntegration = {
  cardHolder?: Maybe<Scalars['String']['output']>;
  cardLabel?: Maybe<Scalars['String']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  status: OrganizationRecurringPaymentMethodMollieStatus;
};

export enum OrganizationRecurringPaymentMethodMollieStatus {
  Inactive = 'INACTIVE',
  Invalid = 'INVALID',
  Valid = 'VALID'
}

export type OrganizationRepresentative = {
  contactInfo?: Maybe<OrganizationRepresentativeContact>;
  description?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organization: MarketplaceOrganization;
  position?: Maybe<Scalars['String']['output']>;
};

export type OrganizationRepresentativeContact = {
  email?: Maybe<Scalars['String']['output']>;
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  skypeId?: Maybe<Scalars['String']['output']>;
};

export type OrganizationRepresentativeContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  skypeId?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationRepresentativeInput = {
  contactInfo?: InputMaybe<OrganizationRepresentativeContactInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  position?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationRequest = {
  description?: Maybe<Scalars['String']['output']>;
  geos?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: MarketplaceOrganization;
  periodEndsAt?: Maybe<Scalars['LocalDateTime']['output']>;
  periodStartsAt?: Maybe<Scalars['LocalDateTime']['output']>;
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  type: OrganizationRequestType;
  verticals?: Maybe<Array<Scalars['String']['output']>>;
};

export type OrganizationRequestConnection = {
  edges?: Maybe<Array<OrganizationRequestEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationRequestEdge = {
  node: OrganizationRequest;
};

export type OrganizationRequestFilter = {
  geos?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<OrganizationRequestType>>;
  verticals?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrganizationRequestInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  geos?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  periodEndsAt?: InputMaybe<Scalars['LocalDateTime']['input']>;
  periodStartsAt?: InputMaybe<Scalars['LocalDateTime']['input']>;
  pricePerUnit?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  type: OrganizationRequestType;
  verticals?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum OrganizationRequestType {
  Action = 'ACTION',
  IncentivizedAction = 'INCENTIVIZED_ACTION',
  Install = 'INSTALL',
  Lead = 'LEAD'
}

export enum OrganizationType {
  Lead = 'LEAD',
  Mmp = 'MMP',
  Perform = 'PERFORM',
  Rewarded = 'REWARDED',
  Search = 'SEARCH'
}

export type OrganizationWhiteLabel = {
  backgroundColor?: Maybe<Scalars['String']['output']>;
  brandmarkUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  profitGoal: Scalars['Int']['output'];
};

export type OrganizationWhiteLabelInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  brandmarkUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  profitGoal: Scalars['Int']['input'];
};

export type Os = {
  platform?: Maybe<Platform>;
  version?: Maybe<OsVersion>;
};

export type OsVersion = {
  maxVersion?: Maybe<Scalars['String']['output']>;
  minVersion?: Maybe<Scalars['String']['output']>;
};

/** Describes the amount and starting position of the records to be retrieved */
export type Pagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Offset starting from 0 */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerAdvertiser = {
  accountManager: User;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  offers: PartnerAdvertiserOfferConnection;
  /** Stats associated to this advertiser represented as a time series */
  report: Array<Report>;
  salesManager?: Maybe<User>;
};


export type PartnerAdvertiserOffersArgs = {
  filter?: InputMaybe<PartnerAdvertiserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PartnerAdvertiserOfferSort>;
};


export type PartnerAdvertiserReportArgs = {
  queries: Array<ReportQuery>;
};

export type PartnerAdvertiserEventType = {
  category?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<EventTypeClassification>;
  id?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  payout?: Maybe<PartnerAdvertiserPayout>;
};

export type PartnerAdvertiserFilter = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<OfferStatus>>;
};

export type PartnerAdvertiserOffer = {
  appStoreId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventTypes: Array<PartnerAdvertiserEventType>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paidPayout?: Maybe<PartnerAdvertiserPayout>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Array<Maybe<Report>>>;
  status: OfferStatus;
  targeting: Targeting;
};


export type PartnerAdvertiserOfferReportArgs = {
  queries?: InputMaybe<Array<InputMaybe<ReportQuery>>>;
};

export type PartnerAdvertiserOfferConnection = {
  edges: Array<PartnerAdvertiserOfferEdge>;
  totalCount: Scalars['Int']['output'];
};

export type PartnerAdvertiserOfferEdge = {
  node: PartnerAdvertiserOffer;
};

export type PartnerAdvertiserOfferSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<PartnerAdvertiserSortField>;
  sortQuery?: InputMaybe<SortQuery>;
};

export type PartnerAdvertiserPayout = {
  weGet?: Maybe<Scalars['Float']['output']>;
};

export enum PartnerAdvertiserSortField {
  Id = 'ID'
}

export enum PartnerConversionField {
  ClickPublisherClickId = 'CLICK_PUBLISHER_CLICK_ID',
  ClickTime = 'CLICK_TIME',
  ClickUserDeviceMake = 'CLICK_USER_DEVICE_MAKE',
  ClickUserDeviceModel = 'CLICK_USER_DEVICE_MODEL',
  ClickUserDeviceOs = 'CLICK_USER_DEVICE_OS',
  ClickUserDeviceOsVersion = 'CLICK_USER_DEVICE_OS_VERSION',
  OfferEventId = 'OFFER_EVENT_ID',
  OfferEventName = 'OFFER_EVENT_NAME',
  OfferId = 'OFFER_ID',
  OfferName = 'OFFER_NAME',
  OfferOriginalCurrency = 'OFFER_ORIGINAL_CURRENCY',
  OfferOriginalTheyGet = 'OFFER_ORIGINAL_THEY_GET',
  OfferTheyGet = 'OFFER_THEY_GET',
  OfferTheyGetCurrency = 'OFFER_THEY_GET_CURRENCY',
  PostbackId = 'POSTBACK_ID',
  PostbackImpressionAttribution = 'POSTBACK_IMPRESSION_ATTRIBUTION',
  PostbackTime = 'POSTBACK_TIME',
  PublisherAppName = 'PUBLISHER_APP_NAME',
  PublisherPlacement = 'PUBLISHER_PLACEMENT',
  PublisherPostbackHttpStatusCode = 'PUBLISHER_POSTBACK_HTTP_STATUS_CODE',
  PublisherPostbackUrl = 'PUBLISHER_POSTBACK_URL',
  PublisherSite = 'PUBLISHER_SITE',
  PublisherSubId = 'PUBLISHER_SUB_ID',
  PublisherSubSubId = 'PUBLISHER_SUB_SUB_ID'
}

export type PartnerConversionReportFilter = {
  field: PartnerConversionField;
  operator: GenericFilterOperator;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartnerConversionReportRecord = {
  field: PartnerConversionField;
  value?: Maybe<UserProvidedValue>;
};

export type PartnerConversionReportRow = {
  records: Array<PartnerConversionReportRecord>;
};

export type PartnerConversionReportRowConnection = {
  csvDownloadUrl: Scalars['String']['output'];
  edges?: Maybe<Array<PartnerConversionReportRowEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type PartnerConversionReportRowEdge = {
  node: PartnerConversionReportRow;
};

export type PartnerConversionReportSort = {
  field: PartnerConversionField;
  order: SortOrder;
};

export type PartnerPublisher = {
  accountManager: User;
  accountType?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  allowedSubIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Relationships */
  apiKeys?: Maybe<Array<Scalars['String']['output']>>;
  balance: Scalars['Float']['output'];
  country?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  feedUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isApiPublisher: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  offers?: Maybe<Array<Maybe<PartnerPublisherOffer>>>;
  offersV2: PartnerPublisherOfferConnection;
  payment: PartnerPublisherPayment;
  paymentDetails?: Maybe<PublisherPaymentDetails>;
  payments: PartnerPublisherPaymentConnection;
  phone?: Maybe<Scalars['String']['output']>;
  postbackLinks?: Maybe<Array<PostbackLink>>;
  /** Stats associated to this publisher represented as a time series */
  report: Array<Report>;
  salesManager?: Maybe<User>;
  searchStatsExample: Scalars['String']['output'];
  searchStatsUrl: Scalars['String']['output'];
  smartLinks: PartnerPublisherSmartLinkConnection;
  taxNumber?: Maybe<Scalars['String']['output']>;
  tipaltiIframe?: Maybe<Scalars['String']['output']>;
};


export type PartnerPublisherOffersArgs = {
  filter?: InputMaybe<PartnerPublisherOfferFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<PartnerPublisherOfferSort>;
};


export type PartnerPublisherOffersV2Args = {
  filter?: InputMaybe<PartnerPublisherOfferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PartnerPublisherOfferSort>;
};


export type PartnerPublisherPaymentArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type PartnerPublisherPaymentsArgs = {
  filter?: InputMaybe<PartnerPublisherPaymentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PartnerPublisherReportArgs = {
  queries: Array<ReportQuery>;
};


export type PartnerPublisherSmartLinksArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Describes a the view or a partner publisher into an advertiser */
export type PartnerPublisherAdvertiser = {
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Limited budget view for publisher partners */
export type PartnerPublisherBudget = {
  advertiser: PartnerPublisherAdvertiser;
  /** the total amount available in the given period */
  amount: Scalars['Float']['output'];
  /** the consumed amount for the given period */
  consumed: Scalars['Float']['output'];
  eventType?: Maybe<PartnerPublisherEventType>;
  offer?: Maybe<PartnerPublisherOffer>;
  publisher?: Maybe<PartnerPublisher>;
  status: Status;
  threshold?: Maybe<BudgetThreshold>;
  type: BudgetType;
  validity: BudgetValidity;
};

export type PartnerPublisherConfig = {
  conversionReportEnabled: Scalars['Boolean']['output'];
  editPostbacksEnabled: Scalars['Boolean']['output'];
  eventsInReportsEnabled: Scalars['Boolean']['output'];
  excludeSmartlinkFeeds: Scalars['Boolean']['output'];
  offerMetricsInDashboardEnabled: Scalars['Boolean']['output'];
  offerTagsEnabled: Scalars['Boolean']['output'];
  offerTagsLabel?: Maybe<Scalars['String']['output']>;
  offersEnabled: Scalars['Boolean']['output'];
  privacyPolicy?: Maybe<Scalars['String']['output']>;
  referralsEnabled: Scalars['Boolean']['output'];
  smartlinksEnabled: Scalars['Boolean']['output'];
  supportTicketsEnabled: Scalars['Boolean']['output'];
  termsAndConditions?: Maybe<Scalars['String']['output']>;
};

export type PartnerPublisherConfigInput = {
  conversionReportEnabled: Scalars['Boolean']['input'];
  editPostbacksEnabled: Scalars['Boolean']['input'];
  eventsInReportsEnabled: Scalars['Boolean']['input'];
  excludeSmartlinkFeeds: Scalars['Boolean']['input'];
  offerMetricsInDashboardEnabled: Scalars['Boolean']['input'];
  offerTagsEnabled: Scalars['Boolean']['input'];
  offerTagsLabel?: InputMaybe<Scalars['String']['input']>;
  offersEnabled: Scalars['Boolean']['input'];
  privacyPolicy?: InputMaybe<Scalars['String']['input']>;
  referralsEnabled: Scalars['Boolean']['input'];
  smartlinksEnabled: Scalars['Boolean']['input'];
  supportTicketsEnabled: Scalars['Boolean']['input'];
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
};

/** A view of the Event Type for publisher partners */
export type PartnerPublisherEventType = {
  category?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<EventTypeClassification>;
  id?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  margin?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  offer?: Maybe<PartnerPublisherOffer>;
};

export type PartnerPublisherLandingPage = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** An offer that contains the information allowed to be show for a publisher */
export type PartnerPublisherOffer = {
  accessState: OfferAccessState;
  additionalInformation?: Maybe<Scalars['String']['output']>;
  advertiser?: Maybe<PartnerPublisherAdvertiser>;
  appStoreId?: Maybe<Scalars['String']['output']>;
  budget?: Maybe<PartnerPublisherBudget>;
  budgets: Array<PartnerPublisherBudget>;
  conversionTrackingType: Scalars['Int']['output'];
  creatives?: Maybe<Array<CreativePack>>;
  creativesURL?: Maybe<Scalars['String']['output']>;
  customRestrictions?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  eventTypes: Array<PartnerPublisherEventType>;
  htmlTemplates?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  impressionTrackingLink: Scalars['String']['output'];
  isApprovalRequired: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  kpi?: Maybe<Scalars['String']['output']>;
  landingPages: Array<PartnerPublisherLandingPage>;
  leadflow: Scalars['String']['output'];
  margin?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  paidPayout?: Maybe<PartnerPublisherPayout>;
  paidPayouts: Array<PartnerPublisherPayout>;
  payout?: Maybe<PartnerPublisherPayout>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  /** Stats associated to this offer represented as a time series. */
  report?: Maybe<Array<Maybe<Report>>>;
  restrictions: Array<Maybe<Scalars['String']['output']>>;
  revenueShareEnabled?: Maybe<Scalars['Boolean']['output']>;
  sourceOfferId?: Maybe<Scalars['String']['output']>;
  stats: PartnerPublisherOfferStats;
  status: OfferStatus;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  targetedPayouts: Array<PartnerPublisherTargetedPayout>;
  targeting: Targeting;
  trackingLink: Scalars['String']['output'];
  vtaEnabled?: Maybe<Scalars['Boolean']['output']>;
};


/** An offer that contains the information allowed to be show for a publisher */
export type PartnerPublisherOfferReportArgs = {
  queries?: InputMaybe<Array<InputMaybe<ReportQuery>>>;
};

export type PartnerPublisherOfferConnection = {
  edges: Array<PartnerPublisherOfferEdge>;
  totalCount: Scalars['Int']['output'];
};

export type PartnerPublisherOfferEdge = {
  node: PartnerPublisherOffer;
};

export type PartnerPublisherOfferFilter = {
  accessState?: InputMaybe<Array<OfferAccessState>>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  isApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<OfferStatus>>;
  subset?: InputMaybe<Array<InputMaybe<PartnerPublisherOfferSubset>>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PartnerPublisherOfferSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<PartnerPublisherSortField>;
  sortQuery?: InputMaybe<SortQuery>;
};

export type PartnerPublisherOfferStats = {
  cr?: Maybe<Scalars['Float']['output']>;
  epc?: Maybe<Scalars['Float']['output']>;
};

export enum PartnerPublisherOfferSubset {
  New = 'NEW',
  Running = 'RUNNING'
}

export type PartnerPublisherPayment = {
  amount: Scalars['Float']['output'];
  createdAt: Scalars['LocalDateTime']['output'];
  end: Scalars['LocalDateTime']['output'];
  id: Scalars['String']['output'];
  paymentProcessorResponse?: Maybe<Array<PublisherPaymentParam>>;
  publisherNote?: Maybe<Scalars['String']['output']>;
  start: Scalars['LocalDateTime']['output'];
  status: PublisherPaymentStatus;
};

export type PartnerPublisherPaymentConnection = {
  edges?: Maybe<Array<PartnerPublisherPaymentEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type PartnerPublisherPaymentEdge = {
  node: PartnerPublisherPayment;
};

export type PartnerPublisherPaymentFilter = {
  createdAtEnd?: InputMaybe<Scalars['LocalDateTime']['input']>;
  createdAtStart?: InputMaybe<Scalars['LocalDateTime']['input']>;
  status?: InputMaybe<Array<PublisherPaymentStatus>>;
};

export type PartnerPublisherPaymentInput = {
  amount: Scalars['Float']['input'];
  end: Scalars['LocalDateTime']['input'];
  publisherId?: InputMaybe<Scalars['String']['input']>;
  publisherNote?: InputMaybe<Scalars['String']['input']>;
  rewardedUserId?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['LocalDateTime']['input'];
};

/** Describes how much money we receive for an event (weGet) and how much we pay our publisher (theyGet) */
export type PartnerPublisherPayout = {
  eventType?: Maybe<PartnerPublisherEventType>;
  offer: PartnerPublisherOffer;
  publisher?: Maybe<PartnerPublisher>;
  /** In USD dollars */
  theyGet?: Maybe<Scalars['Float']['output']>;
};

export type PartnerPublisherSmartLink = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PartnerPublisherSmartLinkConnection = {
  edges: Array<PartnerPublisherSmartLinkEdge>;
  totalCount: Scalars['Int']['output'];
};

export type PartnerPublisherSmartLinkEdge = {
  node: PartnerPublisherSmartLink;
};

export enum PartnerPublisherSortField {
  Clicks = 'CLICKS',
  Conversions = 'CONVERSIONS',
  Cr = 'CR',
  Id = 'ID',
  Impressions = 'IMPRESSIONS',
  OfferCr = 'OFFER_CR',
  OfferEpc = 'OFFER_EPC',
  PaidConversions = 'PAID_CONVERSIONS',
  Payout = 'PAYOUT',
  TheyGet = 'THEY_GET'
}

export type PartnerPublisherTargetedPayout = {
  advancedTargetingGroup: AdvancedTargetingGroup;
  eventType?: Maybe<PartnerPublisherEventType>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  offer: PartnerPublisherOffer;
  /** In USD dollars */
  theyGet?: Maybe<Scalars['Float']['output']>;
};

export type PartnerRawFilterClause = {
  dimension: PartnerRawStatsDimension;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type PartnerRawQuery = {
  dimensions: Array<PartnerRawStatsDimension>;
  filters?: InputMaybe<Array<PartnerRawFilterClause>>;
  metrics: Array<PartnerRawStatsMetric>;
  pagination: RawQueryPaginationInput;
  sort: PartnerRawQuerySort;
  timeRange: RawDateRangeInput;
};

export type PartnerRawQuerySort = {
  dimension?: InputMaybe<PartnerRawStatsDimension>;
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<PartnerRawStatsMetric>;
};

export type PartnerRawReport = {
  /** In order to download this report you have to call /download/raw-reports/{downloadToken} */
  downloadToken: Scalars['String']['output'];
  results: Array<PartnerRawRow>;
  totals?: Maybe<Array<PartnerRawStatsMetricResult>>;
};

export type PartnerRawRow = {
  dimensions: Array<PartnerRawStatsDimensionResult>;
  metrics: Array<PartnerRawStatsMetricResult>;
};

export enum PartnerRawStatsDimension {
  Date = 'DATE',
  DateDay = 'DATE_DAY',
  DateHour = 'DATE_HOUR',
  DateMonth = 'DATE_MONTH',
  DateYear = 'DATE_YEAR',
  EventTypeId = 'EVENT_TYPE_ID',
  EventTypeName = 'EVENT_TYPE_NAME',
  OfferAppId = 'OFFER_APP_ID',
  OfferId = 'OFFER_ID',
  OfferName = 'OFFER_NAME',
  PublisherPlacement = 'PUBLISHER_PLACEMENT',
  PublisherSite = 'PUBLISHER_SITE',
  PublisherSubId = 'PUBLISHER_SUB_ID',
  PublisherSubSubId = 'PUBLISHER_SUB_SUB_ID',
  RecommendationId = 'RECOMMENDATION_ID',
  RewardedUserId = 'REWARDED_USER_ID',
  UserGeoCountry = 'USER_GEO_COUNTRY'
}

export type PartnerRawStatsDimensionResult = {
  name: PartnerRawStatsDimension;
  value?: Maybe<Scalars['String']['output']>;
};

export enum PartnerRawStatsMetric {
  ActConversions = 'ACT_CONVERSIONS',
  ActPaidConversions = 'ACT_PAID_CONVERSIONS',
  ActWeGet = 'ACT_WE_GET',
  AdClicks = 'AD_CLICKS',
  Clicks = 'CLICKS',
  Coverage = 'COVERAGE',
  Impressions = 'IMPRESSIONS',
  MonetizedSearches = 'MONETIZED_SEARCHES',
  PubConversions = 'PUB_CONVERSIONS',
  PubConversionRate = 'PUB_CONVERSION_RATE',
  PubPaidConversions = 'PUB_PAID_CONVERSIONS',
  PubTheyGet = 'PUB_THEY_GET',
  ReversedPubConversions = 'REVERSED_PUB_CONVERSIONS',
  ReversedTheyGet = 'REVERSED_THEY_GET',
  Searches = 'SEARCHES',
  SearchCtr = 'SEARCH_CTR',
  SearchMonetizedCtr = 'SEARCH_MONETIZED_CTR',
  SearchMonetizedPrpm = 'SEARCH_MONETIZED_PRPM',
  SearchMonetizedRpm = 'SEARCH_MONETIZED_RPM',
  SearchPrpc = 'SEARCH_PRPC',
  SearchPrpm = 'SEARCH_PRPM',
  SearchQualityAdvertiserScore = 'SEARCH_QUALITY_ADVERTISER_SCORE',
  SearchRpc = 'SEARCH_RPC',
  SearchRpm = 'SEARCH_RPM'
}

export type PartnerRawStatsMetricResult = {
  name: PartnerRawStatsMetric;
  value?: Maybe<Scalars['String']['output']>;
};

export type Payout = {
  audits: Array<Audit>;
  eventType?: Maybe<EventType>;
  /** Margin applied to theyGet (theyGet = weGet * (1 - margin)) */
  margin?: Maybe<Scalars['Float']['output']>;
  offer: Offer;
  publisher?: Maybe<Publisher>;
  /** Display-only origin of the effective theyGetPoints at this payout's key (incl. POINTS_EXCHANGE_RATE). */
  renderedTheyGetPointsSource?: Maybe<TheyGetSource>;
  /** Display-only origin of the effective theyGet at this payout's key. */
  renderedTheyGetSource?: Maybe<TheyGetSource>;
  /**
   * Display-only origin of the effective weGet at this payout's key (see TheyGetSource), so listings
   * that read legacy Payout rows (e.g. paidPayout) can label values like the split-payout views do.
   */
  renderedWeGetSource?: Maybe<TheyGetSource>;
  specificity?: Maybe<OfferPublisherPayoutType>;
  /** In USD dollars */
  theyGet?: Maybe<Scalars['Float']['output']>;
  theyGetPoints?: Maybe<Scalars['Float']['output']>;
  /** In USD dollars */
  weGet?: Maybe<Scalars['Float']['output']>;
  /** Independent margin stored on the weGet component (not derived) */
  weGetMargin?: Maybe<Scalars['Float']['output']>;
};

/** How the input amount is turned into the player's reward. */
export enum PayoutAdjustmentStrategy {
  Exact = 'EXACT',
  Margin = 'MARGIN',
  Multiplier = 'MULTIPLIER'
}

export type PayoutBound = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

/** Payout cherry-picking: users who only complete the high-value events and never the cheaper ones */
export enum PayoutCherryPickingSortBy {
  CompletedEvents = 'COMPLETED_EVENTS',
  PayoutRatio = 'PAYOUT_RATIO',
  TheyGet = 'THEY_GET',
  TotalConversions = 'TOTAL_CONVERSIONS',
  UserMinPayout = 'USER_MIN_PAYOUT',
  WeGet = 'WE_GET'
}

/**
 * One component of a composite save. value is USD for the monetary components and raw points for the
 * points component.
 */
export type PayoutComponentInput = {
  margin?: InputMaybe<Scalars['Float']['input']>;
  op: PayoutComponentOp;
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** The operation to apply to a single component within a composite save. */
export enum PayoutComponentOp {
  Delete = 'DELETE',
  Upsert = 'UPSERT'
}

export type PayoutConversionPolicy = {
  /** Margin fraction (MARGIN) or multiplier factor (MULTIPLIER); ignored for EXACT. */
  adjustmentValue?: Maybe<Scalars['Float']['output']>;
  advertiserId: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Points per one USD, used whenever a conversion crosses the money <-> points line. */
  pointsPerUsd?: Maybe<Scalars['Float']['output']>;
  primarySignal?: Maybe<PayoutSignal>;
  strategy?: Maybe<PayoutAdjustmentStrategy>;
  userPayoutTarget?: Maybe<PayoutTarget>;
};

export type PayoutConversionPolicyInput = {
  adjustmentValue?: InputMaybe<Scalars['Float']['input']>;
  advertiserId: Scalars['String']['input'];
  pointsPerUsd?: InputMaybe<Scalars['Float']['input']>;
  primarySignal?: InputMaybe<PayoutSignal>;
  strategy?: InputMaybe<PayoutAdjustmentStrategy>;
  userPayoutTarget?: InputMaybe<PayoutTarget>;
};

export type PayoutEditFilter = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PayoutEditImportError = {
  eventTypeId?: Maybe<Scalars['String']['output']>;
  offerId?: Maybe<Scalars['String']['output']>;
  publisherId?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type PayoutEditImportResult = {
  created: Scalars['Int']['output'];
  errorDetails: Array<PayoutEditImportError>;
  errors: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type PayoutEmailContext = {
  currency?: Maybe<Scalars['String']['output']>;
  theyGet?: Maybe<Scalars['String']['output']>;
  weGet?: Maybe<Scalars['String']['output']>;
};

export type PayoutInput = {
  key: PayoutKey;
  margin?: InputMaybe<Scalars['Float']['input']>;
  theyGet?: InputMaybe<Scalars['Float']['input']>;
  theyGetPoints?: InputMaybe<Scalars['Float']['input']>;
  weGet?: InputMaybe<Scalars['Float']['input']>;
};

export type PayoutKey = {
  eventTypeId?: InputMaybe<Scalars['String']['input']>;
  offerId: Scalars['String']['input'];
  publisherId?: InputMaybe<Scalars['String']['input']>;
};

export type PayoutMargin = {
  advertiserId?: Maybe<Scalars['String']['output']>;
  eventTypeId?: Maybe<Scalars['String']['output']>;
  margin: Scalars['Float']['output'];
  offerId?: Maybe<Scalars['String']['output']>;
  publisherId?: Maybe<Scalars['String']['output']>;
};

export type PayoutMarginFilter = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  eventTypeId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
};

export type PayoutMarginInput = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  eventTypeId?: InputMaybe<Scalars['String']['input']>;
  margin: Scalars['Float']['input'];
  offerId?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
};

export type PayoutMarginKey = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  eventTypeId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Per-advertiser rule for turning what a network reports into what the player is paid.
 * Applied at render time; a stored/manual payout value always wins over a policy-derived one.
 * How to interpret the number a network reports for an offer.
 */
export enum PayoutSignal {
  TheyGetPoints = 'THEY_GET_POINTS',
  TheyGetUsd = 'THEY_GET_USD',
  WeGetPoints = 'WE_GET_POINTS',
  WeGetUsd = 'WE_GET_USD'
}

/** What the player is paid in. */
export enum PayoutTarget {
  Points = 'POINTS',
  Usd = 'USD'
}

/**
 * Composite view bundling the three independently-stored payout components for one
 * (offer, publisher, event type) key. Any component may be null when no value is set.
 */
export type PayoutV2 = {
  /**
   * Display-only effective margin fraction (0..1) that produced renderedTheyGet, when it was margin-
   * derived (component margin or a configured PayoutMargin at any scope). Null when theyGet is an
   * explicit value, policy-derived, or nothing resolves. Never send this back as a stored margin.
   */
  renderedMargin?: Maybe<Scalars['Float']['output']>;
  /**
   * Display-only effective publisher payout in USD, resolved the same way scutum/postbackstream pay:
   * theyGet.value if set, else weGet x (1 - margin) using theyGet.margin or, when absent, the most
   * specific configured PayoutMargin. Null when nothing resolves. Never send this back as theyGet.value
   * on a save - it is derived, not a stored value.
   */
  renderedTheyGet?: Maybe<Scalars['Float']['output']>;
  /**
   * Display-only effective player points reward, resolved the same way scutum/postbackstream pay:
   * the stored theyGetPoints value if set, else derived by the advertiser's payout conversion policy
   * (e.g. weGetPoints × rate/margin), else theyGet × the publisher's points exchange rate. Null when
   * nothing resolves. Never send this back as a stored value.
   */
  renderedTheyGetPoints?: Maybe<Scalars['Float']['output']>;
  /**
   * Origin of the effective player points reward (renderedTheyGetPoints): FIXED_BY_OPERATOR for a manual
   * value, ADVERTISER_POLICY when derived by the advertiser's conversion policy, FIXED_BY_NETWORK for a
   * raw imported value when no policy applies, POINTS_EXCHANGE_RATE when derived as theyGet × the
   * publisher's points exchange rate, NONE when nothing resolves.
   */
  renderedTheyGetPointsSource: TheyGetSource;
  /**
   * What determined renderedTheyGet (and renderedMargin), so the UI can show a single consistent
   * source label next to both. NONE when renderedTheyGet is null.
   */
  renderedTheyGetSource: TheyGetSource;
  /**
   * Origin of the effective weGet points (the points the network pays us): FIXED_BY_OPERATOR when set
   * manually, FIXED_BY_NETWORK when imported, NONE when there are none. Lets the UI label weGetPoints.
   */
  renderedWeGetPointsSource: TheyGetSource;
  /**
   * Origin of the effective weGet (the amount the network pays us): FIXED_BY_OPERATOR when set manually,
   * FIXED_BY_NETWORK when imported, NONE when there is no weGet. Lets the UI label weGet consistently.
   */
  renderedWeGetSource: TheyGetSource;
  theyGet?: Maybe<TheyGetPayout>;
  theyGetPoints?: Maybe<TheyGetPointsPayout>;
  weGet?: Maybe<WeGetPayout>;
  weGetPoints?: Maybe<WeGetPointsPayout>;
};

/**
 * Composite save input. A component left out (null) is untouched; a present component applies its op,
 * so a single mutation can create one component, delete another and update the third.
 */
export type PayoutV2Input = {
  key: PayoutKey;
  theyGet?: InputMaybe<PayoutComponentInput>;
  theyGetPoints?: InputMaybe<PayoutComponentInput>;
  weGet?: InputMaybe<PayoutComponentInput>;
  weGetPoints?: InputMaybe<PayoutComponentInput>;
};

export enum Permission {
  Admin = 'ADMIN',
  Adops = 'ADOPS',
  Guest = 'GUEST',
  Manager = 'MANAGER',
  RestrictedAffiliateManager = 'RESTRICTED_AFFILIATE_MANAGER',
  RestrictedManager = 'RESTRICTED_MANAGER',
  User = 'USER'
}

export type PermissionConfig = {
  tags: TagsPermissionConfig;
};

export type PermissionConfigInput = {
  tags: TagsPermissionConfigInput;
};

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export enum PlatformType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type PossibleRuleCustomization = {
  active: Scalars['Boolean']['output'];
  namespace: RuleNamespace;
  parameters: Array<RuleCustomizationParameter>;
  rule: Scalars['String']['output'];
};

export enum PostbackDecision {
  Failed = 'FAILED',
  Passed = 'PASSED'
}

export type PostbackEditModificationBatchInput = {
  end?: Maybe<Scalars['LocalDateTime']['output']>;
  filters?: Maybe<Array<ConversionReportFilterSnapshot>>;
  firePostbacks?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  postbackEdit: PostbackEditModificationInputSnapshot;
  postbackIds?: Maybe<Array<Scalars['String']['output']>>;
  sort?: Maybe<ConversionReportSortSnapshot>;
  start?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type PostbackEditModificationInput = {
  decision?: InputMaybe<PostbackDecision>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Move the conversion to this time (UTC). The conversion gets a new id since the time is encoded in it. */
  postbackTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  state?: InputMaybe<PostbackState>;
  theyGet?: InputMaybe<Scalars['Float']['input']>;
  theyGetPoints?: InputMaybe<Scalars['Float']['input']>;
  weGet?: InputMaybe<Scalars['Float']['input']>;
};

export type PostbackEditModificationInputSnapshot = {
  decision?: Maybe<PostbackDecision>;
  id?: Maybe<Scalars['ID']['output']>;
  postbackId?: Maybe<Scalars['String']['output']>;
  postbackTime?: Maybe<Scalars['LocalDateTime']['output']>;
  state?: Maybe<PostbackState>;
  theyGet?: Maybe<Scalars['Float']['output']>;
  theyGetPoints?: Maybe<Scalars['Float']['output']>;
  weGet?: Maybe<Scalars['Float']['output']>;
};

export type PostbackEvaluation = {
  activeRules: Array<Scalars['String']['output']>;
  decision: PostbackDecision;
  failedRules: Array<Scalars['String']['output']>;
  originalDecision?: Maybe<PostbackDecision>;
};

export type PostbackEvaluationInput = {
  activeRules?: InputMaybe<Array<Scalars['String']['input']>>;
  decision: PostbackDecision;
  failedRules?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum PostbackEvaluationRule {
  ActionToActionTime = 'ACTION_TO_ACTION_TIME',
  AdvertiserBlockedPublisher = 'ADVERTISER_BLOCKED_PUBLISHER',
  AnyBudgetReached = 'ANY_BUDGET_REACHED',
  BannedUser = 'BANNED_USER',
  BlacklistedSubId = 'BLACKLISTED_SUB_ID',
  BudgetReached = 'BUDGET_REACHED',
  ClickToActionTime = 'CLICK_TO_ACTION_TIME',
  ClickToDefaultActionTime = 'CLICK_TO_DEFAULT_ACTION_TIME',
  ClickToInstallTime = 'CLICK_TO_INSTALL_TIME',
  EnforceEventSettings = 'ENFORCE_EVENT_SETTINGS',
  EventTypePrivate = 'EVENT_TYPE_PRIVATE',
  FieldPatternMatch = 'FIELD_PATTERN_MATCH',
  OfferNotActive = 'OFFER_NOT_ACTIVE',
  PostbackIsRejected = 'POSTBACK_IS_REJECTED',
  PublisherNotApproved = 'PUBLISHER_NOT_APPROVED',
  RandomEvaluation = 'RANDOM_EVALUATION',
  TrafficControl = 'TRAFFIC_CONTROL',
  TwentyFourMetrics = 'TWENTY_FOUR_METRICS'
}

export type PostbackFileModification = {
  /** Event ID / Adv. Event Type values that are not events of the click's offer (with the click id); those rows were skipped. */
  invalidEventTypes?: Maybe<Array<Scalars['String']['output']>>;
  matched: Scalars['Int']['output'];
  unmatched: Scalars['Int']['output'];
  /** Click ids (or click id + event type rows) that matched no conversion. */
  unmatchedClickIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Postback ids that matched no conversion. */
  unmatchedPostbackIds?: Maybe<Array<Scalars['String']['output']>>;
};

/** The Postback link represents the URL that is called for a publisher when an event is received */
export type PostbackLink = {
  advertiserRejected: Scalars['Boolean']['output'];
  attributionRestriction: PostbackLinkAttributionRestriction;
  body?: Maybe<Scalars['String']['output']>;
  /** Forward only postbacks with one of these evaluation decisions. Null/empty = no restriction. */
  decisions?: Maybe<Array<PostbackDecision>>;
  /**
   * First entry of eventTypeIds, kept for older clients.
   * @deprecated Use eventTypeIds
   */
  eventTypeId?: Maybe<Scalars['String']['output']>;
  /**
   * Event types (of offerId) the link includes or excludes, depending on eventTypeMode; "" stands for the
   * offer's default event. Empty for mode ALL.
   */
  eventTypeIds?: Maybe<Array<Scalars['String']['output']>>;
  eventTypeMode: PostbackLinkEventTypeMode;
  /** If non-empty, a postback that failed evaluation rules is only forwarded when at least one of them is in this list. */
  failedEvaluationRules?: Maybe<Array<Scalars['String']['output']>>;
  /** If non-empty, a postback that failed status rules is only forwarded when at least one of them is in this list. */
  failedStatusRules?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Also forward advertiser reversals (reversal=true postbacks) of conversions this link forwarded. The link is
   * rendered as-is with the reversed conversion as macro context; use the #{reversal.*} macros to tell the partner.
   */
  forwardReversals: Scalars['Boolean']['output'];
  headers?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  level?: Maybe<PostbackLinkLevel>;
  method?: Maybe<PostbackLinkMethod>;
  offerId?: Maybe<Scalars['String']['output']>;
  onlyPaidPostbacks: Scalars['Boolean']['output'];
  postbackUrl: Scalars['String']['output'];
  publisherId?: Maybe<Scalars['String']['output']>;
  /** Forward only postbacks in one of these states. Null/empty = no restriction (unless legacy statusLevels apply). */
  states?: Maybe<Array<PostbackState>>;
  /** @deprecated Use states/decisions/failedStatusRules/failedEvaluationRules */
  statusLevels: Array<PostbackStatusLevel>;
};

export enum PostbackLinkAttributionRestriction {
  Both = 'BOTH',
  ClickId = 'CLICK_ID',
  PeaChain = 'PEA_CHAIN'
}

/** How eventTypeIds restricts the events a postback link forwards. */
export enum PostbackLinkEventTypeMode {
  /**
   * Every event of the offer, including ones created later (INCLUDE links for the same publisher/offer take
   * precedence for the events they list).
   */
  All = 'ALL',
  /** Every event of the offer, including ones created later, except the listed ones. */
  Exclude = 'EXCLUDE',
  /** Only the listed events. */
  Include = 'INCLUDE'
}

export type PostbackLinkInput = {
  advertiserRejected?: InputMaybe<Scalars['Boolean']['input']>;
  attributionRestriction?: InputMaybe<PostbackLinkAttributionRestriction>;
  body?: InputMaybe<Scalars['String']['input']>;
  decisions?: InputMaybe<Array<PostbackDecision>>;
  /** Legacy single event type; ignored when eventTypeIds is non-empty. */
  eventTypeId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Event types (of offerId) the link includes or excludes, depending on eventTypeMode; "" stands for the
   * offer's default event.
   */
  eventTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Defaults to ALL when eventTypeIds is empty, INCLUDE otherwise. INCLUDE/EXCLUDE require a non-empty list. */
  eventTypeMode?: InputMaybe<PostbackLinkEventTypeMode>;
  failedEvaluationRules?: InputMaybe<Array<Scalars['String']['input']>>;
  failedStatusRules?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Defaults to false. */
  forwardReversals?: InputMaybe<Scalars['Boolean']['input']>;
  headers?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<PostbackLinkLevel>;
  method?: InputMaybe<PostbackLinkMethod>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  onlyPaidPostbacks?: InputMaybe<Scalars['Boolean']['input']>;
  postbackUrl: Scalars['String']['input'];
  publisherId?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<PostbackState>>;
  statusLevels?: InputMaybe<Array<PostbackStatusLevel>>;
};

export enum PostbackLinkLevel {
  Both = 'BOTH',
  Default = 'DEFAULT',
  Event = 'EVENT'
}

export enum PostbackLinkMethod {
  Get = 'GET',
  Post = 'POST'
}

export type PostbackLog = {
  clickId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  offer?: Maybe<Offer>;
  postbackId?: Maybe<Scalars['String']['output']>;
  publisher?: Maybe<Publisher>;
  queryString?: Maybe<Scalars['String']['output']>;
  serverIp?: Maybe<Scalars['String']['output']>;
  serverUa?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PostbackLogStatus>;
  time?: Maybe<Scalars['String']['output']>;
};

export type PostbackLogConnection = {
  edges: Array<PostbackLogEdge>;
  totalCount: Scalars['Long']['output'];
};

export type PostbackLogEdge = {
  node: PostbackLog;
};

export enum PostbackLogField {
  ClickId = 'CLICK_ID',
  Errors = 'ERRORS',
  OfferId = 'OFFER_ID',
  PostbackId = 'POSTBACK_ID',
  PublisherId = 'PUBLISHER_ID',
  QueryString = 'QUERY_STRING',
  ServerIp = 'SERVER_IP',
  ServerUa = 'SERVER_UA',
  Status = 'STATUS',
  Time = 'TIME'
}

export type PostbackLogFilter = {
  field: PostbackLogField;
  operator: GenericFilterOperator;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PostbackLogSort = {
  field: PostbackLogField;
  order: SortOrder;
};

export enum PostbackLogStatus {
  Failed = 'FAILED',
  Reversal = 'REVERSAL',
  Success = 'SUCCESS'
}

export type PostbackModification = {
  decision?: Maybe<PostbackDecision>;
  id: Scalars['ID']['output'];
  modificationStatus: PostbackModificationStatus;
  postbackId: Scalars['String']['output'];
  postbackTime?: Maybe<Scalars['LocalDateTime']['output']>;
  state?: Maybe<PostbackState>;
  theyGet?: Maybe<Scalars['Float']['output']>;
  theyGetPoints?: Maybe<Scalars['Float']['output']>;
  weGet?: Maybe<Scalars['Float']['output']>;
};

export type PostbackModificationFileBatchInput = {
  advEventTypeColumn?: Maybe<Scalars['Int']['output']>;
  clickIdColumn?: Maybe<Scalars['Int']['output']>;
  createPostbacks?: Maybe<Scalars['Boolean']['output']>;
  csvSeparator?: Maybe<Scalars['String']['output']>;
  csvUrl?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<PostbackDecision>;
  decisionColumn?: Maybe<Scalars['Int']['output']>;
  eventTypeIdColumn?: Maybe<Scalars['Int']['output']>;
  postbackIdColumn?: Maybe<Scalars['Int']['output']>;
  postbackTimeColumn?: Maybe<Scalars['Int']['output']>;
  preview?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<PostbackState>;
  stateColumn?: Maybe<Scalars['Int']['output']>;
  theyGet?: Maybe<Scalars['Float']['output']>;
  theyGetColumn?: Maybe<Scalars['Int']['output']>;
  weGet?: Maybe<Scalars['Float']['output']>;
  weGetColumn?: Maybe<Scalars['Int']['output']>;
};

export type PostbackModificationFileInstructionsInput = {
  /** Together with clickIdColumn: only the click's conversion whose event type has this advertiser event id is matched. Created conversions get this event type. */
  advEventTypeColumn?: InputMaybe<Scalars['Int']['input']>;
  /** Column with the click id. Required unless postbackIdColumn is set, and required to create conversions. */
  clickIdColumn?: InputMaybe<Scalars['Int']['input']>;
  createPostbacks?: InputMaybe<Scalars['Boolean']['input']>;
  csvSeparator?: InputMaybe<Scalars['String']['input']>;
  csvUrl: Scalars['String']['input'];
  decision?: InputMaybe<PostbackDecision>;
  decisionColumn?: InputMaybe<Scalars['Int']['input']>;
  /** Together with clickIdColumn: only the click's conversion of this event type is matched (the default event is matched by its 'null-<offerId>' id). */
  eventTypeIdColumn?: InputMaybe<Scalars['Int']['input']>;
  /** Column with the conversion (postback) id. Rows with a postback id match that conversion directly; the event type columns are not applied to them. */
  postbackIdColumn?: InputMaybe<Scalars['Int']['input']>;
  postbackTimeColumn?: InputMaybe<Scalars['Int']['input']>;
  preview: Scalars['Boolean']['input'];
  state?: InputMaybe<PostbackState>;
  stateColumn?: InputMaybe<Scalars['Int']['input']>;
  theyGet?: InputMaybe<Scalars['Float']['input']>;
  theyGetColumn?: InputMaybe<Scalars['Int']['input']>;
  weGet?: InputMaybe<Scalars['Float']['input']>;
  weGetColumn?: InputMaybe<Scalars['Int']['input']>;
};

export enum PostbackModificationStatus {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  ReadyForClickhouse = 'READY_FOR_CLICKHOUSE',
  ReadyForDruid = 'READY_FOR_DRUID'
}

export type PostbackResponse = {
  httpStatusCode?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PostbackResponseInput = {
  httpStatusCode?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum PostbackShieldRule {
  AdvertiserBlockedPublisher = 'ADVERTISER_BLOCKED_PUBLISHER',
  BlacklistedIp = 'BLACKLISTED_IP',
  BlacklistedSubId = 'BLACKLISTED_SUB_ID',
  BudgetReached = 'BUDGET_REACHED',
  ClickToInstallTime = 'CLICK_TO_INSTALL_TIME',
  EventTypePrivate = 'EVENT_TYPE_PRIVATE',
  IspAccess = 'ISP_ACCESS',
  OfferAccess = 'OFFER_ACCESS',
  OfferActiveStatus = 'OFFER_ACTIVE_STATUS',
  RejectedPostback = 'REJECTED_POSTBACK'
}

export type PostbackShieldRules = {
  offerId?: Maybe<Scalars['String']['output']>;
  publisherId?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Array<Maybe<PostbackShieldRule>>>;
};

export type PostbackShieldRulesInput = {
  offerId: Scalars['String']['input'];
  publisherId?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<PostbackShieldRule>>>;
};

export type PostbackShieldRulesKey = {
  offerId: Scalars['String']['input'];
  publisherId?: InputMaybe<Scalars['String']['input']>;
};

export enum PostbackState {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type PostbackStatus = {
  activeRules: Array<Scalars['String']['output']>;
  failedRules: Array<Scalars['String']['output']>;
  originalState?: Maybe<PostbackState>;
  state: PostbackState;
};

export type PostbackStatusInput = {
  activeRules?: InputMaybe<Array<Scalars['String']['input']>>;
  failedRules?: InputMaybe<Array<Scalars['String']['input']>>;
  state: PostbackState;
};

export enum PostbackStatusLevel {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  RejectedByAdvertiser = 'REJECTED_BY_ADVERTISER'
}

export enum PostbackStatusRule {
  AdvertiserOfferId = 'ADVERTISER_OFFER_ID',
  AlternateDuplicateDetection = 'ALTERNATE_DUPLICATE_DETECTION',
  AnyBudgetReached = 'ANY_BUDGET_REACHED',
  AppsflyerRetargeting = 'APPSFLYER_RETARGETING',
  BudgetReached = 'BUDGET_REACHED',
  DecisionDeniedRule = 'DECISION_DENIED_RULE',
  DefaultStatusRule = 'DEFAULT_STATUS_RULE',
  DuplicatedClick = 'DUPLICATED_CLICK',
  InvalidAdjustIp = 'INVALID_ADJUST_IP',
  InvalidEventType = 'INVALID_EVENT_TYPE',
  InvalidPurchase = 'INVALID_PURCHASE',
  InvalidSecurityToken = 'INVALID_SECURITY_TOKEN',
  InvalidServerIp = 'INVALID_SERVER_IP',
  OfferNotActive = 'OFFER_NOT_ACTIVE',
  PublisherNotApproved = 'PUBLISHER_NOT_APPROVED',
  RejectedByAdvertiser = 'REJECTED_BY_ADVERTISER',
  SkadInvalidSignature = 'SKAD_INVALID_SIGNATURE',
  SkadNotValidatedByMmp = 'SKAD_NOT_VALIDATED_BY_MMP',
  VtaNotEnabled = 'VTA_NOT_ENABLED'
}

export type Product = {
  description?: Maybe<Scalars['String']['output']>;
  geos?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  kpis?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  offerId?: Maybe<Scalars['String']['output']>;
  organization: MarketplaceOrganization;
  payout?: Maybe<Array<ProductPayout>>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  restrictions?: Maybe<Array<Scalars['String']['output']>>;
  type: ProductType;
  verticals?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProductConnection = {
  edges?: Maybe<Array<ProductEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type ProductEdge = {
  node: Product;
};

export type ProductFeature = {
  type: ProductFeatureType;
};

export enum ProductFeatureType {
  Advertisers = 'ADVERTISERS',
  Apps = 'APPS',
  AppsflyerReport = 'APPSFLYER_REPORT',
  AutomationFillers = 'AUTOMATION_FILLERS',
  AutomationRule = 'AUTOMATION_RULE',
  ClickReport = 'CLICK_REPORT',
  CohortReport = 'COHORT_REPORT',
  CustomReport = 'CUSTOM_REPORT',
  Domains = 'DOMAINS',
  Explorer = 'EXPLORER',
  FeedApiConfig = 'FEED_API_CONFIG',
  Fillers = 'FILLERS',
  Integration = 'INTEGRATION',
  Intercom = 'INTERCOM',
  Kpis = 'KPIS',
  Lead = 'LEAD',
  Marketplace = 'MARKETPLACE',
  OffersAutomationFillers = 'OFFERS_AUTOMATION_FILLERS',
  OffersPublisherGroups = 'OFFERS_PUBLISHER_GROUPS',
  OffersTrafficSmartLinks = 'OFFERS_TRAFFIC_SMART_LINKS',
  OfferScan = 'OFFER_SCAN',
  Optimizations = 'OPTIMIZATIONS',
  PublishersBlockedAdvertisers = 'PUBLISHERS_BLOCKED_ADVERTISERS',
  PublishersFeedApiConfiguration = 'PUBLISHERS_FEED_API_CONFIGURATION',
  PublishersTrafficSmartLinks = 'PUBLISHERS_TRAFFIC_SMART_LINKS',
  PubGroups = 'PUB_GROUPS',
  ReportsAppsflyer = 'REPORTS_APPSFLYER',
  SearchArbitrage = 'SEARCH_ARBITRAGE',
  ShortClickIds = 'SHORT_CLICK_IDS',
  Smartlink = 'SMARTLINK',
  Superset = 'SUPERSET',
  ToolsScanOffer = 'TOOLS_SCAN_OFFER',
  TrafficSmartLinks = 'TRAFFIC_SMART_LINKS',
  Worfklows = 'WORFKLOWS'
}

export type ProductFilter = {
  geos?: InputMaybe<Array<Scalars['String']['input']>>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<ProductType>>;
  verticals?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductPayout = {
  currency?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  payout?: Maybe<Scalars['Float']['output']>;
};

export enum ProductType {
  App = 'APP',
  Lead = 'LEAD',
  Other = 'OTHER',
  Physical = 'PHYSICAL',
  Subscription = 'SUBSCRIPTION'
}

export type PubGroup = {
  advertiser?: Maybe<Advertiser>;
  defaultPublisher?: Maybe<Publisher>;
  groupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  members?: Maybe<Array<PubGroupMember>>;
  offer?: Maybe<Offer>;
  report?: Maybe<Report>;
  rotation: PubGroupRotation;
  useAllActivePublishers?: Maybe<Scalars['Boolean']['output']>;
};


export type PubGroupReportArgs = {
  delta?: InputMaybe<DeltaParameters>;
  end: Scalars['String']['input'];
  estimation?: InputMaybe<EstimationParameters>;
  filter?: InputMaybe<Array<InputMaybe<StatsFilter>>>;
  granularity?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ReportSort>;
  start: Scalars['String']['input'];
};

export type PubGroupConnection = {
  edges: Array<PubGroupEdge>;
  totalCount: Scalars['Int']['output'];
};

export type PubGroupEdge = {
  node: PubGroup;
};

export type PubGroupFilter = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
};

export type PubGroupInput = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  members?: InputMaybe<Array<PubGroupMemberInput>>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  rotation: PubGroupRotationInput;
  useAllActivePublishers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PubGroupKpi = {
  /** number of milliseconds based which the threshold is calculated */
  jitter?: Maybe<Scalars['Float']['output']>;
  /** number of events of specified type */
  operator: PubGroupKpiOperator;
  /** The operator that applies to the threshold */
  period: Scalars['Int']['output'];
  threshold: Scalars['Float']['output'];
  type: PubGroupKpiType;
};

export type PubGroupKpiInput = {
  /** number of milliseconds based which the threshold is calculated */
  jitter?: InputMaybe<Scalars['Float']['input']>;
  /** number of events of specified type */
  operator: PubGroupKpiOperator;
  /** The operator that applies to the threshold */
  period: Scalars['Int']['input'];
  threshold: Scalars['Float']['input'];
  type: PubGroupKpiType;
};

export enum PubGroupKpiOperator {
  Gte = 'GTE',
  Lte = 'LTE'
}

export enum PubGroupKpiType {
  Clicks = 'CLICKS',
  Impressions = 'IMPRESSIONS',
  PaidConversions = 'PAID_CONVERSIONS',
  Rejections = 'REJECTIONS'
}

export type PubGroupMember = {
  publisher: Publisher;
  ratio?: Maybe<Scalars['Float']['output']>;
  /** How much of this publisher's traffic should be used in the group */
  report?: Maybe<Report>;
};


export type PubGroupMemberReportArgs = {
  delta?: InputMaybe<DeltaParameters>;
  end: Scalars['String']['input'];
  estimation?: InputMaybe<EstimationParameters>;
  filter?: InputMaybe<Array<InputMaybe<StatsFilter>>>;
  granularity?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ReportSort>;
  start: Scalars['String']['input'];
};

export type PubGroupMemberInput = {
  publisherId: Scalars['String']['input'];
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

export type PubGroupRotation = {
  groupRotationPeriod?: Maybe<Scalars['Long']['output']>;
  /** should the subids be generated for this group */
  kpis?: Maybe<Array<PubGroupKpi>>;
  /** Number of milliseconds after which the group should generate new subids */
  numberOfSubids?: Maybe<Scalars['Int']['output']>;
  /** The number of subids we should generate */
  subidGeneration?: Maybe<Scalars['Boolean']['output']>;
  /** Number of milliseconds after which the group should generate a new id */
  subidRotationPeriod?: Maybe<Scalars['Long']['output']>;
};

export type PubGroupRotationInput = {
  groupRotationPeriod?: InputMaybe<Scalars['Long']['input']>;
  /** should the subids be generated for this group */
  kpis?: InputMaybe<Array<PubGroupKpiInput>>;
  /** Number of milliseconds after which the group should generate new subids */
  numberOfSubids?: InputMaybe<Scalars['Int']['input']>;
  /** The number of subids we should generate */
  subidGeneration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of milliseconds after which the group should generate a new id */
  subidRotationPeriod?: InputMaybe<Scalars['Long']['input']>;
};

/** A publisher is a source of traffic coming into the system which is distributed to the pool of offers */
export type Publisher = {
  accessState?: Maybe<OfferAccessState>;
  accountManager?: Maybe<User>;
  accountType?: Maybe<PublisherType>;
  address?: Maybe<Scalars['String']['output']>;
  allowedSubIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Relationships */
  apiKeys: Array<Scalars['String']['output']>;
  appsflyerConfig?: Maybe<AppsflyerPublisherConfig>;
  audits: Array<Audit>;
  balance?: Maybe<Scalars['Float']['output']>;
  billingDetails?: Maybe<PublisherBillingDetails>;
  blacklistedSubIds: Array<BlacklistedSubId>;
  contacts: Array<PublisherContact>;
  country?: Maybe<Scalars['String']['output']>;
  counts: PublisherCounts;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  feedUrl?: Maybe<Scalars['String']['output']>;
  formSubmission?: Maybe<FormResult>;
  hasOwnClickId?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  integration?: Maybe<PublisherIntegration>;
  isApiPublisher: Scalars['Boolean']['output'];
  isOrganicPublisher?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  needsOfferNotifications?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  offers: Array<Offer>;
  offersV2: OfferConnection;
  paymentDetails?: Maybe<PublisherPaymentDetails>;
  pdId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pointsExchangeRate?: Maybe<Scalars['Float']['output']>;
  postbackLinks?: Maybe<Array<PostbackLink>>;
  /** The advertiser blocked publisher, if this publisher is blocked */
  publisherBlockedAdvertisers: Array<AdvertiserBlockedPublisher>;
  /** @deprecated Use publisherOffersV2 instead */
  publisherGroups: Array<PublisherGroup>;
  publisherOffers: Array<PublisherOfferView>;
  publisherOffersCount: Scalars['Int']['output'];
  publisherOffersV2: PublisherOfferViewConnection;
  referralPublisher?: Maybe<Publisher>;
  /** Stats associated to this publisher represented as a time series */
  report: Array<Report>;
  salesManager?: Maybe<User>;
  searchStatsExample?: Maybe<Scalars['String']['output']>;
  searchStatsUrl?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PublisherStatus>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  trackingDomain?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** A publisher is a source of traffic coming into the system which is distributed to the pool of offers */
export type PublisherAccessStateArgs = {
  offerId: Scalars['String']['input'];
};


/** A publisher is a source of traffic coming into the system which is distributed to the pool of offers */
export type PublisherBlacklistedSubIdsArgs = {
  filter?: InputMaybe<BlacklistedSubIdsFilter>;
  pagination?: InputMaybe<Pagination>;
};


/** A publisher is a source of traffic coming into the system which is distributed to the pool of offers */
export type PublisherContactsArgs = {
  filter?: InputMaybe<PublisherContactFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<PublisherContactSort>;
};


/** A publisher is a source of traffic coming into the system which is distributed to the pool of offers */
export type PublisherOffersArgs = {
  filter?: InputMaybe<OfferFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<OfferSort>;
};


/** A publisher is a source of traffic coming into the system which is distributed to the pool of offers */
export type PublisherOffersV2Args = {
  filter?: InputMaybe<OfferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OfferSort>;
};


/** A publisher is a source of traffic coming into the system which is distributed to the pool of offers */
export type PublisherPublisherGroupsArgs = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
};


/** A publisher is a source of traffic coming into the system which is distributed to the pool of offers */
export type PublisherPublisherOffersArgs = {
  filter?: InputMaybe<PublisherToOfferFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<PublisherToOfferSort>;
};


/** A publisher is a source of traffic coming into the system which is distributed to the pool of offers */
export type PublisherPublisherOffersCountArgs = {
  filter?: InputMaybe<PublisherToOfferFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<PublisherToOfferSort>;
};


/** A publisher is a source of traffic coming into the system which is distributed to the pool of offers */
export type PublisherPublisherOffersV2Args = {
  filter?: InputMaybe<PublisherToOfferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PublisherToOfferSort>;
};


/** A publisher is a source of traffic coming into the system which is distributed to the pool of offers */
export type PublisherReportArgs = {
  queries?: InputMaybe<Array<InputMaybe<ReportQuery>>>;
};

export type PublisherBankPaymentDetails = {
  details?: Maybe<Scalars['String']['output']>;
};

export type PublisherBankPaymentDetailsInput = {
  details?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherBatchOperation = {
  active: Scalars['Boolean']['output'];
  changeOfferAccessStateAction?: Maybe<PublisherBatchOperationChangeOfferAccessState>;
  changeStatusAction?: Maybe<PublisherBatchOperationChangeStatusAction>;
  changeTagsAction?: Maybe<PublisherBatchOperationChangeTagsAction>;
  description?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<PublisherBatchOperationFilter>>;
  fireWebhookAction?: Maybe<PublisherBatchOperationFireWebhook>;
  id: Scalars['String']['output'];
  lastExecutionAt?: Maybe<Scalars['LocalDateTime']['output']>;
  name: Scalars['String']['output'];
  schedule: BatchOperationSchedule;
};

export type PublisherBatchOperationChangeOfferAccessState = {
  currentOfferState: Array<OfferAccessState>;
  newOfferState: OfferAccessState;
};

export type PublisherBatchOperationChangeOfferAccessStateInput = {
  currentOfferState: Array<OfferAccessState>;
  newOfferState: OfferAccessState;
};

export type PublisherBatchOperationChangeStatusAction = {
  status: PublisherStatus;
};

export type PublisherBatchOperationChangeStatusActionInput = {
  status: PublisherStatus;
};

export type PublisherBatchOperationChangeTagsAction = {
  tagsToAdd?: Maybe<Array<Scalars['String']['output']>>;
  tagsToRemove?: Maybe<Array<Scalars['String']['output']>>;
};

export type PublisherBatchOperationChangeTagsActionInput = {
  tagsToAdd?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsToRemove?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PublisherBatchOperationConnection = {
  edges?: Maybe<Array<PublisherBatchOperationEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type PublisherBatchOperationEdge = {
  node: PublisherBatchOperation;
};

export type PublisherBatchOperationFilter = {
  field: PublisherBatchOperationFilterField;
  operator: BatchOperationFilterOperator;
  values: Array<Scalars['String']['output']>;
};

export enum PublisherBatchOperationFilterField {
  AccountManagerId = 'ACCOUNT_MANAGER_ID',
  Clicks = 'CLICKS',
  Country = 'COUNTRY',
  Cr = 'CR',
  CreatedAt = 'CREATED_AT',
  DefaultConversions = 'DEFAULT_CONVERSIONS',
  Events = 'EVENTS',
  Id = 'ID',
  Impressions = 'IMPRESSIONS',
  InternalNote = 'INTERNAL_NOTE',
  IsNew = 'IS_NEW',
  Name = 'NAME',
  NonRejectedConversions = 'NON_REJECTED_CONVERSIONS',
  NoOfApprovedOffers = 'NO_OF_APPROVED_OFFERS',
  NoOfBlockedOffers = 'NO_OF_BLOCKED_OFFERS',
  NoOfPendingOffers = 'NO_OF_PENDING_OFFERS',
  PaidConversions = 'PAID_CONVERSIONS',
  PaidCr = 'PAID_CR',
  RejectedConversions = 'REJECTED_CONVERSIONS',
  SalesManagerId = 'SALES_MANAGER_ID',
  Status = 'STATUS',
  Tags = 'TAGS',
  TheyGet = 'THEY_GET',
  TotalConversions = 'TOTAL_CONVERSIONS',
  UpdatedAt = 'UPDATED_AT',
  WeGet = 'WE_GET'
}

export type PublisherBatchOperationFilterInput = {
  field: PublisherBatchOperationFilterField;
  operator: BatchOperationFilterOperator;
  values: Array<Scalars['String']['input']>;
};

export type PublisherBatchOperationFireWebhook = {
  body?: Maybe<Scalars['String']['output']>;
  headers?: Maybe<Scalars['String']['output']>;
  method: BatchOperationWebhookMethod;
  url: Scalars['String']['output'];
};

export type PublisherBatchOperationFireWebhookInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  headers?: InputMaybe<Scalars['String']['input']>;
  method: BatchOperationWebhookMethod;
  url: Scalars['String']['input'];
};

export type PublisherBatchOperationInput = {
  active: Scalars['Boolean']['input'];
  changeOfferAccessStateAction?: InputMaybe<PublisherBatchOperationChangeOfferAccessStateInput>;
  changeStatusAction?: InputMaybe<PublisherBatchOperationChangeStatusActionInput>;
  changeTagsAction?: InputMaybe<PublisherBatchOperationChangeTagsActionInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<PublisherBatchOperationFilterInput>>;
  fireWebhookAction?: InputMaybe<PublisherBatchOperationFireWebhookInput>;
  name: Scalars['String']['input'];
  schedule: BatchOperationScheduleInput;
};

export type PublisherBatchOperationLogConnection = {
  edges?: Maybe<Array<PublisherBatchOperationLogEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type PublisherBatchOperationLogEdge = {
  node: PublisherBatchOperationLogEntry;
};

export type PublisherBatchOperationLogEntry = {
  actions?: Maybe<Array<BatchOperationLogActionEntry>>;
  publisher: Publisher;
};

export type PublisherBatchOperationReadFilter = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherBillingDetails = {
  address: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paymentTerm: PublisherBillingDetailsPaymentTerm;
  taxId: Scalars['String']['output'];
  taxRate: Scalars['Float']['output'];
};

export type PublisherBillingDetailsInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
  paymentTerm: PublisherBillingDetailsPaymentTerm;
  taxId: Scalars['String']['input'];
  taxRate: Scalars['Float']['input'];
};

export enum PublisherBillingDetailsPaymentTerm {
  Net7 = 'NET7',
  Net14 = 'NET14',
  Net30 = 'NET30',
  Net60 = 'NET60'
}

export type PublisherBrandedCurrencyRewardsPaymentDetails = {
  details?: Maybe<Scalars['String']['output']>;
};

export type PublisherBrandedCurrencyRewardsPaymentDetailsInput = {
  details?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherCapitalistPaymentDetails = {
  details?: Maybe<Scalars['String']['output']>;
};

export type PublisherCapitalistPaymentDetailsInput = {
  details?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherConnection = {
  edges: Array<PublisherEdge>;
  totalCount: Scalars['Int']['output'];
};

export type PublisherContact = {
  businessRole?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isNotifiable: Scalars['Boolean']['output'];
  isPrimary: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  needsUser: Scalars['Boolean']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  publisherId: Scalars['String']['output'];
  skypeId?: Maybe<Scalars['String']['output']>;
  status: Status;
  user?: Maybe<User>;
};

export type PublisherContactFilter = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
};

export type PublisherContactInput = {
  businessRole?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isNotifiable: Scalars['Boolean']['input'];
  isPrimary: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  needsUser: Scalars['Boolean']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  publisherId: Scalars['String']['input'];
  sendEmails?: InputMaybe<Scalars['Boolean']['input']>;
  skypeId?: InputMaybe<Scalars['String']['input']>;
  status: Status;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherContactSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<PublisherContactSortBy>;
};

export enum PublisherContactSortBy {
  Name = 'NAME',
  PublisherContactId = 'PUBLISHER_CONTACT_ID',
  PublisherId = 'PUBLISHER_ID'
}

export type PublisherCounts = {
  approvedOffers: Scalars['Int']['output'];
  servedOffers: Scalars['Int']['output'];
};

export type PublisherCryptoWalletPaymentDetails = {
  address?: Maybe<Scalars['String']['output']>;
  coin?: Maybe<Scalars['String']['output']>;
};

export type PublisherCryptoWalletPaymentDetailsInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  coin?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherData = {
  acceptHeader?: Maybe<Scalars['String']['output']>;
  app?: Maybe<Scalars['String']['output']>;
  appId?: Maybe<Scalars['String']['output']>;
  clickId?: Maybe<Scalars['String']['output']>;
  creative?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  managerId?: Maybe<Scalars['String']['output']>;
  originalSubId?: Maybe<Scalars['String']['output']>;
  placement?: Maybe<Scalars['String']['output']>;
  publisher: Publisher;
  referrer?: Maybe<Scalars['String']['output']>;
  site?: Maybe<Scalars['String']['output']>;
  subId?: Maybe<Scalars['String']['output']>;
  subSubId?: Maybe<Scalars['String']['output']>;
  unique1?: Maybe<Scalars['String']['output']>;
  unique2?: Maybe<Scalars['String']['output']>;
  unique3?: Maybe<Scalars['String']['output']>;
};

export type PublisherDataInput = {
  acceptHeader?: InputMaybe<Scalars['String']['input']>;
  app?: InputMaybe<Scalars['String']['input']>;
  appId?: InputMaybe<Scalars['String']['input']>;
  clickId?: InputMaybe<Scalars['String']['input']>;
  creative?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  managerId?: InputMaybe<Scalars['String']['input']>;
  originalSubId?: InputMaybe<Scalars['String']['input']>;
  placement?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
  subSubId?: InputMaybe<Scalars['String']['input']>;
  unique1?: InputMaybe<Scalars['String']['input']>;
  unique2?: InputMaybe<Scalars['String']['input']>;
  unique3?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherEdge = {
  node: Publisher;
};

export type PublisherEmailContext = {
  address?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publisherManager?: Maybe<UserEmailContext>;
};

export type PublisherEvaluatedPostbackFilter = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endTime: Scalars['LocalDateTime']['input'];
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherSubIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startTime: Scalars['LocalDateTime']['input'];
};

export type PublisherFacebookIntegration = {
  adAccountId: Scalars['String']['output'];
  availableCampaigns: Array<Scalars['String']['output']>;
  syncAll?: Maybe<Scalars['Boolean']['output']>;
  syncingCampaigns?: Maybe<Array<Scalars['String']['output']>>;
};

export type PublisherFacebookIntegrationInput = {
  adAccountId: Scalars['String']['input'];
  syncAll?: InputMaybe<Scalars['Boolean']['input']>;
  syncingCampaigns?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PublisherFilter = {
  accountManagerId?: InputMaybe<Scalars['String']['input']>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  salesManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<InputMaybe<PublisherStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PublisherGoogleIntegration = {
  availableCampaigns: Array<Scalars['String']['output']>;
  operatingCustomerId: Scalars['String']['output'];
  syncAll?: Maybe<Scalars['Boolean']['output']>;
  syncingCampaigns?: Maybe<Array<Scalars['String']['output']>>;
};

export type PublisherGoogleIntegrationInput = {
  operatingCustomerId: Scalars['String']['input'];
  syncAll?: InputMaybe<Scalars['Boolean']['input']>;
  syncingCampaigns?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PublisherGroup = {
  id: Scalars['String']['output'];
  members?: Maybe<Array<Maybe<PublisherGroupMember>>>;
  /** Statistics about the performance of the publisher group based on the given fields */
  report?: Maybe<Report>;
};


export type PublisherGroupMembersArgs = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
};


export type PublisherGroupReportArgs = {
  delta?: InputMaybe<DeltaParameters>;
  end: Scalars['String']['input'];
  estimation?: InputMaybe<EstimationParameters>;
  filter?: InputMaybe<Array<InputMaybe<StatsFilter>>>;
  granularity?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ReportSort>;
  start: Scalars['String']['input'];
};

export type PublisherGroupMember = {
  advertiser?: Maybe<Advertiser>;
  offer?: Maybe<Offer>;
  publisher: Publisher;
  publisherGroupId?: Maybe<Scalars['String']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
  /** indicates that we will generate the sub ids and discard the publisher's */
  subIdGeneration?: Maybe<Scalars['Boolean']['output']>;
};

export type PublisherGroupMemberId = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  publisherGroupId: Scalars['String']['input'];
  publisherId: Scalars['String']['input'];
};

export type PublisherGroupMemberInput = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  publisherGroupId: Scalars['String']['input'];
  publisherId: Scalars['String']['input'];
  ratio?: InputMaybe<Scalars['Float']['input']>;
  /** indicates that we will generate the sub ids and discard the publisher's */
  subIdGeneration?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PublisherInput = {
  accountManagerId: Scalars['String']['input'];
  accountType: PublisherType;
  address?: InputMaybe<Scalars['String']['input']>;
  allowedSubIds?: InputMaybe<Array<Scalars['String']['input']>>;
  billingDetails?: InputMaybe<PublisherBillingDetailsInput>;
  /** The name of the ublisher, deprecated, use the name property instead */
  company: Scalars['String']['input'];
  country: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  formSubmissionId?: InputMaybe<Scalars['String']['input']>;
  hasOwnClickId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isApiPublisher?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the publisher */
  name?: InputMaybe<Scalars['String']['input']>;
  needsOfferNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referralPublisherId?: InputMaybe<Scalars['String']['input']>;
  salesManagerId?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  status: PublisherStatus;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherIntegration = {
  facebookIntegration?: Maybe<PublisherFacebookIntegration>;
  googleIntegration?: Maybe<PublisherGoogleIntegration>;
  id: Scalars['String']['output'];
  publisherId: Scalars['String']['output'];
};

export type PublisherIntegrationInput = {
  facebookIntegration?: InputMaybe<PublisherFacebookIntegrationInput>;
  googleIntegration?: InputMaybe<PublisherGoogleIntegrationInput>;
  publisherId: Scalars['String']['input'];
};

export type PublisherIntegrationTest = {
  debugInformation?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  postbackUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PublisherKey = {
  apiKey?: Maybe<Array<Scalars['String']['output']>>;
  publisherId: Scalars['String']['output'];
  trackingUrl: Scalars['String']['output'];
};

export type PublisherKeyInput = {
  numberOfKeysToGenerate?: InputMaybe<Scalars['Int']['input']>;
  publisherId: Scalars['String']['input'];
  trackingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherMargin = {
  margin?: Maybe<Scalars['Float']['output']>;
  publisherId?: Maybe<Scalars['String']['output']>;
};

export type PublisherMarginInput = {
  margin: Scalars['Float']['input'];
  publisherId: Scalars['String']['input'];
};

export type PublisherMarginSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<PublisherMarginSortBy>;
};

export enum PublisherMarginSortBy {
  Margin = 'MARGIN',
  PublisherId = 'PUBLISHER_ID'
}

export type PublisherNotificationInput = {
  publisherId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};

export type PublisherOfferFilter = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offerManagerId?: InputMaybe<Scalars['String']['input']>;
  offerStatus?: InputMaybe<Array<OfferStatus>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherManagerId?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<OfferAccessState>>;
};

export type PublisherOfferView = {
  accessState?: Maybe<OfferAccessState>;
  adSrvUrl: Scalars['String']['output'];
  audits: Array<Audit>;
  blockingReason?: Maybe<Scalars['String']['output']>;
  budgets: Array<Budget>;
  clickTrackingUrl: Scalars['String']['output'];
  feedApiStatus: FeedApiStatus;
  htmlServeUrl: Scalars['String']['output'];
  impressionTrackingUrl: Scalars['String']['output'];
  offer: Offer;
  paidPayout?: Maybe<Payout>;
  /**
   * The resolved split payout for this (offer, publisher, event type) key: the same effective theyGet,
   * margin and their source that scutum/postbackstream pay, incl. weGet/margins inherited from the
   * offer default or an advertiser/publisher-scoped margin — even when nothing is stored for this
   * publisher. Display only (renderedTheyGet/renderedMargin/renderedTheyGetSource); never a stored value.
   */
  payoutV2: PayoutV2;
  payouts: Array<Payout>;
  publisher: Publisher;
  report: Array<Report>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type PublisherOfferViewBudgetsArgs = {
  eventTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<Status>>>;
  thresholds?: InputMaybe<Array<InputMaybe<BudgetThreshold>>>;
  validities?: InputMaybe<Array<InputMaybe<BudgetValidity>>>;
};


export type PublisherOfferViewPayoutV2Args = {
  eventTypeId?: InputMaybe<Scalars['String']['input']>;
};


export type PublisherOfferViewPayoutsArgs = {
  eventTypeId?: InputMaybe<Scalars['String']['input']>;
};


export type PublisherOfferViewReportArgs = {
  queries: Array<ReportQuery>;
};

export type PublisherOfferViewConnection = {
  edges: Array<PublisherOfferViewEdge>;
  totalCount: Scalars['Int']['output'];
};

export type PublisherOfferViewEdge = {
  node: PublisherOfferView;
};

export type PublisherPaxumPaymentDetails = {
  details?: Maybe<Scalars['String']['output']>;
};

export type PublisherPaxumPaymentDetailsInput = {
  details?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherPayment = {
  amount: Scalars['Float']['output'];
  createdAt: Scalars['LocalDateTime']['output'];
  end: Scalars['LocalDateTime']['output'];
  id: Scalars['String']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  invoiceDetails?: Maybe<PublisherPaymentInvoiceDetails>;
  paymentProcessorResponse?: Maybe<Array<PublisherPaymentParam>>;
  publisher: Publisher;
  publisherNote?: Maybe<Scalars['String']['output']>;
  referralInfo?: Maybe<ReferralInfo>;
  rewardedUser?: Maybe<RewardedUser>;
  start: Scalars['LocalDateTime']['output'];
  status: PublisherPaymentStatus;
};

export type PublisherPaymentConnection = {
  edges?: Maybe<Array<PublisherPaymentEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type PublisherPaymentDetails = PublisherBankPaymentDetails | PublisherBrandedCurrencyRewardsPaymentDetails | PublisherCapitalistPaymentDetails | PublisherCryptoWalletPaymentDetails | PublisherPaxumPaymentDetails | PublisherPayoneerPaymentDetails | PublisherPaypalPaymentDetails | PublisherTilloPaymentDetails | PublisherTipaltiPaymentDetails | PublisherTremendousPaymentDetails;

export type PublisherPaymentDetailsInput = {
  bank?: InputMaybe<PublisherBankPaymentDetailsInput>;
  brandedCurrencyRewards?: InputMaybe<PublisherBrandedCurrencyRewardsPaymentDetailsInput>;
  capitalist?: InputMaybe<PublisherCapitalistPaymentDetailsInput>;
  cryptoWallet?: InputMaybe<PublisherCryptoWalletPaymentDetailsInput>;
  paxum?: InputMaybe<PublisherPaxumPaymentDetailsInput>;
  payoneer?: InputMaybe<PublisherPayoneerPaymentDetailsInput>;
  paypal?: InputMaybe<PublisherPaypalPaymentDetailsInput>;
  publisherId: Scalars['String']['input'];
  tillo?: InputMaybe<PublisherTilloPaymentDetailsInput>;
  tipalti?: InputMaybe<PublisherTipaltiPaymentDetailsInput>;
  tremendous?: InputMaybe<PublisherTremendousPaymentDetailsInput>;
};

export enum PublisherPaymentDetailsType {
  Bank = 'BANK',
  BrandedCurrencyRewards = 'BRANDED_CURRENCY_REWARDS',
  Capitalist = 'CAPITALIST',
  CryptoWallet = 'CRYPTO_WALLET',
  Paxum = 'PAXUM',
  Payoneer = 'PAYONEER',
  Paypal = 'PAYPAL',
  Tillo = 'TILLO',
  Tipalti = 'TIPALTI',
  Tremendous = 'TREMENDOUS'
}

export type PublisherPaymentEdge = {
  node: PublisherPayment;
};

export type PublisherPaymentFilter = {
  completePaymentInfo?: InputMaybe<Scalars['Boolean']['input']>;
  createdAtEnd?: InputMaybe<Scalars['LocalDateTime']['input']>;
  createdAtStart?: InputMaybe<Scalars['LocalDateTime']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  isReferral?: InputMaybe<Scalars['Boolean']['input']>;
  onlyRewardedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDetails?: InputMaybe<Array<PublisherPaymentDetailsType>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  rewardedUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<PublisherPaymentStatus>>;
};

export type PublisherPaymentInput = {
  amount: Scalars['Float']['input'];
  end: Scalars['LocalDateTime']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  invoiceDetails?: InputMaybe<PublisherPaymentInvoiceDetailsInput>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  publisherNote?: InputMaybe<Scalars['String']['input']>;
  referralInfo?: InputMaybe<ReferralInfoInput>;
  rewardedUserId?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['LocalDateTime']['input'];
  status: PublisherPaymentStatus;
};

export type PublisherPaymentInvoiceDetails = {
  date?: Maybe<Scalars['LocalDate']['output']>;
  /** Signed, short-lived link path for generated PDFs (prefix with the API host), else url */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** True when the PDF was generated by the platform */
  generated: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  /** Uploaded invoice link (generated invoices are private, use downloadUrl) */
  url?: Maybe<Scalars['String']['output']>;
};

export type PublisherPaymentInvoiceDetailsInput = {
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherPaymentParam = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum PublisherPaymentSchedule {
  Biweekly = 'BIWEEKLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type PublisherPaymentSchedulerSettings = {
  allowedPublisherTags?: Maybe<Array<Scalars['String']['output']>>;
  disallowedPublisherTags?: Maybe<Array<Scalars['String']['output']>>;
  paymentStatus: PublisherPaymentStatus;
  schedule: PublisherPaymentSchedule;
  threshold?: Maybe<Scalars['Float']['output']>;
};

export type PublisherPaymentSchedulerSettingsInput = {
  allowedPublisherTags?: InputMaybe<Array<Scalars['String']['input']>>;
  disallowedPublisherTags?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentStatus: PublisherPaymentStatus;
  schedule: PublisherPaymentSchedule;
  threshold?: InputMaybe<Scalars['Float']['input']>;
};

export enum PublisherPaymentStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Open = 'OPEN',
  Paid = 'PAID',
  Requested = 'REQUESTED',
  SentToPaymentProcessor = 'SENT_TO_PAYMENT_PROCESSOR'
}

export type PublisherPayoneerPaymentDetails = {
  email?: Maybe<Scalars['String']['output']>;
};

export type PublisherPayoneerPaymentDetailsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherPaypalPaymentDetails = {
  email?: Maybe<Scalars['String']['output']>;
};

export type PublisherPaypalPaymentDetailsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherReferralCommissionLevel = {
  id: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  target: PublisherReferralCommissionLevelTarget;
};

export type PublisherReferralCommissionLevelInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  level: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  percentage: Scalars['Float']['input'];
  target: PublisherReferralCommissionLevelTarget;
};

export enum PublisherReferralCommissionLevelTarget {
  Profit = 'PROFIT',
  TheyGet = 'THEY_GET',
  WeGet = 'WE_GET'
}

export type PublisherReferralConnection = {
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  publisherIds?: Maybe<Array<Scalars['String']['output']>>;
  publisherTags?: Maybe<Array<Scalars['String']['output']>>;
};

export type PublisherReferralConnectionInput = {
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherTags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PublisherReferralPlan = {
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  levels: Array<PublisherReferralCommissionLevel>;
  name: Scalars['String']['output'];
  publisherReferralPlanConnection: PublisherReferralConnection;
};

export type PublisherReferralPlanConnection = {
  edges?: Maybe<Array<PublisherReferralPlanEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type PublisherReferralPlanEdge = {
  node: PublisherReferralPlan;
};

export type PublisherReferralPlanInput = {
  description: Scalars['String']['input'];
  levels: Array<PublisherReferralCommissionLevelInput>;
  name: Scalars['String']['input'];
  publisherReferralPlanConnection: PublisherReferralConnectionInput;
};

export type PublisherReferralReport = {
  end: Scalars['LocalDateTime']['output'];
  rows: Array<PublisherReferralReportRow>;
  start: Scalars['LocalDateTime']['output'];
};

export type PublisherReferralReportComponent = {
  amount: Scalars['Float']['output'];
  level?: Maybe<PublisherReferralCommissionLevel>;
  publisher: Publisher;
};

export type PublisherReferralReportFilter = {
  from: Scalars['LocalDateTime']['input'];
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  to: Scalars['LocalDateTime']['input'];
};

export type PublisherReferralReportRow = {
  amount: Scalars['Float']['output'];
  components: Array<PublisherReferralReportComponent>;
  end: Scalars['LocalDateTime']['output'];
  payment?: Maybe<PublisherPayment>;
  publisher: Publisher;
  start: Scalars['LocalDateTime']['output'];
};

export type PublisherSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<PublisherSortBy>;
  sortQuery?: InputMaybe<SortQuery>;
};

export enum PublisherSortBy {
  Clicks = 'CLICKS',
  Conversions = 'CONVERSIONS',
  Profit = 'PROFIT',
  PublisherId = 'PUBLISHER_ID',
  TheyGet = 'THEY_GET',
  WeGet = 'WE_GET'
}

export enum PublisherStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Deleted = 'DELETED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type PublisherTag = {
  name: Scalars['String']['output'];
  numberOfPublishers: Scalars['Int']['output'];
  preApproved: Scalars['Boolean']['output'];
  publishers?: Maybe<Array<Publisher>>;
};

export type PublisherTilloPaymentDetails = {
  details?: Maybe<Scalars['String']['output']>;
};

export type PublisherTilloPaymentDetailsInput = {
  details?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherTipaltiPaymentDetails = {
  isPayable?: Maybe<Scalars['Boolean']['output']>;
};

export type PublisherTipaltiPaymentDetailsInput = {
  isPayable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PublisherToOfferFilter = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  isApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  offerManagerId?: InputMaybe<Scalars['String']['input']>;
  offerStatus?: InputMaybe<OfferStatus>;
  offerVisibility?: InputMaybe<OfferVisibility>;
  smartlinkId?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<OfferAccessState>>>;
  theyGet?: InputMaybe<OfferPublisherPayoutType>;
  weGet?: InputMaybe<OfferPublisherPayoutType>;
};

export type PublisherToOfferSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<PublisherToOfferSortBy>;
  sortQuery?: InputMaybe<SortQuery>;
};

export enum PublisherToOfferSortBy {
  Clicks = 'CLICKS',
  Conversions = 'CONVERSIONS',
  NumberOfJumps = 'NUMBER_OF_JUMPS',
  OfferId = 'OFFER_ID',
  OfferName = 'OFFER_NAME',
  Profit = 'PROFIT',
  RemainingDailyClickBudget = 'REMAINING_DAILY_CLICK_BUDGET',
  RemainingDailyConversionBudget = 'REMAINING_DAILY_CONVERSION_BUDGET',
  RemainingDailyImpressionBudget = 'REMAINING_DAILY_IMPRESSION_BUDGET',
  RemainingDailyRevenueBudget = 'REMAINING_DAILY_REVENUE_BUDGET',
  RemainingForeverClickBudget = 'REMAINING_FOREVER_CLICK_BUDGET',
  RemainingForeverConversionBudget = 'REMAINING_FOREVER_CONVERSION_BUDGET',
  RemainingForeverImpressionBudget = 'REMAINING_FOREVER_IMPRESSION_BUDGET',
  RemainingForeverRevenueBudget = 'REMAINING_FOREVER_REVENUE_BUDGET',
  RemainingHourlyClickBudget = 'REMAINING_HOURLY_CLICK_BUDGET',
  RemainingHourlyConversionBudget = 'REMAINING_HOURLY_CONVERSION_BUDGET',
  RemainingHourlyImpressionBudget = 'REMAINING_HOURLY_IMPRESSION_BUDGET',
  RemainingHourlyRevenueBudget = 'REMAINING_HOURLY_REVENUE_BUDGET',
  RemainingMonthlyConversionBudget = 'REMAINING_MONTHLY_CONVERSION_BUDGET',
  RemainingMonthlyRevenueBudget = 'REMAINING_MONTHLY_REVENUE_BUDGET',
  TheyGet = 'THEY_GET',
  WeGet = 'WE_GET'
}

export type PublisherTremendousPaymentDetails = {
  details?: Maybe<Scalars['String']['output']>;
};

export type PublisherTremendousPaymentDetailsInput = {
  details?: InputMaybe<Scalars['String']['input']>;
};

export enum PublisherType {
  Direct = 'DIRECT',
  Fbmarketer = 'FBMARKETER',
  MediaBuyer = 'MEDIA_BUYER',
  Network = 'NETWORK',
  SmartlinkPublisher = 'SMARTLINK_PUBLISHER'
}

export type PushNotification = {
  audience: Audience;
  body: Scalars['String']['output'];
  deepLinkEntityId?: Maybe<Scalars['String']['output']>;
  deepLinkType?: Maybe<PushNotificationDeepLinkType>;
  id: Scalars['String']['output'];
  status: PushNotificationStatus;
  time: Scalars['LocalDateTime']['output'];
  title: Scalars['String']['output'];
};

export type PushNotificationConnection = {
  edges: Array<PushNotificationEdge>;
  totalCount: Scalars['Int']['output'];
};

export enum PushNotificationDeepLinkType {
  Offer = 'OFFER',
  OffersList = 'OFFERS_LIST',
  Payments = 'PAYMENTS',
  Profile = 'PROFILE',
  RequestPayment = 'REQUEST_PAYMENT',
  Reward = 'REWARD',
  RewardsList = 'REWARDS_LIST',
  Support = 'SUPPORT'
}

export type PushNotificationEdge = {
  node: PushNotification;
};

export enum PushNotificationStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type Query = {
  /**
   * Fraud report that flags unusually low or high conversion rates: for each group it returns clicks, install conversions (default event only) and CR = conversions / clicks, keeping groups whose CR is outside the threshold range.
   *
   * Only approved conversions are considered. The query defines the time range, filters, level of detail (offer, offer+publisher or offer+publisher+sub id), time granularity, an optional extra group-by dimension, an optional minimum number of conversions per row (minApplicableConversions) and sorting. Only rows whose metric lies outside the [minThreshold, maxThreshold] range are returned; thresholds are ratios between 0 and 1. Network (cockpit) users only.
   */
  abnormalCRReport: FraudReportConnection;
  /**
   * Fraud report that flags unusual device-model distributions: for each group and device model it returns the model's conversions, the group's total conversions and the model's share (PERCENT), keeping models whose share is outside the threshold range.
   *
   * Only approved conversions are considered. The query defines the time range, filters, level of detail (offer, offer+publisher or offer+publisher+sub id), time granularity, an optional extra group-by dimension, an optional minimum number of conversions per row (minApplicableConversions) and sorting. Only rows whose metric lies outside the [minThreshold, maxThreshold] range are returned; thresholds are ratios between 0 and 1. Network (cockpit) users only.
   */
  abnormalDeviceDistributionReport: FraudReportConnection;
  /**
   * Returns the app activity report for MMP-tracked apps: metrics such as users, sessions, installs, events, revenue, cost, ROAS and ARPU over time at the requested granularity, optionally grouped by dimensions (app, store app, geo, device, offer, publisher, app event and more).
   *
   * The result includes the requested page of rows, the total row count and csvDownloadUrl, a time-limited link (relative to the API host, valid for about one hour) to download the full, unpaginated report as CSV.
   *
   * Network (cockpit) users only. If the report cannot be computed, the query fails with a generic error.
   */
  activityReport: ActivityReportConnection;
  /**
   * Lists the distinct categories found in the ad keyword pool, optionally narrowed to categories starting with a prefix. Useful for building keyword import filters. The result is an unordered set of category names.
   *
   * Network (cockpit) users only.
   */
  adKeywordCategories?: Maybe<Array<Scalars['String']['output']>>;
  /** Returns single ad keyword import spec */
  adKeywordImportSpec: AdKeywordImportSpec;
  /** Ad keyword field filter types */
  adKeywordImportSpecFilterFields: Array<AdKeywordImportSpecFilterField>;
  /** List all ad keyword import specs */
  adKeywordImportSpecs: AdKeywordImportSpecConnection;
  /**
   * Previews what an ad keyword import filter would select: returns the total number of keywords matching the given filters (`amount`) and a random sample of up to 5 matching keyword names (`keywords`). When nothing matches, `amount` is 0 and `keywords` is empty.
   *
   * Network (cockpit) users only.
   */
  adKeywordPreview: AdKeywordPreview;
  /**
   * Lists the network adapters available for advertiser API integrations (automatic offer import). Each descriptor lists the adapter name, the tracking URL parameters and API configuration parameters it needs, and the offer fields it can import.
   *
   * Network (cockpit) users only.
   */
  adapterDescriptors: Array<AdapterDescriptor>;
  /** Returns single adv targeting bundle */
  advancedTargetingValueBundle: AdvancedTargetingValueBundle;
  /**
   * Lists advanced targeting value bundles: named, reusable lists of values for one targeting field type that can be referenced from targeting rules. Supports offset pagination and an optional filter by field type; `totalCount` is the number of matching bundles before pagination.
   *
   * Network (cockpit) users only.
   */
  advancedTargetingValueBundles: AdvancedTargetingValueBundleConnection;
  /**
   * Returns a single advertiser by its id, or null if no advertiser with that id exists.
   *
   * Network (cockpit) users only. Users with a restricted manager role get an access-denied error for advertisers they are not the account or sales manager of.
   */
  advertiser?: Maybe<Advertiser>;
  /**
   * Returns a single advertiser batch operation (a saved, optionally scheduled set of filters and actions applied to many advertisers at once). Returns an error if it does not exist.
   *
   * Network (cockpit) users only.
   */
  advertiserBatchOperation: AdvertiserBatchOperation;
  /**
   * Lists advertiser batch operations, newest first. The filter can restrict the list to specific ids or to operations whose id equals, or whose name contains (case-insensitive), a keyword. `totalCount` is the number of operations matching the filter.
   *
   * Network (cockpit) users only.
   */
  advertiserBatchOperations: AdvertiserBatchOperationConnection;
  advertiserBillingProfile?: Maybe<AdvertiserBillingProfile>;
  /**
   * Returns a single network import configuration (an advertiser config, shown as a "Network" in the UI) by its id. It holds the integration type, credentials and sync settings used to import offers from an advertiser's platform. Returns an error if no config with that id exists.
   *
   * Network (cockpit) users only.
   */
  advertiserConfig: AdvertiserConfig;
  /**
   * Calls the network API behind an advertiser config live and returns the raw requests and responses (one entry per request, several for paginated APIs), to help diagnose import problems. Credential-like values in URLs and parameters are masked; very large response bodies are truncated. If the network API fails, the status is UPSTREAM_ERROR and the requests captured before the failure are returned.
   *
   * This performs real API calls and can take several minutes. Fails if the advertiser config does not exist. Network (cockpit) users only.
   */
  advertiserConfigApiResponse: AdvertiserConfigApiResponse;
  /** Returns the sync status of an advertiser config (network offer import). If an on-demand sync was started with `triggerAdvertiserConfigSync`, the state reflects that run (PENDING, SUCCESS, FAILED or TIMED_OUT, with per-entity change counts on success and the error on failure); otherwise the state is IDLE and `lastRun` / `lastSuccess` describe the scheduled runs. Fails if the advertiser config does not exist. Network (cockpit) users only. */
  advertiserConfigSyncStatus: AdvertiserConfigSyncStatus;
  /**
   * Lists network import configurations (advertiser configs) matching the given filter. Filter criteria are combined with AND. Returns an empty list when nothing matches.
   *
   * Network (cockpit) users only.
   */
  advertiserConfigs: Array<AdvertiserConfig>;
  /**
   * Returns a single advertiser contact (a person linked to an advertiser) by its id. Returns an error if no contact with that id exists.
   *
   * Network (cockpit) users only.
   */
  advertiserContact?: Maybe<AdvertiserContact>;
  /** List of advertiserContact as found by given filters */
  advertiserContacts: Array<AdvertiserContact>;
  /**
   * Returns a single advertiser coupon by id. Fails with an error if no coupon with that id exists.
   *
   * Network (cockpit) users only.
   */
  advertiserCoupon: AdvertiserCoupon;
  /**
   * Lists advertiser coupon codes, newest first. A coupon ties a code to an offer and a default publisher, with a validity window, and comes with its own tracking link.
   *
   * Filter criteria are combined with AND. Users restricted to managing specific publishers or advertisers only see coupons belonging to those.
   */
  advertiserCoupons: AdvertiserCouponConnection;
  /**
   * Exports advertisers as a CSV file and returns a download URL for it. Up to 50,000 advertisers matching the filter are exported, in the given sort order, with one column per requested field (the header row uses readable field names). Traffic and revenue statistic columns cover the last month.
   *
   * The same visibility rules as the corresponding list query apply, so partner portal and restricted users only export what they can see. Fails with an error if the file cannot be created.
   */
  advertiserDetailsDownload: Scalars['String']['output'];
  advertiserInvoice?: Maybe<AdvertiserInvoice>;
  /** Advertisers with approved revenue in [start, end] (dates inclusive, platform time zone) */
  advertiserInvoiceCandidates: Array<AdvertiserInvoiceCandidate>;
  /** Prefilled recipients/subject/message for sendAdvertiserInvoice */
  advertiserInvoiceEmailDraft: AdvertiserInvoiceEmailDraft;
  /** Current platform revenue lines for one advertiser; grouping defaults to profile, then settings */
  advertiserInvoiceLines: Array<AdvertiserInvoiceLineItem>;
  advertiserInvoiceSettings: AdvertiserInvoiceSettings;
  advertiserInvoiceSummary: AdvertiserInvoiceSummary;
  /** Advertiser invoices (ADMIN/ADOPS) */
  advertiserInvoices: AdvertiserInvoiceConnection;
  /** Retrieves a raw report based on a raw query */
  advertiserRawReport: PartnerRawReport;
  /**
   * Returns a single advertiser rebate by id. Returns an error if no rebate with that id exists.
   *
   * Network (cockpit) users only.
   */
  advertiserRebate: AdvertiserRebate;
  /**
   * Lists advertiser rebates (a rebate rate applied to selected advertisers and/or offers over an optional time window), ordered by id descending. `totalCount` is the number of matching rebates.
   *
   * Filter options: `keyword` matches the rebate name or description (case-sensitive); `advertiserIds` and `offerIds` return rebates that cover at least one of the given advertisers or offers.
   *
   * Network (cockpit) users only.
   */
  advertiserRebates: AdvertiserRebateConnection;
  /**
   * Returns a single advertiser report import template by id. Fails with a not-found error if it does not exist.
   *
   * Network (cockpit) users only.
   */
  advertiserReportImportSpec: AdvertiserReportImportSpec;
  /**
   * Lists advertiser report import templates. A template describes the CSV layout of an advertiser's report (separator, rows to skip, which column holds which field and in what format, default values) so the report can be uploaded, or emailed to the template's inbox address, and imported as conversions/stats.
   *
   * Network (cockpit) users only.
   */
  advertiserReportImportSpecs: AdvertiserReportImportSpecConnection;
  /** Advertiser report import task */
  advertiserReportImportTask: AdvertiserReportImportTask;
  /**
   * Lists advertiser report import tasks (individual uploaded or emailed report files processed with a template), newest first, with their status (QUEUED, PROCESSING, PROCESSED, FAILED), status message and result summary. Filter criteria are combined with AND.
   *
   * Network (cockpit) users only.
   */
  advertiserReportImportTasks: AdvertiserReportImportTaskConnection;
  /**
   * Lists advertiser tags for autocomplete.
   *
   * With a `prefix`, only tags starting with that prefix (case-insensitive) are matched from the tags in use; the organization's pre-defined tags are always included. Without a prefix, all tags are returned.
   *
   * Network (cockpit) users only.
   */
  advertiserTags?: Maybe<Array<AdvertiserTag>>;
  /**
   * Lists advertisers matching the given filter as a plain list. Deprecated: use `advertisersV2`, which returns the same data plus a total count.
   *
   * Filter criteria are combined with AND. If no status filter is given, the account's default advertiser status filter (if configured) is applied. Users with a restricted manager role only see advertisers they manage. Network (cockpit) users only.
   * @deprecated Use advertisersV2 instead
   */
  advertisers: Array<Advertiser>;
  /**
   * Lists advertisers matching the given filter, with paging and the total number of matches (`totalCount`).
   *
   * Filter criteria are combined with AND. If no status filter is given, the account's default advertiser status filter (if configured) is applied. Statistic sorts use the time range from `sort.sortQuery`, or from the `report` selection on the returned advertisers. Returns an empty list when nothing matches. Users with a restricted manager role only see advertisers they manage. Network (cockpit) users only.
   */
  advertisersV2: AdvertiserConnection;
  /** Retrieves all submissions for the form with the given id, sorted by submission time, most recent first */
  allFormSubmissions: Array<FormResult>;
  /**
   * Returns a single app (an MMP-tracked product that groups one or more store apps under an advertiser) by id. Fails with a not-found error if it does not exist.
   *
   * Network (cockpit) users only.
   */
  app: App;
  /**
   * Looks up public listing details (name, icon, description, screenshots, store URL) for an app directly from its store. Supported for the Apple App Store and Google Play; other stores, unknown ids or failed lookups return an error.
   *
   * Network (cockpit) users only.
   */
  appDetails: AppDetails;
  /** Returns single app event */
  appEventType: AppEventType;
  /** Returns filtered app event types */
  appEventTypes: AppEventTypeConnection;
  /**
   * Lists apps (MMP-tracked products, each grouping one or more store apps under an advertiser). Filter criteria are combined with AND. Sorted by app id descending unless another sort is given.
   *
   * Network (cockpit) users only.
   */
  apps: AppConnection;
  /**
   * Returns a grouped report over AppsFlyer blocked-installs / blocked-in-app-events data imported into the platform. The requested `fields` define the columns and grouping, results can be filtered and sorted, and the response includes a CSV download link.
   *
   * Filters without values are ignored. `totalCount` is the number of result rows.
   *
   * Network (cockpit) users only.
   */
  appsflyerBlockingReport: AppsflyerBlockingReportConnection;
  /**
   * Returns the AppsFlyer click signing (Protect360) configuration: the stored AppsFlyer API token and the signing mode currently active in AppsFlyer. Returns null if no token has been configured.
   *
   * The mode is read live from AppsFlyer; it is reported as DISABLED if AppsFlyer does not return one.
   *
   * Network (cockpit) users only.
   */
  appsflyerClickSigningConfig?: Maybe<AppsflyerClickSigningConfig>;
  /**
   * Returns the AppsFlyer click signing report for the given time range: per app, partner and time, the number of total, valid, unsigned, expired and invalidly signed clicks, with the offers involved. Data is fetched from AppsFlyer using the configured click signing token, and the response includes a CSV download link for the same report.
   *
   * Returns an error if the report cannot be retrieved from AppsFlyer (for example when no token is configured).
   *
   * Network (cockpit) users only.
   */
  appsflyerClickSigningReport?: Maybe<AppsflyerClickSigningReportConnection>;
  /**
   * Lists AppsFlyer media source mappings, which tell the AppsFlyer importer which publisher to attribute conversions to for given media source names (optionally limited to one offer and to a date range). Results are ordered by id and paginated with `first`/`offset`; `totalCount` is the number of matching mappings.
   *
   * Filters: `offerIds`, `publisherIds`, `mediaSource` (case-insensitive substring match on any of the mapping's media sources) and `activeOn` (mappings whose start date is on or before and whose end date is after the given date).
   *
   * Network (cockpit) users only.
   */
  appsflyerMediaSourceMappings: AppsflyerMediaSourceMappingConnection;
  /**
   * Returns a single AppsFlyer network cost upload token by id, or null if it does not exist.
   *
   * Network (cockpit) users only.
   */
  appsflyerNetworkCostUploadToken?: Maybe<AppsflyerNetworkCostUploadToken>;
  /**
   * Lists the named AppsFlyer tokens used to upload network cost data to AppsFlyer. Returns an empty list if none are configured.
   *
   * Network (cockpit) users only.
   */
  appsflyerNetworkCostUploadTokens: Array<AppsflyerNetworkCostUploadToken>;
  /**
   * Lists the named AppsFlyer API tokens stored for the account, which AppsFlyer offer configurations refer to when importing data from AppsFlyer. Returns an empty list if none are configured.
   *
   * Network (cockpit) users only.
   */
  appsflyerOfferTokens?: Maybe<Array<AppsflyerOfferToken>>;
  /**
   * Returns a grouped report over AppsFlyer "partners by date" aggregate data (impressions, clicks, installs, sessions, loyal users, revenue and similar metrics by app, date, country, media source and campaign) imported into the platform. The requested `fields` define the columns and grouping, and the response includes a CSV download link.
   *
   * Filters without values are ignored. `totalCount` is the number of result rows.
   *
   * Network (cockpit) users only.
   */
  appsflyerPartnerByDateReport: AppsflyerPartnersByDateConnection;
  attributionExpiration?: Maybe<AttributionExpiration>;
  /** AttributionExpiration */
  attributionExpirations: Array<AttributionExpiration>;
  /** Returns a single audience by id, with its filters, member users and push notifications. Fails with an error if the audience does not exist. Network (cockpit) users only. */
  audience: Audience;
  /** Lists rewarded user audiences, newest first. The optional keyword matches the audience id exactly or the name or description (case-insensitive substring). `totalCount` is the number of matching audiences. Returns at most 10,000 per page. Network (cockpit) users only. */
  audiences: AudienceConnection;
  /**
   * Lists audit log entries (recorded changes to offers, advertisers, publishers, rules and other entities), most recent first, with a total count. The total count is capped for very large result sets. Filter criteria are combined with AND.
   *
   * Users with a restricted manager role only see changes to entities they manage. Network (cockpit) users only.
   */
  audits: AuditConnection;
  /** Retrieves the list of all user authentication logs */
  authLogs?: Maybe<AuthLogConnection>;
  /**
   * Lists auto-approval configurations, which define which imported offers (by advertiser, country, platform and quality limits) are approved into live offers automatically. Each given filter field must match.
   *
   * Network (cockpit) users only.
   */
  autoApprovalConfigs: Array<AutoApprovalConfig>;
  /** Retrieves an automation rule by id */
  automationRule: AutomationRule;
  /** Retrieves all the automation rule actions for a trigger */
  automationRuleActions?: Maybe<Array<AutomationRuleAction>>;
  /** Retrieves automation rule logs, after executing dry run */
  automationRuleExecutionLog: AutomationRuleExecutionLog;
  /** Retrieves all the automation rule filter operation types */
  automationRuleFilterOperationValueType?: Maybe<Array<AutomationRuleFilterOperationValueType>>;
  /** Retrieves all the automation rule filters for a trigger */
  automationRuleFilters?: Maybe<Array<AutomationRuleFilterType>>;
  /** Retrieves all the automation rule trrigers */
  automationRuleTriggers?: Maybe<Array<AutomationRuleTrigger>>;
  /** Retrieves all the automations rules, optionally filtering it */
  automationRules: Array<AutomationRule>;
  /** Lists entries of the banned-users list maintained by the BANNED_USER postback evaluation rule. Each entry is a banned click with its publisher-side user id, publisher, advertiser, offer and the rules that failed for it. Filter by click ids, user id, publisher, offer, advertiser or failed rule; without click ids the results are sorted by click id. `totalCount` is the number of matching entries. Network (cockpit) users only. */
  bannedUsers: BannedUserConnection;
  /**
   * Returns the organization's Google BigQuery export configuration: whether it is enabled, the target project, dataset and location, the exported event types, the sync interval, the backfill start and per-event-type sync state. Service-account credentials are never returned; `serviceAccountConfigured` only tells whether they are stored. Returns a disabled, empty configuration if none has been saved.
   *
   * Network (cockpit) users only.
   */
  bigQueryExportConfig: BigQueryExportConfig;
  /** @deprecated Use blacklistedSubIdsV2 instead */
  blacklistedSubIds: Array<BlacklistedSubId>;
  /** Returns all the blacklisted sub ids that match the filter */
  blacklistedSubIdsV2: BlacklistedSubIdConnection;
  /**
   * Fraud report that flags bot-like behaviour: per user it builds the sequence of events with their time since click (bucketed), then counts how many users share the exact same sequence within each group. Sequences whose share of the group's users (PERCENT) is outside the threshold range are returned, along with the count of matching users and the group total.
   *
   * Only approved conversions are considered. The query defines the time range, filters, level of detail (offer, offer+publisher or offer+publisher+sub id), time granularity, an optional extra group-by dimension, an optional minimum number of conversions per row (minApplicableConversions) and sorting. Only rows whose metric lies outside the [minThreshold, maxThreshold] range are returned; thresholds are ratios between 0 and 1. Network (cockpit) users only.
   */
  botDetectionReport: FraudReportConnection;
  /**
   * Calculates the amount owed to a publisher for a time range: the sum of the publisher's payout (they get) over that period, in the account currency as a decimal. Returns 0 when there is nothing to pay.
   *
   * When rewardedUserId is given, the amount is calculated for the publisher that rewarded user belongs to. Time bounds are interpreted in the account time zone.
   *
   * Network (cockpit) users only.
   */
  calculatePublisherPayment: Scalars['Float']['output'];
  /** Recommendations for targetting when setting a click budget */
  clickBudgetRecommendations: ClickBudgetTargetingRecommendation;
  /**
   * Returns data-availability information for raw reporting data: the earliest and latest fully available stats days, the earliest and latest record time, and record counts for the most recent hours. Useful to check how fresh raw report data is.
   *
   * Only the CLICKS, IMPRESSIONS and ACT_CONVERSIONS metrics are supported; other requested metrics are omitted from the result.
   *
   * Network (cockpit) users only.
   */
  clickHouseReport: Array<ClickHouseReport>;
  /**
   * Fraud report that flags click spamming via long click-to-install times (CTIT): for each group it returns the number of install conversions (default event only) whose time between click and conversion exceeds the given threshold, the total, and their share (PERCENT), keeping groups whose share is outside the threshold range.
   *
   * Only approved conversions are considered. The query defines the time range, filters, level of detail (offer, offer+publisher or offer+publisher+sub id), time granularity, an optional extra group-by dimension, an optional minimum number of conversions per row (minApplicableConversions) and sorting. Only rows whose metric lies outside the [minThreshold, maxThreshold] range are returned; thresholds are ratios between 0 and 1. Network (cockpit) users only.
   */
  clickSpammingReport: FraudReportConnection;
  /** Describes all available ClickHouse tables and their columns */
  clickhouseDescribeTables: Array<ClickHouseTableDescription>;
  /** Executes a read-only SQL query against ClickHouse */
  clickhouseQuery: ClickHouseQueryResult;
  /**
   * Returns a cohort report for MMP-tracked apps: users are grouped into cohorts by install period and the chosen metric (retention, sessions, revenue, cost, ROAS, events, ...) is reported for each following period, as per-period or cumulative values.
   *
   * The result includes the requested page of rows, the total row count and a time-limited CSV download link for the full report (relative to the API host, valid for about one hour).
   *
   * Network (cockpit) users only. If the report cannot be computed, the query fails with a generic error.
   */
  cohortReport: CohortReportConnection;
  /**
   * Returns a single controlled access rule by id. A controlled access rule whitelists or blacklists traffic-source values (app id, app name, site, creative, placement, sub id, sub-sub id, original sub id) for an offer, publisher and/or advertiser. Fails with a not-found error if it does not exist.
   *
   * Network (cockpit) users only.
   */
  controlledAccessObject: ControlledAccessObject;
  /**
   * Lists controlled access rules (whitelists and blacklists of traffic-source values such as app ids, sites or sub ids for offers, publishers and advertisers). All filter criteria are combined with AND; without criteria all rules are returned, newest first.
   *
   * Network (cockpit) users only.
   */
  controlledAccessObjects: ControlledAccessObjectConnection;
  /**
   * List of converions as found by given filters
   * @deprecated Use conversionReport instead
   */
  conversion: Array<Conversion>;
  /**
   * Returns individual conversions (postbacks) received between `start` and `end`, with the requested fields per row, a total row count (`totalCount`) and a `csvDownloadUrl` for exporting the full result (up to 100,000 rows) as CSV. Rows are sorted by conversion time, newest first, unless `sort` is given. Times are interpreted in the account's time zone.
   *
   * For users with a restricted manager role, rows are limited to the advertisers or publishers they manage. Network (cockpit) users only.
   */
  conversionReport: ConversionReportRowConnection;
  /**
   * Returns rows of a data report type (for example the Click report), one record per requested field. When no TIME filter is given, the range is taken from start/end, defaulting to the start of the day 7 days ago until now, in the account time zone. Sorted by the report's default field descending unless a sort is given.
   *
   * The result includes the requested page of rows, the total row count matching the filters, and csvDownloadUrl, a time-limited link (relative to the API host, valid for about one hour) to download all matching rows (up to 2,000,000) as CSV. Fails with an error for an unknown report type or if the report cannot be generated.
   *
   * Network (cockpit) users only.
   */
  dataReport: DataReportRowConnection;
  /** Returns the fields available in a data report type (for example Click), with their name, data type (TEXT, NUMBER, BOOLEAN, DATE), display label, whether they are shown by default, and display weight. Fields are ordered by weight. Fails with a not-found error for an unknown report type; use dataReports to list the available types. */
  dataReportFields?: Maybe<Array<DataReportField>>;
  /** List of available data report types */
  dataReports?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Lists the tracking rule customizations defined in the account, newest first, with a total count. Filter criteria are combined with AND.
   *
   * Network (cockpit) users only.
   */
  definedTrackingCustomizationRules: RuleCustomizationConnection;
  /**
   * Fraud report that flags device mismatches: for each group it returns the number of conversions whose user agent differs from the user agent of the originating click, the total, and their share (PERCENT), keeping groups whose share is outside the threshold range.
   *
   * Only approved conversions are considered. The query defines the time range, filters, level of detail (offer, offer+publisher or offer+publisher+sub id), time granularity, an optional extra group-by dimension, an optional minimum number of conversions per row (minApplicableConversions) and sorting. Only rows whose metric lies outside the [minThreshold, maxThreshold] range are returned; thresholds are ratios between 0 and 1. Network (cockpit) users only.
   */
  deviceMismatchReport: FraudReportConnection;
  /** Entry point for autocomplete values used when building advanced targeting rules: browsers, operating systems, carriers, cities, states, device makes and models. Each sub-field accepts its own prefix and limit arguments. */
  deviceValues: DeviceValues;
  /**
   * Lists custom (tracking) domains assigned to specific advertisers, offers or publishers, filtered by the given criteria. `totalCount` is the number of matching entries.
   *
   * Network (cockpit) users only.
   */
  domainCustomizations: DomainCustomizationConnection;
  /** Retrieves all the evaluated postbacks */
  evaluatedPostbacks: Array<EvaluatedPostback>;
  /**
   * Lists generated event log files: CSV exports of raw click, impression or click-redirection logs for a time range (at most 7 days) and a set of offers, advertisers, publishers or publisher sub ids. Each file has a generation status and, once ready, a download URL. Files expire and are removed automatically after a while.
   *
   * Network (cockpit) users only.
   */
  eventLogFiles: EventLogFileConnection;
  /** Single event type by ovent type id */
  eventType?: Maybe<EventType>;
  /** List of event types as found by given filters */
  eventTypes: Array<EventType>;
  /**
   * Returns platform usage per billing period: the number of clicks, impressions, postbacks, discarded clicks/impressions, unattributed postbacks and the total, for each period (`start`-`end` dates). Periods are sorted newest first and cover roughly the last 12 months. Usage figures are recalculated once a day.
   *
   * Network (cockpit) users only.
   */
  eventUsages?: Maybe<EventUsageConnection>;
  /** Returns a single event value extraction rule by id, or null if it does not exist. Network (cockpit) users only. */
  eventValueExtractionRule?: Maybe<EventValueExtractionRule>;
  /** Lists event value extraction rules, in order of precedence: most specific first (event type, then offer, then advertiser level), then highest priority. Filter by advertisers, offers, event types, target field, active flag or a keyword matching the rule's name, expression or id. `totalCount` is the number of matching rules. Network (cockpit) users only. */
  eventValueExtractionRules: EventValueExtractionRuleConnection;
  /**
   * Returns the offer feed API configuration (feed sections with their filters and whitelisted/blacklisted offers) for a publisher, together with the number of offers the feed currently contains.
   *
   * When `publisherId` is omitted, the default configuration used for publishers without their own configuration is returned. If no configuration exists, a configuration with no sections is returned.
   *
   * Network (cockpit) users only.
   */
  feedApiConfiguration?: Maybe<FeedApiConfiguration>;
  /** Returns all feed api configurations */
  feedApiConfigurations?: Maybe<Array<FeedApiConfiguration>>;
  /**
   * Returns a single filler by its id. Returns an error if no filler with that id exists.
   *
   * Network (cockpit) users only.
   */
  filler: Filler;
  /**
   * Lists fillers, with a total count. A filler supplies weighted values for a click parameter (such as sub id, app name, site or placement) for traffic matching its advertisers, offers, publishers, tags, country and OS. Filter criteria are combined with AND.
   *
   * Network (cockpit) users only.
   */
  fillers: FillerConnection;
  /** Retrieves the form with the given id */
  form: Form;
  /** Lists the submissions of the given form, newest first. Submissions that have already been turned into a publisher are left out. Returns an empty list when the form has no such submissions. */
  formSubmissions: Array<FormResult>;
  /** Lists the account's forms (such as sign-up forms) with their fields, optionally only those with a given tag. */
  forms: Array<Form>;
  /** Returns the rewarded fraud scoring policy of the organization: daily scan on/off, lookback window in days, the identifier used to group activity into users, and the automatic-ban settings. Returns default values if the policy has never been saved. Network (cockpit) users only. */
  fraudPolicyConfig: FraudPolicyConfig;
  /**
   * Returns a conversion funnel for MMP-tracked apps: for an ordered sequence of app events, how many users completed each step (and the share of users relative to the funnel start), optionally grouped by dimensions. A user advances in the funnel only when the events occur in order within the conversion window.
   *
   * The result includes the requested page of rows, the total row count and a time-limited CSV download link for the full report (relative to the API host, valid for about one hour).
   *
   * Network (cockpit) users only. If the report cannot be computed, the query fails with a generic error.
   */
  funnelReport: FunnelReportConnection;
  /**
   * Returns whether migration syncing is enabled account-wide. Advertisers without their own migration state use this value.
   *
   * Network (cockpit) users only.
   */
  generalMigrationState: Scalars['Boolean']['output'];
  /**
   * Generates a CSV file with the payouts that match the filter and returns a link to download it. Each row has advertiser id, offer id, publisher id, event type id, weGet and theyGet (as decimal amounts). Publisher-specific payouts are only included for publishers that have access to the offer. Edit the file and upload it back with `importPayoutEditCSV` to change payouts in bulk.
   *
   * Network (cockpit) users only.
   */
  generatePayoutsEditCSV: Scalars['String']['output'];
  /**
   * Fraud report that flags geo mismatches: for each group it returns the number of install conversions (default event only) whose country, region or city differs from that of the originating click, the total, and their share (PERCENT), keeping groups whose share is outside the threshold range.
   *
   * Only approved conversions are considered. The query defines the time range, filters, level of detail (offer, offer+publisher or offer+publisher+sub id), time granularity, an optional extra group-by dimension, an optional minimum number of conversions per row (minApplicableConversions) and sorting. Only rows whose metric lies outside the [minThreshold, maxThreshold] range are returned; thresholds are ratios between 0 and 1. Network (cockpit) users only.
   */
  geoMismatchReport: FraudReportConnection;
  /**
   * Lists the global postback links, i.e. postback links that are not bound to a specific publisher or offer and therefore apply platform-wide.
   *
   * Network (cockpit) users only.
   */
  globalPostbackLinks: Array<PostbackLink>;
  /**
   * Searches offers, advertisers and publishers by keyword (name, id and related identifiers such as an offer's app store id) and returns the matches grouped by entity type. Types without matches are left out. Offers are ranked by revenue over the last 7 days.
   *
   * Users with a restricted manager role only get entities they manage. Network (cockpit) users only.
   */
  groupedSearch: Array<GroupedSearchResult>;
  /**
   * Returns a single imported offer by its id. Returns an error if it does not exist.
   *
   * Users with a restricted manager role get an access-denied error for imported offers of advertisers they do not manage.
   */
  importedOffer: ImportedOffer;
  /**
   * Retrieves all the imported offers, optionally filtering it
   * @deprecated Use importedOffersV2 instead
   */
  importedOffers: Array<ImportedOffer>;
  /**
   * Lists imported offers (offers fetched from advertisers' platforms through network import configurations, which can be approved into live offers), with paging and a total count. Only offers from advertisers whose import syncing is active are included. Filter criteria are combined with AND.
   *
   * Users with a restricted manager role only see imported offers of advertisers they manage.
   */
  importedOffersV2: ImportedOfferConnection;
  /**
   * Checks whether a custom domain is set up correctly, i.e. its DNS (CNAME) points to the platform or the domain already serves the platform. Returns true if it does, false otherwise (including when the domain does not exist).
   *
   * Results are cached briefly: a successful check is reused for up to 10 minutes, a failed one for up to 1 minute, so a freshly fixed domain may take a minute to report true.
   */
  isDomainConfiguredCorrectly: Scalars['Boolean']['output'];
  /**
   * Checks whether a custom domain is reachable over HTTPS with a working certificate. Returns true if an HTTPS request to the domain succeeds, false otherwise.
   *
   * Results are cached briefly: a successful check is reused for up to 10 minutes, a failed one for up to 1 minute.
   */
  isSSLConfiguredCorrectly: Scalars['Boolean']['output'];
  /**
   * Returns a single KPI by its id. Returns an error if no KPI with that id exists.
   *
   * Network (cockpit) users only.
   */
  kpi: Kpi;
  /**
   * Lists KPIs: monitoring rules that check a target metric for matching offers, advertisers or publishers and trigger actions (notifications, status or access changes) when it is missed. Returns the matching KPIs with a total count. Filter criteria are combined with AND.
   *
   * Network (cockpit) users only.
   */
  kpis: KpiConnection;
  /**
   * Lists all lead evaluation rules that can be applied to incoming leads (for example lead targeting, duplicated or invalid email, anonymous proxy and recency checks).
   *
   * Network (cockpit) users only.
   */
  leadEvaluationRules: Array<LeadEvaluationRule>;
  /**
   * Returns a single lead forwarding endpoint by id. A lead forwarding endpoint describes how leads are sent to an advertiser's HTTP endpoint (URL, method, content type, body template, headers, variables, targeting, optional pre-ping and the expected response). Fails with a not-found error if it does not exist.
   *
   * Network (cockpit) users only.
   */
  leadForwardingEndpoint: LeadForwardingEndpoint;
  /**
   * Lists lead forwarding endpoints (advertiser HTTP endpoints that leads are forwarded to), newest first. Filter criteria are combined with AND. `totalCount` is the number of matching endpoints.
   *
   * Network (cockpit) users only.
   */
  leadForwardingEndpoints: LeadForwardingEndpointConnection;
  marketplaceAdvertiserPartners: MarketplaceAdvertiserPartnerConnection;
  marketplaceOrganization?: Maybe<MarketplaceOrganization>;
  marketplaceOrganizations: MarketplaceOrganizationConnection;
  marketplacePostbackLink?: Maybe<MarketplacePostbackLink>;
  /** Returns the currently signed-in user (profile, roles and settings). */
  me: User;
  /** Returns a single memo by its id. Returns an error if the memo does not exist or belongs to another user. */
  memo: Memo;
  /** Lists the in-app memos (notifications) of the current user, with a total count. Only the caller's own memos are returned; any user id in the filter is ignored. */
  memos: MemoConnection;
  /**
   * Returns the migration sync state per advertiser, used while an account is being migrated from another platform. Advertisers without their own state inherit the account-wide state (see `generalMigrationState`). Without an advertiser id, returns the state of all active, paused and pending advertisers.
   *
   * Network (cockpit) users only.
   */
  migrationStates: Array<MigrationState>;
  /**
   * Lists conversion modification batches (bulk edits or CSV uploads that modify or create conversions), newest first, with their progress counters.
   *
   * Returns an empty connection when the feature is not available on the account. `totalCount` is the total number of batches.
   *
   * Network (cockpit) users only.
   */
  modificationBatches: ModificationBatchConnection;
  networkPartners: MarketplaceNetworkPartnerConnection;
  /**
   * Lists email notifications sent from the platform (for example offer announcements to publishers or payout change notices), including recipients, contents and send status. Notifications without recipients are left out. Filter criteria are combined with AND.
   *
   * Network (cockpit) users only.
   */
  notifications: Array<Notification>;
  /**
   * Returns a single offer by its id, or null if no offer with that id exists.
   *
   * Network (cockpit) users only.
   */
  offer?: Maybe<Offer>;
  /**
   * Returns a single offer batch operation (a saved, optionally scheduled set of filters and actions applied to many offers at once). Returns an error if it does not exist.
   *
   * Network (cockpit) users only.
   */
  offerBatchOperation: OfferBatchOperation;
  /**
   * Lists offer batch operations, newest first. The filter can restrict the list to specific ids or to operations whose id equals, or whose name contains (case-insensitive), a keyword. `totalCount` is the number of operations matching the filter.
   *
   * Network (cockpit) users only.
   */
  offerBatchOperations: OfferBatchOperationConnection;
  /**
   * Exports offers as a CSV file and returns a download URL for it. Up to 50,000 offers matching the filter are exported, in the given sort order, with one column per requested field (the header row uses readable field names). Traffic and revenue statistic columns cover the last month.
   *
   * The same visibility rules as the corresponding list query apply, so partner portal and restricted users only export what they can see. Fails with an error if the file cannot be created.
   */
  offerDetailsDownload: Scalars['String']['output'];
  /**
   * Entry point for autocomplete values used by the offer scan tool: device makes, device types, models, OS versions and browsers. Each sub-field accepts its own prefix and limit arguments.
   *
   * Network (cockpit) users only.
   */
  offerScanDeviceValues: OfferScanDeviceValues;
  /**
   * Lists offer tags for autocomplete. Each tag is returned with the offers that carry it.
   *
   * With a `prefix`, only tags starting with that prefix (case-insensitive) are matched from the tags in use; the organization's pre-defined tags are always included. Without a prefix, all tags are returned.
   *
   * Network (cockpit) users only.
   */
  offerTags?: Maybe<Array<OfferTag>>;
  /**
   * Lists offers matching the given filter as a plain list. Deprecated: use `offersV2`, which returns the same data plus a total count.
   *
   * Filter criteria are combined with AND. If no status filter is given, the account's default offer status filter (if configured) is applied. Users with a restricted manager role only see offers of the advertisers they manage. Network (cockpit) users only.
   * @deprecated Use offersV2 instead
   */
  offers: Array<Offer>;
  /**
   * Lists offers matching the given filter, with paging and the total number of matches (`totalCount`).
   *
   * Filter criteria are combined with AND. If no status filter is given, the account's default offer status filter (if configured) is applied. Results can be sorted by id, advertiser offer id, default payout, remaining budgets, number of redirect jumps or a statistic (clicks, conversions, revenue, payout, profit); statistic sorts use the time range from `sort.sortQuery`, or from the `report` selection on the returned offers. Returns an empty list when nothing matches. Users with a restricted manager role only see offers of the advertisers they manage. Network (cockpit) users only.
   */
  offersV2: OfferConnection;
  /** Returns the organization (account) that this API endpoint belongs to, including its settings and domains. Returns an error if the organization data cannot be loaded. */
  organization: Organization;
  organizationIntegrationRequest: OrganizationIntegrationRequest;
  organizationIntegrationRequests: OrganizationIntegrationRequestConnection;
  /**
   * Lists the invoices Swaarm has issued to your account for its billing periods, with number, dates, amount, currency, payment status and a link to the invoice document. Returns an empty list when platform billing is not enabled for the account.
   *
   * Network (cockpit) users only.
   */
  organizationInvoices: OrganizationInvoiceConnection;
  /**
   * Returns the status of the account's recurring card payment method in Mollie, used for automated platform billing: INACTIVE when no Mollie payment method is set up, VALID (with masked card number, label and holder) when a valid mandate exists, INVALID otherwise. Fails with an error if billing is not configured for the account.
   *
   * Network (cockpit) users only.
   */
  organizationRecurringMolliePayment: OrganizationRecurringPaymentMethodMollieIntegration;
  organizationRequest: OrganizationRequest;
  organizationRequests: OrganizationRequestConnection;
  /** Single advertiser by id */
  partnerAdvertiser: PartnerAdvertiser;
  /** Single advertiser offer by offer and publisher id */
  partnerAdvertiserOffer: PartnerAdvertiserOffer;
  /** All partner advertisers to which the user has access */
  partnerAdvertisers: Array<PartnerAdvertiser>;
  /**
   * Returns the given publisher's approved conversions received between `start` and `end`, with the requested fields per row, a total row count (`totalCount`) and a `csvDownloadUrl` for exporting the result as CSV. Rejected conversions and conversions for events hidden from the publisher are not included. Rows are sorted by conversion time, newest first, unless `sort` is given. Times are interpreted in the account's time zone.
   *
   * Partner portal publisher users can only query publishers they are a contact of. Network (cockpit) users can query any publisher.
   */
  partnerConversionReport: PartnerConversionReportRowConnection;
  /**
   * Returns the partner-portal view of a single publisher by its id. Returns an error if the publisher does not exist.
   *
   * Network (cockpit) users can read any publisher. Partner portal publisher users can only read publishers they are a contact of, and cannot request network revenue (`weGet`) statistics.
   */
  partnerPublisher: PartnerPublisher;
  /** Returns the partner (publisher) portal settings of the organization: terms and conditions, privacy policy, the label used for offer tags, and which portal features are enabled for publishers (offers, smart links, conversion report, support tickets, referrals, etc.). Returns default settings if none have been saved. */
  partnerPublisherConfig: PartnerPublisherConfig;
  /**
   * Returns the partner-portal view of a single offer as seen by the given publisher. Returns an error if the offer does not exist.
   *
   * Partner portal publisher users must be a contact of the publisher, and private offers are only visible once the publisher has been approved for them; network revenue (`weGet`) statistics cannot be requested. Network (cockpit) users can read any offer, but get an error for a private offer the selected publisher has not been approved for.
   */
  partnerPublisherOffer: PartnerPublisherOffer;
  partnerPublisherOfferTags?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Lists the publishers the current user can open in the partner portal.
   *
   * Admins, ad-ops users and managers get all active publishers. Other users get the publishers they are a contact of (with portal access enabled). Returns an empty list when the caller is not signed in or has no publishers.
   */
  partnerPublishers: Array<PartnerPublisher>;
  /**
   * Runs a statistics query for one publisher, limited to that publisher's traffic, and returns the result rows plus totals and a `downloadToken` for downloading the full report. Network-side metrics (actual revenue and actual conversion counts) cannot be requested and return an error.
   *
   * Partner portal publisher users can only query publishers they are a contact of. Network (cockpit) users can query any publisher.
   */
  partnerRawReport: PartnerRawReport;
  /** Returns the payout conversion policy of an advertiser (how network-reported amounts are turned into end user rewards), or null if the advertiser has none. Network (cockpit) users only. */
  payoutConversionPolicy?: Maybe<PayoutConversionPolicy>;
  /**
   * Lists configured payout margins. A margin is a fraction used to derive the publisher payout from the advertiser payout (theyGet = weGet × (1 − margin)); it can be set at advertiser, offer, publisher and event type level. Each given filter field must match exactly. Filtering by publisher only returns that publisher's publisher-level margins.
   *
   * Network (cockpit) users only.
   */
  payoutMargins: Array<PayoutMargin>;
  /** Resolves the most specific split payout (weGet/theyGet/theyGetPoints) for a key */
  payoutV2?: Maybe<PayoutV2>;
  /**
   * Returns the organization's permission settings. Currently this covers tag editing: for advertisers, publishers and offers, the minimum user permission level (e.g. ADMIN, ADOPS, MANAGER) required to write tags. Returns default settings if none have been saved.
   *
   * Network (cockpit) users only.
   */
  permissionConfig: PermissionConfig;
  /**
   * Lists every search-feed integration type supported by the platform, each with its default configuration and configuration spec. The returned entries are templates and are not linked to any advertiser (their `id` is null); use them to discover which integrations can be set up and which settings they need.
   *
   * Network (cockpit) users only.
   */
  possibleSearchIntegrations?: Maybe<Array<SearchIntegration>>;
  /**
   * Lists every tracking rule that can be customized in the given namespaces, with whether it is active by default and the parameters it accepts. Use it to build a rule customization.
   *
   * Network (cockpit) users only.
   */
  possibleTrackingCustomizationRules: Array<PossibleRuleCustomization>;
  /** Retrieves the list of all evaluation decision rules */
  postbackEvaluationRules: Array<PostbackEvaluationRule>;
  /**
   * Returns the log of incoming postbacks received in a time window, with their outcome (SUCCESS, FAILED or REVERSAL), error messages, raw query string, sender IP and user agent, click id, offer and publisher. Useful for debugging why a conversion was or was not recorded.
   *
   * `start` and `end` are interpreted in the organization's time zone and are both inclusive. Additional filters are combined with AND; IN / NOT_IN / CONTAINS / NOT_CONTAINS filters without values are ignored. `totalCount` is the number of matching entries.
   *
   * Network (cockpit) users only.
   */
  postbackLogs: PostbackLogConnection;
  /** Retrieves the postback modification with the given id */
  postbackModification: PostbackModification;
  /**
   * Lists postback (conversion) modifications, i.e. requested edits to already recorded conversions and their processing state.
   *
   * Without a status filter, all modifications are returned sorted by last update, most recent first. Filtering by PROCESSING also includes modifications that are in later intermediate processing stages but not yet finished. Results are paged with `pagination` (default page size 500).
   *
   * Network (cockpit) users only.
   */
  postbackModifications: Array<PostbackModification>;
  /** Retrieves the list of all evaluation status rules */
  postbackStatusRules: Array<PostbackStatusRule>;
  /**
   * Simulates an advertiser batch operation without changing anything and returns the per-advertiser log of what it would do. Provide either `id` to preview a saved operation, or `input` to preview an operation that has not been saved yet; `id` takes precedence when both are given.
   *
   * At most 10,000 matching advertisers are evaluated. Returns an error if `id` does not exist.
   *
   * Network (cockpit) users only.
   */
  previewAdvertiserBatchOperation: AdvertiserBatchOperationLogConnection;
  /**
   * Runs a one-off fetch against the advertiser's platform using the given (unsaved) network import configuration and returns the offers it would import, without saving anything. Use it to check credentials and field mappings before creating or updating a config.
   *
   * The call waits for the remote platform to respond, so it can be slow, and it fails if the platform rejects the request or cannot be reached. Network (cockpit) users only.
   */
  previewAdvertiserConfig: Array<ImportedOffer>;
  /**
   * Simulates an offer batch operation without changing anything and returns the per-offer log of what it would do. Provide either `id` to preview a saved operation, or `input` to preview an operation that has not been saved yet; `id` takes precedence when both are given.
   *
   * At most 10,000 matching offers are evaluated. Returns an error if `id` does not exist.
   *
   * Network (cockpit) users only.
   */
  previewOfferBatchOperation: OfferBatchOperationLogConnection;
  /**
   * Simulates a publisher batch operation without changing anything and returns the per-publisher log of what it would do. Provide either `id` to preview a saved operation, or `input` to preview an operation that has not been saved yet; `id` takes precedence when both are given.
   *
   * At most 10,000 matching publishers are evaluated. Returns an error if `id` does not exist.
   *
   * Network (cockpit) users only.
   */
  previewPublisherBatchOperation: PublisherBatchOperationLogConnection;
  product: Product;
  products: ProductConnection;
  /**
   * Fraud report that flags proxy traffic: for each group it returns the number of conversions coming from IP addresses known to be proxies, the total, and their share (PERCENT), keeping groups whose share is outside the threshold range. The sort option is not applied to this report.
   *
   * Only approved conversions are considered. The query defines the time range, filters, level of detail (offer, offer+publisher or offer+publisher+sub id), time granularity, an optional extra group-by dimension, an optional minimum number of conversions per row (minApplicableConversions) and sorting. Only rows whose metric lies outside the [minThreshold, maxThreshold] range are returned; thresholds are ratios between 0 and 1. Network (cockpit) users only.
   */
  proxyDetectionReport: FraudReportConnection;
  /**
   * Returns the public subset of the platform's settings that the rewarded app needs before a user signs in: app branding (name, title, logo, icon, store and website URLs), social login client identifiers, feature toggles (tutorial, referrals, daily check-in, first-time experience, showing USD values), the referral message, the minimum payment amount and the points-to-USD exchange rate. Settings that are not set are returned with their default values; sensitive values are never included.
   *
   * Can be called without authentication.
   */
  publicServiceConfigs: Array<ServiceConfig>;
  /**
   * Returns a single publisher by its id, or null if no publisher with that id exists.
   *
   * Network (cockpit) users only. Users with a restricted manager role get an access-denied error for publishers they are not the account or sales manager of.
   */
  publisher?: Maybe<Publisher>;
  /**
   * Returns a single publisher batch operation (a saved, optionally scheduled set of filters and actions applied to many publishers at once). Returns an error if it does not exist.
   *
   * Network (cockpit) users only.
   */
  publisherBatchOperation: PublisherBatchOperation;
  /**
   * Lists publisher batch operations, newest first. The filter can restrict the list to specific ids or to operations whose id equals, or whose name contains (case-insensitive), a keyword. `totalCount` is the number of operations matching the filter.
   *
   * Network (cockpit) users only.
   */
  publisherBatchOperations: PublisherBatchOperationConnection;
  /**
   * Returns a single publisher contact (a person linked to a publisher) by its id. Returns an error if no contact with that id exists.
   *
   * Network (cockpit) users only.
   */
  publisherContact?: Maybe<PublisherContact>;
  /** List of publisherContact as found by given filters */
  publisherContacts: Array<PublisherContact>;
  /**
   * Exports publishers as a CSV file and returns a download URL for it. Up to 50,000 publishers matching the filter are exported, in the given sort order, with one column per requested field (the header row uses readable field names). Traffic and revenue statistic columns cover the last month.
   *
   * The same visibility rules as the corresponding list query apply, so partner portal and restricted users only export what they can see. Fails with an error if the file cannot be created.
   */
  publisherDetailsDownload: Scalars['String']['output'];
  /** Retrieves all the publisher evaluated postbacks for a publisher id */
  publisherEvaluatedPostbacks: Array<EvaluatedPostback>;
  /** Single publisher group member */
  publisherGroupMember?: Maybe<PublisherGroupMember>;
  /** Single publisher margin, by publisher id */
  publisherMargin?: Maybe<PublisherMargin>;
  /** List of publisher margins */
  publisherMargins: Array<PublisherMargin>;
  /**
   * Lists publisher-offer relationships (offer access entries), each with the publisher, the offer, the access state and per-relationship data such as payouts, budgets and tracking URLs.
   *
   * The filter can restrict by access state, advertiser, offer, publisher, offer status and account manager. Users with restricted manager access only see relationships of the publishers/advertisers they manage. `totalCount` is the number of matching entries.
   *
   * Network (cockpit) users only.
   */
  publisherOffers: PublisherOfferViewConnection;
  /**
   * Returns a single publisher payment by id. Fails with a not-found error if it does not exist.
   *
   * Network (cockpit) users only.
   */
  publisherPayment: PublisherPayment;
  /** Returns publisher payment scheduler settings */
  publisherPaymentSchedulerSettings?: Maybe<PublisherPaymentSchedulerSettings>;
  /**
   * Lists publisher payments, newest first. Filter criteria are combined with AND.
   *
   * Without any filter criteria, payments made to rewarded users are excluded; use onlyRewardedUsers or rewardedUserIds to list those.
   *
   * Network (cockpit) users only.
   */
  publisherPayments: PublisherPaymentConnection;
  /** Returns a single publisher referral plan by id. A referral plan defines commission levels (percentage of the referred publishers' profit, payout or revenue, per referral depth) that a publisher earns for the publishers it referred, and which publishers it applies to (specific publishers, publisher tags, or the default plan). Fails with a not-found error if it does not exist. */
  publisherReferralPlan: PublisherReferralPlan;
  /** Lists publisher referral plans. */
  publisherReferralPlans: PublisherReferralPlanConnection;
  /** Calculates referral commissions earned by referring publishers for a time range. Each publisher's plan is resolved in this order: a plan naming the publisher explicitly, then a plan matching one of its tags, then the default plan. For every publisher it referred, a row is returned with the commission from the first level plus deeper levels (publishers referred by the referred publisher, and so on), each component being the level's percentage of the referred publisher's profit, payout (they get) or revenue (we get) in the period. Rows are ordered by amount, ascending; amounts are in the account currency. */
  publisherReferralReport: PublisherReferralReport;
  /**
   * Lists publisher tags for autocomplete.
   *
   * With a `prefix`, only tags starting with that prefix (case-insensitive) are matched from the tags in use; the organization's pre-defined tags are always included. Without a prefix, all tags are returned.
   *
   * Network (cockpit) users only.
   */
  publisherTags?: Maybe<Array<PublisherTag>>;
  /**
   * Lists publishers matching the given filter as a plain list. Deprecated: use `publishersV2`, which returns the same data plus a total count.
   *
   * Filter criteria are combined with AND; the keyword also matches publisher contact emails and names. If no status filter is given, the account's default publisher status filter (if configured) is applied. Users with a restricted manager role only see publishers they manage. Network (cockpit) users only.
   * @deprecated Use publishersV2 instead
   */
  publishers: Array<Publisher>;
  /**
   * Lists publishers matching the given filter, with paging and the total number of matches (`totalCount`).
   *
   * Filter criteria are combined with AND; the keyword also matches publisher contact emails and names. If no status filter is given, the account's default publisher status filter (if configured) is applied. Statistic sorts use the time range from `sort.sortQuery`, or from the `report` selection on the returned publishers. Returns an empty list when nothing matches. Users with a restricted manager role only see publishers they manage. Network (cockpit) users only.
   */
  publishersV2: PublisherConnection;
  pushNotification: PushNotification;
  /** Lists all push notifications, newest first, with their audience, schedule, status and delivery counts. `totalCount` is the total number of notifications. Returns at most 10,000 per page. Network (cockpit) users only. */
  pushNotifications: PushNotificationConnection;
  /**
   * Runs a flexible statistics query over a time range with the chosen dimensions, metrics, filters, metric filters, sorting and paging, and returns the result rows plus totals. The response also includes a `downloadToken` for downloading the full report as a file.
   *
   * Queries that would return too much data are stopped with an error asking for fewer dimensions or a shorter time range; some dimension and metric combinations are not supported. For users with a restricted manager role, results are limited to the advertisers or publishers they manage. Network (cockpit) users only.
   */
  rawReport: RawReport;
  /** Lists the available realtime integration providers, with their kind (mappable offers, iframe, e-commerce or embedded SDK) and the configuration fields each one needs (label, whether mandatory). Use the provider `type` when calling `saveRealtimeIntegration`. Network (cockpit) users only. */
  realtimeIntegrationAdapters: Array<RealtimeIntegrationAdapter>;
  /** Lists realtime integrations (networks whose offers are fetched live at serve time), optionally only those of one advertiser. Returns an empty list when none match. Network (cockpit) users only. */
  realtimeIntegrations: Array<RealtimeIntegration>;
  /**
   * Runs one or more aggregated statistics queries (clicks, impressions, conversions, revenue, payout, profit, ...) and returns one report per query, in the same order. Each query has its own time range, granularity, filters, dimensions and metrics. When a query has no dimensions or metrics, they are taken from the fields selected on the returned `stats`.
   *
   * For users with a restricted manager role, results are limited to the advertisers or publishers they manage. Network (cockpit) users only.
   */
  report: Array<Report>;
  /** Returns single retargeting file */
  retargetingFile: RetargetingFile;
  /** Returns list of retargeting files */
  retargetingFiles: RetargetingFileConnection;
  /** Lists all RewardOS apps (host apps embedding the RewardOS SDK offer wall), sorted by name, including their keys, secrets, settings and player counts. Network (cockpit) users only. */
  rewardOsApps: Array<RewardOsApp>;
  rewardOsTransactions: RewardOsTransactionConnection;
  /** The signed-in player's points wallet. */
  rewardOsWallet: RewardOsWallet;
  rewardedCohorts: RewardedCohortReport;
  /**
   * Returns the rewarded app dashboard for a date range: totals, per-day and per-day-per-platform metrics (active users, new users, app opens, conversions, revenue, reward cost, paid-out cost, profit, ARPU) and the top offers. Days are calendar days in the organization's timezone, which is returned in the report. Results may be up to a minute old.
   *
   * The range must cover 1 to 366 days and may not end after today. Optionally restrict to up to 100 publishers. Account managers restricted to specific publishers only see data of those publishers. Fails if rewarded reporting is not enabled for the platform. Network (cockpit) users only.
   */
  rewardedDashboard: RewardedDashboardReport;
  /** Returns whether a rewarded user account exists for the given email address, for example to choose between the sign-in and sign-up flow in the rewarded app. Can be called without authentication. */
  rewardedEmailExists: Scalars['Boolean']['output'];
  /** Minimum amount (USD) a rewarded user can request as a payment/deposit (global/minimumRequestedPaymentAmount, 0 when unset). */
  rewardedMinimumDepositAmount: Scalars['Float']['output'];
  /**
   * Returns an offer as seen in the rewarded app, including click and impression URLs personalised for the currently authenticated rewarded-app user. If the offer does not exist, an error is returned.
   *
   * Only available on platforms with the rewarded product enabled; otherwise access is denied.
   */
  rewardedOffer: RewardedOffer;
  rewardedOfferFunnel: RewardedOfferFunnelReport;
  /**
   * Returns a single support ticket with its messages. Fails with an error if the ticket does not exist.
   *
   * Callable by the ticket's rewarded user (player) with their own token, and by network (cockpit) users; account managers restricted to specific publishers can only open tickets of players of those publishers.
   */
  rewardedSupportTicket: RewardedUserSupportTicket;
  /** Lists rewarded users' support tickets, ordered by the time of their latest message (most recent first). Filter by rewarded user and/or by the assigned account manager. `totalCount` is the number of matching tickets. Account managers restricted to specific publishers only see tickets of players of those publishers. Network (cockpit) users only. */
  rewardedSupportTickets: RewardedUserSupportTicketConnection;
  rewardedSystemOffers: Array<RewardedSystemOfferConfig>;
  /**
   * Returns the profile of the currently authenticated rewarded-app user (player), including their balance, offers and rewards through nested fields.
   *
   * Only available on platforms with the rewarded product enabled; otherwise access is denied.
   */
  rewardedUser: RewardedUser;
  /** Rewarded anti-fraud report: groups of different users that share the same device fingerprint, IP address or persistent app device id (`groupBy`) in the time range, a sign of one person running several accounts. Each row lists the users in the group, the offer/advertiser/publisher (not set for persistent-id groups, which span offers), conversion count and payouts. Users are identified by the identifier configured in the fraud policy. `csvDownloadUrl` links to a CSV export of the full report. Network (cockpit) users only. */
  rewardedUserMultiAccounting: RewardedFraudMultiAccountConnection;
  /**
   * Lists the payment (withdrawal) requests of a rewarded user, newest first, with their amount, status and payment details. When `first` or `offset` is omitted, the first 500 payments are returned.
   *
   * Callable by the rewarded user (player) for their own account with their own token, and by network (cockpit) users.
   */
  rewardedUserPayments: PartnerPublisherPaymentConnection;
  rewardedUserPaymentsByInternalId: PartnerPublisherPaymentConnection;
  /** Rewarded anti-fraud report: users who only complete the high-value events of an offer. For each user and offer, the payout of the user's cheapest completed event is compared to the cheapest event any user completed on that offer; users at or above `minRatio` (default 2.0) with at least `minConversions` conversions (default 3) are reported. Users are identified by the identifier configured in the fraud policy. `csvDownloadUrl` links to a CSV export of the full report. Network (cockpit) users only. */
  rewardedUserPayoutCherryPicking: RewardedFraudPayoutCherryPickingConnection;
  /** Rewarded anti-fraud report on referral abuse: for each referrer, how many accounts they invited (by invitee registration time in the optional window, organization timezone), how many were verified and credited, and how many invitees share a device, advertising id, persistent app id or IP address with the referrer or with each other, combined into a risk score. Use `suspiciousOnly` to show only referrers with at least one linked invitee. This report has no CSV export. Network (cockpit) users only. */
  rewardedUserReferrals: RewardedFraudReferralConnection;
  /** Rewarded anti-fraud report: per user and offer, how many originally approved conversions were later reversed (chargebacks), with the reversal rate and payouts. Only users with at least `minConversions` approved conversions (default 5) are included. Users are identified by the identifier configured in the fraud policy. `csvDownloadUrl` links to a CSV export of the full report. Network (cockpit) users only. */
  rewardedUserReversals: RewardedFraudReversalConnection;
  /** Rewarded anti-fraud report: per user and offer, how many conversions failed postback evaluation rules (by default ACTION_TO_ACTION_TIME, BANNED_USER and ENFORCE_EVENT_SETTINGS) in the time range, with total/failed counts, violation rate and payouts. Users are identified by the identifier configured in the fraud policy (see `fraudPolicyConfig`). Results are paginated; `totalCount` is the number of rows and `csvDownloadUrl` links to a CSV export of the full report (null if it could not be generated). Network (cockpit) users only. */
  rewardedUserRuleViolations: RewardedFraudRuleViolationConnection;
  /** Rewarded anti-fraud report: moments when several different users converted on the same offer event at practically the same time. Conversions are grouped into time buckets of `bucketSeconds` (default 10) and buckets with at least `minUsers` distinct users (default 3) are reported, with the users involved and payouts. Users are identified by the identifier configured in the fraud policy. `csvDownloadUrl` links to a CSV export of the full report. Network (cockpit) users only. */
  rewardedUserSynchronizedConversions: RewardedFraudSynchronizedConversionsConnection;
  /** Rewarded anti-fraud report: users whose conversions are concentrated in one hour of the day, which can indicate automated activity. Each row shows the peak hour, its share of the user's conversions and the hourly distribution. Only users with at least `minPostbacks` conversions (default 10) are included. Users are identified by the identifier configured in the fraud policy. `csvDownloadUrl` links to a CSV export of the full report. Network (cockpit) users only. */
  rewardedUserTimeOfDay: RewardedFraudTimeOfDayConnection;
  /** Rewarded anti-fraud report: clusters of two or more users who completed the same events of an offer at the same delays after their click (delays rounded to `roundingSeconds`, default 5), a sign of scripted or farmed completions. Each row shows the timing pattern, the users sharing it, conversion count and payouts. Users are identified by the identifier configured in the fraud policy. `csvDownloadUrl` links to a CSV export of the full report. Network (cockpit) users only. */
  rewardedUserTimingClusters: RewardedFraudTimingClusterConnection;
  /** Rewarded anti-fraud report: users with bursts of conversions, measured as the highest number of conversions within any window of `windowMinutes` (default 60). Only users whose peak reaches `minPeak` (default 10) are included. Users are identified by the identifier configured in the fraud policy. `csvDownloadUrl` links to a CSV export of the full report. Network (cockpit) users only. */
  rewardedUserVelocity: RewardedFraudVelocityConnection;
  /** Rewarded anti-fraud report: users whose conversions come from anonymized IP addresses (VPN, proxy, Tor or data center; in `strict` mode also corporate, education and public networks), with the number and rate of such conversions and the number of distinct anonymized IPs. Users are identified by the identifier configured in the fraud policy. `csvDownloadUrl` links to a CSV export of the full report. Network (cockpit) users only. */
  rewardedUserVpn: RewardedFraudVpnConnection;
  /**
   * Lists rewarded-app users (players) with filtering, sorting and pagination. `totalCount` is the number of users matching the filter.
   *
   * Filters: exact `id`, a list of `ids`, a case-insensitive `keyword` matched against email, nickname, first and last name, `countries` and `statuses`.
   *
   * Sorting defaults to user id descending. Sorting by a performance metric (clicks, conversions, weGet, theyGet, profit, theyGet points) ranks users by their stats; the time range is taken from the stats requested on the nested fields of the result, or from `sort.sortQuery` when given.
   *
   * Network (cockpit) users only.
   */
  rewardedUsers: RewardedUserConnection;
  /** Retrieves all the possible roles in the system */
  roles: Array<Role>;
  /**
   * Lists the saved raw report queries of a user, together with the organization-wide default saved queries (those not owned by any user).
   *
   * Network (cockpit) users only.
   */
  savedRawQueries: Array<SavedRawQueryType>;
  /**
   * Returns a single saved raw report query by id, including its query definition and any email schedule. Returns an error if no saved query with that id exists.
   *
   * Network (cockpit) users only.
   */
  savedRawQuery: SavedRawQueryType;
  /**
   * Lists scheduled changes (payout, budget, offer, offer access and notification changes planned for a future time), sorted by scheduled time, latest first. Changes that refer to offers which no longer exist are left out. Filter criteria are combined with AND.
   *
   * Network (cockpit) users only.
   */
  scheduledChanges: Array<ScheduledChange>;
  /**
   * Returns the device App Set ids that are registered as SDK breakpoint collectors, i.e. the test devices allowed to capture screens (breakpoints) through the SDK. Returns an empty list when none are registered.
   *
   * Network (cockpit) users only.
   */
  sdkBreakpointCollectorAppSetIds?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Lists SDK breakpoints: app screens (views) captured by the Swaarm SDK, each with a name, screenshot and optionally the app event it is mapped to. When several breakpoints share the same name, only the most recently captured one is returned. Results are ordered by name, descending.
   *
   * Network (cockpit) users only.
   */
  sdkBreakpoints: SdkBreakpointConnection;
  /**
   * Fraud report for SDK-tracked apps that flags conversions reported by an app version different from the current store version: for each group it returns the number of such conversions, the total, and their share (PERCENT), keeping groups whose share is outside the threshold range.
   *
   * Only approved conversions are considered. The query defines the time range, filters, level of detail (offer, offer+publisher or offer+publisher+sub id), time granularity, an optional extra group-by dimension, an optional minimum number of conversions per row (minApplicableConversions) and sorting. Only rows whose metric lies outside the [minThreshold, maxThreshold] range are returned; thresholds are ratios between 0 and 1. Network (cockpit) users only.
   */
  sdkFraudReport: FraudReportConnection;
  /**
   * Lists SDK events sent by apps using a test SDK token, ordered by device (client) time, oldest first. Use it to verify an SDK integration before going live. Filter criteria are combined with AND.
   *
   * Network (cockpit) users only.
   */
  sdkTestEvents: SdkEventConnection;
  /** Returns all the tracked sdk breakpoints */
  sdkTrackedBreakpoints: Array<SdkTrackedBreakpoint>;
  /** Search through all entities */
  search: Array<SearchEntity>;
  searchStats: SearchStatsConnection;
  /**
   * Returns the account's configuration settings as service/key/value entries. Sensitive values are masked.
   *
   * Network (cockpit) users get all settings. Partner portal publisher and advertiser users only get the account's default currency and time zone.
   */
  serviceConfigs: Array<ServiceConfig>;
  /** Returns the minimum client application version and API version that are compatible with this version of the API. Clients can use it to detect that they need to update. */
  serviceVersions: ServiceVersions;
  /**
   * Returns a single rewarded-app user (player) by id, so a network user can inspect that player's profile, offers and rewards. Returns an error if the user does not exist.
   *
   * Network (cockpit) users only.
   */
  singleRewardedUser: RewardedUser;
  singleRewardedUserByEmail: RewardedUser;
  singleRewardedUserByInternalId: RewardedUser;
  /**
   * Lists the ad networks registered for Apple SKAdNetwork attribution, with their network id and key pair. Results are paged with `pagination` (default page size 500).
   *
   * Network (cockpit) users only.
   */
  skadNetworks: Array<SkAdNetwork>;
  /**
   * Lists the offers of a smart link together with their weights: the system-calculated weight, the manual weight override (if set) and whether the offer is currently serveable through the link. Offers that only have a manual weight but are not in the link's current offer inventory are included as not serveable.
   *
   * Results are sorted by effective weight (manual weight when set, otherwise system weight), highest first. Returns an error if the smart link does not exist.
   *
   * Network (cockpit) users only.
   */
  smartLinkWeights: OfferWeightVariantConnection;
  /**
   * Returns a single smart link by id. Returns an error if no smart link with that id exists.
   *
   * Network (cockpit) users only.
   */
  smartRecommendationLink: SmartRecommendationLink;
  /**
   * Lists smart links, sorted by id in descending order (newest first).
   *
   * The filter can match a keyword (exact id or case-insensitive part of the name) and restrict the list to smart links that include a given offer, advertiser or publisher. Results are paged with `pagination` (default page size 500).
   *
   * Network (cockpit) users only.
   */
  smartRecommendationLinks: Array<SmartRecommendationLink>;
  /**
   * Returns the stickiness report for MMP-tracked apps: daily active users (DAU), trailing monthly active users (MAU) and stickiness (DAU / MAU) per day, optionally grouped by dimensions.
   *
   * The result includes the requested page of rows, the total row count and a time-limited CSV download link for the full report (relative to the API host, valid for about one hour).
   *
   * Network (cockpit) users only. If the report cannot be computed, the query fails with a generic error.
   */
  stickinessReport: StickinessReportConnection;
  /**
   * Returns a single store app (one app listing in a specific store, e.g. the iOS App Store or Google Play version of an app) by id. Fails with a not-found error if it does not exist.
   *
   * Network (cockpit) users only.
   */
  storeApp: StoreApp;
  /**
   * Lists store apps (per-store listings of apps). Filter criteria are combined with AND. Sorted by store app id descending unless another sort is given.
   *
   * Network (cockpit) users only.
   */
  storeApps: StoreAppConnection;
  /**
   * Returns a single support ticket with its messages. Returns an error if the ticket does not exist.
   *
   * Network (cockpit) users can read any ticket; partner portal users can only read their own tickets.
   */
  supportTicket: SupportTicket;
  /**
   * Lists support tickets matching the filter. Criteria in the filter are combined with AND; the time range is only applied when both `timeFrom` and `timeTo` are set. Without `sort`, no particular order is guaranteed. `totalCount` is the number of matching tickets.
   *
   * Partner portal users only see their own tickets. Network users with restricted manager access only see tickets of the partners they manage; other network users see all tickets.
   */
  supportTickets: SupportTicketConnection;
  /** Supported timezones */
  supportedTimezones: Array<Scalars['String']['output']>;
  /**
   * Returns a single targeted lead configuration (a rule that forwards matching leads to a lead forwarding endpoint, with priority, mode and optional targeting) by id. Returns an error if it does not exist.
   *
   * Network (cockpit) users only.
   */
  targetedLead: TargetedLead;
  /**
   * Lists all targeted lead configurations, newest (highest id) first, with offset pagination. `totalCount` is the total number of targeted leads.
   *
   * Network (cockpit) users only.
   */
  targetedLeads: TargetedLeadConnection;
  /** Dry-runs a jq extraction expression against sample attribution partner data without saving anything. Returns the numeric value that would be written (null when the expression yields nothing usable), the first raw jq output, any compile or runtime error, and the JSON input the expression was evaluated against. Network (cockpit) users only. */
  testEventValueExtractionRule: EventValueExtractionTestResult;
  /**
   * Returns a single tracking rule customization by its id: an override of a click, impression, lead or postback rule (enabled state and parameters) for specific advertisers, offers or publishers. Returns an error if it does not exist.
   *
   * Network (cockpit) users only.
   */
  trackingCustomizationRule: RuleCustomization;
  /**
   * Returns the list of macros (for example `{publisher.id}`, `{device.ids.gaid}`, `{user.ip}`) that can be used in offer tracking URLs and are replaced with click values when a click is redirected.
   *
   * Network (cockpit) users only.
   */
  trackingUrlMacros: Array<Scalars['String']['output']>;
  /**
   * Returns a single traffic tag (a label automatically applied to incoming traffic that matches its targeting rules) by id. Returns an error if no traffic tag with that id exists.
   *
   * Network (cockpit) users only.
   */
  trafficTag: TrafficTag;
  /**
   * Lists traffic tags, newest (highest id) first, with offset pagination. The optional keyword filter does a case-insensitive match on the tag name, its description and its targeting rule. `totalCount` is the number of matching tags before pagination.
   *
   * Network (cockpit) users only.
   */
  trafficTags: TrafficTagConnection;
  /**
   * Returns a single traffic targeting entry (a named targeting condition with an associated traffic rule). Returns an error if it does not exist.
   *
   * Network (cockpit) users only.
   */
  trafficTarget: TrafficTargeting;
  /**
   * Lists traffic targeting entries, newest first. The keyword filter matches (case-insensitive) the name, the description or the targeting rule text. `totalCount` is the number of matching entries.
   *
   * Network (cockpit) users only.
   */
  trafficTargets: TrafficTargetingConnection;
  /**
   * Returns a single platform user by id. Returns an error if no user with that id exists.
   *
   * Network (cockpit) users only.
   */
  user: User;
  /**
   * Lists the network (cockpit) users of the account, newest first. Filter criteria are combined with AND. Users with a restricted manager role only get their own user.
   *
   * Network (cockpit) users only.
   */
  users: Array<User>;
};


export type QueryAbnormalCrReportArgs = {
  first: Scalars['Int']['input'];
  minClicks?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  query: FraudReportQuery;
};


export type QueryAbnormalDeviceDistributionReportArgs = {
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  query: FraudReportQuery;
};


export type QueryActivityReportArgs = {
  activityQuery: ActivityQuery;
};


export type QueryAdKeywordCategoriesArgs = {
  prefix?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdKeywordImportSpecArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdKeywordImportSpecsArgs = {
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryAdKeywordPreviewArgs = {
  filters?: InputMaybe<Array<AdKeywordImportSpecFilterInput>>;
};


export type QueryAdvancedTargetingValueBundleArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdvancedTargetingValueBundlesArgs = {
  filter?: InputMaybe<AdvancedTargetingValueBundleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdvertiserArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdvertiserBatchOperationArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdvertiserBatchOperationsArgs = {
  filter?: InputMaybe<AdvertiserBatchOperationReadFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdvertiserBillingProfileArgs = {
  advertiserId: Scalars['String']['input'];
};


export type QueryAdvertiserConfigArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdvertiserConfigApiResponseArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdvertiserConfigSyncStatusArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdvertiserConfigsArgs = {
  filter?: InputMaybe<AdvertiserConfigFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<AdvertiserConfigSort>;
};


export type QueryAdvertiserContactArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdvertiserContactsArgs = {
  filter?: InputMaybe<AdvertiserContactFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<AdvertiserContactSort>;
};


export type QueryAdvertiserCouponArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdvertiserCouponsArgs = {
  filter?: InputMaybe<AdvertiserCouponFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdvertiserDetailsDownloadArgs = {
  fields: Array<ExportAdvertiserField>;
  filter?: InputMaybe<AdvertiserFilter>;
  sort?: InputMaybe<AdvertiserSort>;
};


export type QueryAdvertiserInvoiceArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdvertiserInvoiceCandidatesArgs = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  end: Scalars['LocalDate']['input'];
  start: Scalars['LocalDate']['input'];
};


export type QueryAdvertiserInvoiceEmailDraftArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdvertiserInvoiceLinesArgs = {
  advertiserId: Scalars['String']['input'];
  end: Scalars['LocalDate']['input'];
  grouping?: InputMaybe<AdvertiserInvoiceLineGrouping>;
  start: Scalars['LocalDate']['input'];
};


export type QueryAdvertiserInvoiceSummaryArgs = {
  filter?: InputMaybe<AdvertiserInvoiceFilter>;
};


export type QueryAdvertiserInvoicesArgs = {
  filter?: InputMaybe<AdvertiserInvoiceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdvertiserRawReportArgs = {
  advertiserId: Scalars['String']['input'];
  rawQuery: PartnerRawQuery;
};


export type QueryAdvertiserRebateArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdvertiserRebatesArgs = {
  filter?: InputMaybe<AdvertiserRebateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdvertiserReportImportSpecArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvertiserReportImportSpecsArgs = {
  filter?: InputMaybe<AdvertiserReportImportSpecFilter>;
  first?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryAdvertiserReportImportTaskArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdvertiserReportImportTasksArgs = {
  filter: AdvertiserReportImportTaskFilter;
  first?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryAdvertiserTagsArgs = {
  prefix?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvertisersArgs = {
  filter?: InputMaybe<AdvertiserFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<AdvertiserSort>;
};


export type QueryAdvertisersV2Args = {
  filter?: InputMaybe<AdvertiserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AdvertiserSort>;
};


export type QueryAllFormSubmissionsArgs = {
  formId: Scalars['String']['input'];
  pagination?: InputMaybe<Pagination>;
};


export type QueryAppArgs = {
  id: Scalars['String']['input'];
};


export type QueryAppDetailsArgs = {
  appStoreId: Scalars['String']['input'];
  store: AppStoreType;
};


export type QueryAppEventTypeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAppEventTypesArgs = {
  filter?: AppEventTypeFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAppsArgs = {
  filter?: AppFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AppSort>;
};


export type QueryAppsflyerBlockingReportArgs = {
  end: Scalars['LocalDateTime']['input'];
  fields: Array<AppsflyerBlockingReportField>;
  filters?: InputMaybe<Array<AppsflyerBlockingReportFilter>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AppsflyerBlockingReportSort>;
  start: Scalars['LocalDateTime']['input'];
};


export type QueryAppsflyerClickSigningReportArgs = {
  filter?: InputMaybe<AppsflyerClickSigningFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryAppsflyerMediaSourceMappingsArgs = {
  filter?: InputMaybe<AppsflyerMediaSourceMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAppsflyerNetworkCostUploadTokenArgs = {
  id: Scalars['String']['input'];
};


export type QueryAppsflyerPartnerByDateReportArgs = {
  end: Scalars['LocalDateTime']['input'];
  fields: Array<AppsflyerPartnerByDateField>;
  filters?: InputMaybe<Array<AppsflyerPartnerByDateFilter>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AppsflyerPartnersByDateSort>;
  start: Scalars['LocalDateTime']['input'];
};


export type QueryAttributionExpirationArgs = {
  key: AttributionExpirationKey;
};


export type QueryAttributionExpirationsArgs = {
  filter?: InputMaybe<AttributionExpirationFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryAudienceArgs = {
  id: Scalars['String']['input'];
};


export type QueryAudiencesArgs = {
  filter?: InputMaybe<AudiencesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAuditsArgs = {
  filter?: InputMaybe<AuditFilter>;
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryAuthLogsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAutoApprovalConfigsArgs = {
  filter?: InputMaybe<AutoApprovalConfigFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryAutomationRuleArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAutomationRuleActionsArgs = {
  trigger: AutomationRuleTrigger;
};


export type QueryAutomationRuleExecutionLogArgs = {
  id: Scalars['String']['input'];
};


export type QueryAutomationRuleFilterOperationValueTypeArgs = {
  filterType: AutomationRuleFilterType;
};


export type QueryAutomationRuleFiltersArgs = {
  trigger: AutomationRuleTrigger;
};


export type QueryAutomationRulesArgs = {
  filter?: InputMaybe<AutomationRuleReadFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryBannedUsersArgs = {
  filter?: InputMaybe<BannedUsersFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBlacklistedSubIdsArgs = {
  filter?: InputMaybe<BlacklistedSubIdsFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryBlacklistedSubIdsV2Args = {
  filter?: InputMaybe<BlacklistedSubIdsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBotDetectionReportArgs = {
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  query: FraudReportQuery;
  timeBucketSeconds?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCalculatePublisherPaymentArgs = {
  end: Scalars['LocalDateTime']['input'];
  publisherId?: InputMaybe<Scalars['String']['input']>;
  rewardedUserId?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type QueryClickBudgetRecommendationsArgs = {
  clicks?: InputMaybe<Scalars['Int']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClickHouseReportArgs = {
  metrics: Array<RawStatsMetric>;
  noCache?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryClickSpammingReportArgs = {
  ctitThrSeconds: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  query: FraudReportQuery;
};


export type QueryClickhouseQueryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sql: Scalars['String']['input'];
};


export type QueryCohortReportArgs = {
  cohortQuery: CohortQuery;
};


export type QueryControlledAccessObjectArgs = {
  id: Scalars['String']['input'];
};


export type QueryControlledAccessObjectsArgs = {
  filter?: InputMaybe<ControlledAccessObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConversionArgs = {
  filter?: InputMaybe<ConversionFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ConversionSort>;
};


export type QueryConversionReportArgs = {
  appIds?: InputMaybe<Array<Scalars['String']['input']>>;
  csvFields?: InputMaybe<Array<ConversionReportField>>;
  end: Scalars['LocalDateTime']['input'];
  fields?: InputMaybe<Array<ConversionReportField>>;
  filters?: InputMaybe<Array<ConversionReportFilter>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ConversionReportSort>;
  start: Scalars['LocalDateTime']['input'];
  storeAppIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDataReportArgs = {
  csvFields?: InputMaybe<Array<Scalars['String']['input']>>;
  end?: InputMaybe<Scalars['LocalDateTime']['input']>;
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<Array<DataReportFilter>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DataReportSort>;
  start?: InputMaybe<Scalars['LocalDateTime']['input']>;
  type: Scalars['String']['input'];
};


export type QueryDataReportFieldsArgs = {
  type: Scalars['String']['input'];
};


export type QueryDefinedTrackingCustomizationRulesArgs = {
  filter?: InputMaybe<RuleCustomizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDeviceMismatchReportArgs = {
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  query: FraudReportQuery;
};


export type QueryDomainCustomizationsArgs = {
  filter: DomainCustomizationFilter;
  pagination?: InputMaybe<Pagination>;
};


export type QueryEvaluatedPostbacksArgs = {
  filter: EvaluatedPostbackFilter;
  pagination?: InputMaybe<Pagination>;
};


export type QueryEventLogFilesArgs = {
  filter: EventLogFileFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEventTypeArgs = {
  id: Scalars['String']['input'];
};


export type QueryEventTypesArgs = {
  filter?: InputMaybe<EventTypeFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<EventTypeSort>;
};


export type QueryEventUsagesArgs = {
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryEventValueExtractionRuleArgs = {
  id: Scalars['String']['input'];
};


export type QueryEventValueExtractionRulesArgs = {
  filter?: InputMaybe<EventValueExtractionRuleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFeedApiConfigurationArgs = {
  publisherId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFeedApiConfigurationsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryFillerArgs = {
  id: Scalars['String']['input'];
};


export type QueryFillersArgs = {
  filter?: InputMaybe<FillerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFormArgs = {
  id: Scalars['String']['input'];
};


export type QueryFormSubmissionsArgs = {
  formId: Scalars['String']['input'];
  pagination?: InputMaybe<Pagination>;
};


export type QueryFormsArgs = {
  pagination?: InputMaybe<Pagination>;
  tag?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFunnelReportArgs = {
  funnelQuery: FunnelQuery;
};


export type QueryGeneratePayoutsEditCsvArgs = {
  filter: PayoutEditFilter;
};


export type QueryGeoMismatchReportArgs = {
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  query: FraudReportQuery;
};


export type QueryGroupedSearchArgs = {
  keyword: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryImportedOfferArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryImportedOffersArgs = {
  filter?: InputMaybe<ImportedOfferFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ImportedOfferSort>;
};


export type QueryImportedOffersV2Args = {
  filter?: InputMaybe<ImportedOfferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ImportedOfferSort>;
};


export type QueryIsDomainConfiguredCorrectlyArgs = {
  domain: Scalars['String']['input'];
};


export type QueryIsSslConfiguredCorrectlyArgs = {
  domain: Scalars['String']['input'];
};


export type QueryKpiArgs = {
  id: Scalars['String']['input'];
};


export type QueryKpisArgs = {
  filter?: InputMaybe<KpiReadFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<KpiSort>;
};


export type QueryLeadForwardingEndpointArgs = {
  id: Scalars['String']['input'];
};


export type QueryLeadForwardingEndpointsArgs = {
  filter?: InputMaybe<LeadForwardingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMarketplaceAdvertiserPartnersArgs = {
  filter?: InputMaybe<AdvertiserNetworkRelationshipFilter>;
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryMarketplaceOrganizationArgs = {
  id: Scalars['String']['input'];
};


export type QueryMarketplaceOrganizationsArgs = {
  filter?: InputMaybe<MarketplaceOrganizationFilter>;
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryMarketplacePostbackLinkArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryMemoArgs = {
  id: Scalars['String']['input'];
};


export type QueryMemosArgs = {
  filter?: InputMaybe<MemoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MemoSort>;
};


export type QueryMigrationStatesArgs = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryModificationBatchesArgs = {
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryNetworkPartnersArgs = {
  filter?: InputMaybe<AdvertiserNetworkRelationshipFilter>;
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryNotificationsArgs = {
  filter?: InputMaybe<NotificationFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<NotificationSort>;
};


export type QueryOfferArgs = {
  id: Scalars['String']['input'];
};


export type QueryOfferBatchOperationArgs = {
  id: Scalars['String']['input'];
};


export type QueryOfferBatchOperationsArgs = {
  filter?: InputMaybe<OfferBatchOperationReadFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOfferDetailsDownloadArgs = {
  fields: Array<ExportOfferField>;
  filter?: InputMaybe<OfferFilter>;
  sort?: InputMaybe<OfferSort>;
};


export type QueryOfferTagsArgs = {
  prefix?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOffersArgs = {
  filter?: InputMaybe<OfferFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<OfferSort>;
};


export type QueryOffersV2Args = {
  filter?: InputMaybe<OfferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OfferSort>;
};


export type QueryOrganizationIntegrationRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationIntegrationRequestsArgs = {
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryOrganizationInvoicesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationRequestsArgs = {
  filter?: InputMaybe<OrganizationRequestFilter>;
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryPartnerAdvertiserArgs = {
  id: Scalars['String']['input'];
};


export type QueryPartnerAdvertiserOfferArgs = {
  advertiserId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryPartnerConversionReportArgs = {
  csvFields?: InputMaybe<Array<PartnerConversionField>>;
  end: Scalars['LocalDateTime']['input'];
  fields?: InputMaybe<Array<PartnerConversionField>>;
  filters?: InputMaybe<Array<PartnerConversionReportFilter>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  publisherId: Scalars['String']['input'];
  sort?: InputMaybe<PartnerConversionReportSort>;
  start: Scalars['LocalDateTime']['input'];
};


export type QueryPartnerPublisherArgs = {
  id: Scalars['String']['input'];
};


export type QueryPartnerPublisherOfferArgs = {
  id: Scalars['String']['input'];
  publisherId: Scalars['String']['input'];
};


export type QueryPartnerPublisherOfferTagsArgs = {
  prefix?: InputMaybe<Scalars['String']['input']>;
  publisherId: Scalars['String']['input'];
};


export type QueryPartnerRawReportArgs = {
  publisherId: Scalars['String']['input'];
  rawQuery: PartnerRawQuery;
};


export type QueryPayoutConversionPolicyArgs = {
  advertiserId: Scalars['String']['input'];
};


export type QueryPayoutMarginsArgs = {
  filter?: InputMaybe<PayoutMarginFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryPayoutV2Args = {
  key: PayoutKey;
};


export type QueryPossibleTrackingCustomizationRulesArgs = {
  namespaces: Array<RuleNamespace>;
};


export type QueryPostbackLogsArgs = {
  end: Scalars['LocalDateTime']['input'];
  filters?: InputMaybe<Array<PostbackLogFilter>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PostbackLogSort>;
  start: Scalars['LocalDateTime']['input'];
};


export type QueryPostbackModificationArgs = {
  id: Scalars['String']['input'];
};


export type QueryPostbackModificationsArgs = {
  pagination?: InputMaybe<Pagination>;
  status?: InputMaybe<PostbackModificationStatus>;
};


export type QueryPreviewAdvertiserBatchOperationArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<AdvertiserBatchOperationInput>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPreviewAdvertiserConfigArgs = {
  input: AdvertiserConfigInput;
};


export type QueryPreviewOfferBatchOperationArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<OfferBatchOperationInput>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPreviewPublisherBatchOperationArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<PublisherBatchOperationInput>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryProxyDetectionReportArgs = {
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  query: FraudReportQuery;
};


export type QueryPublisherArgs = {
  id: Scalars['String']['input'];
};


export type QueryPublisherBatchOperationArgs = {
  id: Scalars['String']['input'];
};


export type QueryPublisherBatchOperationsArgs = {
  filter?: InputMaybe<PublisherBatchOperationReadFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPublisherContactArgs = {
  id: Scalars['String']['input'];
};


export type QueryPublisherContactsArgs = {
  filter?: InputMaybe<PublisherContactFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<PublisherContactSort>;
};


export type QueryPublisherDetailsDownloadArgs = {
  fields: Array<ExportPublisherField>;
  filter?: InputMaybe<PublisherFilter>;
  sort?: InputMaybe<PublisherSort>;
};


export type QueryPublisherEvaluatedPostbacksArgs = {
  filter: PublisherEvaluatedPostbackFilter;
  pagination?: InputMaybe<Pagination>;
  publisherId: Scalars['String']['input'];
};


export type QueryPublisherGroupMemberArgs = {
  id: PublisherGroupMemberId;
};


export type QueryPublisherMarginArgs = {
  id: Scalars['String']['input'];
};


export type QueryPublisherMarginsArgs = {
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<PublisherMarginSort>;
};


export type QueryPublisherOffersArgs = {
  filter?: InputMaybe<PublisherOfferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPublisherPaymentArgs = {
  id: Scalars['String']['input'];
};


export type QueryPublisherPaymentsArgs = {
  filter?: InputMaybe<PublisherPaymentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPublisherReferralPlanArgs = {
  id: Scalars['String']['input'];
};


export type QueryPublisherReferralPlansArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPublisherReferralReportArgs = {
  filter: PublisherReferralReportFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPublisherTagsArgs = {
  prefix?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublishersArgs = {
  filter?: InputMaybe<PublisherFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<PublisherSort>;
};


export type QueryPublishersV2Args = {
  filter?: InputMaybe<PublisherFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PublisherSort>;
};


export type QueryPushNotificationArgs = {
  id: Scalars['String']['input'];
};


export type QueryPushNotificationsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRawReportArgs = {
  rawQuery: RawQueryInput;
};


export type QueryRealtimeIntegrationsArgs = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReportArgs = {
  queries: Array<ReportQuery>;
};


export type QueryRetargetingFileArgs = {
  id: Scalars['String']['input'];
};


export type QueryRetargetingFilesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardOsTransactionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardedCohortsArgs = {
  input: RewardedDashboardInput;
};


export type QueryRewardedDashboardArgs = {
  input: RewardedDashboardInput;
};


export type QueryRewardedEmailExistsArgs = {
  email: Scalars['String']['input'];
};


export type QueryRewardedOfferArgs = {
  id: Scalars['String']['input'];
};


export type QueryRewardedOfferFunnelArgs = {
  eventTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  input: RewardedDashboardInput;
  offerId: Scalars['ID']['input'];
};


export type QueryRewardedSupportTicketArgs = {
  id: Scalars['String']['input'];
};


export type QueryRewardedSupportTicketsArgs = {
  filter?: InputMaybe<RewardedUserSupportTicketFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardedUserMultiAccountingArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RewardedFraudMultiAccountInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardedUserPaymentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryRewardedUserPaymentsByInternalIdArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  internalId: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardedUserPayoutCherryPickingArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RewardedFraudPayoutCherryPickingInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardedUserReferralsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RewardedFraudReferralInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardedUserReversalsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RewardedFraudReversalInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardedUserRuleViolationsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RewardedFraudRuleViolationInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardedUserSynchronizedConversionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RewardedFraudSynchronizedConversionsInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardedUserTimeOfDayArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RewardedFraudTimeOfDayInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardedUserTimingClustersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RewardedFraudTimingClusterInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardedUserVelocityArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RewardedFraudVelocityInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardedUserVpnArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RewardedFraudVpnInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardedUsersArgs = {
  filter?: InputMaybe<RewardedUsersFilter>;
  pagination: Pagination;
  sort?: InputMaybe<RewardedUsersSort>;
};


export type QuerySavedRawQueriesArgs = {
  user: Scalars['String']['input'];
};


export type QuerySavedRawQueryArgs = {
  id: Scalars['String']['input'];
};


export type QueryScheduledChangesArgs = {
  filter?: InputMaybe<ScheduledChangeFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QuerySdkBreakpointsArgs = {
  filter?: InputMaybe<SdkBreakpointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySdkFraudReportArgs = {
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  query: FraudReportQuery;
  storeVersion: Scalars['String']['input'];
};


export type QuerySdkTestEventsArgs = {
  filter?: InputMaybe<SdkTestEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySdkTrackedBreakpointsArgs = {
  appId: Scalars['String']['input'];
};


export type QuerySearchArgs = {
  keyword: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchStatsArgs = {
  end: Scalars['LocalDateTime']['input'];
  start: Scalars['LocalDateTime']['input'];
};


export type QuerySingleRewardedUserArgs = {
  id: Scalars['String']['input'];
};


export type QuerySingleRewardedUserByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QuerySingleRewardedUserByInternalIdArgs = {
  internalId: Scalars['String']['input'];
};


export type QuerySkadNetworksArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QuerySmartLinkWeightsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySmartRecommendationLinkArgs = {
  id: Scalars['String']['input'];
};


export type QuerySmartRecommendationLinksArgs = {
  filter?: InputMaybe<SmartRecommendationLinkFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryStickinessReportArgs = {
  stickinessQuery: StickinessQuery;
};


export type QueryStoreAppArgs = {
  id: Scalars['String']['input'];
};


export type QueryStoreAppsArgs = {
  filter?: StoreAppFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StoreAppSort>;
};


export type QuerySupportTicketArgs = {
  id: Scalars['String']['input'];
};


export type QuerySupportTicketsArgs = {
  filter?: InputMaybe<SupportTicketFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SupportTicketSort>;
};


export type QuerySupportedTimezonesArgs = {
  prefix?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTargetedLeadArgs = {
  id: Scalars['String']['input'];
};


export type QueryTargetedLeadsArgs = {
  first?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryTestEventValueExtractionRuleArgs = {
  expression: Scalars['String']['input'];
  sample: EventValueExtractionSampleInput;
};


export type QueryTrackingCustomizationRuleArgs = {
  id: Scalars['String']['input'];
};


export type QueryTrafficTagArgs = {
  id: Scalars['String']['input'];
};


export type QueryTrafficTagsArgs = {
  filter?: InputMaybe<TrafficTagFilter>;
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryTrafficTargetArgs = {
  id: Scalars['String']['input'];
};


export type QueryTrafficTargetsArgs = {
  filter?: InputMaybe<TrafficTargetingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  pagination?: InputMaybe<Pagination>;
};

export type RawDateRangeInput = {
  end: Scalars['LocalDateTime']['input'];
  granularity: RawGranularity;
  start: Scalars['LocalDateTime']['input'];
};

export type RawDateRangeType = {
  end: Scalars['LocalDateTime']['output'];
  granularity: RawGranularity;
  start: Scalars['LocalDateTime']['output'];
};

export type RawFilterClauseInput = {
  dimension: RawStatsDimension;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type RawFilterClauseType = {
  dimension: RawStatsDimension;
  value: Array<Maybe<Scalars['String']['output']>>;
};

export enum RawGranularity {
  All = 'ALL',
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type RawMetricFilterClauseInput = {
  metric: RawStatsMetric;
  operator?: InputMaybe<RawMetricFilterOperator>;
  values: Array<Scalars['Float']['input']>;
};

export type RawMetricFilterClauseType = {
  metric: RawStatsMetric;
  operator?: Maybe<RawMetricFilterOperator>;
  values: Array<Scalars['Float']['output']>;
};

export enum RawMetricFilterOperator {
  Between = 'BETWEEN',
  Equals = 'EQUALS',
  Gte = 'GTE',
  Lte = 'LTE'
}

export type RawQueryInput = {
  dimensions: Array<RawStatsDimension>;
  filters?: InputMaybe<Array<RawFilterClauseInput>>;
  globalSearch?: InputMaybe<Scalars['String']['input']>;
  metricFilters?: InputMaybe<Array<RawMetricFilterClauseInput>>;
  metrics: Array<RawStatsMetric>;
  pagination: RawQueryPaginationInput;
  sort: RawQuerySortInput;
  timeRange: RawDateRangeInput;
};

export type RawQueryPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RawQueryPaginationType = {
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
};

export type RawQuerySortInput = {
  dimension?: InputMaybe<RawStatsDimension>;
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<RawStatsMetric>;
};

export type RawQuerySortType = {
  dimension?: Maybe<RawStatsDimension>;
  direction?: Maybe<SortOrder>;
  field?: Maybe<RawStatsMetric>;
};

export type RawQueryType = {
  dimensions: Array<RawStatsDimension>;
  filters?: Maybe<Array<RawFilterClauseType>>;
  metricFilters?: Maybe<Array<RawMetricFilterClauseType>>;
  metrics: Array<RawStatsMetric>;
  pagination: RawQueryPaginationType;
  sort: RawQuerySortType;
  timeRange: RawDateRangeType;
};

export type RawReport = {
  /** In order to download this report you have to call /download/raw-reports/{downloadToken} */
  downloadToken: Scalars['String']['output'];
  results: Array<RawRow>;
  totals?: Maybe<Array<RawStatsMetricResult>>;
};

export type RawRow = {
  dimensions: Array<RawStatsDimensionResult>;
  metrics: Array<RawStatsMetricResult>;
};

export enum RawStatsDimension {
  AdvertiserAccountManagerId = 'ADVERTISER_ACCOUNT_MANAGER_ID',
  AdvertiserAccountManagerName = 'ADVERTISER_ACCOUNT_MANAGER_NAME',
  AdvertiserId = 'ADVERTISER_ID',
  AdvertiserName = 'ADVERTISER_NAME',
  AdvertiserSalesManagerId = 'ADVERTISER_SALES_MANAGER_ID',
  AdvertiserSalesManagerName = 'ADVERTISER_SALES_MANAGER_NAME',
  AdvertiserTags = 'ADVERTISER_TAGS',
  AppsflyerAgency = 'APPSFLYER_AGENCY',
  AppEventTypeId = 'APP_EVENT_TYPE_ID',
  AppEventTypeName = 'APP_EVENT_TYPE_NAME',
  AppId = 'APP_ID',
  AppName = 'APP_NAME',
  ClickDate = 'CLICK_DATE',
  ClickDateHour = 'CLICK_DATE_HOUR',
  ClickDateMonth = 'CLICK_DATE_MONTH',
  ClickDateWeek = 'CLICK_DATE_WEEK',
  ClickDateYear = 'CLICK_DATE_YEAR',
  Date = 'DATE',
  DateDay = 'DATE_DAY',
  DateHour = 'DATE_HOUR',
  DateMonth = 'DATE_MONTH',
  DateYear = 'DATE_YEAR',
  EvaluationFailedClickRules = 'EVALUATION_FAILED_CLICK_RULES',
  EvaluationFailedClickSubrules = 'EVALUATION_FAILED_CLICK_SUBRULES',
  EvaluationFailedDecisionRules = 'EVALUATION_FAILED_DECISION_RULES',
  EvaluationFailedDecisionSubrules = 'EVALUATION_FAILED_DECISION_SUBRULES',
  EvaluationFailedImpressionsRules = 'EVALUATION_FAILED_IMPRESSIONS_RULES',
  EvaluationFailedImpressionsSubrules = 'EVALUATION_FAILED_IMPRESSIONS_SUBRULES',
  EvaluationFailedStatusRules = 'EVALUATION_FAILED_STATUS_RULES',
  EvaluationFailedStatusSubrules = 'EVALUATION_FAILED_STATUS_SUBRULES',
  EventTypeAdvertiserId = 'EVENT_TYPE_ADVERTISER_ID',
  EventTypeId = 'EVENT_TYPE_ID',
  EventTypeName = 'EVENT_TYPE_NAME',
  OfferAdgroupId = 'OFFER_ADGROUP_ID',
  OfferAdgroupName = 'OFFER_ADGROUP_NAME',
  OfferAdvertiserOfferId = 'OFFER_ADVERTISER_OFFER_ID',
  OfferAdId = 'OFFER_AD_ID',
  OfferAdName = 'OFFER_AD_NAME',
  OfferAppId = 'OFFER_APP_ID',
  OfferCampaignId = 'OFFER_CAMPAIGN_ID',
  OfferCampaignName = 'OFFER_CAMPAIGN_NAME',
  OfferId = 'OFFER_ID',
  OfferImportedOfferId = 'OFFER_IMPORTED_OFFER_ID',
  OfferLandingPageId = 'OFFER_LANDING_PAGE_ID',
  OfferLandingPageName = 'OFFER_LANDING_PAGE_NAME',
  OfferMigrationId = 'OFFER_MIGRATION_ID',
  OfferName = 'OFFER_NAME',
  OfferStatus = 'OFFER_STATUS',
  OfferTags = 'OFFER_TAGS',
  OfferTargetedPayoutId = 'OFFER_TARGETED_PAYOUT_ID',
  OfferTargetedPayoutName = 'OFFER_TARGETED_PAYOUT_NAME',
  OfferTrackerName = 'OFFER_TRACKER_NAME',
  PostbackDecision = 'POSTBACK_DECISION',
  PostbackStatus = 'POSTBACK_STATUS',
  PublisherApp = 'PUBLISHER_APP',
  PublisherAppId = 'PUBLISHER_APP_ID',
  PublisherCreative = 'PUBLISHER_CREATIVE',
  PublisherCreativeId = 'PUBLISHER_CREATIVE_ID',
  PublisherGroup = 'PUBLISHER_GROUP',
  PublisherId = 'PUBLISHER_ID',
  PublisherManagerId = 'PUBLISHER_MANAGER_ID',
  PublisherManagerName = 'PUBLISHER_MANAGER_NAME',
  PublisherMigrationId = 'PUBLISHER_MIGRATION_ID',
  PublisherName = 'PUBLISHER_NAME',
  PublisherOriginalSubId = 'PUBLISHER_ORIGINAL_SUB_ID',
  PublisherPlacement = 'PUBLISHER_PLACEMENT',
  PublisherReferrer = 'PUBLISHER_REFERRER',
  PublisherSalesManagerId = 'PUBLISHER_SALES_MANAGER_ID',
  PublisherSalesManagerName = 'PUBLISHER_SALES_MANAGER_NAME',
  PublisherSite = 'PUBLISHER_SITE',
  PublisherSubId = 'PUBLISHER_SUB_ID',
  PublisherSubSubId = 'PUBLISHER_SUB_SUB_ID',
  PublisherTags = 'PUBLISHER_TAGS',
  PublisherTerm = 'PUBLISHER_TERM',
  PublisherUnique1 = 'PUBLISHER_UNIQUE1',
  PublisherUnique2 = 'PUBLISHER_UNIQUE2',
  PublisherUnique3 = 'PUBLISHER_UNIQUE3',
  RecommendationId = 'RECOMMENDATION_ID',
  RejectionReason = 'REJECTION_REASON',
  RejectionReasonValue = 'REJECTION_REASON_VALUE',
  RewardedUserId = 'REWARDED_USER_ID',
  Store = 'STORE',
  StoreAppId = 'STORE_APP_ID',
  StoreAppName = 'STORE_APP_NAME',
  TrafficTags = 'TRAFFIC_TAGS',
  UserConnectionCarrierCode = 'USER_CONNECTION_CARRIER_CODE',
  UserConnectionIsp = 'USER_CONNECTION_ISP',
  UserConnectionMcc = 'USER_CONNECTION_MCC',
  UserConnectionMnc = 'USER_CONNECTION_MNC',
  UserConnectionType = 'USER_CONNECTION_TYPE',
  UserDeviceBrowser = 'USER_DEVICE_BROWSER',
  UserDeviceLanguage = 'USER_DEVICE_LANGUAGE',
  UserDeviceMake = 'USER_DEVICE_MAKE',
  UserDeviceModel = 'USER_DEVICE_MODEL',
  UserDeviceOs = 'USER_DEVICE_OS',
  UserDeviceOsVersion = 'USER_DEVICE_OS_VERSION',
  UserDevicePreferredLanguage = 'USER_DEVICE_PREFERRED_LANGUAGE',
  UserDeviceType = 'USER_DEVICE_TYPE',
  UserDeviceUa = 'USER_DEVICE_UA',
  UserGeoCity = 'USER_GEO_CITY',
  UserGeoCountry = 'USER_GEO_COUNTRY',
  UserGeoRegion = 'USER_GEO_REGION'
}

export type RawStatsDimensionResult = {
  name: RawStatsDimension;
  value?: Maybe<Scalars['String']['output']>;
};

export enum RawStatsMetric {
  ActiveUsers = 'ACTIVE_USERS',
  ActConversions = 'ACT_CONVERSIONS',
  ActPaidConversions = 'ACT_PAID_CONVERSIONS',
  ActTheyGet = 'ACT_THEY_GET',
  ActWeGet = 'ACT_WE_GET',
  AdClicks = 'AD_CLICKS',
  AppAverageCustomNumericValue = 'APP_AVERAGE_CUSTOM_NUMERIC_VALUE',
  AppCustomNumericValue = 'APP_CUSTOM_NUMERIC_VALUE',
  /**
   * RETENTION_1D
   * RETENTION_3D
   * RETENTION_7D
   * RETENTION_30D
   */
  Arpu = 'ARPU',
  Clicks = 'CLICKS',
  ConversionRate = 'CONVERSION_RATE',
  ConversionRateUniqueClicks = 'CONVERSION_RATE_UNIQUE_CLICKS',
  CostRebate = 'COST_REBATE',
  Coverage = 'COVERAGE',
  Ctr = 'CTR',
  DailyClickCap = 'DAILY_CLICK_CAP',
  DailyConversionCap = 'DAILY_CONVERSION_CAP',
  DailyPublisherClickCap = 'DAILY_PUBLISHER_CLICK_CAP',
  DailyPublisherConversionCap = 'DAILY_PUBLISHER_CONVERSION_CAP',
  DailyPublisherRevenueCap = 'DAILY_PUBLISHER_REVENUE_CAP',
  DailyRevenueCap = 'DAILY_REVENUE_CAP',
  DiscardedClicks = 'DISCARDED_CLICKS',
  DiscardedImpressions = 'DISCARDED_IMPRESSIONS',
  EarningsPerClick = 'EARNINGS_PER_CLICK',
  EarningsPerUniqueClick = 'EARNINGS_PER_UNIQUE_CLICK',
  Ecpa = 'ECPA',
  Events = 'EVENTS',
  EventRate = 'EVENT_RATE',
  FailedOutgoingLeads = 'FAILED_OUTGOING_LEADS',
  Impressions = 'IMPRESSIONS',
  IncomingLeads = 'INCOMING_LEADS',
  LeadForwardingFailureRate = 'LEAD_FORWARDING_FAILURE_RATE',
  LeadForwardingRate = 'LEAD_FORWARDING_RATE',
  LeadForwardingSuccessRate = 'LEAD_FORWARDING_SUCCESS_RATE',
  MonetizedSearches = 'MONETIZED_SEARCHES',
  MonthlyClickCap = 'MONTHLY_CLICK_CAP',
  MonthlyConversionCap = 'MONTHLY_CONVERSION_CAP',
  MonthlyRevenueCap = 'MONTHLY_REVENUE_CAP',
  NewUsers = 'NEW_USERS',
  OutgoingLeads = 'OUTGOING_LEADS',
  PostbackTheyGet = 'POSTBACK_THEY_GET',
  PostbackWeGet = 'POSTBACK_WE_GET',
  Profit = 'PROFIT',
  ProfitRebate = 'PROFIT_REBATE',
  PubConversions = 'PUB_CONVERSIONS',
  PubConversionRate = 'PUB_CONVERSION_RATE',
  PubEarningsPerUniqueClick = 'PUB_EARNINGS_PER_UNIQUE_CLICK',
  PubPaidConversions = 'PUB_PAID_CONVERSIONS',
  PubTheyGet = 'PUB_THEY_GET',
  PubTheyGetPoints = 'PUB_THEY_GET_POINTS',
  PubWeGet = 'PUB_WE_GET',
  Rebate = 'REBATE',
  RevenueRebate = 'REVENUE_REBATE',
  ReversedConversions = 'REVERSED_CONVERSIONS',
  ReversedPubConversions = 'REVERSED_PUB_CONVERSIONS',
  ReversedTheyGet = 'REVERSED_THEY_GET',
  ReversedWeGet = 'REVERSED_WE_GET',
  Roas = 'ROAS',
  SaleAmount = 'SALE_AMOUNT',
  Searches = 'SEARCHES',
  SearchClientLatency = 'SEARCH_CLIENT_LATENCY',
  SearchCtr = 'SEARCH_CTR',
  SearchLatency = 'SEARCH_LATENCY',
  SearchMonetizedCtr = 'SEARCH_MONETIZED_CTR',
  SearchMonetizedPrpm = 'SEARCH_MONETIZED_PRPM',
  SearchMonetizedRpm = 'SEARCH_MONETIZED_RPM',
  SearchPrpc = 'SEARCH_PRPC',
  SearchPrpm = 'SEARCH_PRPM',
  SearchQualityAdvertiserCoverage = 'SEARCH_QUALITY_ADVERTISER_COVERAGE',
  SearchQualityAdvertiserScore = 'SEARCH_QUALITY_ADVERTISER_SCORE',
  SearchQualityFollowupSearches = 'SEARCH_QUALITY_FOLLOWUP_SEARCHES',
  SearchQualityInitialSearches = 'SEARCH_QUALITY_INITIAL_SEARCHES',
  SearchQualitySearchEngineCoverage = 'SEARCH_QUALITY_SEARCH_ENGINE_COVERAGE',
  SearchQualitySearchEngineFollowupSearches = 'SEARCH_QUALITY_SEARCH_ENGINE_FOLLOWUP_SEARCHES',
  SearchQualitySearchEngineInitialSearches = 'SEARCH_QUALITY_SEARCH_ENGINE_INITIAL_SEARCHES',
  SearchQualitySearchEngineScore = 'SEARCH_QUALITY_SEARCH_ENGINE_SCORE',
  SearchRpc = 'SEARCH_RPC',
  SearchRpm = 'SEARCH_RPM',
  Sessions = 'SESSIONS',
  SuccessfulOutgoingLeads = 'SUCCESSFUL_OUTGOING_LEADS',
  TotalConversions = 'TOTAL_CONVERSIONS',
  TotalTheyGet = 'TOTAL_THEY_GET',
  TotalWeGet = 'TOTAL_WE_GET',
  UniqueClicks = 'UNIQUE_CLICKS'
}

export type RawStatsMetricResult = {
  name: RawStatsMetric;
  value?: Maybe<Scalars['String']['output']>;
};

export type RealtimeIntegration = {
  advertiserId: Scalars['String']['output'];
  config: Array<RealtimeIntegrationConfig>;
  containerOfferId?: Maybe<Scalars['String']['output']>;
  display?: Maybe<RealtimeIntegrationDisplay>;
  enabled: Scalars['Boolean']['output'];
  fallbackUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kind: RealtimeIntegrationKind;
  lastErrors?: Maybe<Array<Scalars['String']['output']>>;
  listCacheTtlSeconds?: Maybe<Scalars['Long']['output']>;
  name: Scalars['String']['output'];
  /** SDK kind only: path + query template of the S2S callback the partner must call, relative to this API's origin (partner macros such as {sid} left in place). */
  s2sPath?: Maybe<Scalars['String']['output']>;
  timeoutMillis?: Maybe<Scalars['Long']['output']>;
  type: Scalars['String']['output'];
};

export type RealtimeIntegrationAdapter = {
  config: Array<RealtimeIntegrationConfig>;
  kind: RealtimeIntegrationKind;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type RealtimeIntegrationConfig = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  mandatory: Scalars['Boolean']['output'];
  secret: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type RealtimeIntegrationConfigInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type RealtimeIntegrationDisplay = {
  description?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RealtimeIntegrationDisplayInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RealtimeIntegrationInput = {
  advertiserId: Scalars['String']['input'];
  config?: InputMaybe<Array<RealtimeIntegrationConfigInput>>;
  display?: InputMaybe<RealtimeIntegrationDisplayInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fallbackUrl?: InputMaybe<Scalars['String']['input']>;
  listCacheTtlSeconds?: InputMaybe<Scalars['Long']['input']>;
  name: Scalars['String']['input'];
  timeoutMillis?: InputMaybe<Scalars['Long']['input']>;
  type: Scalars['String']['input'];
};

export enum RealtimeIntegrationKind {
  Ecommerce = 'ECOMMERCE',
  Iframe = 'IFRAME',
  Mappable = 'MAPPABLE',
  /** Partner SDK embedded in the rewarded app (e.g. adjoe Playtime); rewards arrive through the partner's S2S callback. */
  Sdk = 'SDK'
}

export type RealtimeOffer = {
  containerOfferId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<RealtimeOfferEvent>>;
  expectedPayout?: Maybe<RewardedPayout>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  integrationId: Scalars['String']['output'];
  itemId?: Maybe<Scalars['String']['output']>;
  kind: RealtimeIntegrationKind;
  name?: Maybe<Scalars['String']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  trackingUrl: Scalars['String']['output'];
};

export type RealtimeOfferEvent = {
  name?: Maybe<Scalars['String']['output']>;
  payout?: Maybe<RewardedPayout>;
};

export type Recipient = {
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RecipientInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type RedirectionRule = {
  advertiserIdOperator: RedirectionRuleFilterOperator;
  advertiserIds?: Maybe<Array<Scalars['String']['output']>>;
  decision: RedirectionRuleDecision;
  offerIdOperator: RedirectionRuleFilterOperator;
  offerIds?: Maybe<Array<Scalars['String']['output']>>;
  publisherIdOperator: RedirectionRuleFilterOperator;
  publisherIds?: Maybe<Array<Scalars['String']['output']>>;
  smartLinkId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  unwantedFailedRules?: Maybe<Array<ClickRule>>;
};

export enum RedirectionRuleDecision {
  Recycle = 'RECYCLE',
  Stop = 'STOP'
}

export enum RedirectionRuleFilterOperator {
  In = 'IN',
  NotIn = 'NOT_IN'
}

export type RedirectionRuleInput = {
  advertiserIdOperator?: InputMaybe<RedirectionRuleFilterOperator>;
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  decision?: InputMaybe<RedirectionRuleDecision>;
  offerIdOperator?: InputMaybe<RedirectionRuleFilterOperator>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIdOperator?: InputMaybe<RedirectionRuleFilterOperator>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  unwantedFailedRules?: InputMaybe<Array<ClickRule>>;
};

export enum RedirectionType {
  Iframe = 'IFRAME',
  Javascript = 'JAVASCRIPT',
  MetaRefresh = 'META_REFRESH',
  ShortDelay = 'SHORT_DELAY',
  ThreeOTwo = 'THREE_O_TWO',
  ThreeOTwoWithReferrer = 'THREE_O_TWO_WITH_REFERRER'
}

export type ReferralInfo = {
  end: Scalars['LocalDateTime']['output'];
  start: Scalars['LocalDateTime']['output'];
};

export type ReferralInfoInput = {
  end: Scalars['LocalDateTime']['input'];
  start: Scalars['LocalDateTime']['input'];
};

/** Referral abuse: referrers whose invited accounts are linked through a device / advertising id or IP */
export enum ReferralSortBy {
  CreditedReferrals = 'CREDITED_REFERRALS',
  LastReferralAt = 'LAST_REFERRAL_AT',
  ReferredUsers = 'REFERRED_USERS',
  RiskScore = 'RISK_SCORE',
  SharedDeviceUsers = 'SHARED_DEVICE_USERS',
  SharedIpUsers = 'SHARED_IP_USERS'
}

export type Repetitions = {
  activeOffers: Array<Offer>;
  countryRepetitions: Array<CountryRepetition>;
  previousOffers: Array<Offer>;
  profit: Scalars['Float']['output'];
};

export type Report = {
  end: Scalars['String']['output'];
  granularity: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  start: Scalars['String']['output'];
  stats: Array<Stat>;
};

export type ReportQuery = {
  delta?: InputMaybe<DeltaParameters>;
  dimensions?: InputMaybe<Array<StatsField>>;
  end: Scalars['String']['input'];
  estimation?: InputMaybe<EstimationParameters>;
  filters?: InputMaybe<Array<InputMaybe<StatsFilter>>>;
  granularity: Scalars['String']['input'];
  metrics?: InputMaybe<Array<Metric>>;
  name?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ReportSort>;
  start: Scalars['String']['input'];
};

export type ReportSort = {
  direction?: InputMaybe<SortOrder>;
  metric?: InputMaybe<Metric>;
};

export type RetargetingFile = {
  hash: RetargetingFileIdentifierHash;
  id: Scalars['String']['output'];
  offer: Offer;
  urls: Array<Scalars['String']['output']>;
};

export type RetargetingFileConnection = {
  edges?: Maybe<Array<RetargetingFileEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type RetargetingFileEdge = {
  node: RetargetingFile;
};

export enum RetargetingFileIdentifierHash {
  None = 'NONE',
  Sha256 = 'SHA256'
}

export type RetargetingFileInput = {
  hash: RetargetingFileIdentifierHash;
  offerId: Scalars['String']['input'];
  urls: Array<Scalars['String']['input']>;
};

/** Reversal / chargeback rate per traffic source */
export enum ReversalSortBy {
  ReversalRate = 'REVERSAL_RATE',
  ReversedConversions = 'REVERSED_CONVERSIONS',
  TheyGet = 'THEY_GET',
  TotalConversions = 'TOTAL_CONVERSIONS',
  WeGet = 'WE_GET'
}

/** An app that embeds the RewardOS SDK. One app maps to one publisher; its players are that publisher's rewarded users. */
export type RewardOsApp = {
  /** Public identifier shipped inside the app. */
  appKey: Scalars['String']['output'];
  callbackSecret: Scalars['String']['output'];
  /** Receives a signed POST for every wallet debit; null = no callbacks. */
  callbackUrl?: Maybe<Scalars['String']['output']>;
  currencyIconUrl?: Maybe<Scalars['String']['output']>;
  /** How points are called inside the wall; null = points. */
  currencyName?: Maybe<Scalars['String']['output']>;
  currencyNamePlural?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  /** Name of the host app's own currency that points are transferred into. */
  inAppCurrencyName?: Maybe<Scalars['String']['output']>;
  /** Units of the host app's currency credited per point; null = 1. */
  inAppExchangeRate?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Number of players (rewarded users) of this app. */
  playerCount: Scalars['Int']['output'];
  pointsUse: RewardOsPointsUse;
  publisher?: Maybe<Publisher>;
  publisherId: Scalars['String']['output'];
  /** When true, sessions without a valid signature are rejected. */
  requireSignedUsers: Scalars['Boolean']['output'];
  /** Bearer key of the server-to-server API (/rewardos/v1). */
  serverApiKey: Scalars['String']['output'];
  theme?: Maybe<RewardOsTheme>;
  /** HMAC-SHA256 key the customer's backend signs player ids with. */
  userSigningSecret: Scalars['String']['output'];
  /** Overrides the global/rewardOsWallUrl service config for this app. */
  wallUrl?: Maybe<Scalars['String']['output']>;
};

export type RewardOsAppInput = {
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  currencyIconUrl?: InputMaybe<Scalars['String']['input']>;
  currencyName?: InputMaybe<Scalars['String']['input']>;
  currencyNamePlural?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  inAppCurrencyName?: InputMaybe<Scalars['String']['input']>;
  inAppExchangeRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pointsUse?: InputMaybe<RewardOsPointsUse>;
  /** Only when creating: attach the app to an existing publisher. Left out, a publisher named after the app is created. */
  publisherId?: InputMaybe<Scalars['String']['input']>;
  requireSignedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  theme?: InputMaybe<RewardOsThemeInput>;
  wallUrl?: InputMaybe<Scalars['String']['input']>;
};

export type RewardOsClientConfig = {
  appId: Scalars['String']['output'];
  appName: Scalars['String']['output'];
  currencyIconUrl?: Maybe<Scalars['String']['output']>;
  currencyName?: Maybe<Scalars['String']['output']>;
  currencyNamePlural?: Maybe<Scalars['String']['output']>;
  inAppCurrencyName?: Maybe<Scalars['String']['output']>;
  /** Units of the host app's currency credited per point. */
  inAppExchangeRate: Scalars['Float']['output'];
  minimumCashOutUsd: Scalars['Float']['output'];
  pointsPerUsd: Scalars['Float']['output'];
  pointsUse: RewardOsPointsUse;
  showUsdValues: Scalars['Boolean']['output'];
  theme: RewardOsTheme;
  /** Where the SDK loads the wall from; null when not configured. */
  wallUrl?: Maybe<Scalars['String']['output']>;
};

export enum RewardOsColorScheme {
  /** Follows the device setting. */
  Auto = 'AUTO',
  Dark = 'DARK',
  Light = 'LIGHT'
}

export enum RewardOsPlatform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export enum RewardOsPointsUse {
  Both = 'BOTH',
  /** Points are cashed out through the platform's payment provider. */
  CashOut = 'CASH_OUT',
  /** Points are transferred into the host app's own currency. */
  InApp = 'IN_APP'
}

export enum RewardOsSecretKind {
  Callback = 'CALLBACK',
  ServerApi = 'SERVER_API',
  UserSigning = 'USER_SIGNING'
}

export type RewardOsSession = {
  config: RewardOsClientConfig;
  isNewUser: Scalars['Boolean']['output'];
  rewardedUserId: Scalars['String']['output'];
  token: RewardOsToken;
  userId: Scalars['String']['output'];
};

export type RewardOsSessionInput = {
  appKey: Scalars['String']['input'];
  platform?: InputMaybe<RewardOsPlatform>;
  sdkVersion?: InputMaybe<Scalars['String']['input']>;
  /** Hex HMAC-SHA256(userSigningSecret, userId). Required when the app enforces signed users. */
  signature?: InputMaybe<Scalars['String']['input']>;
  /** The customer's own id for the player. The player is created on first sight. */
  userId: Scalars['String']['input'];
};

/** Look of the wall inside the host app. Every field is optional; the wall falls back to its defaults. */
export type RewardOsTheme = {
  backgroundColor?: Maybe<Scalars['String']['output']>;
  colorScheme?: Maybe<RewardOsColorScheme>;
  cornerRadius?: Maybe<Scalars['Int']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  mutedTextColor?: Maybe<Scalars['String']['output']>;
  onPrimaryColor?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  surfaceColor?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RewardOsThemeInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  colorScheme?: InputMaybe<RewardOsColorScheme>;
  cornerRadius?: InputMaybe<Scalars['Int']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  mutedTextColor?: InputMaybe<Scalars['String']['input']>;
  onPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  surfaceColor?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Access token of the player API. The SDK renews it by starting a new session. */
export type RewardOsToken = {
  accessToken: Scalars['String']['output'];
  /** Seconds until the token expires. */
  expiresIn: Scalars['Int']['output'];
};

export type RewardOsTransaction = {
  createdAt?: Maybe<Scalars['LocalDateTime']['output']>;
  id: Scalars['String']['output'];
  points: Scalars['Float']['output'];
  /** Where the player collects an approved cash-out (gift card / payout link). Opening it completes the cash-out. */
  redeemUrl?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status: RewardOsTransactionStatus;
  type: RewardOsTransactionType;
  usd: Scalars['Float']['output'];
};

export type RewardOsTransactionConnection = {
  items: Array<RewardOsTransaction>;
  totalCount: Scalars['Int']['output'];
};

export enum RewardOsTransactionStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum RewardOsTransactionType {
  CashOut = 'CASH_OUT',
  InAppTransfer = 'IN_APP_TRANSFER'
}

export type RewardOsWallet = {
  availablePoints: Scalars['Float']['output'];
  availableUsd: Scalars['Float']['output'];
  /** Null until the player verified an email address. */
  email?: Maybe<Scalars['String']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  lifetimePoints: Scalars['Float']['output'];
  /** Points locked in cash-outs that are not paid yet. */
  pendingPoints: Scalars['Float']['output'];
  /** Points transferred into the host app's currency. */
  spentPoints: Scalars['Float']['output'];
};

export type RewardUserOpenEvent = {
  acquisitionSource?: InputMaybe<Scalars['String']['input']>;
  advertisingId?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  buildVersion?: InputMaybe<Scalars['String']['input']>;
  bundleId?: InputMaybe<Scalars['String']['input']>;
  cpuArchitectures?: InputMaybe<Array<Scalars['String']['input']>>;
  designName?: InputMaybe<Scalars['String']['input']>;
  deviceCategory?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['String']['input'];
  deviceType?: InputMaybe<Scalars['String']['input']>;
  deviceYearClass?: InputMaybe<Scalars['Int']['input']>;
  expoPushToken?: InputMaybe<Scalars['String']['input']>;
  fontScale?: InputMaybe<Scalars['Float']['input']>;
  isDevice?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  osv?: InputMaybe<Scalars['String']['input']>;
  /** App-generated UUID kept in the device keychain / secure store; never cleared on logout. */
  persId?: InputMaybe<Scalars['String']['input']>;
  pixelRatio?: InputMaybe<Scalars['Float']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  screenHeight?: InputMaybe<Scalars['Int']['input']>;
  screenWidth?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['LocalDateTime']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  totalMemory?: InputMaybe<Scalars['Float']['input']>;
  trackingPermission?: InputMaybe<TrackingPermission>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type RewardedAppDetails = {
  iosStoreUrl?: Maybe<Scalars['String']['output']>;
  logo: Scalars['String']['output'];
  playStoreUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  webUrl?: Maybe<Scalars['String']['output']>;
};

export type RewardedBalance = {
  availableBalance?: Maybe<Scalars['Float']['output']>;
  pendingBalance?: Maybe<Scalars['Float']['output']>;
  withdrawnBalance?: Maybe<Scalars['Float']['output']>;
};

export type RewardedCohortReport = {
  observedThrough: Scalars['LocalDate']['output'];
  rows: Array<RewardedCohortRow>;
  timezone: Scalars['String']['output'];
  usersWithoutRegistrationDate: Scalars['Long']['output'];
};

export type RewardedCohortRow = {
  day1: RewardedRetention;
  day7: RewardedRetention;
  day7Ltv?: Maybe<Scalars['Float']['output']>;
  day30: RewardedRetention;
  day30Ltv?: Maybe<Scalars['Float']['output']>;
  dimension: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  observedLtv?: Maybe<Scalars['Float']['output']>;
  observedMargin?: Maybe<Scalars['Float']['output']>;
  users: Scalars['Long']['output'];
};

export type RewardedCompletedEvent = {
  eventType?: Maybe<RewardedEventType>;
  theyGet?: Maybe<Scalars['Float']['output']>;
  theyGetPoints?: Maybe<Scalars['Float']['output']>;
  time: Scalars['LocalDateTime']['output'];
};

export type RewardedDashboardDay = {
  date: Scalars['LocalDate']['output'];
  metrics: RewardedDashboardMetrics;
};

export type RewardedDashboardInput = {
  end: Scalars['LocalDate']['input'];
  publisherIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  start: Scalars['LocalDate']['input'];
};

export type RewardedDashboardMetrics = {
  activeUsers: Scalars['Long']['output'];
  appOpens: Scalars['Long']['output'];
  arpu?: Maybe<Scalars['Float']['output']>;
  conversions: Scalars['Long']['output'];
  newUsers: Scalars['Long']['output'];
  paidOutCost: Scalars['Float']['output'];
  profit: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
  rewardCost: Scalars['Float']['output'];
};

export type RewardedDashboardOffer = {
  conversions: Scalars['Long']['output'];
  interactions: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  offerId: Scalars['ID']['output'];
  profit: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
  rewardCost: Scalars['Float']['output'];
};

export enum RewardedDashboardOfferSort {
  Conversions = 'CONVERSIONS',
  Interactions = 'INTERACTIONS',
  Profit = 'PROFIT',
  Revenue = 'REVENUE',
  RewardCost = 'REWARD_COST'
}

export enum RewardedDashboardPlatform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Unknown = 'UNKNOWN',
  Web = 'WEB'
}

export type RewardedDashboardPlatformDay = {
  date: Scalars['LocalDate']['output'];
  metrics: RewardedDashboardMetrics;
  platform: RewardedDashboardPlatform;
};

export type RewardedDashboardReport = {
  days: Array<RewardedDashboardDay>;
  end: Scalars['LocalDate']['output'];
  generatedAt: Scalars['LocalDateTime']['output'];
  platformDays: Array<RewardedDashboardPlatformDay>;
  start: Scalars['LocalDate']['output'];
  timezone: Scalars['String']['output'];
  topOffers: Array<RewardedDashboardOffer>;
  totals: RewardedDashboardMetrics;
  usersWithoutRegistrationDate: Scalars['Long']['output'];
};


export type RewardedDashboardReportTopOffersArgs = {
  direction?: InputMaybe<SortOrder>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<RewardedDashboardOfferSort>;
};

export type RewardedEventCompletion = {
  theyGet?: Maybe<Scalars['Float']['output']>;
  theyGetPoints?: Maybe<Scalars['Float']['output']>;
  time: Scalars['LocalDateTime']['output'];
};

export type RewardedEventType = {
  category?: Maybe<Scalars['String']['output']>;
  completed: Scalars['Boolean']['output'];
  creativeThumbnail?: Maybe<Scalars['String']['output']>;
  creativeUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  payout?: Maybe<RewardedPayout>;
  reward?: Maybe<RewardedEventCompletion>;
};

export type RewardedFraudMultiAccountConnection = {
  csvDownloadUrl?: Maybe<Scalars['String']['output']>;
  edges: Array<RewardedFraudMultiAccountEdge>;
  totalCount: Scalars['Long']['output'];
};

export type RewardedFraudMultiAccountEdge = {
  node: RewardedFraudMultiAccountRow;
};

export type RewardedFraudMultiAccountInput = {
  direction?: InputMaybe<SortOrder>;
  end: Scalars['LocalDateTime']['input'];
  groupBy: MultiAccountGroupBy;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<MultiAccountSortBy>;
  start: Scalars['LocalDateTime']['input'];
  userIdentifier: UserIdentifierType;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RewardedFraudMultiAccountRow = {
  advertiser?: Maybe<Advertiser>;
  fingerprint: Scalars['String']['output'];
  offer?: Maybe<Offer>;
  publisher?: Maybe<Publisher>;
  theyGet: Scalars['Float']['output'];
  totalPostbacks: Scalars['Int']['output'];
  userCount: Scalars['Int']['output'];
  userIds: Array<Scalars['String']['output']>;
  weGet: Scalars['Float']['output'];
};

export type RewardedFraudPayoutCherryPickingConnection = {
  csvDownloadUrl?: Maybe<Scalars['String']['output']>;
  edges: Array<RewardedFraudPayoutCherryPickingEdge>;
  totalCount: Scalars['Long']['output'];
};

export type RewardedFraudPayoutCherryPickingEdge = {
  node: RewardedFraudPayoutCherryPickingRow;
};

export type RewardedFraudPayoutCherryPickingInput = {
  direction?: InputMaybe<SortOrder>;
  end: Scalars['LocalDateTime']['input'];
  /** Minimum conversions for a user to appear (suppresses small-sample noise). */
  minConversions?: InputMaybe<Scalars['Int']['input']>;
  /** How much more expensive a user's cheapest completed event must be than the offer's cheapest to flag. */
  minRatio?: InputMaybe<Scalars['Float']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<PayoutCherryPickingSortBy>;
  start: Scalars['LocalDateTime']['input'];
  userIdentifier: UserIdentifierType;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RewardedFraudPayoutCherryPickingRow = {
  advertiser?: Maybe<Advertiser>;
  completedEvents: Scalars['Int']['output'];
  offer?: Maybe<Offer>;
  offerMinPayout: Scalars['Float']['output'];
  payoutRatio: Scalars['Float']['output'];
  publisher?: Maybe<Publisher>;
  theyGet: Scalars['Float']['output'];
  totalConversions: Scalars['Int']['output'];
  userAvgPayout: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
  userMinPayout: Scalars['Float']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  weGet: Scalars['Float']['output'];
};

export type RewardedFraudReferralConnection = {
  edges: Array<RewardedFraudReferralEdge>;
  totalCount: Scalars['Long']['output'];
};

export type RewardedFraudReferralEdge = {
  node: RewardedFraudReferralRow;
};

export type RewardedFraudReferralInput = {
  direction?: InputMaybe<SortOrder>;
  end?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** Only referrers with at least this many invited users in the window. */
  minReferredUsers?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ReferralSortBy>;
  /** Window over the invited users' registration time (organization timezone); both optional. */
  start?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** Only referrers with at least one invited account linked through a device or IP. */
  suspiciousOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict to these referrer ids. */
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RewardedFraudReferralRow = {
  creditedReferrals: Scalars['Int']['output'];
  distinctEmailDomains: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstReferralAt?: Maybe<Scalars['LocalDateTime']['output']>;
  lastReferralAt?: Maybe<Scalars['LocalDateTime']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  referredUserIds: Array<Scalars['String']['output']>;
  referredUsers: Scalars['Int']['output'];
  /** 0-1: share of invited users linked through a device (full weight) or IP (half weight). */
  riskScore: Scalars['Float']['output'];
  sharedDeviceUserIds: Array<Scalars['String']['output']>;
  /** Invited users sharing a device id / advertising id / keychain persId with the referrer or with each other. */
  sharedDeviceUsers: Scalars['Int']['output'];
  sharedIpUserIds: Array<Scalars['String']['output']>;
  /** Invited users sharing an IP with the referrer or with each other. */
  sharedIpUsers: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  verifiedUsers: Scalars['Int']['output'];
};

export type RewardedFraudReversalConnection = {
  csvDownloadUrl?: Maybe<Scalars['String']['output']>;
  edges: Array<RewardedFraudReversalEdge>;
  totalCount: Scalars['Long']['output'];
};

export type RewardedFraudReversalEdge = {
  node: RewardedFraudReversalRow;
};

export type RewardedFraudReversalInput = {
  direction?: InputMaybe<SortOrder>;
  end: Scalars['LocalDateTime']['input'];
  /** Minimum originally-approved conversions for a user to appear (suppresses small-sample noise). */
  minConversions?: InputMaybe<Scalars['Int']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<ReversalSortBy>;
  start: Scalars['LocalDateTime']['input'];
  userIdentifier: UserIdentifierType;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RewardedFraudReversalRow = {
  advertiser?: Maybe<Advertiser>;
  offer?: Maybe<Offer>;
  publisher?: Maybe<Publisher>;
  reversalRate: Scalars['Float']['output'];
  reversedConversions: Scalars['Int']['output'];
  reversedTheyGet: Scalars['Float']['output'];
  theyGet: Scalars['Float']['output'];
  totalConversions: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  weGet: Scalars['Float']['output'];
};

export type RewardedFraudRuleViolationConnection = {
  csvDownloadUrl?: Maybe<Scalars['String']['output']>;
  edges: Array<RewardedFraudRuleViolationEdge>;
  totalCount: Scalars['Long']['output'];
};

export type RewardedFraudRuleViolationEdge = {
  node: RewardedFraudRuleViolationRow;
};

export type RewardedFraudRuleViolationInput = {
  direction?: InputMaybe<SortOrder>;
  end: Scalars['LocalDateTime']['input'];
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  rules?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<RuleViolationSortBy>;
  start: Scalars['LocalDateTime']['input'];
  userIdentifier: UserIdentifierType;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RewardedFraudRuleViolationRow = {
  advertiser?: Maybe<Advertiser>;
  failedNonBanned: Scalars['Int']['output'];
  failedPostbacks: Scalars['Int']['output'];
  failedRules: Array<Scalars['String']['output']>;
  offer?: Maybe<Offer>;
  publisher?: Maybe<Publisher>;
  theyGet: Scalars['Float']['output'];
  totalPostbacks: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  violationRate: Scalars['Float']['output'];
  weGet: Scalars['Float']['output'];
};

export type RewardedFraudSignal = {
  evidence: Array<FraudSignalEvidence>;
  firstSeen?: Maybe<Scalars['LocalDateTime']['output']>;
  lastSeen?: Maybe<Scalars['LocalDateTime']['output']>;
  /** How many distinct pieces of evidence fired within the scan window (drives recurrence weighting). */
  occurrences: Scalars['Int']['output'];
  type: FraudSignalType;
};

export type RewardedFraudSynchronizedConversionsConnection = {
  csvDownloadUrl?: Maybe<Scalars['String']['output']>;
  edges: Array<RewardedFraudSynchronizedConversionsEdge>;
  totalCount: Scalars['Long']['output'];
};

export type RewardedFraudSynchronizedConversionsEdge = {
  node: RewardedFraudSynchronizedConversionsRow;
};

export type RewardedFraudSynchronizedConversionsInput = {
  /** Width of the time window (seconds) conversions are bucketed into. */
  bucketSeconds?: InputMaybe<Scalars['Int']['input']>;
  direction?: InputMaybe<SortOrder>;
  end: Scalars['LocalDateTime']['input'];
  /** Minimum distinct users in a bucket for it to be reported. */
  minUsers?: InputMaybe<Scalars['Int']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<SynchronizedConversionsSortBy>;
  start: Scalars['LocalDateTime']['input'];
  userIdentifier: UserIdentifierType;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RewardedFraudSynchronizedConversionsRow = {
  advertiser?: Maybe<Advertiser>;
  eventTypeId?: Maybe<Scalars['String']['output']>;
  eventTypeName?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<Offer>;
  publisher?: Maybe<Publisher>;
  theyGet: Scalars['Float']['output'];
  timeBucket: Scalars['String']['output'];
  totalPostbacks: Scalars['Int']['output'];
  userCount: Scalars['Int']['output'];
  userIds: Array<Scalars['String']['output']>;
  weGet: Scalars['Float']['output'];
};

export type RewardedFraudTimeOfDayConnection = {
  csvDownloadUrl?: Maybe<Scalars['String']['output']>;
  edges: Array<RewardedFraudTimeOfDayEdge>;
  totalCount: Scalars['Long']['output'];
};

export type RewardedFraudTimeOfDayEdge = {
  node: RewardedFraudTimeOfDayRow;
};

export type RewardedFraudTimeOfDayInput = {
  direction?: InputMaybe<SortOrder>;
  end: Scalars['LocalDateTime']['input'];
  minPostbacks?: InputMaybe<Scalars['Int']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<TimeOfDaySortBy>;
  start: Scalars['LocalDateTime']['input'];
  userIdentifier: UserIdentifierType;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RewardedFraudTimeOfDayRow = {
  advertiser?: Maybe<Advertiser>;
  hourDistribution: Array<Scalars['Int']['output']>;
  offer?: Maybe<Offer>;
  peakHour: Scalars['Int']['output'];
  peakHourPostbacks: Scalars['Int']['output'];
  peakHourRate: Scalars['Float']['output'];
  publisher?: Maybe<Publisher>;
  theyGet: Scalars['Float']['output'];
  totalPostbacks: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  weGet: Scalars['Float']['output'];
};

export type RewardedFraudTimingClusterConnection = {
  csvDownloadUrl?: Maybe<Scalars['String']['output']>;
  edges: Array<RewardedFraudTimingClusterEdge>;
  totalCount: Scalars['Long']['output'];
};

export type RewardedFraudTimingClusterEdge = {
  node: RewardedFraudTimingClusterRow;
};

export type RewardedFraudTimingClusterInput = {
  direction?: InputMaybe<SortOrder>;
  end: Scalars['LocalDateTime']['input'];
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  roundingSeconds?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<TimingClusterSortBy>;
  start: Scalars['LocalDateTime']['input'];
  userIdentifier: UserIdentifierType;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RewardedFraudTimingClusterRow = {
  advertiser?: Maybe<Advertiser>;
  offer?: Maybe<Offer>;
  publisher?: Maybe<Publisher>;
  theyGet: Scalars['Float']['output'];
  timingFingerprint: Scalars['String']['output'];
  totalPostbacks: Scalars['Int']['output'];
  userCount: Scalars['Int']['output'];
  userIds: Array<Scalars['String']['output']>;
  weGet: Scalars['Float']['output'];
};

export type RewardedFraudVelocityConnection = {
  csvDownloadUrl?: Maybe<Scalars['String']['output']>;
  edges: Array<RewardedFraudVelocityEdge>;
  totalCount: Scalars['Long']['output'];
};

export type RewardedFraudVelocityEdge = {
  node: RewardedFraudVelocityRow;
};

export type RewardedFraudVelocityInput = {
  direction?: InputMaybe<SortOrder>;
  end: Scalars['LocalDateTime']['input'];
  /** Minimum peak-window conversion count for a user to appear. */
  minPeak?: InputMaybe<Scalars['Int']['input']>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<VelocitySortBy>;
  start: Scalars['LocalDateTime']['input'];
  userIdentifier: UserIdentifierType;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Burst window size in minutes. */
  windowMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type RewardedFraudVelocityRow = {
  advertiser?: Maybe<Advertiser>;
  distinctWindows: Scalars['Int']['output'];
  offer?: Maybe<Offer>;
  peakInWindow: Scalars['Int']['output'];
  peakWindowStart?: Maybe<Scalars['String']['output']>;
  publisher?: Maybe<Publisher>;
  theyGet: Scalars['Float']['output'];
  totalConversions: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  weGet: Scalars['Float']['output'];
  windowMinutes: Scalars['Int']['output'];
};

export type RewardedFraudVpnConnection = {
  csvDownloadUrl?: Maybe<Scalars['String']['output']>;
  edges: Array<RewardedFraudVpnEdge>;
  totalCount: Scalars['Long']['output'];
};

export type RewardedFraudVpnEdge = {
  node: RewardedFraudVpnRow;
};

export type RewardedFraudVpnInput = {
  direction?: InputMaybe<SortOrder>;
  end: Scalars['LocalDateTime']['input'];
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<VpnSortBy>;
  start: Scalars['LocalDateTime']['input'];
  /** When true, corporate/edu/public IPs also count as anonymized; otherwise only vpn/proxy/tor/datacenter. */
  strict?: InputMaybe<Scalars['Boolean']['input']>;
  userIdentifier: UserIdentifierType;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RewardedFraudVpnRow = {
  advertiser?: Maybe<Advertiser>;
  offer?: Maybe<Offer>;
  proxyTypes: Array<Scalars['String']['output']>;
  publisher?: Maybe<Publisher>;
  theyGet: Scalars['Float']['output'];
  totalPostbacks: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  vpnConversions: Scalars['Int']['output'];
  vpnIpCount: Scalars['Int']['output'];
  vpnRate: Scalars['Float']['output'];
  weGet: Scalars['Float']['output'];
};

export type RewardedFunnelEvent = {
  eventTypeId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RewardedFunnelStep = {
  conversionRate?: Maybe<Scalars['Float']['output']>;
  dropOffRate?: Maybe<Scalars['Float']['output']>;
  droppedUsers?: Maybe<Scalars['Long']['output']>;
  eventTypeId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  reachedUsers: Scalars['Long']['output'];
  sequenceUsers: Scalars['Long']['output'];
};

export type RewardedOffer = {
  additionalInformation?: Maybe<Scalars['String']['output']>;
  appStoreId?: Maybe<Scalars['String']['output']>;
  completedStatus: RewardedOffersCompletedStatus;
  creatives: Array<RewardedOfferCreativePack>;
  description?: Maybe<Scalars['String']['output']>;
  eventTypes: Array<RewardedEventType>;
  id: Scalars['String']['output'];
  impressionUrl?: Maybe<Scalars['String']['output']>;
  /** Set for the platform's own engagement offers (referral, daily check-in, welcome bonus); null for advertiser offers. */
  kind?: Maybe<RewardedSystemOfferKind>;
  kpi?: Maybe<Scalars['String']['output']>;
  leadflow: Leadflow;
  name: Scalars['String']['output'];
  percentageCompleted: Scalars['Float']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  restrictions?: Maybe<Array<Scalars['String']['output']>>;
  status: OfferStatus;
  /** Player-specific state of a system offer; null for advertiser offers. */
  systemState?: Maybe<RewardedSystemOfferState>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  targeting: Targeting;
  totalPayout: RewardedPayout;
  trackingUrl: Scalars['String']['output'];
  verticals?: Maybe<Array<Scalars['String']['output']>>;
};

export type RewardedOfferConnection = {
  edges: Array<RewardedOfferEdge>;
  totalCount: Scalars['Int']['output'];
};

export type RewardedOfferCreativePack = {
  creatives: Array<Creative>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type RewardedOfferEdge = {
  node: RewardedOffer;
};

export type RewardedOfferFunnelReport = {
  availableEvents: Array<RewardedFunnelEvent>;
  offerId: Scalars['ID']['output'];
  steps: Array<RewardedFunnelStep>;
  timezone: Scalars['String']['output'];
};

export enum RewardedOffersCompletedStatus {
  /** Cockpit-only: at least one click, no conversion yet. */
  Clicked = 'CLICKED',
  Completed = 'COMPLETED',
  Started = 'STARTED',
  Unattempted = 'UNATTEMPTED',
  /** Cockpit-only: at least one impression, no click or conversion yet. */
  Viewed = 'VIEWED'
}

export type RewardedOffersFilter = {
  autoFilter?: InputMaybe<Scalars['Boolean']['input']>;
  completionStatuses?: InputMaybe<Array<RewardedOffersCompletedStatus>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Scalars['String']['input']>;
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  excludeCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeOses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Excludes offers having at least one of these tags. */
  excludeTags?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  oses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only offers having at least one of these restrictions. */
  restrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only offers having at least one of these verticals. */
  verticals?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum RewardedOffersOrdering {
  /** EPC over the trailing 6 days, descending. */
  Default = 'DEFAULT',
  /** Hides offers the user already has progress on and puts offers tagged 'RewardedOrdering:<n>' first (ascending n), remaining offers by EPC descending. */
  TagPrioritized = 'TAG_PRIORITIZED'
}

export type RewardedPayout = {
  theyGet?: Maybe<Scalars['Float']['output']>;
  theyGetPoints?: Maybe<Scalars['Float']['output']>;
};

export type RewardedReport = {
  end: Scalars['LocalDateTime']['output'];
  granularity: RewardedReportInputGranularity;
  rows: Array<RewardedReportRow>;
  start: Scalars['LocalDateTime']['output'];
};

export enum RewardedReportDimension {
  Datetime = 'DATETIME',
  OfferId = 'OFFER_ID'
}

export type RewardedReportDimensionResult = {
  dimension: RewardedReportDimension;
  value?: Maybe<Scalars['String']['output']>;
};

export type RewardedReportInput = {
  dimensions: Array<RewardedReportDimension>;
  end: Scalars['LocalDateTime']['input'];
  granularity: RewardedReportInputGranularity;
  start: Scalars['LocalDateTime']['input'];
};

export enum RewardedReportInputGranularity {
  All = 'ALL',
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type RewardedReportRow = {
  dimensions: Array<RewardedReportDimensionResult>;
  theyGet: Scalars['Float']['output'];
  theyGetPoints: Scalars['Float']['output'];
};

export type RewardedRetention = {
  eligibleUsers: Scalars['Long']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  retainedUsers: Scalars['Long']['output'];
};

export type RewardedRewardsFilter = {
  completionStatuses?: InputMaybe<Array<RewardedOffersCompletedStatus>>;
  country?: InputMaybe<Scalars['String']['input']>;
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A partner SDK the rewarded app should initialise, with its public (non-secret) configuration. */
export type RewardedSdkIntegration = {
  /** Only non-secret, non-empty values. */
  config: Array<RewardedSdkIntegrationConfig>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  /** Provider type, e.g. ADJOE. */
  type: Scalars['String']['output'];
};

export type RewardedSdkIntegrationConfig = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type RewardedSocialLoginInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  idToken?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  provider: SocialLoginProvider;
  /** Referral code of the inviting user; only applied when this login creates the account. */
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type RewardedSystemOfferConfig = {
  id: Scalars['String']['output'];
  kind: RewardedSystemOfferKind;
};

/** Offers the platform provisions for its own users. Each is switched on by a rewarded setting and pays through its default event's points payout. */
export enum RewardedSystemOfferKind {
  AcquisitionSource = 'ACQUISITION_SOURCE',
  /** One check-in per day (organization timezone). */
  DailyCheckin = 'DAILY_CHECKIN',
  /** A one-time welcome reward on the first click. */
  FirstTime = 'FIRST_TIME',
  /** Share a referral code; the referrer is credited once the invited user verified their email. */
  Referral = 'REFERRAL'
}

export type RewardedSystemOfferState = {
  /** Plain public link to the app (website or store listing), without any code. */
  appLink?: Maybe<Scalars['String']['output']>;
  checkedInToday: Scalars['Boolean']['output'];
  /** FIRST_TIME: already claimed. DAILY_CHECKIN: checked in today. REFERRAL: at least one credited referral. */
  completed: Scalars['Boolean']['output'];
  /** Referred users that verified their email and were credited. */
  creditedReferrals: Scalars['Int']['output'];
  kind: RewardedSystemOfferKind;
  lastCompletedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  /** When the daily check-in becomes available again (start of the next day in the organization timezone). */
  nextCheckinAt?: Maybe<Scalars['LocalDateTime']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  /** The player's personal referral link: the tracking-domain redirect (/reward-refer) carrying their code. */
  referralLink?: Maybe<Scalars['String']['output']>;
  /** The share message with {code}, {link} and {appName} substituted. */
  referralMessage?: Maybe<Scalars['String']['output']>;
  /** Users that registered with this player's code. */
  referredUsers: Scalars['Int']['output'];
};

export type RewardedTutorialOffer = {
  finalCompleted: Scalars['Boolean']['output'];
  /** The second, better paid task that unlocks the full app. */
  finalEvent: RewardedEventType;
  initialCompleted: Scalars['Boolean']['output'];
  /** The first task; its payout is what the player cashes out in FIRST_PAYOUT. */
  initialEvent: RewardedEventType;
  offer: RewardedOffer;
};

/** Where a player is in Tutorial Mode. The app keeps the player on the tutorial screens while active. */
export enum RewardedTutorialStage {
  /** Nothing picked yet: show the 1-2 tutorial offers. */
  ChooseOffer = 'CHOOSE_OFFER',
  /** Finished, feature off, or the player is exempt: the full app is available. */
  Completed = 'COMPLETED',
  /** The initial event paid: request a cash-out, wait for approval, claim the payout link. */
  FirstPayout = 'FIRST_PAYOUT',
  /** The initial paid event of the picked offer is open: show the task and wait for its conversion. */
  FirstTask = 'FIRST_TASK',
  /** The first cash-out was claimed: the final paid event is open; the redeem page stays reachable. */
  SecondTask = 'SECOND_TASK'
}

export type RewardedTutorialState = {
  /** True while the player is inside the tutorial and must not see the regular dashboard. */
  active: Scalars['Boolean']['output'];
  /** The task to do now: the initial event in FIRST_TASK, the final event in SECOND_TASK, null otherwise. */
  currentEvent?: Maybe<RewardedEventType>;
  /** The offers the player can pick from (operator-configured, live, targeted at the player's device); empty when inactive. */
  offers: Array<RewardedTutorialOffer>;
  /** The player's most recent cash-out request; its status (REQUESTED/APPROVED/DENIED/PAID) drives FIRST_PAYOUT. */
  payment?: Maybe<PartnerPublisherPayment>;
  /** The offer the player picked; null until chosen. */
  selectedOffer?: Maybe<RewardedTutorialOffer>;
  stage: RewardedTutorialStage;
};

export type RewardedUser = {
  /** Cockpit-only full event history including FAILED events with failure reasons (sourced from ClickHouse). */
  allEvents: RewardedUserProgressConnection;
  allRewardedTags: Array<Scalars['String']['output']>;
  audiences: Array<Audience>;
  balance: RewardedBalance;
  /** Self-declared profile country. */
  country?: Maybe<Scalars['String']['output']>;
  /** Account creation time in the organization timezone. Falls back to the REWARDED_USER CREATE audit for accounts older than the field. */
  createdAt?: Maybe<Scalars['LocalDateTime']['output']>;
  customFields: Array<RewardedUserProfileCustomField>;
  /** Geo (IP) country of the most recently used device; null when no device resolved to one. The `countries` filter of `rewardedUsers` matches on this. */
  deviceCountry?: Maybe<Scalars['String']['output']>;
  devices?: Maybe<Array<RewardedUserDevice>>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  /** 0-100 fraud score compiled from the rewarded fraud reports. Null until the first scan. */
  fraudScore?: Maybe<Scalars['Float']['output']>;
  fraudScoreUpdatedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  fraudSignals: Array<RewardedFraudSignal>;
  fraudTier?: Maybe<FraudRiskTier>;
  highlightedOffers: RewardedOfferConnection;
  id: Scalars['String']['output'];
  internalId?: Maybe<Scalars['String']['output']>;
  internalReport: Array<Report>;
  lastName?: Maybe<Scalars['String']['output']>;
  nickname: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  offer: RewardedOffer;
  /** Cockpit-only: distinct offers the user clicked / viewed within [start, end] (Druid); defaults to all time. */
  offerEngagement: RewardedUserOfferEngagement;
  offers: RewardedOfferConnection;
  payments: PartnerPublisherPaymentConnection;
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
  progress: RewardedUserProgressConnection;
  publisher: Publisher;
  /** Offers resolved live from realtime integrations; clicks land on the integration's container offer. */
  realtimeOffers: Array<RealtimeOffer>;
  referral?: Maybe<RewardedUser>;
  /** This user's own referral code (generated on demand). */
  referralCode?: Maybe<Scalars['String']['output']>;
  /** When the referrer was credited for this (invited) user; null when never credited. */
  referralCreditedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  referralId?: Maybe<Scalars['String']['output']>;
  /** Number of users that registered with this user's referral code. */
  referredUsers: Scalars['Int']['output'];
  report: RewardedReport;
  rewards: RewardedUserRewardConnection;
  /** Enabled partner SDK integrations (e.g. adjoe Playtime) the app should initialise; empty when none are configured. */
  sdkIntegrations: Array<RewardedSdkIntegration>;
  /** Per-user override for showing USD next to points; null inherits the global rewardedShowUsdValues setting. Cockpit-managed. */
  showUsdValues?: Maybe<Scalars['Boolean']['output']>;
  stats: RewardedUserCounts;
  status: RewardedUserStatus;
  supportTickets: RewardedUserSupportTicketConnection;
  totalTheyGet?: Maybe<Scalars['Float']['output']>;
  totalTheyGetPoints?: Maybe<Scalars['Float']['output']>;
  /** Tutorial Mode (guided first earning): where the player is and what to show. Derived on every read, so the app may poll it. */
  tutorial: RewardedTutorialState;
  /** Tutorial Mode: the offer the player picked; null until chosen. */
  tutorialOfferId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  /** Effective flag the app uses: per-user override when set, otherwise the global rewardedShowUsdValues setting. */
  usdDisplayEnabled: Scalars['Boolean']['output'];
  userAcquisitionEvents?: Maybe<Array<RewardedUserAcquisitionEvent>>;
};


export type RewardedUserAllEventsArgs = {
  filter?: InputMaybe<RewardedUserProgressFilter>;
  pagination: Pagination;
};


export type RewardedUserInternalReportArgs = {
  queries?: InputMaybe<Array<InputMaybe<ReportQuery>>>;
};


export type RewardedUserOfferArgs = {
  id: Scalars['String']['input'];
};


export type RewardedUserOfferEngagementArgs = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};


export type RewardedUserOffersArgs = {
  filter?: InputMaybe<RewardedOffersFilter>;
  ordering?: InputMaybe<RewardedOffersOrdering>;
  pagination: Pagination;
};


export type RewardedUserPaymentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RewardedUserProgressArgs = {
  filter?: InputMaybe<RewardedUserProgressFilter>;
  pagination: Pagination;
};


export type RewardedUserRealtimeOffersArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type RewardedUserReportArgs = {
  input: RewardedReportInput;
};


export type RewardedUserRewardsArgs = {
  filter?: InputMaybe<RewardedRewardsFilter>;
  pagination: Pagination;
};


export type RewardedUserSupportTicketsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RewardedUserUserAcquisitionEventsArgs = {
  since: Scalars['LocalDateTime']['input'];
};

export type RewardedUserAcquisitionEvent = {
  score?: Maybe<Scalars['Float']['output']>;
  type: RewardedUserAcquisitionEventType;
};

export enum RewardedUserAcquisitionEventType {
  Cashout = 'CASHOUT',
  GameLevel = 'GAME_LEVEL',
  Iaa = 'IAA',
  Iap = 'IAP',
  Install = 'INSTALL',
  Registration = 'REGISTRATION'
}

export type RewardedUserConnection = {
  edges: Array<RewardedUserEdge>;
  totalCount: Scalars['Int']['output'];
};

export type RewardedUserCounts = {
  completedOffers: Scalars['Int']['output'];
  startedOffers: Scalars['Int']['output'];
  totalTheyGet: Scalars['Float']['output'];
  totalTheyGetPoints: Scalars['Float']['output'];
};

export type RewardedUserDevice = {
  acquisitionSource?: Maybe<Scalars['String']['output']>;
  acquisitionSourceCapturedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  advertisingId?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  expoPushToken?: Maybe<Scalars['String']['output']>;
  geo?: Maybe<Geo>;
  ip?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastAccess?: Maybe<Scalars['LocalDateTime']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  osv?: Maybe<Scalars['String']['output']>;
  /** App-generated UUID kept in the device keychain / secure store; never cleared on logout. */
  persId?: Maybe<Scalars['String']['output']>;
  /** Proxy/VPN type of the device IP at capture time (vpn, proxy, tor, datacenter, ...). Null when not anonymized. */
  proxyType?: Maybe<Scalars['String']['output']>;
};

export type RewardedUserEdge = {
  node: RewardedUser;
};

/** One client-side telemetry event. Ip, geo and proxy classification are added by the backend from the request. */
export type RewardedUserEventInput = {
  appBuild?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  eventTypeId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Array<RewardedUserEventPropertyInput>>;
  screen?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  /** Client UTC time; ignored when in the future or older than a day. */
  time?: InputMaybe<Scalars['LocalDateTime']['input']>;
  type: RewardedUserEventType;
};

export type RewardedUserEventPropertyInput = {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Telemetry event types of the rewarded app. Client-side types are reported through rewardedTrackEvents; the rest are stamped by the backend. */
export enum RewardedUserEventType {
  AccountDeletionRequested = 'ACCOUNT_DELETION_REQUESTED',
  AppBackground = 'APP_BACKGROUND',
  AppForeground = 'APP_FOREGROUND',
  AppOpen = 'APP_OPEN',
  Checkin = 'CHECKIN',
  EmailVerified = 'EMAIL_VERIFIED',
  Login = 'LOGIN',
  OfferClick = 'OFFER_CLICK',
  OfferListView = 'OFFER_LIST_VIEW',
  OfferView = 'OFFER_VIEW',
  PaymentRequested = 'PAYMENT_REQUESTED',
  PushOpened = 'PUSH_OPENED',
  ReferralCredited = 'REFERRAL_CREDITED',
  ReferralShare = 'REFERRAL_SHARE',
  Register = 'REGISTER',
  RewardView = 'REWARD_VIEW',
  ScreenView = 'SCREEN_VIEW',
  SupportTicket = 'SUPPORT_TICKET',
  TutorialStep = 'TUTORIAL_STEP'
}

export type RewardedUserInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<RewardedUserProfileCustomFieldInput>>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  publisherId?: InputMaybe<Scalars['String']['input']>;
  /** Referral code of the inviting user (registration only; rejected when unknown or the user's own). */
  referralCode?: InputMaybe<Scalars['String']['input']>;
  referralId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RewardedUserStatus>;
};

export type RewardedUserOfferEngagement = {
  /** Offers with at least one click by the user. */
  interactedOffers: Scalars['Int']['output'];
  /** Offers with at least one impression by the user. */
  viewedOffers: Scalars['Int']['output'];
};

export type RewardedUserProfileCustomField = {
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type RewardedUserProfileCustomFieldInput = {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type RewardedUserProgressConnection = {
  edges: Array<RewardedUserProgressEdge>;
  totalCount: Scalars['Int']['output'];
};

export type RewardedUserProgressEdge = {
  node: RewardedUserProgressEntry;
};

export type RewardedUserProgressEntry = {
  eventType?: Maybe<RewardedEventType>;
  /** True when this event's postback was rejected (FAILED decision). */
  failed: Scalars['Boolean']['output'];
  /** Evaluation rules that caused the failure (empty when not failed). */
  failedRules?: Maybe<Array<Scalars['String']['output']>>;
  offer: RewardedOffer;
  reachedAt: Scalars['LocalDateTime']['output'];
  theyGet?: Maybe<Scalars['Float']['output']>;
  theyGetPoints?: Maybe<Scalars['Float']['output']>;
};

export type RewardedUserProgressFilter = {
  from?: InputMaybe<Scalars['LocalDateTime']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['LocalDateTime']['input']>;
};

export type RewardedUserReward = {
  completed: Array<RewardedCompletedEvent>;
  offer: RewardedOffer;
  totalPayout: RewardedPayout;
};

export type RewardedUserRewardConnection = {
  edges: Array<RewardedUserRewardEdge>;
  totalCount: Scalars['Int']['output'];
};

export type RewardedUserRewardEdge = {
  node: RewardedUserReward;
};

export enum RewardedUserStatus {
  Active = 'ACTIVE',
  BannedForFraud = 'BANNED_FOR_FRAUD',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export type RewardedUserSupportMessage = {
  accountManager?: Maybe<User>;
  /** Urls of the pictures attached to the message. */
  attachments: Array<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  id: Scalars['String']['output'];
  time: Scalars['LocalDateTime']['output'];
  user?: Maybe<RewardedUser>;
};

export type RewardedUserSupportTicket = {
  accountManager: User;
  body: Scalars['String']['output'];
  /** Whose turn it is, for every caller: OPEN = not answered yet, REPLIED = support wrote last, NEW_MESSAGE = the user wrote last, CLOSED. */
  conversationStatus: RewardedUserSupportTicketStatus;
  /** When the ticket was opened. */
  createdAt?: Maybe<Scalars['LocalDateTime']['output']>;
  id: Scalars['String']['output'];
  lastMessagedAt: Scalars['LocalDateTime']['output'];
  latestSupportMessage?: Maybe<RewardedUserSupportMessage>;
  messages: Array<RewardedUserSupportMessage>;
  rewardedUser: RewardedUser;
  /** For rewarded users this is OPEN until the ticket is closed (what the first apps expect); use conversationStatus instead. */
  status: RewardedUserSupportTicketStatus;
  title: Scalars['String']['output'];
  unreadMessageCount: Scalars['Int']['output'];
};

export type RewardedUserSupportTicketConnection = {
  edges: Array<RewardedUserSupportTicketEdge>;
  totalCount: Scalars['Int']['output'];
};

export type RewardedUserSupportTicketEdge = {
  node: RewardedUserSupportTicket;
};

export type RewardedUserSupportTicketFilter = {
  rewardedUserId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type RewardedUserSupportTicketInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  message: RewardedUserSupportTicketMessageInput;
  rewardedUserId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type RewardedUserSupportTicketMessageInput = {
  /** Up to 5 urls returned by rewardedUploadSupportTicketAttachment or rewardedUploadSupportTicketAttachmentBase64. */
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  body?: InputMaybe<Scalars['String']['input']>;
};

export enum RewardedUserSupportTicketStatus {
  Closed = 'CLOSED',
  /** Open ticket whose most recent message is from the rewarded user (awaiting an account-manager reply). */
  NewMessage = 'NEW_MESSAGE',
  Open = 'OPEN',
  /** Open ticket whose most recent message is from the account manager. */
  Replied = 'REPLIED'
}

export type RewardedUserUpdateInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<RewardedUserProfileCustomFieldInput>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  profilePictureUrl?: InputMaybe<Scalars['String']['input']>;
  referralId?: InputMaybe<Scalars['String']['input']>;
  /** Cockpit only: per-user override for the points + USD display (null = inherit the global setting). */
  showUsdValues?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<RewardedUserStatus>;
};

export type RewardedUsersFilter = {
  completedOffers?: InputMaybe<Array<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  startedOffers?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<RewardedUserStatus>>;
};

export type RewardedUsersSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<RewardedUsersSortField>;
  sortQuery?: InputMaybe<SortQuery>;
};

export enum RewardedUsersSortField {
  Clicks = 'CLICKS',
  Completeness = 'COMPLETENESS',
  Conversions = 'CONVERSIONS',
  EngagedOffers = 'ENGAGED_OFFERS',
  FraudScore = 'FRAUD_SCORE',
  Id = 'ID',
  InteractedOffers = 'INTERACTED_OFFERS',
  Profit = 'PROFIT',
  TheyGet = 'THEY_GET',
  TheyGetPoints = 'THEY_GET_POINTS',
  TotalTheyGetPoints = 'TOTAL_THEY_GET_POINTS',
  ViewedOffers = 'VIEWED_OFFERS',
  WeGet = 'WE_GET'
}

export enum Role {
  Admin = 'ADMIN',
  Adops = 'ADOPS',
  AdvertiserPartner = 'ADVERTISER_PARTNER',
  CockpitUser = 'COCKPIT_USER',
  Manager = 'MANAGER',
  PublisherPartner = 'PUBLISHER_PARTNER',
  RestrictedAffiliateManager = 'RESTRICTED_AFFILIATE_MANAGER',
  RestrictedManager = 'RESTRICTED_MANAGER'
}

export type RuleCustomization = {
  active: Scalars['Boolean']['output'];
  advertisers?: Maybe<Array<Advertiser>>;
  id: Scalars['String']['output'];
  namespace: RuleNamespace;
  notes?: Maybe<Scalars['String']['output']>;
  offers?: Maybe<Array<Offer>>;
  parameters: Array<RuleCustomizationParameter>;
  publishers?: Maybe<Array<Publisher>>;
  rule: Scalars['String']['output'];
};

export type RuleCustomizationConnection = {
  edges: Array<RuleCustomizationEdge>;
  totalCount: Scalars['Int']['output'];
};

export type RuleCustomizationEdge = {
  node: RuleCustomization;
};

export type RuleCustomizationFilter = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  namespaces?: InputMaybe<Array<RuleNamespace>>;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  rules?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RuleCustomizationInput = {
  active: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  key: RuleCustomizationKey;
  notes?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Array<RuleCustomizationParameterInput>>;
};

export type RuleCustomizationKey = {
  advertiserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  namespace: RuleNamespace;
  offerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  rule: Scalars['String']['input'];
};

export type RuleCustomizationParameter = {
  name: Scalars['String']['output'];
  parameterType: RuleCustomizationParameterType;
  value?: Maybe<Scalars['String']['output']>;
};

export type RuleCustomizationParameterInput = {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum RuleCustomizationParameterType {
  Boolean = 'BOOLEAN',
  Duration = 'DURATION',
  EventType = 'EVENT_TYPE',
  File = 'FILE',
  Number = 'NUMBER',
  Percentage = 'PERCENTAGE',
  String = 'STRING'
}

export enum RuleNamespace {
  Click = 'CLICK',
  Impression = 'IMPRESSION',
  Lead = 'LEAD',
  PostbackEvaluation = 'POSTBACK_EVALUATION',
  PostbackStatus = 'POSTBACK_STATUS'
}

export enum RuleViolationSortBy {
  FailedNonBanned = 'FAILED_NON_BANNED',
  FailedPostbacks = 'FAILED_POSTBACKS',
  TheyGet = 'THEY_GET',
  TotalPostbacks = 'TOTAL_POSTBACKS',
  ViolationRate = 'VIOLATION_RATE',
  WeGet = 'WE_GET'
}

export type SkAdMapping = {
  appId: Scalars['String']['output'];
  campaignId?: Maybe<Scalars['Int']['output']>;
  externalCampaignId?: Maybe<Scalars['String']['output']>;
  externalCampaignName?: Maybe<Scalars['String']['output']>;
  networkId: Scalars['String']['output'];
  offerId: Scalars['String']['output'];
  publisherId?: Maybe<Scalars['String']['output']>;
};

export type SkAdMappingInput = {
  appId: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  externalCampaignId?: InputMaybe<Scalars['String']['input']>;
  externalCampaignName?: InputMaybe<Scalars['String']['input']>;
  networkId: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
  publisherId: Scalars['String']['input'];
};

export type SkAdMappingKey = {
  appId: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  networkId: Scalars['String']['input'];
};

export type SkAdNetwork = {
  networkId: Scalars['String']['output'];
  privateKey?: Maybe<Scalars['String']['output']>;
  publicKey?: Maybe<Scalars['String']['output']>;
};

export type SkAdNetworkInput = {
  networkId: Scalars['String']['input'];
  privateKey?: InputMaybe<Scalars['String']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
};

export type SkAdPostbackLink = {
  campaignId?: Maybe<Scalars['Int']['output']>;
  method?: Maybe<SkAdPostbackLinkMethod>;
  mmpInfo?: Maybe<MmpPostbackInfo>;
  networkId: Scalars['String']['output'];
  offerId: Scalars['String']['output'];
  payload?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SkAdPostbackLinkType>;
  url?: Maybe<Scalars['String']['output']>;
  validatePostbacksWithMMP?: Maybe<Scalars['Boolean']['output']>;
};

export type SkAdPostbackLinkInput = {
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  method?: InputMaybe<SkAdPostbackLinkMethod>;
  mmpInfo?: InputMaybe<MmpPostbackInfoInput>;
  networkId: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SkAdPostbackLinkType>;
  url?: InputMaybe<Scalars['String']['input']>;
  validatePostbacksWithMMP?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkAdPostbackLinkKey = {
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  networkId: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
};

export enum SkAdPostbackLinkMethod {
  Get = 'GET',
  Post = 'POST'
}

export enum SkAdPostbackLinkType {
  Adjust = 'ADJUST',
  Appsflyer = 'APPSFLYER',
  Generic = 'GENERIC',
  Kochava = 'KOCHAVA',
  Singular = 'SINGULAR'
}

export type SanForwardingSettings = {
  accessToken?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  offerId?: Maybe<Scalars['String']['output']>;
  pixelId?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SanType>;
};

export type SanForwardingSettingsInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  pixelId?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SanType>;
};

export enum SanType {
  Apple = 'APPLE',
  Google = 'GOOGLE',
  Linkedin = 'LINKEDIN',
  Meta = 'META',
  Snap = 'SNAP',
  Tiktok = 'TIKTOK'
}

export type SavedRawQueryInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  overrideTimeRange?: InputMaybe<TimeRangeOverride>;
  query: RawQueryInput;
  scheduledRawReportEmail?: InputMaybe<ScheduledRawReportEmailInput>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type SavedRawQueryType = {
  createdBy?: Maybe<User>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  overrideTimeRange?: Maybe<TimeRangeOverride>;
  query: RawQueryType;
  scheduledRawReportEmail?: Maybe<ScheduledRawReportEmail>;
  user?: Maybe<Scalars['String']['output']>;
};

export type ScheduledChange = {
  budgetChanges: Array<Budget>;
  createdAt: Scalars['LocalDateTime']['output'];
  createdBy: User;
  executedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  offerAccessChanges: Array<OfferAccessChange>;
  offerChanges: Array<Offer>;
  offerForPublisherNotifications: Array<Notification>;
  offerPayoutChangeNotifications?: Maybe<Array<Notification>>;
  offerStatusChanges: Array<OfferStatusChange>;
  operations: Array<ScheduledChangeOperation>;
  payoutChanges: Array<Payout>;
  status: ScheduledChangeStatus;
  tags: Array<Scalars['String']['output']>;
  time: Scalars['LocalDateTime']['output'];
};

export type ScheduledChangeFilter = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  operations?: InputMaybe<Array<ScheduledChangeOperation>>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ScheduledChangeStatus>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ScheduledChangeInput = {
  budgetChanges?: InputMaybe<Array<BudgetInput>>;
  note?: InputMaybe<Scalars['String']['input']>;
  offerAccessChanges?: InputMaybe<Array<OfferAccess>>;
  offerChanges?: InputMaybe<Array<OfferInput>>;
  offerForPublisherNotifications?: InputMaybe<Array<OfferForPublisherNotificationInput>>;
  offerPayoutChangeNotifications?: InputMaybe<Array<OfferPayoutChangeNotificationInput>>;
  offerStatusChanges?: InputMaybe<Array<OfferStatusChangeInput>>;
  payoutChanges?: InputMaybe<Array<PayoutInput>>;
  /** You can use to categorize your scheduled change. Example, tag it with push-notification and then you can use the tag to filter for it */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  time: Scalars['LocalDateTime']['input'];
};

export enum ScheduledChangeOperation {
  BudgetChange = 'BUDGET_CHANGE',
  Notification = 'NOTIFICATION',
  OfferAccessChange = 'OFFER_ACCESS_CHANGE',
  OfferChange = 'OFFER_CHANGE',
  OfferStatusChange = 'OFFER_STATUS_CHANGE',
  PayoutChange = 'PAYOUT_CHANGE'
}

export enum ScheduledChangeStatus {
  Executed = 'EXECUTED',
  Failed = 'FAILED',
  Queued = 'QUEUED'
}

export type ScheduledRawReportEmail = {
  lastRanAt?: Maybe<Scalars['LocalDateTime']['output']>;
  message: Scalars['String']['output'];
  numberOfTimes?: Maybe<Scalars['Int']['output']>;
  schedule: Scalars['String']['output'];
  /** Cron expression to determine how often we send it. If schedule is null we will send it only once */
  subject: Scalars['String']['output'];
  to: Array<Scalars['String']['output']>;
};

export type ScheduledRawReportEmailInput = {
  message: Scalars['String']['input'];
  numberOfTimes?: InputMaybe<Scalars['Int']['input']>;
  schedule: Scalars['String']['input'];
  /** Cron expression to determine how often we send it. If schedule is null we will send it only once */
  subject: Scalars['String']['input'];
  to: Array<Scalars['String']['input']>;
};

export type SdkBreakpoint = {
  createdAt?: Maybe<Scalars['LocalDateTime']['output']>;
  eventType?: Maybe<AppEventType>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  screenshotUrl: Scalars['String']['output'];
  storeApp: StoreApp;
  type: SdkBreakpointType;
};

export type SdkBreakpointConnection = {
  edges: Array<SdkBreakpointEdge>;
  totalCount: Scalars['Int']['output'];
};

export type SdkBreakpointEdge = {
  node: SdkBreakpoint;
};

export type SdkBreakpointFilter = {
  appEventTypeId?: InputMaybe<Scalars['String']['input']>;
  hasEvent?: InputMaybe<Scalars['Boolean']['input']>;
  storeAppId?: InputMaybe<Scalars['String']['input']>;
};

export enum SdkBreakpointType {
  View = 'VIEW'
}

export type SdkEvent = {
  advertisingId?: Maybe<Scalars['String']['output']>;
  aggregatedValue?: Maybe<Scalars['String']['output']>;
  clientTime?: Maybe<Scalars['LocalDateTime']['output']>;
  eventType?: Maybe<AppEventType>;
  ip?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  osv?: Maybe<Scalars['String']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  storeApp?: Maybe<StoreApp>;
  token?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  vendorId?: Maybe<Scalars['String']['output']>;
};

export type SdkEventConnection = {
  edges: Array<SdkEventEdge>;
  totalCount: Scalars['Int']['output'];
};

export type SdkEventEdge = {
  node: SdkEvent;
};

export type SdkTestEventFilter = {
  eventTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  storeAppIds?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SdkTrackedBreakpoint = {
  appEventTypeId: Scalars['String']['output'];
  breakpointId: Scalars['String']['output'];
};

export type SdkTrackedBreakpointInput = {
  appEventTypeId: Scalars['String']['input'];
  breakpointId: Scalars['String']['input'];
  storeAppId: Scalars['String']['input'];
};

/** Represents the result of a search query, the type and the id can be further used to retrieve the whole entity */
export type SearchEntity = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SearchIntegration = {
  config: Array<SearchIntegrationConfig>;
  id?: Maybe<Scalars['String']['output']>;
  importSchedule?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastErrors?: Maybe<Array<Scalars['String']['output']>>;
  lastImportAt?: Maybe<Scalars['LocalDateTime']['output']>;
  reimportSchedule?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  spec: SearchIntegrationSpec;
  type: Scalars['String']['output'];
};

export type SearchIntegrationConfig = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  mandatory: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type SearchIntegrationConfigInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SearchIntegrationInput = {
  config?: InputMaybe<Array<SearchIntegrationConfigInput>>;
  importSchedule?: InputMaybe<Array<Scalars['String']['input']>>;
  reimportSchedule?: InputMaybe<Array<Scalars['String']['input']>>;
  type: Scalars['String']['input'];
};

export type SearchIntegrationSpec = {
  fieldMappings: Array<SearchIntegrationSpecFieldMapping>;
  instructions: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SearchIntegrationSpecFieldMapping = {
  apiField: Scalars['String']['output'];
  swaarmField: Scalars['String']['output'];
};

export type SearchStatsConnection = {
  edges: Array<SearchStatsEdge>;
  id: Scalars['Int']['output'];
  lastUpdated: Scalars['LocalDateTime']['output'];
  totalCount: Scalars['Long']['output'];
};

export enum SearchStatsDimension {
  AdvertiserId = 'ADVERTISER_ID',
  AdvertiserName = 'ADVERTISER_NAME',
  City = 'CITY',
  ConnectionIsp = 'CONNECTION_ISP',
  ConnectionType = 'CONNECTION_TYPE',
  Country = 'COUNTRY',
  DeviceMake = 'DEVICE_MAKE',
  DeviceType = 'DEVICE_TYPE',
  FeedId = 'FEED_ID',
  FeedName = 'FEED_NAME',
  LandingPageId = 'LANDING_PAGE_ID',
  LandingPageName = 'LANDING_PAGE_NAME',
  Language = 'LANGUAGE',
  Os = 'OS',
  OsVersion = 'OS_VERSION',
  PublisherId = 'PUBLISHER_ID',
  PublisherName = 'PUBLISHER_NAME',
  PublisherTerm = 'PUBLISHER_TERM',
  Region = 'REGION'
}

export type SearchStatsDimensionRecord = {
  dimension: SearchStatsDimension;
  value?: Maybe<Scalars['String']['output']>;
};

export type SearchStatsEdge = {
  node: SearchStatsRow;
};

export enum SearchStatsMetric {
  AdClicks = 'AD_CLICKS',
  Clicks = 'CLICKS',
  Cost = 'COST',
  MonetizedSearches = 'MONETIZED_SEARCHES',
  Profit = 'PROFIT',
  Revenue = 'REVENUE',
  Searches = 'SEARCHES'
}

export type SearchStatsMetricRecord = {
  metric: SearchStatsMetric;
  value?: Maybe<Scalars['Long']['output']>;
};

export type SearchStatsRow = {
  dimensions: Array<SearchStatsDimensionRecord>;
  id: Scalars['Int']['output'];
  lastUpdated: Scalars['LocalDateTime']['output'];
  metrics: Array<SearchStatsMetricRecord>;
};

export type ServiceConfig = {
  key: Scalars['String']['output'];
  service: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ServiceVersions = {
  api: Scalars['String']['output'];
  app: Scalars['String']['output'];
};

export type SmartLinkLandingPage = {
  destinationSmartLinkId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  impressionTrackingUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ratio: Scalars['Float']['output'];
  smartLinkId: Scalars['String']['output'];
  targeting?: Maybe<AdvancedTargeting>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type SmartLinkLandingPageInput = {
  destinationSmartLinkId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  impressionTrackingUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ratio: Scalars['Float']['input'];
  targeting?: InputMaybe<AdvancedTargetingInput>;
  trackingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SmartRecommendationLink = {
  description?: Maybe<Scalars['String']['output']>;
  exponentialFactor?: Maybe<Scalars['Float']['output']>;
  fallbackLandingPages?: Maybe<Array<SmartLinkLandingPage>>;
  id: Scalars['ID']['output'];
  internalPublisherId?: Maybe<Scalars['String']['output']>;
  inventoryConfigs?: Maybe<Array<InventoryConfig>>;
  name: Scalars['String']['output'];
  randomPercent?: Maybe<Scalars['Float']['output']>;
  redirectionRules?: Maybe<Array<RedirectionRule>>;
  strategy?: Maybe<Strategy>;
  url: Scalars['String']['output'];
  visibleToPublishers: Scalars['Boolean']['output'];
};

export type SmartRecommendationLinkFilter = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
};

export type SmartRecommendationLinkInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  exponentialFactor?: InputMaybe<Scalars['Float']['input']>;
  fallbackLandingPages?: InputMaybe<Array<SmartLinkLandingPageInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internalPublisherId?: InputMaybe<Scalars['String']['input']>;
  inventoryConfigs?: InputMaybe<Array<InventoryConfigInput>>;
  name: Scalars['String']['input'];
  randomPercent?: InputMaybe<Scalars['Float']['input']>;
  redirectionRules?: InputMaybe<Array<RedirectionRuleInput>>;
  strategy?: InputMaybe<Strategy>;
  visibleToPublishers?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SocialLoginProvider {
  Apple = 'APPLE',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE'
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortQuery = {
  delta?: InputMaybe<DeltaSortParameters>;
  end: Scalars['String']['input'];
  estimation?: InputMaybe<EstimationSortParameters>;
  filters?: InputMaybe<Array<InputMaybe<StatsFilter>>>;
  metric: Metric;
  start: Scalars['String']['input'];
};

export type Stat = {
  activeUsers?: Maybe<Scalars['Float']['output']>;
  adClicks?: Maybe<Scalars['Float']['output']>;
  advertiser?: Maybe<Advertiser>;
  app?: Maybe<App>;
  appEventType?: Maybe<AppEventType>;
  arpu?: Maybe<Scalars['Float']['output']>;
  /** The cost of infrastructure to handle the click amount */
  clickCost?: Maybe<Scalars['Float']['output']>;
  clicks?: Maybe<Scalars['Float']['output']>;
  conversions?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  coverage?: Maybe<Scalars['Float']['output']>;
  /** The conversion rate */
  cr?: Maybe<Scalars['Float']['output']>;
  /** allows you to retrieve delta (comparison to the past) metrics. Delta metrics are calculated using the same dimensions and filters as the original ones but with a different time range. */
  delta?: Maybe<DeltaMetrics>;
  end: Scalars['String']['output'];
  /** allows you to retrieve the estimated (comparison to the future) metrics. Estimated metrics are calculated using the same dimensions as the original ones. */
  estimation?: Maybe<EstimatedMetrics>;
  eventType?: Maybe<EventType>;
  events?: Maybe<Scalars['Float']['output']>;
  /** weGet - theyGet - clickCost */
  finalProfit?: Maybe<Scalars['Float']['output']>;
  impressions?: Maybe<Scalars['Float']['output']>;
  /** actTheyGet / actWeGet */
  margin?: Maybe<Scalars['Float']['output']>;
  monetizedSearches?: Maybe<Scalars['Float']['output']>;
  newUsers?: Maybe<Scalars['Float']['output']>;
  offer?: Maybe<Offer>;
  organic: Scalars['Boolean']['output'];
  paidConversions?: Maybe<Scalars['Float']['output']>;
  partnerPublisher?: Maybe<PartnerPublisher>;
  partnerPublisherAdvertiser?: Maybe<PartnerPublisherAdvertiser>;
  partnerPublisherEventType?: Maybe<PartnerPublisherEventType>;
  partnerPublisherOffer?: Maybe<PartnerPublisherOffer>;
  /** weGet - theyGet */
  profit?: Maybe<Scalars['Float']['output']>;
  pubConversions?: Maybe<Scalars['Float']['output']>;
  pubPaidConversions?: Maybe<Scalars['Float']['output']>;
  publisher?: Maybe<Publisher>;
  publisherSubId?: Maybe<Scalars['String']['output']>;
  rewardedUser?: Maybe<RewardedUser>;
  roas?: Maybe<Scalars['Float']['output']>;
  searchCtr?: Maybe<Scalars['Float']['output']>;
  searchMonetizedCtr?: Maybe<Scalars['Float']['output']>;
  searchMonetizedRpm?: Maybe<Scalars['Float']['output']>;
  searchQualityAdvertiserCoverage?: Maybe<Scalars['Float']['output']>;
  searchQualityAdvertiserScore?: Maybe<Scalars['Float']['output']>;
  searchQualityFollowupSearches?: Maybe<Scalars['Float']['output']>;
  searchQualityInitialSearches?: Maybe<Scalars['Float']['output']>;
  searchQualitySearchEngineCoverage?: Maybe<Scalars['Float']['output']>;
  searchQualitySearchEngineFollowupSearches?: Maybe<Scalars['Float']['output']>;
  searchQualitySearchEngineInitialSearches?: Maybe<Scalars['Float']['output']>;
  searchQualitySearchEngineScore?: Maybe<Scalars['Float']['output']>;
  searchRpc?: Maybe<Scalars['Float']['output']>;
  searchRpm?: Maybe<Scalars['Float']['output']>;
  searches?: Maybe<Scalars['Float']['output']>;
  sessions?: Maybe<Scalars['Float']['output']>;
  start: Scalars['String']['output'];
  storeApp?: Maybe<StoreApp>;
  /** Amount the pub is paid in USD */
  theyGet?: Maybe<Scalars['Float']['output']>;
  theyGetPoints?: Maybe<Scalars['Float']['output']>;
  /** Amount we got in USD */
  weGet?: Maybe<Scalars['Float']['output']>;
};

export enum StatsField {
  AdvertiserId = 'ADVERTISER_ID',
  AppId = 'APP_ID',
  Country = 'COUNTRY',
  EventType = 'EVENT_TYPE',
  OfferId = 'OFFER_ID',
  Organic = 'ORGANIC',
  PublisherGroupId = 'PUBLISHER_GROUP_ID',
  PublisherId = 'PUBLISHER_ID',
  PublisherSubId = 'PUBLISHER_SUB_ID',
  RewardedUserId = 'REWARDED_USER_ID',
  StoreAppId = 'STORE_APP_ID'
}

export type StatsFilter = {
  field?: InputMaybe<StatsField>;
  operator?: InputMaybe<FilterOperator>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum Status {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum StickinessMetric {
  Dau = 'DAU',
  Stickiness = 'STICKINESS',
  TrailingMau = 'TRAILING_MAU'
}

export type StickinessQuery = {
  appIds?: InputMaybe<Array<Scalars['String']['input']>>;
  end: Scalars['LocalDateTime']['input'];
  filters?: InputMaybe<Array<AppReportFilter>>;
  first: Scalars['Int']['input'];
  groupBy?: InputMaybe<Array<AppReportDimension>>;
  metrics: Array<StickinessMetric>;
  offset: Scalars['Int']['input'];
  sort?: InputMaybe<Array<StickinessSort>>;
  start: Scalars['LocalDateTime']['input'];
  storeAppIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StickinessReportConnection = {
  csvDownloadUrl: Scalars['String']['output'];
  edges: Array<StickinessReportEdge>;
  totalCount: Scalars['Int']['output'];
};

export type StickinessReportEdge = {
  node: StickinessReportRow;
};

export type StickinessReportMetricRecord = {
  field: StickinessMetric;
  value: Scalars['Float']['output'];
};

export type StickinessReportRow = {
  date: Scalars['LocalDateTime']['output'];
  dimensions: Array<AppReportDimensionRecord>;
  metrics: Array<StickinessReportMetricRecord>;
};

export type StickinessSort = {
  byDate?: InputMaybe<Scalars['Boolean']['input']>;
  dimension?: InputMaybe<AppReportDimension>;
  direction?: InputMaybe<SortOrder>;
  metric?: InputMaybe<StickinessMetric>;
};

export type StoreApp = {
  app: App;
  description?: Maybe<Scalars['String']['output']>;
  facebookInstallReferrerDecryptionKey?: Maybe<Scalars['String']['output']>;
  icon: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  offers: OfferConnection;
  report: Array<Report>;
  screenshots?: Maybe<Array<Scalars['String']['output']>>;
  sdkBreakpoints: SdkBreakpointConnection;
  store: AppStoreType;
  storeAppIosIntegration?: Maybe<StoreAppIosIntegration>;
  storeId: Scalars['String']['output'];
  storeUrl?: Maybe<Scalars['String']['output']>;
  tokens?: Maybe<Array<AppToken>>;
};


export type StoreAppOffersArgs = {
  filter?: InputMaybe<StoreAppOfferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StoreAppOfferSort>;
};


export type StoreAppReportArgs = {
  queries: Array<ReportQuery>;
};


export type StoreAppSdkBreakpointsArgs = {
  filter?: InputMaybe<SdkBreakpointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type StoreAppTokensArgs = {
  types?: InputMaybe<Array<AppTokenType>>;
};

export type StoreAppConnection = {
  edges?: Maybe<Array<StoreAppEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type StoreAppEdge = {
  node: StoreApp;
};

export type StoreAppFacebookInstallReferrerDecryptionKeyInput = {
  facebookInstallReferrerDecryptionKey: Scalars['String']['input'];
  storeAppId: Scalars['String']['input'];
};

export type StoreAppFilter = {
  appIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type StoreAppInput = {
  appId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  icon: Scalars['String']['input'];
  name: Scalars['String']['input'];
  screenshots?: InputMaybe<Array<Scalars['String']['input']>>;
  store: AppStoreType;
  storeAppIosIntegration?: InputMaybe<StoreAppIosIntegrationInput>;
  storeId: Scalars['String']['input'];
  storeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type StoreAppIosIntegration = {
  bundleId: Scalars['String']['output'];
  issuerId: Scalars['String']['output'];
  keyId: Scalars['String']['output'];
  privateKey: Scalars['String']['output'];
};

export type StoreAppIosIntegrationInput = {
  bundleId: Scalars['String']['input'];
  issuerId: Scalars['String']['input'];
  keyId: Scalars['String']['input'];
  privateKey: Scalars['String']['input'];
};

export type StoreAppOfferFilter = {
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<OfferStatus>>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StoreAppOfferSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<StoreAppOfferSortBy>;
  sortQuery?: InputMaybe<SortQuery>;
};

export enum StoreAppOfferSortBy {
  OfferId = 'OFFER_ID',
  OfferName = 'OFFER_NAME'
}

export type StoreAppSort = {
  direction?: InputMaybe<SortOrder>;
  field?: InputMaybe<StoreAppSortBy>;
  sortQuery?: InputMaybe<SortQuery>;
};

export enum StoreAppSortBy {
  AppId = 'APP_ID',
  StoreAppId = 'STORE_APP_ID',
  StoreAppName = 'STORE_APP_NAME'
}

export enum Strategy {
  PlusMinusTwoBucket = 'PLUS_MINUS_TWO_BUCKET'
}

export type StringArrayValue = {
  value: Array<Scalars['String']['output']>;
};

export type StringValue = {
  value: Scalars['String']['output'];
};

export type SupportTicket = {
  accountManager: User;
  id: Scalars['String']['output'];
  lastMessagedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  messages: Array<SupportTicketMessage>;
  partnerUser: User;
  publisher: Publisher;
  status: SupportTicketStatus;
  time: Scalars['LocalDateTime']['output'];
  title: Scalars['String']['output'];
};

export type SupportTicketConnection = {
  edges?: Maybe<Array<SupportTicketEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type SupportTicketEdge = {
  node: SupportTicket;
};

export type SupportTicketFilter = {
  accountManagerId?: InputMaybe<Scalars['String']['input']>;
  messageBody?: InputMaybe<Scalars['String']['input']>;
  partnerUserId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SupportTicketStatus>;
  timeFrom?: InputMaybe<Scalars['LocalDateTime']['input']>;
  timeTo?: InputMaybe<Scalars['LocalDateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SupportTicketInput = {
  accountManagerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  message: SupportTicketMessageInput;
  partnerUserId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type SupportTicketMessage = {
  body?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  supportTicket: SupportTicket;
  time: Scalars['LocalDateTime']['output'];
  user: User;
};

export type SupportTicketMessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
};

export type SupportTicketSort = {
  direction: SortOrder;
  field: SupportTicketSortBy;
};

export enum SupportTicketSortBy {
  AccountManager = 'ACCOUNT_MANAGER',
  LastMessagedAt = 'LAST_MESSAGED_AT',
  PartnerUser = 'PARTNER_USER',
  Status = 'STATUS',
  Time = 'TIME',
  Title = 'TITLE'
}

export enum SupportTicketStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type SupportedField = {
  creatable: Scalars['Boolean']['output'];
  defaultable: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  field: ImportedOfferField;
  name: Scalars['String']['output'];
  syncable: Scalars['Boolean']['output'];
  type: AdapterParamType;
};

/** Synchronized conversions: the same event on the same offer completed by many users at the same moment */
export enum SynchronizedConversionsSortBy {
  TheyGet = 'THEY_GET',
  TotalPostbacks = 'TOTAL_POSTBACKS',
  UserCount = 'USER_COUNT',
  WeGet = 'WE_GET'
}

export type TagsPermissionConfig = {
  allowedWriteForAdvertiser: Permission;
  allowedWriteForOffer: Permission;
  allowedWriteForPublisher: Permission;
};

export type TagsPermissionConfigInput = {
  allowedWriteForAdvertiser: Permission;
  allowedWriteForOffer: Permission;
  allowedWriteForPublisher: Permission;
};

export type TargetedLead = {
  active: Scalars['Boolean']['output'];
  advancedTargetingGroup?: Maybe<AdvancedTargetingGroup>;
  enablePrePing?: Maybe<Scalars['Boolean']['output']>;
  endpoint: LeadForwardingEndpoint;
  id: Scalars['String']['output'];
  mode?: Maybe<TargetedLeadMode>;
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
};

export type TargetedLeadConnection = {
  edges?: Maybe<Array<TargetedLeadEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type TargetedLeadEdge = {
  node: TargetedLead;
};

export type TargetedLeadInput = {
  active: Scalars['Boolean']['input'];
  advancedTargetingGroup?: InputMaybe<AdvancedTargetingGroupInput>;
  enablePrePing?: InputMaybe<Scalars['Boolean']['input']>;
  leadEndpointId: Scalars['String']['input'];
  mode?: InputMaybe<TargetedLeadMode>;
  name: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
};

export enum TargetedLeadMode {
  Cascading = 'CASCADING',
  Parallel = 'PARALLEL'
}

export type TargetedPayout = {
  advancedTargetingGroup: AdvancedTargetingGroup;
  advancedTargetingJson?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<EventType>;
  id: Scalars['String']['output'];
  margin?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  offer: Offer;
  publisher?: Maybe<Publisher>;
  /** In USD dollars */
  theyGet?: Maybe<Scalars['Float']['output']>;
  theyGetPoints?: Maybe<Scalars['Float']['output']>;
  /** In USD dollars */
  weGet?: Maybe<Scalars['Float']['output']>;
};

export type TargetedPayoutFilter = {
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TargetedPayoutInput = {
  advancedTargetingGroup?: InputMaybe<AdvancedTargetingGroupInput>;
  advancedTargetingJson?: InputMaybe<Scalars['String']['input']>;
  eventTypeId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  margin?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
  publisherId?: InputMaybe<Scalars['String']['input']>;
  theyGet?: InputMaybe<Scalars['Float']['input']>;
  theyGetPoints?: InputMaybe<Scalars['Float']['input']>;
  weGet?: InputMaybe<Scalars['Float']['input']>;
};

/** The audience desired for an offer */
export type Targeting = {
  countries: Array<Scalars['String']['output']>;
  os?: Maybe<Os>;
};

export type TargetingInput = {
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  os?: InputMaybe<OsInput>;
};

/**
 * The publisher-side payout. When a margin is set the value may be null (the effective amount is
 * derived from weGet), mirroring the legacy theyGet/margin exclusivity.
 */
export type TheyGetPayout = {
  createdBy?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<EventType>;
  margin?: Maybe<Scalars['Float']['output']>;
  offer: Offer;
  publisher?: Maybe<Publisher>;
  /** In USD dollars */
  value?: Maybe<Scalars['Float']['output']>;
};

/** The publisher-side points payout. The value is raw points rather than money. */
export type TheyGetPointsPayout = {
  createdBy?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<EventType>;
  margin?: Maybe<Scalars['Float']['output']>;
  offer: Offer;
  publisher?: Maybe<Publisher>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Origin of the effective (renderedTheyGet / renderedMargin) publisher payout. */
export enum TheyGetSource {
  /** Derived from an advertiser-scoped configured margin. */
  AdvertiserMargin = 'ADVERTISER_MARGIN',
  /** Derived by the advertiser's payout conversion policy. */
  AdvertiserPolicy = 'ADVERTISER_POLICY',
  /** Derived from the global default margin. */
  DefaultMargin = 'DEFAULT_MARGIN',
  /** An explicit theyGet value imported from the network. */
  FixedByNetwork = 'FIXED_BY_NETWORK',
  /** An explicit theyGet value set manually by an operator. */
  FixedByOperator = 'FIXED_BY_OPERATOR',
  /** An explicit value carried over from legacy data by a migration; its true origin is unknown. */
  Migrated = 'MIGRATED',
  /** Nothing resolved (renderedTheyGet is null). */
  None = 'NONE',
  /** Derived from an offer-scoped margin (incl. this payout's own margin on the offer default). */
  OfferMargin = 'OFFER_MARGIN',
  /** Derived from an offer+publisher-scoped margin (incl. this payout's own margin). */
  OfferPublisherMargin = 'OFFER_PUBLISHER_MARGIN',
  /** theyGetPoints only: derived as theyGet x the publisher's points exchange rate. */
  PointsExchangeRate = 'POINTS_EXCHANGE_RATE',
  /** Derived from a publisher-scoped configured margin. */
  PublisherMargin = 'PUBLISHER_MARGIN'
}

/** Time-of-Day Anomalies */
export enum TimeOfDaySortBy {
  PeakHourPostbacks = 'PEAK_HOUR_POSTBACKS',
  PeakHourRate = 'PEAK_HOUR_RATE',
  TheyGet = 'THEY_GET',
  TotalPostbacks = 'TOTAL_POSTBACKS',
  WeGet = 'WE_GET'
}

export enum TimeRangeOverride {
  Last_7Days = 'LAST_7_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  LastMonth = 'LAST_MONTH',
  LastQuarter = 'LAST_QUARTER',
  LastWeek = 'LAST_WEEK',
  LastYear = 'LAST_YEAR',
  ThisMonth = 'THIS_MONTH',
  ThisQuarter = 'THIS_QUARTER',
  ThisWeek = 'THIS_WEEK',
  ThisYear = 'THIS_YEAR',
  ThreeDaysAgo = 'THREE_DAYS_AGO',
  Today = 'TODAY',
  TwoDaysAgo = 'TWO_DAYS_AGO',
  Yesterday = 'YESTERDAY'
}

/** Event Timing Clusters */
export enum TimingClusterSortBy {
  TheyGet = 'THEY_GET',
  TotalPostbacks = 'TOTAL_POSTBACKS',
  UserCount = 'USER_COUNT',
  WeGet = 'WE_GET'
}

export type TimingStats = {
  avgSeconds: Scalars['Float']['output'];
  medianSeconds: Scalars['Float']['output'];
  p1Seconds: Scalars['Float']['output'];
  p5Seconds: Scalars['Float']['output'];
  p10Seconds: Scalars['Float']['output'];
  p25Seconds: Scalars['Float']['output'];
  p75Seconds: Scalars['Float']['output'];
  p99Seconds: Scalars['Float']['output'];
};

export type TrackingEmailContext = {
  trackingLink?: Maybe<Scalars['String']['output']>;
};

export enum TrackingPermission {
  Denied = 'DENIED',
  Granted = 'GRANTED',
  Restricted = 'RESTRICTED',
  Undetermined = 'UNDETERMINED'
}

export type TrafficTag = {
  active: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  tag: Scalars['String']['output'];
  targeting: AdvancedTargeting;
};

export type TrafficTagConnection = {
  edges?: Maybe<Array<TrafficTagEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type TrafficTagEdge = {
  node: TrafficTag;
};

export type TrafficTagFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type TrafficTagInput = {
  active: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
  targeting: AdvancedTargetingInput;
};

export type TrafficTargeting = {
  active: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  target: AdvancedTargeting;
  trafficRule: AdvancedTargeting;
};

export type TrafficTargetingConnection = {
  edges?: Maybe<Array<TrafficTargetingEdge>>;
  totalCount: Scalars['Int']['output'];
};

export type TrafficTargetingEdge = {
  node: TrafficTargeting;
};

export type TrafficTargetingFilter = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type TrafficTargetingInput = {
  active: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  target: AdvancedTargetingInput;
  trafficRule: AdvancedTargetingInput;
};

export type UnbanUsersInput = {
  /** Click ids whose entries are removed. */
  clickIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  /** Removes every entry of this publisher-side user id (all of their banned clicks); publisherId narrows it to one publisher. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UnbanUsersResult = {
  /** Requested click ids that had no entry (already unbanned or never banned). */
  notFoundClickIds: Array<Scalars['String']['output']>;
  removedClickIds: Array<Scalars['String']['output']>;
};

export type UploadResult = {
  url: Scalars['String']['output'];
};

export type User = {
  auth0Id?: Maybe<Scalars['String']['output']>;
  authId: Scalars['String']['output'];
  authLogs: AuthLogConnection;
  createdBy?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['LocalDateTime']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  permissions: Array<Permission>;
  /** Read-only users can run queries but every mutation is rejected */
  readOnly: Scalars['Boolean']['output'];
  roles: Array<Role>;
  settings?: Maybe<UserSettings>;
  skype?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
};


export type UserAuthLogsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UserData = {
  connection?: Maybe<Connection>;
  device?: Maybe<Device>;
  geo?: Maybe<Geo>;
  ids?: Maybe<Ids>;
};

export type UserDataInput = {
  connection?: InputMaybe<ConnectionInput>;
  device?: InputMaybe<DeviceInput>;
  geo?: InputMaybe<GeoInput>;
  ids?: InputMaybe<IdsInput>;
};

export type UserEmailContext = {
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UserFilter = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
};

export enum UserIdentifierType {
  PubClickId = 'PUB_CLICK_ID',
  RewardedUserId = 'REWARDED_USER_ID',
  Unique1 = 'UNIQUE1',
  Unique2 = 'UNIQUE2',
  Unique3 = 'UNIQUE3',
  Unique4 = 'UNIQUE4',
  Unique5 = 'UNIQUE5',
  Unique6 = 'UNIQUE6',
  Unique7 = 'UNIQUE7',
  Unique8 = 'UNIQUE8',
  Unique9 = 'UNIQUE9'
}

export type UserInput = {
  email: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['LocalDateTime']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** Omit to keep the current value on update; defaults to false on create */
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  roles: Array<Role>;
  skype?: InputMaybe<Scalars['String']['input']>;
  status: UserStatus;
};

export type UserProvidedParam = {
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<UserProvidedValue>;
};

export type UserProvidedParamInput = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  floatValue?: InputMaybe<Scalars['Float']['input']>;
  intValue?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
  stringArrayValue?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

export type UserProvidedValue = BooleanValue | DateValue | FloatValue | IntValue | StringArrayValue | StringValue;

export type UserSettings = {
  answersSupportTickets?: Maybe<Scalars['Boolean']['output']>;
  memosSettings?: Maybe<Array<UserSettingsMemos>>;
};

export type UserSettingsInput = {
  answersSupportTickets?: InputMaybe<Scalars['Boolean']['input']>;
  memosSettings?: InputMaybe<Array<UserSettingsMemosInput>>;
};

export type UserSettingsMemos = {
  active: Scalars['Boolean']['output'];
  frequency: EmailFrequency;
  tag: MemoTag;
};

export type UserSettingsMemosInput = {
  active: Scalars['Boolean']['input'];
  frequency: EmailFrequency;
  tag: MemoTag;
};

export enum UserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Conversion velocity / burst detection */
export enum VelocitySortBy {
  DistinctWindows = 'DISTINCT_WINDOWS',
  PeakInWindow = 'PEAK_IN_WINDOW',
  TheyGet = 'THEY_GET',
  TotalConversions = 'TOTAL_CONVERSIONS',
  WeGet = 'WE_GET'
}

/**
 * SUM: add up aggregatedEventValue of every postback of the click.
 * LATEST: use the aggregatedEventValue of the most recent postback that carried one (advertiser sends a running total).
 */
export enum VirtualAggregatedValueMode {
  Latest = 'LATEST',
  Sum = 'SUM'
}

export type VirtualEventConditions = {
  /** How the aggregated value is derived: SUM over all postbacks (default) or LATEST reported value (running totals) */
  aggregatedValueMode: VirtualAggregatedValueMode;
  maxAggregatedValue?: Maybe<Scalars['Float']['output']>;
  maxTheyGet?: Maybe<Scalars['Float']['output']>;
  maxWeGet?: Maybe<Scalars['Float']['output']>;
  minAggregatedValue?: Maybe<Scalars['Float']['output']>;
  minTheyGet?: Maybe<Scalars['Float']['output']>;
  minWeGet?: Maybe<Scalars['Float']['output']>;
  mode: VirtualEventMode;
  requiredEventTypeIds: Array<Scalars['String']['output']>;
};

export type VirtualEventConditionsInput = {
  aggregatedValueMode?: InputMaybe<VirtualAggregatedValueMode>;
  maxAggregatedValue?: InputMaybe<Scalars['Float']['input']>;
  maxTheyGet?: InputMaybe<Scalars['Float']['input']>;
  maxWeGet?: InputMaybe<Scalars['Float']['input']>;
  minAggregatedValue?: InputMaybe<Scalars['Float']['input']>;
  minTheyGet?: InputMaybe<Scalars['Float']['input']>;
  minWeGet?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<VirtualEventMode>;
  requiredEventTypeIds: Array<Scalars['String']['input']>;
};

export enum VirtualEventMode {
  All = 'ALL',
  Any = 'ANY'
}

/** VPN / Proxy / Anonymized-IP usage */
export enum VpnSortBy {
  TheyGet = 'THEY_GET',
  TotalPostbacks = 'TOTAL_POSTBACKS',
  VpnConversions = 'VPN_CONVERSIONS',
  VpnRate = 'VPN_RATE',
  WeGet = 'WE_GET'
}

/** The platform-side payout, stored independently of theyGet / theyGetPoints. */
export type WeGetPayout = {
  createdBy?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<EventType>;
  margin?: Maybe<Scalars['Float']['output']>;
  offer: Offer;
  publisher?: Maybe<Publisher>;
  /** In USD dollars */
  value?: Maybe<Scalars['Float']['output']>;
};

/**
 * The platform-side points payout: what the network pays us in points. The advertiser's payout
 * conversion policy turns this into the player reward at render time.
 */
export type WeGetPointsPayout = {
  createdBy?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<EventType>;
  margin?: Maybe<Scalars['Float']['output']>;
  offer: Offer;
  publisher?: Maybe<Publisher>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type WeightedValue = {
  value: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type WeightedValueInput = {
  value: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};
